import styled, { css, ThemeProvider as ThemeProvider$1 } from 'styled-components';
import PropTypes from 'prop-types';
import React, { forwardRef, useState, useEffect, useMemo, useCallback, useRef, createContext, useContext, createElement as createElement$2 } from 'react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import styledCss from '@styled-system/css';
export { default as css } from '@styled-system/css';
import { variant, compose, layout, space as space$1, color as color$1, background, display, flexbox, margin, padding, position, flex, flexDirection, shadow, typography as typography$1, border, width, height, minWidth, minHeight, maxWidth, maxHeight, verticalAlign, overflow, overflowX, overflowY, grid, textAlign, fontSize, fontWeight, system } from 'styled-system';
import Select, { components } from 'react-select';
import { useSwipeable } from 'react-swipeable';
import FocusTrap from 'focus-trap-react';
import ReactDOM, { createPortal } from 'react-dom';
import axios from 'axios';
import Autocomplete from 'react-autocomplete';
import Cookies from 'js-cookie';
import { object, string } from 'yup';
import cn from 'classnames';
import { useForm, Controller } from 'react-hook-form';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';

var viewVariants$1 = {
  "default": {
    // add custom styling here
  }
};
var _wcImport20 = {
  viewVariants: viewVariants$1
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$Q =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$n = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$m = fails$n;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$m(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var call$k = Function.prototype.call;

var functionCall = call$k.bind ? call$k.bind(call$k) : function () {
  return call$k.apply(call$k, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$3 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$3(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$5 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var FunctionPrototype$2 = Function.prototype;
var bind$9 = FunctionPrototype$2.bind;
var call$j = FunctionPrototype$2.call;
var callBind = bind$9 && bind$9.bind(call$j);

var functionUncurryThis = bind$9 ? function (fn) {
  return fn && callBind(call$j, fn);
} : function (fn) {
  return fn && function () {
    return call$j.apply(fn, arguments);
  };
};

var uncurryThis$v = functionUncurryThis;

var toString$g = uncurryThis$v({}.toString);
var stringSlice$b = uncurryThis$v(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$b(toString$g(it), 8, -1);
};

var global$P = global$Q;
var uncurryThis$u = functionUncurryThis;
var fails$l = fails$n;
var classof$8 = classofRaw$1;

var Object$5 = global$P.Object;
var split$3 = uncurryThis$u(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$l(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object$5('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$8(it) == 'String' ? split$3(it, '') : Object$5(it);
} : Object$5;

var global$O = global$Q;

var TypeError$i = global$O.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$b = function (it) {
  if (it == undefined) throw TypeError$i("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$a = requireObjectCoercible$b;

var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$a(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$m = function (argument) {
  return typeof argument == 'function';
};

var isCallable$l = isCallable$m;

var isObject$a = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$l(it);
};

var global$N = global$Q;
var isCallable$k = isCallable$m;

var aFunction = function (argument) {
  return isCallable$k(argument) ? argument : undefined;
};

var getBuiltIn$8 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$N[namespace]) : global$N[namespace] && global$N[namespace][method];
};

var uncurryThis$t = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$t({}.isPrototypeOf);

var getBuiltIn$7 = getBuiltIn$8;

var engineUserAgent = getBuiltIn$7('navigator', 'userAgent') || '';

var global$M = global$Q;
var userAgent$3 = engineUserAgent;

var process$4 = global$M.process;
var Deno = global$M.Deno;
var versions = process$4 && process$4.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$3) {
  match = userAgent$3.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$3.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$1 = engineV8Version;
var fails$k = fails$n;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$k(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$2 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$L = global$Q;
var getBuiltIn$6 = getBuiltIn$8;
var isCallable$j = isCallable$m;
var isPrototypeOf$5 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var Object$4 = global$L.Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$6('Symbol');
  return isCallable$j($Symbol) && isPrototypeOf$5($Symbol.prototype, Object$4(it));
};

var global$K = global$Q;

var String$6 = global$K.String;

var tryToString$4 = function (argument) {
  try {
    return String$6(argument);
  } catch (error) {
    return 'Object';
  }
};

var global$J = global$Q;
var isCallable$i = isCallable$m;
var tryToString$3 = tryToString$4;

var TypeError$h = global$J.TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$6 = function (argument) {
  if (isCallable$i(argument)) return argument;
  throw TypeError$h(tryToString$3(argument) + ' is not a function');
};

var aCallable$5 = aCallable$6;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$7 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$5(func);
};

var global$I = global$Q;
var call$i = functionCall;
var isCallable$h = isCallable$m;
var isObject$9 = isObject$a;

var TypeError$g = global$I.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$h(fn = input.toString) && !isObject$9(val = call$i(fn, input))) return val;
  if (isCallable$h(fn = input.valueOf) && !isObject$9(val = call$i(fn, input))) return val;
  if (pref !== 'string' && isCallable$h(fn = input.toString) && !isObject$9(val = call$i(fn, input))) return val;
  throw TypeError$g("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var isPure = false;

var global$H = global$Q;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$4 = Object.defineProperty;

var setGlobal$3 = function (key, value) {
  try {
    defineProperty$4(global$H, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$H[key] = value;
  } return value;
};

var global$G = global$Q;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$G[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.19.1',
  mode: 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});

var global$F = global$Q;
var requireObjectCoercible$9 = requireObjectCoercible$b;

var Object$3 = global$F.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$6 = function (argument) {
  return Object$3(requireObjectCoercible$9(argument));
};

var uncurryThis$s = functionUncurryThis;
var toObject$5 = toObject$6;

var hasOwnProperty = uncurryThis$s({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$5(it), key);
};

var uncurryThis$r = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$f = uncurryThis$r(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$f(++id + postfix, 36);
};

var global$E = global$Q;
var shared$3 = shared$4.exports;
var hasOwn$d = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$3('wks');
var Symbol$2 = global$E.Symbol;
var symbolFor = Symbol$2 && Symbol$2['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$l = function (name) {
  if (!hasOwn$d(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL$1 || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL$1 && hasOwn$d(Symbol$2, name)) {
      WellKnownSymbolsStore[name] = Symbol$2[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var global$D = global$Q;
var call$h = functionCall;
var isObject$8 = isObject$a;
var isSymbol$1 = isSymbol$2;
var getMethod$6 = getMethod$7;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$k = wellKnownSymbol$l;

var TypeError$f = global$D.TypeError;
var TO_PRIMITIVE = wellKnownSymbol$k('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$8(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$6(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$h(exoticToPrim, input, pref);
    if (!isObject$8(result) || isSymbol$1(result)) return result;
    throw TypeError$f("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$3 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$C = global$Q;
var isObject$7 = isObject$a;

var document$3 = global$C.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$7(document$3) && isObject$7(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$a = descriptors;
var fails$j = fails$n;
var createElement$1 = documentCreateElement$2;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$a && !fails$j(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$9 = descriptors;
var call$g = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$4 = createPropertyDescriptor$5;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$2 = toPropertyKey$3;
var hasOwn$c = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$9 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$2(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$c(O, P)) return createPropertyDescriptor$4(!call$g(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var global$B = global$Q;
var isObject$6 = isObject$a;

var String$5 = global$B.String;
var TypeError$e = global$B.TypeError;

// `Assert: Type(argument) is Object`
var anObject$j = function (argument) {
  if (isObject$6(argument)) return argument;
  throw TypeError$e(String$5(argument) + ' is not an object');
};

var global$A = global$Q;
var DESCRIPTORS$8 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var anObject$i = anObject$j;
var toPropertyKey$1 = toPropertyKey$3;

var TypeError$d = global$A.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$8 ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$i(O);
  P = toPropertyKey$1(P);
  anObject$i(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError$d('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$7 = descriptors;
var definePropertyModule$5 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$5;

var createNonEnumerableProperty$7 = DESCRIPTORS$7 ? function (object, key, value) {
  return definePropertyModule$5.f(object, key, createPropertyDescriptor$3(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$a = {exports: {}};

var uncurryThis$q = functionUncurryThis;
var isCallable$g = isCallable$m;
var store$1 = sharedStore;

var functionToString = uncurryThis$q(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$g(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$4 = store$1.inspectSource;

var global$z = global$Q;
var isCallable$f = isCallable$m;
var inspectSource$3 = inspectSource$4;

var WeakMap$1 = global$z.WeakMap;

var nativeWeakMap = isCallable$f(WeakMap$1) && /native code/.test(inspectSource$3(WeakMap$1));

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys$1 = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys$1[key] || (keys$1[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$y = global$Q;
var uncurryThis$p = functionUncurryThis;
var isObject$5 = isObject$a;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$7;
var hasOwn$b = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$c = global$y.TypeError;
var WeakMap = global$y.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$5(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$c('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  var wmget = uncurryThis$p(store.get);
  var wmhas = uncurryThis$p(store.has);
  var wmset = uncurryThis$p(store.set);
  set$1 = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$c(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$b(it, STATE)) throw new TypeError$c(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$6(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$b(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$b(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var DESCRIPTORS$6 = descriptors;
var hasOwn$a = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$6 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$a(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$6 || (DESCRIPTORS$6 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var global$x = global$Q;
var isCallable$e = isCallable$m;
var hasOwn$9 = hasOwnProperty_1;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$7;
var setGlobal$1 = setGlobal$3;
var inspectSource$2 = inspectSource$4;
var InternalStateModule$5 = internalState;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;

var getInternalState$4 = InternalStateModule$5.get;
var enforceInternalState$1 = InternalStateModule$5.enforce;
var TEMPLATE = String(String).split('String');

(redefine$a.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable$e(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn$9(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
      createNonEnumerableProperty$5(value, 'name', name);
    }
    state = enforceInternalState$1(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global$x) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$5(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable$e(this) && getInternalState$4(this).source || inspectSource$2(this);
});

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$5 = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$6 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor$5 : ceil)(number);
};

var toIntegerOrInfinity$5 = toIntegerOrInfinity$6;

var max$1 = Math.max;
var min$4 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$5(index);
  return integer < 0 ? max$1(integer + length, 0) : min$4(integer, length);
};

var toIntegerOrInfinity$4 = toIntegerOrInfinity$6;

var min$3 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$5 = function (argument) {
  return argument > 0 ? min$3(toIntegerOrInfinity$4(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$4 = toLength$5;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$4 = function (obj) {
  return toLength$4(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$3 = lengthOfArrayLike$4;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$3 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$3(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$3(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$3(false)
};

var uncurryThis$o = functionUncurryThis;
var hasOwn$8 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$5 = uncurryThis$o([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$8(hiddenKeys$2, key) && hasOwn$8(O, key) && push$5(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$8(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$5(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$5 = getBuiltIn$8;
var uncurryThis$n = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$h = anObject$j;

var concat$2 = uncurryThis$n([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$h(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$7 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$4 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$4.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$7(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var fails$i = fails$n;
var isCallable$d = isCallable$m;

var replacement = /#|\.prototype\./;

var isForced$3 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$d(detection) ? fails$i(detection)
    : !!detection;
};

var normalize = isForced$3.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$3.data = {};
var NATIVE = isForced$3.NATIVE = 'N';
var POLYFILL = isForced$3.POLYFILL = 'P';

var isForced_1 = isForced$3;

var global$w = global$Q;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$7;
var redefine$9 = redefine$a.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$2 = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$w;
  } else if (STATIC) {
    target = global$w[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$w[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$2(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$2(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$4(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$9(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$5 = descriptors;
var uncurryThis$m = functionUncurryThis;
var call$f = functionCall;
var fails$h = fails$n;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$4 = toObject$6;
var IndexedObject$1 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$3 = Object.defineProperty;
var concat$1 = uncurryThis$m([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$h(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$5 && $assign({ b: 1 }, $assign(defineProperty$3({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$3(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$4(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$5 || call$f(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$d = _export;
var assign$1 = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$d({ target: 'Object', stat: true, forced: Object.assign !== assign$1 }, {
  assign: assign$1
});

/*
  Some values are expressed as a function so that if we decide to make
  them dependent on props in the future, it wouldn't require a significant
  refactor everywhere they are being used.
*/
var baseFontSize = function baseFontSize() {
  return 16;
};
var lato = function lato() {
  return 'Lato,sans-serif';
};
var oswald = function oswald() {
  return 'Oswald,san-serif';
};
var openSans = function openSans() {
  return "'Open Sans','Helvetica Neue','Helvetica',Arial,sans-serif";
};
var typography = {
  heading3xl: {
    size: 74,
    lineHeight: 92
  },
  heading2xl: {
    size: 52,
    lineHeight: 70
  },
  headingXl: {
    size: 42,
    lineHeight: 56
  },
  headingLg: {
    size: 32,
    lineHeight: 44
  },
  headingMd: {
    size: 26,
    lineHeight: 38
  },
  headingSm: {
    size: 20,
    lineHeight: 30
  },
  headingXs: {
    size: 16,
    lineHeight: 24
  },
  bodyLg: {
    size: 18,
    lineHeight: 30
  },
  bodyMd: {
    size: 16,
    lineHeight: 26
  },
  bodySm: {
    size: 14,
    lineHeight: 24
  },
  labelLg: {
    size: 16,
    lineHeight: 20
  },
  labelMd: {
    size: 14,
    lineHeight: 18
  },
  labelSm: {
    size: 12,
    lineHeight: 14
  },
  labelXs: {
    size: 10,
    lineHeight: 12
  }
};
var fontWeights = [300, 400, 600, 700];
fontWeights.light = fontWeights[0];
fontWeights.regular = fontWeights[1];
fontWeights.semiBold = fontWeights[2];
fontWeights.bold = fontWeights[3];
var baseText$1 = function baseText(size, lineHeight) {
  var weight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return {
    fontSize: "".concat(size, "px"),
    fontWeight: weight ? weight : undefined,
    lineHeight: "".concat(lineHeight, "px")
  };
};
var labelText = function labelText(size, lineHeight) {
  return Object.assign({}, baseText$1(size, lineHeight), {
    fontStyle: 'inherit',
    letterSpacing: '-0.025em'
  });
};
var headingVariants = {
  heading3xl: Object.assign({}, baseText$1(typography.heading2xl.size, typography.heading2xl.lineHeight, 700), {
    letterSpacing: '-0.01em'
  }),
  heading2xl: Object.assign({}, baseText$1(typography.heading2xl.size, typography.heading2xl.lineHeight, 700), {
    letterSpacing: '-0.01em'
  }),
  headingXl: Object.assign({}, baseText$1(typography.headingXl.size, typography.headingXl.lineHeight, 700), {
    letterSpacing: '-0.003em'
  }),
  headingLg: Object.assign({}, baseText$1(typography.headingLg.size, typography.headingLg.lineHeight, 700)),
  headingMd: Object.assign({}, baseText$1(typography.headingMd.size, typography.headingMd.lineHeight, 700)),
  headingSm: Object.assign({}, baseText$1(typography.headingSm.size, typography.headingSm.lineHeight, 600)),
  headingXs: Object.assign({}, baseText$1(typography.headingXs.size, typography.headingXs.lineHeight, 600))
};
var textVariants = {
  bodyLg: Object.assign({}, baseText$1(typography.bodyLg.size, typography.bodyLg.lineHeight)),
  bodyMd: Object.assign({}, baseText$1(typography.bodyMd.size, typography.bodyMd.lineHeight)),
  bodySm: Object.assign({}, baseText$1(typography.bodySm.size, typography.bodySm.lineHeight)),
  labelLg: Object.assign({}, labelText(typography.labelLg.size, typography.labelLg.lineHeight)),
  labelMd: Object.assign({}, labelText(typography.labelMd.size, typography.labelMd.lineHeight)),
  labelSm: Object.assign({}, labelText(typography.labelSm.size, typography.labelSm.lineHeight)),
  labelXs: Object.assign({}, labelText(typography.labelXs.size, typography.labelXs.lineHeight))
};
var _wcImport19 = {
  typography: typography,
  fontWeights: fontWeights,
  headingVariants: headingVariants,
  textVariants: textVariants,
  baseFontSize: baseFontSize,
  lato: lato,
  oswald: oswald,
  openSans: openSans
};

var colors = {
  inherit: 'inherit',
  current: 'currentColor',
  transparent: 'transparent',
  black: '#000',
  white: '#fff',
  // Primary
  primary: {
    90: '#46154E',
    80: '#611D6C',
    70: '#7D268B',
    60: '#982EA9',
    50: '#AB54B9',
    40: '#BD79C8',
    30: '#D09FD8',
    20: '#E3C5E7',
    10: '#F5EBF7'
  },
  // Secondary
  secondary: {
    90: '#131F35',
    80: '#1B2B4A',
    70: '#22385E',
    60: '#2A4473',
    50: '#50668C',
    40: '#7787A6',
    30: '#9DA9BF',
    20: '#C4CBD8',
    10: '#E9ECF1',
    5: '#F9F9FB'
  },
  // Neutral
  neutral: {
    100: '#353535',
    90: '#4A4A4A',
    80: '#5D5D5D',
    70: '#727272',
    60: '#868686',
    50: '#999999',
    40: '#AEAEAE',
    30: '#C3C3C3',
    20: '#D7D7D7',
    10: '#EBEBEB',
    0: '#FFFFFF'
  },
  // Semantic Success
  success: {
    base: '#1FA5A4',
    text: '#177A79',
    light: '#E5F6F6'
  },
  // Semantic Alert
  alert: {
    base: '#FB6566',
    text: '#DB0607',
    light: '#F7C4C6'
  },
  // Semantic Warning
  warning: {
    base: '#FDBE61',
    text: '#A06000',
    light: '#FFF6EA'
  },
  // Semantic Info
  info: {
    base: '#B394F2',
    text: '#8155DB',
    light: '#F2ECFE'
  },
  // One Off Colors That Aren't Committed Yet
  oneOffs: ['#cbffc0']
};

// Alias' for deprecated references
colors.primary_90 = colors.primary[90];
colors.primary_80 = colors.primary[80];
colors.primary_70 = colors.primary[70];
colors.primary_60 = colors.primary[60];
colors.primary_50 = colors.primary[50];
colors.primary_40 = colors.primary[40];
colors.primary_30 = colors.primary[30];
colors.primary_20 = colors.primary[20];
colors.primary_10 = colors.primary[10];
colors.neutral_100 = colors.neutral[100];
colors.neutral_90 = colors.neutral[90];
colors.neutral_80 = colors.neutral[80];
colors.neutral_70 = colors.neutral[70];
colors.neutral_60 = colors.neutral[60];
colors.neutral_50 = colors.neutral[50];
colors.neutral_40 = colors.neutral[40];
colors.neutral_30 = colors.neutral[30];
colors.neutral_20 = colors.neutral[20];
colors.neutral_10 = colors.neutral[10];
colors.neutral_0 = colors.neutral[0];
colors.semantic_success_text = colors.success.text;
colors.semantic_success = colors.success.base;
colors.semantic_success_light = colors.success.light;
colors.semantic_alert_text = colors.alert.text;
colors.semantic_alert = colors.alert.base;
colors.semantic_alert_light = colors.alert.light;
colors.semantic_warning_text = colors.warning.text;
colors.semantic_warning = colors.warning.base;
colors.semantic_warning_light = colors.warning.light;
colors.semantic_info_text = colors.info.text;
colors.semantic_info = colors.info.base;
colors.semantic_info_light = colors.info.light;
var _wcImport4 = colors;

// SVG styling
var svgStyle = {
  position: 'inherit',
  zIndex: '1',
  pointerEvents: 'none'
};
var inactiveSmallSvg = {
  width: '6px',
  height: '6px',
  left: '19px',
  bottom: '5px'
};
var activeSmallSvg = {
  width: '9px',
  height: '6px',
  left: '6px',
  bottom: '5px'
};
var inactiveLargeSvg = {
  width: '10px',
  height: '10px',
  left: '29px',
  bottom: '-1px'
};
var activeLargeSvg = {
  width: '12px',
  height: '9.6px',
  left: '8px',
  bottom: '-1px'
};

// SVG VARIANTS
var svgToggleVariants = {
  smallInactive: Object.assign({}, svgStyle, inactiveSmallSvg),
  smallActive: Object.assign({}, svgStyle, activeSmallSvg),
  // smallActiveDisabled: {
  //     ...svgStyle,
  //     ...activeSmallSvg,
  // },
  // smallInactiveDisabled: {
  //     ...svgStyle,
  //     ...activeSmallSvg,
  // },
  largeInactive: Object.assign({}, svgStyle, inactiveLargeSvg),
  largeActive: Object.assign({}, svgStyle, activeLargeSvg)
};

// Toggle label style
var labelStyle = {
  position: 'absolute',
  top: '0px',
  left: '0px',
  backgroundColor: _wcImport4.neutral[80],
  cursor: 'pointer',
  ':hover': {
    backgroundColor: _wcImport4.neutral[100]
  },
  '&::after': {
    content: '""',
    display: 'block',
    borderRadius: '50%',
    backgroundColor: _wcImport4.neutral[0],
    transition: '0.2s'
  }
};
var smallLabel = {
  width: '32px',
  height: '16px',
  borderRadius: '8px',
  '&::after': {
    width: '12px',
    height: '12px',
    margin: '2px'
  }
};
var largeLabel = {
  width: '48px',
  height: '24px',
  borderRadius: '12px',
  '&::after': {
    width: '19.2px',
    height: '19.2px',
    margin: '2.4px'
  }
};
var disabled$1 = {
  cursor: '',
  ':hover': {},
  backgroundColor: _wcImport4.secondary[20]
};
var toggleLabelVariants = {
  small: Object.assign({}, smallLabel, labelStyle, {
    '&::after': Object.assign({}, labelStyle['&::after'], smallLabel['&::after'])
  }),
  smallDisabled: Object.assign({}, smallLabel, labelStyle, disabled$1, {
    '&::after': Object.assign({}, labelStyle['&::after'], smallLabel['&::after'])
  }),
  large: Object.assign({}, largeLabel, labelStyle, {
    '&::after': Object.assign({}, labelStyle['&::after'], largeLabel['&::after'])
  }),
  largeDisabled: Object.assign({}, largeLabel, labelStyle, disabled$1, {
    '&::after': Object.assign({}, labelStyle['&::after'], largeLabel['&::after'])
  })
};

// input variants
var inputStyle$1 = {
  opacity: 0,
  zIndex: 1,
  '&:checked + label': {
    backgroundColor: _wcImport4.primary[60],
    // ':focus-visible': {
    //     outline: 'none',
    //     boxShadow: '0 0 0 2px #982ea980',
    // },
    ':hover': {
      backgroundColor: _wcImport4.primary[70]
    },
    '&::after': {
      content: '""',
      display: 'block',
      borderRadius: '50%',
      transition: '0.2s'
    }
  }
};
var inputVariants = {
  small: Object.assign({}, inputStyle$1, {
    '&:focus-visible&:not(:checked) + label': {
      outline: 'none',
      boxShadow: "0 0 0 2px ".concat(_wcImport4.neutral[30])
    },
    '&:focus-visible + label': {
      outline: 'none',
      boxShadow: '0 0 0 2px #982ea980' //@TODO wtf?
    },
    '&:checked + label': Object.assign({}, inputStyle$1['&:checked + label'], {
      '&::after': Object.assign({
        marginLeft: '18px'
      }, inputStyle$1['&:checked + label']['&::after'])
    })
  }),
  large: Object.assign({}, inputStyle$1, {
    '&:focus-visible&:not(:checked) + label': {
      outline: 'none',
      boxShadow: "0 0 0 2px ".concat(_wcImport4.neutral[30])
    },
    '&:focus-visible + label': {
      outline: 'none',
      boxShadow: '0 0 0 2.4px #982ea980'
    },
    '&:checked + label': Object.assign({}, inputStyle$1['&:checked + label'], {
      '&::after': Object.assign({
        marginLeft: '26px'
      }, inputStyle$1['&:checked + label']['&::after'])
    })
  })
};
var _wcImport18 = {
  svgToggleVariants: svgToggleVariants,
  toggleLabelVariants: toggleLabelVariants,
  inputVariants: inputVariants
};

var timing = [100, 300, 500, 1000, 1500, 10000];
timing.debug = timing[5];
timing.slow = timing[3];
timing.medium = timing[2];
timing.quick = timing[1];
timing.flash = timing[0];
timing.ease = 'ease-in-out';
timing.easeOut = 'cubic-bezier(0.09, 0.4, 0, 0.9)';
timing.touchDecay = timing.medium;
var _wcImport17 = timing;

// Base Styling ====================
var wrapperBaseStyling = {
  position: 'relative',
  verticalAlign: 'middle',
  width: '40px',
  display: 'block'
};
var mediumSVGStyle = {
  '& > input': {
    '& ~ .toggle-svg-container': {
      position: 'absolute',
      top: '4px',
      right: '6px',
      '& > svg': {
        width: '12px',
        height: '12px'
      }
    }
  },
  '& > input:checked': {
    '& ~ .toggle-svg-container': {
      position: 'absolute',
      top: '2px',
      right: '20px',
      '& > svg': {
        width: '16px',
        height: '16px'
      }
    }
  }
};
var largeSVGStyle = {
  '& > input': {
    '& ~ .toggle-svg-container': {
      position: 'absolute',
      top: '6px',
      right: '6px',
      '& > svg': {
        width: '12px',
        height: '12px'
      }
    }
  },
  '& > input:checked': {
    '& ~ .toggle-svg-container': {
      position: 'absolute',
      top: '4px',
      right: '25px',
      '& > svg': {
        width: '16px',
        height: '16px'
      }
    }
  }
};
var styledInputBase = {
  position: 'absolute',
  top: '0px',
  left: '0px',
  pointerEvents: 'none'
};
var hiddenInputBase = {
  opacity: 0,
  zIndex: 1,
  cursor: 'pointer',
  position: 'absolute',
  top: 0,
  left: 0,
  '&:disabled': {
    cursor: 'not-allowed'
  }
};
var afterStyling = {
  content: '""',
  display: 'block',
  borderRadius: '50%',
  backgroundColor: _wcImport4.neutral[0],
  transition: '0.2s'
};

// Color Styling ====================
var disabledStyle = {
  '&:disabled + div': {
    backgroundColor: _wcImport4.neutral[30],
    '&:hover': {
      backgroundColor: _wcImport4.neutral[30]
    }
  }
};
var purpleStyle$1 = Object.assign({
  '& + div': {
    backgroundColor: _wcImport4.neutral[80]
  },
  '&:hover + div': {
    backgroundColor: _wcImport4.neutral[100]
  },
  '&:checked + div': {
    backgroundColor: _wcImport4.primary[60]
    // ':focus-visible': {
    //     outline: 'none',
    //     boxShadow: '0 0 0 2px #982ea980',
    // },
  },
  '&:checked:hover + div': {
    backgroundColor: _wcImport4.primary[70]
  }
}, disabledStyle);

// Size Styling ====================
var mediumDisplay = {
  width: '40px',
  height: '20px',
  borderRadius: '12px',
  '&::after': {
    width: '14px',
    height: '14px',
    margin: '3px'
  }
};
var largeDisplay = {
  width: '48px',
  height: '24px',
  borderRadius: '12px',
  '&::after': {
    width: '18px',
    height: '18px',
    margin: '3px'
  }
};

// Text styling ==============
var labelBaseStyling = {
  fontFamily: openSans(),
  fontSize: 'medium',
  fontWeight: '400',
  lineHeight: '24px',
  letterSpacing: '0px'
};

// Variants ======================
var hiddenInputVariants = {
  medium: Object.assign({}, hiddenInputBase, {
    width: '29px',
    '& + .toggle-svg-container': {
      position: 'absolute'
    },
    '& + div::after': Object.assign({}, afterStyling),
    '&:focus-visible&:not(:checked) + div': {
      outline: 'none',
      boxShadow: "0 0 0 2px ".concat(_wcImport4.neutral[30])
    },
    '&:focus-visible + div': {
      outline: 'none',
      boxShadow: '0 0 0 2px #982ea980' //@TODO wtf?
    },
    '&:checked + div': Object.assign({}, hiddenInputBase['&:checked + div']),
    '&:checked + div::after': {
      margin: '3px 3px 3px 22px'
    }
  }),
  large: Object.assign({}, hiddenInputBase, {
    width: '40px',
    '& + div::after': Object.assign({}, afterStyling),
    '&:focus-visible&:not(:checked) + div': {
      outline: 'none',
      boxShadow: "0 0 0 2px ".concat(_wcImport4.neutral[30])
    },
    '&:focus-visible + div': {
      outline: 'none',
      boxShadow: '0 0 0 2.4px #982ea980'
    },
    '&:checked + div': Object.assign({}, hiddenInputBase['&:checked + div']),
    '&:checked + div::after': {
      margin: '3px 3px 3px 26px'
    }
  })
};
var displayColorVariant$1 = {
  purple: Object.assign({}, purpleStyle$1)
};
var displaySizeVariant$1 = {
  medium: Object.assign({}, styledInputBase, mediumDisplay),
  large: Object.assign({}, styledInputBase, largeDisplay)
};
var switchInputContainerVariant$1 = {
  medium: Object.assign({}, wrapperBaseStyling, mediumSVGStyle, {
    width: '40px',
    height: '20px'
  }),
  large: Object.assign({}, wrapperBaseStyling, largeSVGStyle, {
    width: '48px',
    height: '24px'
  })
};
var switchLabelVariant$1 = {
  medium: Object.assign({}, labelBaseStyling, {
    fontSize: "".concat(typography.labelMd.size, "px"),
    lineHeight: "".concat(typography.labelMd.lineHeight, "px")
  }),
  large: Object.assign({}, labelBaseStyling, {
    fontSize: "".concat(typography.labelMd.size, "px"),
    lineHeight: "".concat(typography.labelMd.lineHeight, "px")
  })
};
var _wcImport16 = {
  hiddenInputVariants: hiddenInputVariants,
  displayColorVariant: displayColorVariant$1,
  displaySizeVariant: displaySizeVariant$1,
  switchInputContainerVariant: switchInputContainerVariant$1,
  switchLabelVariant: switchLabelVariant$1
};

var space = [0, 8, 12, 24, 32, 64, 128];
space.none = space[0];
space.small = space[1];
space.medium = space[3];
space.large = space[4];
space.extraLarge = space[5];
space.largest = space[6];
space.tiny = 3.0;
space.extraSmall = 5.0;
space.em = space[2];
space.tinyNegative = space.tiny * -1;
space.smallNegative = space.small * -1;
space.emNegative = space.em * -1;
space.mediumNegative = space.medium * -1;
space.largeNegative = space.large * -1;
var _wcImport15 = space;

var pxUnits = function pxUnits(v) {
  return "".concat(v, "px");
};

var color = '53, 53, 53';
var settings = {
  small: {
    offset: 4,
    size: 8,
    opacity: 0.2
  },
  medium: {
    offset: 12,
    size: 32,
    opacity: 0.24
  },
  large: {
    offset: 24,
    size: 40,
    opacity: 0.16
  }
};
var getOffset = function getOffset(offset, direction) {
  switch (direction) {
    case 'down':
      return "0 ".concat(pxUnits(offset));
    case 'up':
      return "0 -".concat(pxUnits(offset));
    case 'left':
      return "-".concat(pxUnits(offset), " 0");
    case 'right':
      return "".concat(pxUnits(offset), " 0");
    default:
      return '0 0';
  }
};
var getShadow = function getShadow(direction, size) {
  var shadow = settings[size];
  return "".concat(getOffset(shadow.offset, direction), " ").concat(pxUnits(shadow.size), " rgba(").concat(color, ", ").concat(shadow.opacity, ")");
};
var shadows = {
  // Small
  small: getShadow('down', 'small'),
  smallDown: getShadow('down', 'small'),
  smallUp: getShadow('up', 'small'),
  smallLeft: getShadow('left', 'small'),
  smallRight: getShadow('right', 'small'),
  // Medium
  medium: getShadow('down', 'medium'),
  mediumDown: getShadow('down', 'medium'),
  mediumUp: getShadow('up', 'medium'),
  mediumLeft: getShadow('left', 'medium'),
  mediumRight: getShadow('right', 'medium'),
  // Large
  large: getShadow('down', 'large'),
  largeDown: getShadow('down', 'large'),
  largeUp: getShadow('up', 'large'),
  largeLeft: getShadow('left', 'large'),
  largeRight: getShadow('right', 'large')
};
var _wcImport14 = shadows;

var sizeVariants$5 = {
  medium: {
    width: '16px',
    height: '16px'
  },
  large: {
    width: '20px',
    height: '20px'
  }
};
var disabledStyling = {
  '&:disabled': {
    cursor: 'not-allowed',
    '& ~ div': {
      backgroundColor: _wcImport4.neutral[0],
      borderColor: _wcImport4.neutral[30]
    },
    '&:hover ~ div': {
      backgroundColor: _wcImport4.neutral[0],
      borderColor: _wcImport4.neutral[30]
    },
    '&:checked ~ div': {
      backgroundColor: _wcImport4.neutral[0],
      borderColor: _wcImport4.neutral[30],
      '&::after': {
        backgroundColor: _wcImport4.neutral[30]
      }
    },
    '&:checked:hover ~ div': {
      backgroundColor: _wcImport4.neutral[0],
      borderColor: _wcImport4.neutral[30],
      '&::after': {
        backgroundColor: _wcImport4.neutral[30]
      }
    }
  }
};
var colorVariants$5 = {
  purple: Object.assign({
    '& ~ div': {
      display: 'block',
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: _wcImport4.neutral[60]
    },
    '&:hover ~ div': {
      backgroundColor: _wcImport4.primary[10],
      borderColor: _wcImport4.primary[60]
    },
    '&:checked ~ div': {
      backgroundColor: _wcImport4.neutral[0],
      borderColor: _wcImport4.primary[60],
      '&::after': {
        backgroundColor: _wcImport4.primary[60]
      }
    },
    '&:checked:hover ~ div': {
      backgroundColor: _wcImport4.neutral[0],
      borderColor: _wcImport4.primary[70],
      '&::after': {
        backgroundColor: _wcImport4.primary[70]
      }
    }
  }, disabledStyling),
  error: Object.assign({
    '& ~ div': {
      display: 'block',
      borderWidth: '2px',
      borderStyle: 'solid',
      backgroundColor: _wcImport4.alert.light,
      borderColor: _wcImport4.alert.base
    },
    '&:hover ~ div': {
      backgroundColor: _wcImport4.alert.light,
      borderColor: _wcImport4.alert.base
    },
    '&:checked ~ div': {
      backgroundColor: _wcImport4.alert.light,
      borderColor: _wcImport4.alert.base,
      '&::after': {
        backgroundColor: _wcImport4.alert.base
      }
    }
  }, disabledStyling)
};
var radioContainerSizeVariant = {
  medium: {
    width: '20px',
    height: '20px'
  },
  large: {
    width: '24px',
    height: '24px'
  }
};
var textStyleVariant$1 = {
  error: {
    '& > .helpers__CaptionText-bTLjQV': {
      color: _wcImport4.alert.text
    }
  },
  disabled: {
    color: _wcImport4.neutral[40]
  },
  "default": {
    color: _wcImport4.neutral[100]
  }
};
var _wcImport13 = {
  sizeVariants: sizeVariants$5,
  colorVariants: colorVariants$5,
  radioContainerSizeVariant: radioContainerSizeVariant,
  textStyleVariant: textStyleVariant$1
};

var radii = {
  small: pxUnits(2)
};
var _wcImport12 = radii;

var svg = {
  rating: {
    width: '70px',
    height: '70px',
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 70 70'
  }
};
var group = {
  rating: {
    transform: 'rotate(-90deg) translate(-70px, 0px)'
  }
};
var circleStyle = {
  fill: 'transparent',
  strokeLinecap: 'butt',
  strokeWidth: '8px'
};
var circle = {
  rating: Object.assign({}, circleStyle, {
    stroke: _wcImport4.primary[60]
  }),
  ratingBackground: Object.assign({}, circleStyle, {
    stroke: _wcImport4.neutral[10]
  })
};
var label = {
  rating: {
    width: '70px',
    height: '70px',
    position: 'absolute',
    zIndex: '1',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex'
  }
};
var _wcImport11 = {
  svg: svg,
  circle: circle,
  group: group,
  label: label
};

var paddingVariants = {
  none: {
    padding: pxUnits(0)
  },
  tiny: {
    padding: pxUnits(3)
  },
  small: {
    padding: pxUnits(8)
  },
  medium: {
    padding: pxUnits(16)
  },
  large: {
    padding: pxUnits(32)
  }
};
var _wcImport10 = paddingVariants;

var small = {
  width: 16,
  height: 16,
  color: '#2A4473'
};
var loaderAnimation = {
  animation: 'rotate 1.5s steps(8) infinite',
  '@keyframes rotate': {
    '100%': {
      transform: 'rotate(360deg)'
    }
  }
};
var buttonLoaderVariant = {
  small: Object.assign({}, small, loaderAnimation)
};
var _wcImport9 = {
  buttonLoaderVariant: buttonLoaderVariant
};

var list = {
  bullet: {
    pl: '2px',
    my: '0px'
  },
  icon: {
    pl: '0px'
  }
};
var item = {
  bullet: {
    listStyle: 'none',
    display: 'flex',
    ':before': {
      content: "'·'",
      fontSize: '54px',
      verticalAlign: 'middle',
      lineHeight: '24px',
      pt: '1px',
      pr: '2px'
    }
  },
  icon: {
    pl: '0px',
    pb: '16px',
    display: 'flex'
  }
};
var _wcImport8 = {
  list: list,
  item: item
};

var defaultStyling = {
  color: "".concat(_wcImport4.primary[60], " !important"),
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  textDecoration: 'underline',
  '&:link': {
    color: "".concat(_wcImport4.primary[60], " !important")
  },
  'div > svg': {
    path: {
      fill: _wcImport4.primary[60]
    }
  }
};
var hoverStyling = {
  color: "".concat(_wcImport4.primary[80], " !important"),
  textDecoration: 'underline !important',
  'div > svg': {
    path: {
      fill: _wcImport4.primary[80]
    }
  }
};
var visitedStyling = {
  color: "".concat(_wcImport4.secondary[70], " !important"),
  'div > svg': {
    path: {
      fill: _wcImport4.secondary[70]
    }
  }
};
var linkVariants = {
  standalone: Object.assign({}, defaultStyling, {
    fontWeight: 600,
    '& > div': {
      margin: '0 0 0 6px'
    },
    '&:hover': Object.assign({}, hoverStyling, {
      color: "".concat(_wcImport4.primary[60], " !important"),
      'div > svg': {
        path: {
          fill: _wcImport4.primary[60]
        }
      }
    }),
    '&:active': Object.assign({}, hoverStyling, {
      color: "".concat(_wcImport4.primary[60], " !important"),
      'div > svg': {
        path: {
          fill: _wcImport4.primary[60]
        }
      }
    }),
    '&:visited': Object.assign({}, visitedStyling)
  }),
  inline: Object.assign({}, defaultStyling, {
    '&:hover': Object.assign({}, hoverStyling),
    '&:active': Object.assign({}, hoverStyling),
    '&:visited': Object.assign({}, visitedStyling)
  })
};
var _wcImport7 = {
  linkVariants: linkVariants
};

var iconVariants = {
  iconContainer: {
    svg: {
      display: 'block'
    },
    height: 'auto'
  }
};
var _wcImport6 = {
  iconVariants: iconVariants
};

var defaultGridSize = 8;
var defaultSpacing = {
  _: defaultGridSize,
  lg: defaultGridSize * 1.5
};
var defaultSpacingSmall = pxUnits(defaultGridSize);
var defaultSpacingLarge = pxUnits(defaultGridSize * 1.5);
var defaultLayout = 'fluid';

var gutters = {};

// aliases
gutters.xs = defaultSpacingSmall;
gutters.sm = defaultSpacingSmall;
gutters.md = defaultSpacingLarge;
gutters.lg = defaultSpacingLarge;
gutters.xl = defaultSpacingLarge;
var _wcImport5 = gutters;

// Checkbox Container ========================
var hiddenInputStyle = {
  opacity: 0,
  zIndex: 1,
  cursor: 'pointer',
  width: '100%',
  height: '100%',
  display: 'block',
  margin: '0'
};
var containerStyle = {
  display: 'inline-block',
  verticalAlign: 'middle',
  position: 'relative',
  '& > input': Object.assign({}, hiddenInputStyle, {
    '&:disabled': {
      cursor: 'not-allowed'
    }
  })
};
var styledInputStyle = {
  display: 'inline-block',
  position: 'absolute',
  top: 0,
  left: 0,
  borderRadius: '3px',
  transition: 'all 150ms',
  pointerEvents: 'none',
  zIndex: 1,
  background: _wcImport4.neutral[0],
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: _wcImport4.neutral[50]
};

//  Colors ==============================
var blueStyle = {
  '&:checked + div': {
    background: _wcImport4.secondary[60],
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: _wcImport4.secondary[60]
  },
  '&:hover&:checked + div': {
    background: _wcImport4.secondary[80],
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: _wcImport4.secondary[80]
  },
  '&:hover:not(:checked) + div': {
    background: _wcImport4.secondary[10],
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: _wcImport4.secondary[60]
  }
};
var purpleStyle = {
  '&:checked + div': {
    background: _wcImport4.primary[60],
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: _wcImport4.primary[60]
  },
  '&:hover&:checked + div': {
    background: _wcImport4.primary[70],
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: _wcImport4.primary[70]
  },
  '&:hover:not(:checked) + div': {
    background: _wcImport4.primary[10],
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: _wcImport4.primary[60]
  }
};

//  Error Styling =======================
var errorStyle = {
  '&:not(:checked) + div': {
    background: _wcImport4.alert.light,
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: _wcImport4.alert.base
  },
  '&:checked + div': {
    background: _wcImport4.alert.base,
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: _wcImport4.alert.base
  },
  '&:hover&:checked + div': {
    background: 'primary[70]',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: _wcImport4.alert.base
  },
  '&:hover:not(:checked) + div': {
    background: 'primary[20]',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: _wcImport4.alert.base
  }
};

// Disabled Styling ===========================
var disabledNotChecked = {
  background: _wcImport4.neutral[0],
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: _wcImport4.neutral[30]
};
var disabledChecked = {
  background: _wcImport4.neutral[30],
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: _wcImport4.neutral[30]
};
var disabledContainerStyling = {
  '&:disabled': {
    '&:checked + div': Object.assign({}, disabledChecked),
    '&:not(:checked) + div': Object.assign({}, disabledNotChecked),
    '&:hover&:checked + div': Object.assign({}, disabledChecked),
    '&:hover:not(:checked) + div': Object.assign({}, disabledNotChecked)
  }
};

// Variants =============================
// Container

var containerVariant$1 = {
  smallContainerVariant: Object.assign({}, containerStyle, {
    width: '16px',
    height: '16px',
    '& > .styled-check': {
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 3,
      top: '0px',
      left: '0px'
    }
  }),
  mediumContainerVariant: Object.assign({}, containerStyle, {
    width: '20px',
    height: '20px',
    '& > .styled-check': {
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 3,
      top: '0px',
      left: '0px'
    }
  }),
  largeContainerVariant: Object.assign({}, containerStyle, {
    width: '24px',
    height: '24px',
    '& > .styled-check': {
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 3,
      top: '2px',
      left: '2px'
    }
  })
};

// Colors
var colorVariants$4 = {
  purple: Object.assign({}, purpleStyle, disabledContainerStyling),
  blue: Object.assign({}, blueStyle, disabledContainerStyling),
  error: Object.assign({}, errorStyle)
};
// Sizes
var checkboxSizeVariants = {
  small: Object.assign({}, styledInputStyle, {
    width: '12px',
    height: '12px'
  }),
  medium: Object.assign({}, styledInputStyle, {
    width: '16px',
    height: '16px'
  }),
  large: Object.assign({}, styledInputStyle, {
    width: '20px',
    height: '20px'
  })
};
var textStyleVariant = {
  error: {
    '& > .styled-checkbox-input': {
      color: _wcImport4.alert.text
    }
  },
  disabled: {
    color: _wcImport4.neutral[40]
  },
  "default": {
    color: _wcImport4.neutral[100]
  }
};

// Exports ==============================
var _wcImport3 = {
  containerVariant: containerVariant$1,
  colorVariants: colorVariants$4,
  checkboxSizeVariants: checkboxSizeVariants,
  textStyleVariant: textStyleVariant
};

var globalButtonStyle = {
  '-webkit-tap-highlight-color': 'transparent',
  '&:focus:not(:focus-visible)': {
    outline: 'none'
  },
  alignItems: 'baseline',
  borderWidth: 0,
  borderRadius: '4px',
  boxSizing: 'border-box',
  cursor: 'pointer',
  display: 'inline-flex',
  fontStyle: 'normal',
  // Chrome recently changed button so that they use 'arial' as the font family
  fontFamily: 'inherit',
  fontWeight: 600,
  justifyContent: 'center',
  maxWidth: '100%',
  position: 'relative',
  textAlign: 'center',
  textDecoration: 'none',
  transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
  whiteSpace: 'nowrap',
  '&:hover': {
    transitionDuration: '0s, 0.15s'
  },
  '&:focus': {
    transitionDuration: '0s, 0.2s'
  },
  '&:active': {
    // background, box-shadow
    transitionDuration: '0s, 0s'
  },
  // preventDefault prevents regular active styles from applying in Firefox
  '&[data-firefox-is-active="true"]': {
    transitionDuration: '0s, 0s'
  },
  '&::-moz-focus-inner': {
    border: 0,
    margin: 0,
    padding: 0
  }
};

// STYLING
var primary = Object.assign({}, globalButtonStyle, {
  bg: _wcImport4.primary[60],
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: _wcImport4.primary[60],
  color: _wcImport4.neutral[0],
  '&:active': {
    bg: _wcImport4.primary[70],
    outline: 'none'
  },
  '@media(hover: hover) and (pointer: fine)': {
    '&:hover': {
      /* Targeting devices with mouse cursor and :hover */
      bg: _wcImport4.primary[70]
    }
  }
});
var secondary = Object.assign({}, globalButtonStyle, {
  bg: _wcImport4.neutral[0],
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: _wcImport4.secondary[80],
  color: _wcImport4.secondary[80],
  '&:active': {
    bg: _wcImport4.secondary[10],
    outline: 'none'
  },
  '@media(hover: hover) and (pointer: fine)': {
    '&:hover': {
      /* Targeting devices with mouse cursor and :hover */
      bg: _wcImport4.secondary[10]
    }
  }
});
var primaryText = Object.assign({}, globalButtonStyle, {
  bg: _wcImport4.neutral[0],
  borderWidth: 0,
  color: _wcImport4.primary[60],
  '&:active': {
    bg: _wcImport4.primary[10],
    outline: 'none'
  },
  '@media(hover: hover) and (pointer: fine)': {
    '&:hover': {
      /* Targeting devices with mouse cursor and :hover */
      bg: _wcImport4.primary[10]
    }
  }
});
var secondaryText = Object.assign({}, globalButtonStyle, {
  bg: _wcImport4.neutral[0],
  borderWidth: 0,
  // outline: 'none !important',
  color: _wcImport4.secondary[80],
  '&:active': {
    bg: _wcImport4.secondary[10],
    outline: 'none'
  },
  '@media(hover: hover) and (pointer: fine)': {
    '&:hover': {
      /* Targeting devices with mouse cursor and :hover */
      bg: _wcImport4.secondary[10]
    }
  }
});
var globalDisabled = {
  cursor: 'not-allowed',
  'span > div > svg': {
    path: {
      fill: _wcImport4.neutral[40]
    }
  }
};
var primaryLink = Object.assign({}, globalButtonStyle, {
  bg: _wcImport4.neutral[0],
  borderWidth: 0,
  color: _wcImport4.primary[60],
  '&:active': {
    outline: 'none',
    color: _wcImport4.primary[80],
    textDecoration: 'underline'
  },
  '&:visited': {
    color: _wcImport4.secondary[70],
    textDecoration: 'underline'
  },
  '@media(hover: hover) and (pointer: fine)': {
    '&:hover': {
      /* Targeting devices with mouse cursor and :hover */
      color: _wcImport4.primary[80],
      textDecoration: 'underline'
    }
  },
  'div > svg': {
    path: {
      fill: _wcImport4.primary[60]
    }
  }
});
var secondaryLink = Object.assign({}, globalButtonStyle, {
  bg: _wcImport4.neutral[0],
  borderWidth: 0,
  color: _wcImport4.secondary[70],
  '&:active': {
    outline: 'none',
    textDecoration: 'underline'
  },
  '@media(hover: hover) and (pointer: fine)': {
    '&:hover': {
      /* Targeting devices with mouse cursor and :hover */
      textDecoration: 'underline'
    }
  },
  'div > svg': {
    path: {
      fill: _wcImport4.secondary[70]
    }
  }
});
var disabled = Object.assign({
  bg: _wcImport4.neutral[20],
  borderColor: _wcImport4.neutral[20],
  color: _wcImport4.neutral[0]
}, globalDisabled);
var disabledSecondary = Object.assign({
  bg: _wcImport4.neutral[0],
  borderColor: _wcImport4.neutral[30],
  color: _wcImport4.neutral[30]
}, globalDisabled);
var disabledText = Object.assign({
  bg: _wcImport4.neutral[0],
  color: _wcImport4.neutral[30]
}, globalDisabled);

// VARIANTS
var buttonVariants = {
  primary: Object.assign({}, primary, {
    '&:disabled': Object.assign({}, disabled)
  }),
  secondary: Object.assign({}, secondary, {
    '&:disabled': Object.assign({}, disabledSecondary)
  }),
  primaryText: Object.assign({}, primaryText, {
    '&:disabled': Object.assign({}, disabledText)
  }),
  secondaryText: Object.assign({}, secondaryText, {
    '&:disabled': Object.assign({}, disabledText)
  }),
  primaryLink: Object.assign({}, primaryLink, {
    '&:disabled': Object.assign({}, disabledText)
  }),
  secondaryLink: Object.assign({}, secondaryLink, {
    '&:disabled': Object.assign({}, disabledText)
  })
};
var baseText = function baseText(size, lineHeight) {
  return {
    fontSize: "".concat(size / baseFontSize(), "rem"),
    lineHeight: lineHeight / size
  };
};
var sizeVariants$4 = {
  smallLink: Object.assign({}, baseText(12, 14)),
  mediumLink: Object.assign({}, baseText(14, 18)),
  largeLink: Object.assign({}, baseText(16, 20)),
  small: Object.assign({}, baseText(_wcImport19.typography.labelMd.size, _wcImport19.typography.labelMd.lineHeight), {
    padding: '7px 16px'
  }),
  medium: Object.assign({}, baseText(_wcImport19.typography.labelMd.size, _wcImport19.typography.labelMd.lineHeight), {
    padding: '11px 16px'
  }),
  large: Object.assign({}, baseText(_wcImport19.typography.labelLg.size, _wcImport19.typography.labelLg.lineHeight), {
    padding: '14px 28px'
  })
};
var _wcImport2 = {
  buttonVariants: buttonVariants,
  sizeVariants: sizeVariants$4
};

var breakpoints = ['360px', '600px', '905px', '1240px', '1440px', '576px', '768px', '992px', '1200px'];

// aliases
breakpoints.xs = breakpoints[0];
breakpoints.sm = breakpoints[1];
breakpoints.md = breakpoints[2];
breakpoints.lg = breakpoints[3];
breakpoints.xl = breakpoints[4];
breakpoints.oldxs = breakpoints[0];
breakpoints.oldsm = breakpoints[5];
breakpoints.oldmd = breakpoints[6];
breakpoints.oldlg = breakpoints[7];
breakpoints.oldxl = breakpoints[8];
var _wcImport = breakpoints;

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var _excluded$m = ["variant", "buttonType"];
var colorMapper = {
  primary: 'white',
  secondary: '#2A4473',
  primaryText: '#982EA9',
  secondaryText: '#2A4473',
  primaryLink: '#982EA9'
};
var loaderSize = variant({
  prop: 'variant',
  scale: 'loaders.buttonLoaderVariant',
  variants: {
    // need one member to enable theming
    "default": {}
  }
});
var styleProps$e = compose(layout, space$1, color$1, loaderSize);
var StyledSpinner = /*#__PURE__*/styled.svg.withConfig({
  displayName: "ButtonLoader__StyledSpinner",
  componentId: "sc-ak388h-0"
})(["", ""], styleProps$e);
var ButtonLoader = function ButtonLoader(_ref) {
  var variant = _ref.variant,
    buttonType = _ref.buttonType,
    others = _objectWithoutProperties(_ref, _excluded$m);
  var _color = colorMapper[buttonType];
  return /*#__PURE__*/jsx(StyledSpinner, Object.assign({
    viewBox: "0 0 16 16",
    height: "50px",
    width: "50px",
    variant: variant
  }, others, {
    children: /*#__PURE__*/jsxs("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/jsx("path", {
        d: "M8 1.33334V4",
        stroke: _color,
        strokeOpacity: "0.7",
        strokeWidth: "1.33333",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/jsx("path", {
        d: "M8 12V14.6667",
        stroke: _color,
        strokeOpacity: "0.3",
        strokeWidth: "1.33333",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/jsx("path", {
        d: "M3.28662 3.28667L5.17329 5.17333",
        stroke: _color,
        strokeOpacity: "0.6",
        strokeWidth: "1.33333",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/jsx("path", {
        d: "M10.8267 10.8267L12.7133 12.7133",
        stroke: _color,
        strokeWidth: "1.33333",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/jsx("path", {
        d: "M1.33325 8H3.99992",
        stroke: _color,
        strokeOpacity: "0.5",
        strokeWidth: "1.33333",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/jsx("path", {
        d: "M12 8H14.6667",
        stroke: _color,
        strokeOpacity: "0.9",
        strokeWidth: "1.33333",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/jsx("path", {
        d: "M3.28662 12.7133L5.17329 10.8267",
        stroke: _color,
        strokeOpacity: "0.4",
        strokeWidth: "1.33333",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/jsx("path", {
        d: "M10.8267 5.17333L12.7133 3.28667",
        stroke: _color,
        strokeOpacity: "0.8",
        strokeWidth: "1.33333",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    })
  }));
};
ButtonLoader.defaultProps = {
  variant: 'small'
};

function noop$1() {}
var buttonVariant = variant({
  prop: 'variant',
  scale: 'button.buttonVariants',
  variants: {
    "default": {}
  }
});
var sizeVariant$1 = variant({
  prop: 'size',
  scale: 'button.sizeVariants',
  variants: {
    "default": {}
  }
});
var styleProps$d = compose(background, display, flexbox, margin, padding, position, flex, flexDirection, shadow, typography$1, space$1, border, width, height, minWidth, minHeight, maxWidth, maxHeight, display, verticalAlign, overflow, overflowX, overflowY, buttonVariant, sizeVariant$1);
var styledSpanProps = compose(space$1, layout, color$1, typography$1);
var StyledButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-2l8x3r-0"
})(["", ""], styleProps$d);
var Icon$2 = /*#__PURE__*/styled('span').withConfig({
  displayName: "Button__Icon",
  componentId: "sc-2l8x3r-1"
})(["", " ", ""], styledCss({
  alignSelf: 'center',
  display: 'flex',
  flexGrow: 0,
  flexShrink: 0,
  lineHeight: 0,
  fontSize: 0,
  userSelect: 'none'
}), styledSpanProps);
var Content = /*#__PURE__*/styled.span.withConfig({
  displayName: "Button__Content",
  componentId: "sc-2l8x3r-2"
})({
  alignSelf: 'center',
  flexGrow: 'unset',
  flexShrink: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}, function (_ref) {
  var stretchContent = _ref.stretchContent;
  return {
    flexGrow: stretchContent ? 'unset' : 1
  };
}, styledSpanProps);
var standaloneLinkSizeMap = {
  small: 'smallLink',
  medium: 'mediumLink',
  large: 'largeLink'
};
var Button = /*#__PURE__*/forwardRef(function (_a,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref) {
  var _a$variant = _a.variant,
    variant = _a$variant === void 0 ? 'primary' : _a$variant,
    _a$size = _a.size,
    size = _a$size === void 0 ? 'small' : _a$size,
    testId = _a.testId,
    id = _a.id,
    fixedWidth = _a.fixedWidth,
    disabled = _a.disabled,
    children = _a.children,
    _a$onPress = _a.onPress,
    onPress = _a$onPress === void 0 ? noop$1 : _a$onPress,
    leftIcon = _a.leftIcon,
    rightIcon = _a.rightIcon,
    _a$isLoading = _a.isLoading,
    isLoading = _a$isLoading === void 0 ? false : _a$isLoading,
    _a$isActive = _a.isActive,
    isActive = _a$isActive === void 0 ? false : _a$isActive,
    _a$stretchContent = _a.stretchContent,
    stretchContent = _a$stretchContent === void 0 ? false : _a$stretchContent,
    rest = __rest(_a, ["variant", "size", "testId", "id", "fixedWidth", "disabled", "children", "onPress", "leftIcon", "rightIcon", "isLoading", "isActive", "stretchContent"]);
  var buttonWidth = fixedWidth ? fixedWidth > 0 ? "".concat(fixedWidth, "px") : 'auto' : 'auto';
  var buttonSizeVariant = size;
  if (variant === 'primaryLink' || variant === 'secondaryLink') {
    buttonSizeVariant = standaloneLinkSizeMap[size];
  }
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore-next-line
    jsxs(StyledButton, Object.assign({
      ref: ref,
      "data-testid": testId,
      id: id,
      disabled: disabled,
      variant: variant,
      size: buttonSizeVariant,
      isActive: isActive,
      tabIndex: 0,
      width: buttonWidth
    }, rest, {
      onTouchStart: function onTouchStart() {
        return null;
      },
      onClick: function onClick(e) {
        if (disabled) {
          return;
        }
        if (onPress) {
          onPress(e);
        }
      }
    }, {
      children: [leftIcon && !isLoading && jsx(Icon$2, Object.assign({
        mr: "6px"
      }, {
        children: leftIcon
      }), void 0), isLoading && jsx(ButtonLoader, {
        mr: "small",
        variant: size,
        buttonType: variant
      }, void 0), jsx(Content, Object.assign({
        stretchContent: stretchContent
      }, {
        children: children
      }), void 0), rightIcon && jsx(Icon$2, Object.assign({
        ml: "6px"
      }, {
        children: rightIcon
      }), void 0)]
    }), void 0)
  );
});
Button.displayName = 'Button';
var Button$1 = Button;

var wellKnownSymbol$j = wellKnownSymbol$l;

var TO_STRING_TAG$3 = wellKnownSymbol$j('toStringTag');
var test = {};

test[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var global$v = global$Q;
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$c = isCallable$m;
var classofRaw = classofRaw$1;
var wellKnownSymbol$i = wellKnownSymbol$l;

var TO_STRING_TAG$2 = wellKnownSymbol$i('toStringTag');
var Object$2 = global$v.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$7 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object$2(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$c(O.callee) ? 'Arguments' : result;
};

var global$u = global$Q;
var classof$6 = classof$7;

var String$4 = global$u.String;

var toString$e = function (argument) {
  if (classof$6(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String$4(argument);
};

// a string of all valid unicode whitespaces
var whitespaces$3 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$l = functionUncurryThis;
var requireObjectCoercible$8 = requireObjectCoercible$b;
var toString$d = toString$e;
var whitespaces$2 = whitespaces$3;

var replace$7 = uncurryThis$l(''.replace);
var whitespace = '[' + whitespaces$2 + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$2 = function (TYPE) {
  return function ($this) {
    var string = toString$d(requireObjectCoercible$8($this));
    if (TYPE & 1) string = replace$7(string, ltrim, '');
    if (TYPE & 2) string = replace$7(string, rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$2(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$2(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$2(3)
};

var global$t = global$Q;
var fails$g = fails$n;
var uncurryThis$k = functionUncurryThis;
var toString$c = toString$e;
var trim = stringTrim.trim;
var whitespaces$1 = whitespaces$3;

var $parseInt$1 = global$t.parseInt;
var Symbol$1 = global$t.Symbol;
var ITERATOR$8 = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec$6 = uncurryThis$k(hex.exec);
var FORCED$2 = $parseInt$1(whitespaces$1 + '08') !== 8 || $parseInt$1(whitespaces$1 + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$8 && !fails$g(function () { $parseInt$1(Object(ITERATOR$8)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$2 ? function parseInt(string, radix) {
  var S = trim(toString$c(string));
  return $parseInt$1(S, (radix >>> 0) || (exec$6(hex, S) ? 16 : 10));
} : $parseInt$1;

var $$c = _export;
var $parseInt = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$$c({ global: true, forced: parseInt != $parseInt }, {
  parseInt: $parseInt
});

var anObject$g = anObject$j;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$g(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var regexpStickyHelpers = {};

var fails$f = fails$n;
var global$s = global$Q;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$s.RegExp;

regexpStickyHelpers.UNSUPPORTED_Y = fails$f(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

regexpStickyHelpers.BROKEN_CARET = fails$f(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var DESCRIPTORS$4 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var anObject$f = anObject$j;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var objectDefineProperties = DESCRIPTORS$4 ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$f(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$3.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$4 = getBuiltIn$8;

var html$2 = getBuiltIn$4('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$e = anObject$j;
var defineProperties$1 = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$e(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties$1(result, Properties);
};

var fails$e = fails$n;
var global$r = global$Q;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$r.RegExp;

var regexpUnsupportedDotAll = fails$e(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var fails$d = fails$n;
var global$q = global$Q;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$q.RegExp;

var regexpUnsupportedNcg = fails$d(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$e = functionCall;
var uncurryThis$j = functionUncurryThis;
var toString$b = toString$e;
var regexpFlags = regexpFlags$1;
var stickyHelpers$2 = regexpStickyHelpers;
var shared = shared$4.exports;
var create$3 = objectCreate;
var getInternalState$3 = internalState.get;
var UNSUPPORTED_DOT_ALL$1 = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG$1 = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$7 = uncurryThis$j(''.charAt);
var indexOf = uncurryThis$j(''.indexOf);
var replace$6 = uncurryThis$j(''.replace);
var stringSlice$a = uncurryThis$j(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$e(nativeExec, re1, 'a');
  call$e(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$2 = stickyHelpers$2.UNSUPPORTED_Y || stickyHelpers$2.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$2 || UNSUPPORTED_DOT_ALL$1 || UNSUPPORTED_NCG$1;

if (PATCH) {
  // eslint-disable-next-line max-statements -- TODO
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$3(re);
    var str = toString$b(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$e(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$2 && re.sticky;
    var flags = call$e(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$6(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$a(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$7(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$e(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$a(match.input, charsAdded);
        match[0] = stringSlice$a(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      call$e(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$3(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$3 = patchedExec;

var $$b = _export;
var exec$5 = regexpExec$3;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$b({ target: 'RegExp', proto: true, forced: /./.exec !== exec$5 }, {
  exec: exec$5
});

var FunctionPrototype = Function.prototype;
var apply$3 = FunctionPrototype.apply;
var bind$8 = FunctionPrototype.bind;
var call$d = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (bind$8 ? call$d.bind(apply$3) : function () {
  return call$d.apply(apply$3, arguments);
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var uncurryThis$i = functionUncurryThis;
var redefine$8 = redefine$a.exports;
var regexpExec$2 = regexpExec$3;
var fails$c = fails$n;
var wellKnownSymbol$h = wellKnownSymbol$l;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$7;

var SPECIES$3 = wellKnownSymbol$h('species');
var RegExpPrototype$2 = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$h(KEY);

  var DELEGATES_TO_SYMBOL = !fails$c(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$c(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$3] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis$i(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$i(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$2 || $exec === RegExpPrototype$2.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine$8(String.prototype, KEY, methods[0]);
    redefine$8(RegExpPrototype$2, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty$3(RegExpPrototype$2[SYMBOL], 'sham', true);
};

var isObject$4 = isObject$a;
var classof$5 = classofRaw$1;
var wellKnownSymbol$g = wellKnownSymbol$l;

var MATCH$2 = wellKnownSymbol$g('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$4(it) && ((isRegExp = it[MATCH$2]) !== undefined ? !!isRegExp : classof$5(it) == 'RegExp');
};

var uncurryThis$h = functionUncurryThis;
var fails$b = fails$n;
var isCallable$b = isCallable$m;
var classof$4 = classof$7;
var getBuiltIn$3 = getBuiltIn$8;
var inspectSource$1 = inspectSource$4;

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn$3('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$4 = uncurryThis$h(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function (argument) {
  if (!isCallable$b(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable$b(argument)) return false;
  switch (classof$4(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec$4(constructorRegExp, inspectSource$1(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$2 = !construct || fails$b(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var global$p = global$Q;
var isConstructor$1 = isConstructor$2;
var tryToString$2 = tryToString$4;

var TypeError$b = global$p.TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor$1(argument)) return argument;
  throw TypeError$b(tryToString$2(argument) + ' is not a constructor');
};

var anObject$d = anObject$j;
var aConstructor = aConstructor$1;
var wellKnownSymbol$f = wellKnownSymbol$l;

var SPECIES$2 = wellKnownSymbol$f('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$2 = function (O, defaultConstructor) {
  var C = anObject$d(O).constructor;
  var S;
  return C === undefined || (S = anObject$d(C)[SPECIES$2]) == undefined ? defaultConstructor : aConstructor(S);
};

var uncurryThis$g = functionUncurryThis;
var toIntegerOrInfinity$3 = toIntegerOrInfinity$6;
var toString$a = toString$e;
var requireObjectCoercible$7 = requireObjectCoercible$b;

var charAt$6 = uncurryThis$g(''.charAt);
var charCodeAt$1 = uncurryThis$g(''.charCodeAt);
var stringSlice$9 = uncurryThis$g(''.slice);

var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$a(requireObjectCoercible$7($this));
    var position = toIntegerOrInfinity$3(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt$1(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt$1(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$6(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$9(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt$5 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$3 = function (S, index, unicode) {
  return index + (unicode ? charAt$5(S, index).length : 1);
};

var uncurryThis$f = functionUncurryThis;

var arraySlice$4 = uncurryThis$f([].slice);

var global$o = global$Q;
var call$c = functionCall;
var anObject$c = anObject$j;
var isCallable$a = isCallable$m;
var classof$3 = classofRaw$1;
var regexpExec$1 = regexpExec$3;

var TypeError$a = global$o.TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$a(exec)) {
    var result = call$c(exec, R, S);
    if (result !== null) anObject$c(result);
    return result;
  }
  if (classof$3(R) === 'RegExp') return call$c(regexpExec$1, R, S);
  throw TypeError$a('RegExp#exec called on incompatible receiver');
};

var apply$2 = functionApply;
var call$b = functionCall;
var uncurryThis$e = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$3 = fixRegexpWellKnownSymbolLogic;
var isRegExp$2 = isRegexp;
var anObject$b = anObject$j;
var requireObjectCoercible$6 = requireObjectCoercible$b;
var speciesConstructor$1 = speciesConstructor$2;
var advanceStringIndex$2 = advanceStringIndex$3;
var toLength$3 = toLength$5;
var toString$9 = toString$e;
var getMethod$5 = getMethod$7;
var arraySlice$3 = arraySlice$4;
var callRegExpExec = regexpExecAbstract;
var regexpExec = regexpExec$3;
var stickyHelpers$1 = regexpStickyHelpers;
var fails$a = fails$n;

var UNSUPPORTED_Y$1 = stickyHelpers$1.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min$2 = Math.min;
var $push = [].push;
var exec$3 = uncurryThis$e(/./.exec);
var push$4 = uncurryThis$e($push);
var stringSlice$8 = uncurryThis$e(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$a(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic$3('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString$9(requireObjectCoercible$6(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp$2(separator)) {
        return call$b(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call$b(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push$4(output, stringSlice$8(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply$2($push, output, arraySlice$3(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec$3(separatorCopy, '')) push$4(output, '');
      } else push$4(output, stringSlice$8(string, lastLastIndex));
      return output.length > lim ? arraySlice$3(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call$b(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible$6(this);
      var splitter = separator == undefined ? undefined : getMethod$5(separator, SPLIT);
      return splitter
        ? call$b(splitter, separator, O, limit)
        : call$b(internalSplit, toString$9(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject$b(this);
      var S = toString$9(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor$1(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y$1 ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y$1 ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y$1 ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y$1 ? stringSlice$8(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min$2(toLength$3(splitter.lastIndex + (UNSUPPORTED_Y$1 ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex$2(S, q, unicodeMatching);
        } else {
          push$4(A, stringSlice$8(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push$4(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push$4(A, stringSlice$8(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y$1);

function useWindowSize() {
  var _useState = useState({
      width: undefined,
      height: undefined
    }),
    _useState2 = _slicedToArray(_useState, 2),
    windowSize = _useState2[0],
    setWindowSize = _useState2[1];
  useEffect(function () {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
}

var useViewport = function useViewport() {
  var _useWindowSize = useWindowSize(),
    width = _useWindowSize.width,
    height = _useWindowSize.height;
  var getValue = function getValue(value) {
    return parseInt(value.split('px')[0]);
  };
  var isXS = width > getValue(_wcImport.sm);
  var isSM = width > getValue(_wcImport.md);
  var isMD = width > getValue(_wcImport.lg);
  var isLG = width > getValue(_wcImport.xl);
  var isXL = width > getValue(_wcImport.xl);
  return {
    isXS: isXS,
    isSM: isSM,
    isMD: isMD,
    isLG: isLG,
    isXL: isXL,
    width: width,
    height: height
  };
};
var trueViewPort = function trueViewPort() {
  var useOldBreakPoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var _useWindowSize2 = useWindowSize(),
    width = _useWindowSize2.width,
    height = _useWindowSize2.height;
  var orientation = width > height ? 'landscape' : 'portrait';
  var getValue = function getValue(value) {
    return parseInt(value.split('px')[0]);
  };
  var isXS = width < getValue(useOldBreakPoints ? _wcImport.oldsm : _wcImport.sm) + 1;
  var isSM = width < getValue(useOldBreakPoints ? _wcImport.oldmd : _wcImport.md);
  var isMD = width >= getValue(useOldBreakPoints ? _wcImport.oldmd : _wcImport.md);
  var isLG = width >= getValue(useOldBreakPoints ? _wcImport.oldlg : _wcImport.lg);
  var isXL = width >= getValue(useOldBreakPoints ? _wcImport.oldxl : _wcImport.xl) && !isLG;
  return {
    isXS: isXS,
    isSM: isSM,
    isMD: isMD,
    isLG: isLG,
    isXL: isXL,
    width: width,
    height: height,
    orientation: orientation
  };
};

var _excluded$l = ["_onPress", "limitWidth"];
var FilterTriggerContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _onPress = _ref._onPress,
    limitWidth = _ref.limitWidth,
    props = _objectWithoutProperties(_ref, _excluded$l);
  var _useViewport = useViewport(),
    isXS = _useViewport.isXS;
  var maxSize = !isXS ? 151 : 190;
  var styles = Object.assign({}, Object.assign({
    width: 'fit-content',
    border: 'none',
    padding: '0 10px 0 5px',
    height: '48px',
    zIndex: '2',
    borderRadius: '6px',
    minWidth: '151px',
    background: props.active ? _wcImport4.secondary[20] : _wcImport4.secondary[10],
    color: props.active ? '#2A4473' : _wcImport4.neutral[100],
    '&:active': {
      background: _wcImport4.secondary[30],
      outline: 'none'
    },
    ':hover': {
      background: props.active ? _wcImport4.secondary[30] : _wcImport4.secondary[20]
    }
  }, limitWidth && {
    maxWidth: "".concat(maxSize, "px")
  }), props.css);
  return /*#__PURE__*/jsx(_StyledButton$b, Object.assign({
    size: "large",
    ref: ref
  }, props, {
    onPress: _onPress,
    $_css: styles,
    children: props.children
  }));
});
FilterTriggerContainer.displayName = 'FilterTriggerContainer';
FilterTriggerContainer.propTypes = {
  onPress: PropTypes.func
};
FilterTriggerContainer.defaultProps = {
  onPress: function onPress() {
    return null;
  },
  limitWidth: false
};
var FilterTriggerContainer$1 = FilterTriggerContainer;
var _StyledButton$b = /*#__PURE__*/styled(Button$1).withConfig({
  displayName: "FilterTriggerContainer___StyledButton",
  componentId: "sc-wf6gpc-0"
})(["", ""], function (p) {
  return p.$_css;
});

var labelSizes$1 = {
  small: typography.labelSm,
  medium: typography.labelMd,
  large: typography.labelLg
};
var captionSizes$1 = {
  small: typography.labelXs,
  medium: typography.labelSm,
  large: typography.labelSm
};
var containerVariant = variant({
  prop: 'checkboxContainerVariant',
  scale: 'checkbox.containerVariant',
  variants: {
    "default": {}
  }
});
var colorVariant = variant({
  prop: 'color',
  scale: 'checkbox.colorVariants',
  variants: {
    "default": {}
  }
});
var sizeVariant = variant({
  prop: 'size',
  scale: 'checkbox.checkboxSizeVariants',
  variants: {
    defaults: {}
  }
});
var textStyleVariants$1 = variant({
  prop: 'textStyleVariant',
  scale: 'checkbox.textStyleVariant',
  variants: {
    "default": {}
  }
});

// // CheckBox Container=========================
var checkboxContainerProps = compose(containerVariant);
var CheckBoxContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "helpers__CheckBoxContainer",
  componentId: "sc-17hycn-0"
})(["", ""], checkboxContainerProps);

// HiddenInput ========================
var hiddenInputProps$1 = compose(colorVariant);
var HiddenInput$2 = /*#__PURE__*/styled.input.attrs({
  type: 'checkbox'
}).withConfig({
  displayName: "helpers__HiddenInput",
  componentId: "sc-17hycn-1"
})(["", ""], hiddenInputProps$1);

// //Styled Checkbox =========================
var styledCheckBoxProps = compose(sizeVariant);
var StyledCheckbox = /*#__PURE__*/styled.div.withConfig({
  displayName: "helpers__StyledCheckbox",
  componentId: "sc-17hycn-2"
})(["", ""], styledCheckBoxProps);

// Text Wrapper===============
var textStyleProps$1 = compose(textStyleVariants$1);
var TextWrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "helpers__TextWrapper",
  componentId: "sc-17hycn-3"
})(["display:flex;flex-direction:column;align-items:flex-start;justify-content:center;margin:0 0 0 12px;", ""], textStyleProps$1);

// Checkbox Label ===============
var CheckboxLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "helpers__CheckboxLabel",
  componentId: "sc-17hycn-4"
})(["", ";"], function (props) {
  return styledCss({
    cursor: 'pointer',
    margin: "".concat(props.size === 'medium' ? '1px 0 0' : '2px 0 0'),
    fontFamily: "".concat(openSans()),
    fontSize: "".concat(labelSizes$1[props.size].size, "px"),
    lineHeight: "".concat(labelSizes$1[props.size].lineHeight, "px")
  });
});

// Checkbox Caption===============
var CheckboxCaption = /*#__PURE__*/styled.p.withConfig({
  displayName: "helpers__CheckboxCaption",
  componentId: "sc-17hycn-5"
})(["margin:0;", ";"], function (props) {
  return styledCss({
    fontFamily: "".concat(openSans()),
    fontSize: "".concat(captionSizes$1[props.size].size, "px"),
    lineHeight: "".concat(captionSizes$1[props.size].lineHeight, "px"),
    margin: props.hasLabel ? '8px 0 0' : '0'
  });
});

var advice_icon_24 = function advice_icon_24(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      stroke: "#FFF",
      d: "M12.5 0.5C12.5 0.223858 12.2761 0 12 0C11.7239 0 11.5 0.223858 11.5 0.5V2.5C11.5 2.77614 11.7239 3 12 3C12.2761 3 12.5 2.77614 12.5 2.5V0.5ZM6.2 12C6.2 8.79675 8.79675 6.2 12 6.2C15.2033 6.2 17.8 8.79675 17.8 12C17.8 13.6075 17.1476 15.0605 16.0902 16.1122C14.8022 17.203 14.2138 18.5255 13.9529 19.8H10.0471C9.7835 18.5122 9.18555 17.1755 7.86943 16.0783C6.81329 15.1978 6.2 13.6964 6.2 12ZM10.2092 21C10.2493 21.5451 10.2475 22.0625 10.2374 22.5271C10.2339 22.6874 10.3494 22.8 10.4998 22.8H10.5058H10.5118H10.5179H10.5239H10.5299H10.5359H10.5419H10.548H10.554H10.56H10.5661H10.5721H10.5781H10.5842H10.5902H10.5962H10.6023H10.6083H10.6144H10.6204H10.6265H10.6325H10.6385H10.6446H10.6506H10.6567H10.6628H10.6688H10.6749H10.6809H10.687H10.693H10.6991H10.7052H10.7112H10.7173H10.7234H10.7294H10.7355H10.7416H10.7476H10.7537H10.7598H10.7658H10.7719H10.778H10.7841H10.7901H10.7962H10.8023H10.8084H10.8145H10.8205H10.8266H10.8327H10.8388H10.8449H10.851H10.857H10.8631H10.8692H10.8753H10.8814H10.8875H10.8936H10.8997H10.9058H10.9119H10.918H10.9241H10.9301H10.9362H10.9423H10.9484H10.9545H10.9606H10.9667H10.9728H10.9789H10.985H10.9911H10.9972H11.0033H11.0095H11.0156H11.0217H11.0278H11.0339H11.04H11.0461H11.0522H11.0583H11.0644H11.0705H11.0766H11.0827H11.0888H11.095H11.1011H11.1072H11.1133H11.1194H11.1255H11.1316H11.1377H11.1438H11.15H11.1561H11.1622H11.1683H11.1744H11.1805H11.1866H11.1928H11.1989H11.205H11.2111H11.2172H11.2233H11.2294H11.2356H11.2417H11.2478H11.2539H11.26H11.2661H11.2722H11.2784H11.2845H11.2906H11.2967H11.3028H11.3089H11.315H11.3211H11.3273H11.3334H11.3395H11.3456H11.3517H11.3578H11.3639H11.3701H11.3762H11.3823H11.3884H11.3945H11.4006H11.4067H11.4128H11.4189H11.4251H11.4312H11.4373H11.4434H11.4495H11.4556H11.4617H11.4678H11.4739H11.48H11.4861H11.4922H11.4983H11.5044H11.5105H11.5166H11.5227H11.5288H11.535H11.541H11.5472H11.5532H11.5593H11.5654H11.5715H11.5776H11.5837H11.5898H11.5959H11.602H11.6081H11.6142H11.6203H11.6264H11.6325H11.6386H11.6447H11.6507H11.6568H11.6629H11.669H11.6751H11.6812H11.6873H11.6933H11.6994H11.7055H11.7116H11.7176H11.7237H11.7298H11.7359H11.742H11.748H11.7541H11.7602H11.7662H11.7723H11.7784H11.7844H11.7905H11.7966H11.8026H11.8087H11.8148H11.8208H11.8269H11.8329H11.839H11.845H11.8511H11.8571H11.8632H11.8692H11.8753H11.8813H11.8874H11.8934H11.8995H11.9055H11.9115H11.9176H11.9236H11.9297H11.9357H11.9417H11.9478H11.9538H11.9598H11.9658H11.9719H11.9779H11.9839H11.9899H11.996H12.002H12.008H12.014H12.02H12.026H12.032H12.038H12.0441H12.0501H12.0561H12.0621H12.0681H12.0741H12.0801H12.086H12.092H12.098H12.104H12.11H12.116H12.122H12.128H12.1339H12.1399H12.1459H12.1519H12.1578H12.1638H12.1698H12.1757H12.1817H12.1877H12.1936H12.1996H12.2055H12.2115H12.2174H12.2234H12.2293H12.2353H12.2412H12.2472H12.2531H12.2591H12.265H12.2709H12.2769H12.2828H12.2887H12.2946H12.3006H12.3065H12.3124H12.3183H12.3242H12.3301H12.3361H12.342H12.3479H12.3538H12.3597H12.3656H12.3715H12.3773H12.3832H12.3891H12.395H12.4009H12.4068H12.4127H12.4185H12.4244H12.4303H12.4361H12.442H12.4479H12.4537H12.4596H12.4654H12.4713H12.4771H12.483H12.4888H12.4947H12.5005H12.5064H12.5122H12.518H12.5238H12.5297H12.5355H12.5413H12.5471H12.5529H12.5588H12.5646H12.5704H12.5762H12.582H12.5878H12.5936H12.5994H12.6052H12.6109H12.6167H12.6225H12.6283H12.6341H12.6398H12.6456H12.6514H12.6571H12.6629H12.6686H12.6744H12.6801H12.6859H12.6916H12.6974H12.7031H12.7089H12.7146H12.7203H12.726H12.7318H12.7375H12.7432H12.7489H12.7546H12.7603H12.766H12.7717H12.7774H12.7831H12.7888H12.7945H12.8002H12.8059H12.8115H12.8172H12.8229H12.8285H12.8342H12.8399H12.8455H12.8512H12.8568H12.8625H12.8681H12.8738H12.8794H12.885H12.8907H12.8963H12.9019H12.9075H12.9131H12.9187H12.9243H12.9299H12.9355H12.9411H12.9467H12.9523H12.9579H12.9635H12.9691H12.9746H12.9802H12.9858H12.9913H12.9969H13.0025H13.008H13.0136H13.0191H13.0246H13.0302H13.0357H13.0412H13.0468H13.0523H13.0578H13.0633H13.0688H13.0743H13.0798H13.0853H13.0908H13.0963H13.1018H13.1073H13.1127H13.1182H13.1237H13.1291H13.1346H13.1401H13.1455H13.151H13.1564H13.1618H13.1673H13.1727H13.1781H13.1836H13.189H13.1944H13.1998H13.2052H13.2106H13.216H13.2214H13.2268H13.2322H13.2375H13.2429H13.2483H13.2537H13.259H13.2644H13.2697H13.2751H13.2804H13.2858H13.2911H13.2964H13.3018H13.3071H13.3124H13.3177H13.323H13.3283H13.3336H13.3389H13.3442H13.3495H13.3548H13.3601H13.3653H13.3706H13.3759H13.3811H13.3864H13.3916H13.3969H13.4021H13.4073H13.4126H13.4178H13.423H13.4282H13.4334H13.4386H13.4438H13.449H13.4542H13.4594H13.4646H13.4698H13.4749H13.4801H13.4853H13.4904H13.4956H13.5007C13.6506 22.8 13.7661 22.688 13.7626 22.5271C13.7525 22.0625 13.7507 21.5451 13.7908 21H10.2092ZM19 12C19 13.9587 18.1955 15.7295 16.899 17C15.0466 18.5443 14.9227 20.6848 14.9623 22.5008C14.9804 23.3291 14.3291 24 13.5007 24H10.4998C9.67137 24 9.01957 23.3291 9.03767 22.5008C9.07735 20.6848 8.9534 18.5443 7.10102 17C5.70672 15.8376 5 13.9587 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12ZM11.4 8C11.4 7.66863 11.6686 7.4 12 7.4C12.6041 7.4 13.2022 7.51898 13.7603 7.75015C14.3184 7.98133 14.8255 8.32016 15.2527 8.74731C15.6798 9.17446 16.0187 9.68156 16.2498 10.2397C16.481 10.7978 16.6 11.3959 16.6 12C16.6 12.3314 16.3314 12.6 16 12.6C15.6686 12.6 15.4 12.3314 15.4 12C15.4 11.5535 15.3121 11.1114 15.1412 10.6989C14.9703 10.2864 14.7199 9.91156 14.4042 9.59584C14.0884 9.28012 13.7136 9.02968 13.3011 8.85881C12.8886 8.68794 12.4465 8.6 12 8.6C11.6686 8.6 11.4 8.33137 11.4 8ZM20.379 3.33457C20.5842 3.51934 20.6008 3.83549 20.416 4.0407L19.0778 5.52699C18.893 5.73221 18.5768 5.74878 18.3716 5.564C18.1664 5.37922 18.1498 5.06308 18.3346 4.85786L19.6729 3.37157C19.8577 3.16636 20.1738 3.14979 20.379 3.33457ZM21.5 11C21.2239 11 21 11.2239 21 11.5C21 11.7761 21.2239 12 21.5 12H23.5C23.7761 12 24 11.7761 24 11.5C24 11.2239 23.7761 11 23.5 11H21.5ZM0 11.5C0 11.2239 0.223858 11 0.5 11H2.5C2.77614 11 3 11.2239 3 11.5C3 11.7761 2.77614 12 2.5 12H0.5C0.223858 12 0 11.7761 0 11.5ZM3.59142 4.0407C3.40665 3.83549 3.42321 3.51934 3.62843 3.33457C3.83364 3.14979 4.14979 3.16636 4.33457 3.37157L5.67283 4.85786C5.8576 5.06308 5.84103 5.37922 5.63582 5.564C5.43061 5.74878 5.11446 5.73221 4.92968 5.52699L3.59142 4.0407Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

/* eslint-disable @typescript-eslint/naming-convention */
var alarmClock_20 = function alarmClock_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    viewBox: "0 0 18 20",
    width: "18px",
    height: "20px"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.0395 5.98872C8.0395 5.38745 8.5153 4.90002 9.11143 4.90002C9.70345 4.90002 10.1834 5.38319 10.1834 5.98872V10.3445C10.1834 10.9459 9.70812 11.4334 9.11245 11.4334H6.96655C6.3751 11.4334 5.89563 10.9501 5.89563 10.3445C5.89563 9.74314 6.37088 9.25562 6.96655 9.25562H8.0395V5.98872ZM13.6417 17.7423C12.3271 18.5748 10.7746 19.0558 9.11143 19.0558C7.44828 19.0558 5.89572 18.5748 4.58116 17.7423L3.60765 19.4552C3.31192 19.9755 2.66014 20.1557 2.14387 19.8529C1.63117 19.5522 1.45317 18.8903 1.751 18.3663C1.751 18.3663 2.87562 16.3943 2.90487 16.3558C1.43714 14.7925 0.535967 12.6754 0.535967 10.3446C0.535967 9.0472 0.815154 7.81608 1.31583 6.70982C0.510511 6.0108 0 4.97154 0 3.81115C0 1.70631 1.67972 0 3.75177 0C5.13811 0 6.34882 0.763835 6.99832 1.89981C7.67427 1.72581 8.38222 1.63335 9.11143 1.63335C9.77079 1.63335 10.4128 1.70894 11.0294 1.85207C11.6853 0.742484 12.8814 0 14.2482 0C16.3203 0 18 1.70631 18 3.81115C18 4.89456 17.555 5.87238 16.8405 6.56627C17.3829 7.70918 17.6869 8.9908 17.6869 10.3446C17.6869 12.6754 16.7857 14.7925 15.318 16.3558C15.3472 16.3943 16.4719 18.3663 16.4719 18.3663C16.7697 18.8903 16.5917 19.5522 16.079 19.8529C15.5627 20.1557 14.9109 19.9755 14.6152 19.4552L13.6417 17.7423ZM3.75176 2.1778C2.86374 2.1778 2.14386 2.90907 2.14386 3.81115C2.14386 4.18606 2.26944 4.53656 2.48387 4.81613C3.16776 3.97109 4.00521 3.25916 4.95288 2.72435C4.65497 2.38532 4.22264 2.1778 3.75176 2.1778ZM15.8561 3.81115C15.8561 2.90907 15.1363 2.1778 14.2482 2.1778C13.8161 2.1778 13.4164 2.3526 13.1233 2.64344C14.075 3.15614 14.9204 3.84557 15.617 4.66868C15.7694 4.41751 15.8561 4.12276 15.8561 3.81115ZM2.67981 10.3446C2.67981 13.9529 5.55934 16.878 9.11141 16.878C12.6635 16.878 15.543 13.9529 15.543 10.3446C15.543 6.73626 12.6635 3.81116 9.11141 3.81116C5.55934 3.81116 2.67981 6.73626 2.67981 10.3446Z",
      fill: outlineColor || '#353535'
    }, void 0)
  }), void 0);
};

var arrow_right_20 = function arrow_right_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "10",
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 5C0 4.44772 0.447715 4 1 4L12.585 4L10.2929 1.70711C9.93241 1.34662 9.90468 0.779392 10.2097 0.387101L10.2929 0.292893C10.6534 -0.0675907 11.2206 -0.0953203 11.6129 0.209705L11.7071 0.292893L15.7071 4.29289L15.7485 4.33685L15.8037 4.40469L15.8753 4.51594L15.9288 4.62866L15.9642 4.73401L15.9932 4.88253L16 5L15.9972 5.07524L15.9798 5.20073L15.9503 5.31214L15.9063 5.42322L15.854 5.52071L15.7872 5.61675C15.7623 5.64847 15.7356 5.67864 15.7071 5.70711L11.7071 9.70711C11.3166 10.0976 10.6834 10.0976 10.2929 9.70711C9.93241 9.34662 9.90468 8.77939 10.2097 8.3871L10.2929 8.29289L12.585 6L1 6C0.447715 6 0 5.55228 0 5Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var arrow_right_16 = function arrow_right_16(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "12",
    height: "10",
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.21813 0.395523L6.30132 0.301316C6.6618 -0.0591679 7.22903 -0.0868974 7.62132 0.218127L7.71553 0.301316L11.7071 4.2929L11.7485 4.33686L11.8037 4.4047L11.8753 4.51594L11.9288 4.62867L11.9642 4.73401L11.9931 4.88191L12 5L11.9972 5.07524L11.9798 5.20073L11.9503 5.31215L11.9063 5.42323L11.854 5.52071L11.7803 5.62545L11.7071 5.70711L7.71553 9.69869C7.325 10.0892 6.69184 10.0892 6.30132 9.69869C5.94083 9.3382 5.9131 8.77097 6.21813 8.37868L6.30132 8.28447L8.585 6H1C0.447715 6 0 5.55229 0 5C0 4.44772 0.447715 4 1 4H8.585L6.30132 1.71553C5.94083 1.35505 5.9131 0.787815 6.21813 0.395523Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var baby_20 = function baby_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.4596 10.1963C13.4503 9.45359 14.091 8.27125 14.091 6.93956C14.091 5.60481 13.4473 4.42009 12.4528 3.67772C12.0975 4.9713 10.9109 5.92186 9.50183 5.92186C8.93859 5.92186 8.482 5.46622 8.482 4.90416C8.482 4.34211 8.93859 3.88647 9.50183 3.88647C10.0545 3.88647 10.5045 3.44772 10.5212 2.9002C10.3543 2.87945 10.1843 2.86877 10.0117 2.86877C7.75881 2.86877 5.93244 4.69132 5.93244 6.93956C5.93244 8.27125 6.57322 9.45359 7.56387 10.1963C7.81208 9.8665 8.12565 9.58851 8.48539 9.38146C8.53815 8.5861 9.20136 7.95726 10.0117 7.95726C10.8221 7.95726 11.4853 8.5861 11.5381 9.38146C11.8978 9.58851 12.2114 9.8665 12.4596 10.1963ZM4.40579 13.0479L3.27307 17.1166L16.7269 17.1174L15.5794 13.0459L12.8969 13.0464C12.4767 14.2319 11.3436 15.0812 10.0117 15.0812C8.68023 15.0812 7.5474 14.2324 7.12693 13.0474L4.40579 13.0479ZM3.89279 6.93957C3.89279 3.56721 6.63234 0.833374 10.0117 0.833374C13.3911 0.833374 16.1307 3.56721 16.1307 6.93957C16.1307 8.50348 15.5415 9.93007 14.5726 11.0104H16.1167C16.6775 11.0104 17.2542 11.4481 17.4062 11.9924L19.1301 18.17C19.2815 18.7124 18.9486 19.1525 18.3797 19.1529L1.62154 19.1667C1.05571 19.1672 0.718396 18.729 0.869331 18.1836L2.58222 11.9943C2.73261 11.4509 3.3134 11.0104 3.86989 11.0104H5.45087C4.48195 9.93007 3.89279 8.50348 3.89279 6.93957ZM11.0315 12.0281C11.0315 11.466 10.575 11.0104 10.0117 11.0104C9.44848 11.0104 8.99189 11.466 8.99189 12.0281C8.99189 12.5901 9.44848 13.0458 10.0117 13.0458C10.575 13.0458 11.0315 12.5901 11.0315 12.0281Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var badge_20 = function badge_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsxs("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.43041 15.7073C4.77371 14.285 3.75654 12.4363 3.74396 10.2596C3.75168 7.86208 3.74416 3.78241 3.74397 3.75251C3.74095 3.27552 4.1738 2.92596 4.61631 3.04802C4.63276 3.05256 5.55826 3.29047 6.23346 3.39604C7.47672 3.59044 8.75978 2.40011 10.0001 2.40011C11.2494 2.40011 12.5231 3.59044 13.7664 3.39604C14.4416 3.29047 15.3671 3.05256 15.3835 3.04802C15.826 2.92596 16.2589 3.27552 16.2559 3.75251C16.2557 3.78241 16.2482 7.86208 16.2559 10.2596C16.2433 12.4363 15.2261 14.285 13.5694 15.7073C12.3478 16.7561 10.783 17.5107 9.9954 17.5C9.21686 17.5107 7.652 16.7561 6.43041 15.7073ZM5.00006 3.39604C4.69703 3.35113 5.41155 4.7135 5.13316 4.65643C5.13316 4.93269 5.14088 7.8637 5.13314 10.2576C5.14296 11.9516 5.95087 13.42 7.31375 14.59C7.8525 15.0526 8.45119 15.4401 9.02378 15.7162C9.47227 15.9325 9.86305 16.0542 9.99539 16.0525C10.1368 16.0542 10.5275 15.9325 10.976 15.7162C11.5486 15.4401 12.1473 15.0526 12.6861 14.59C14.0489 13.42 14.8569 11.9516 14.8667 10.2576C14.8589 7.8637 14.8667 4.93269 14.8667 4.65643C14.5883 4.7135 15.3031 3.7076 15.0001 3.75251C13.6732 3.94914 11.0424 3.39604 9.70747 3.39604C8.38154 3.39604 6.32688 3.59268 5.00006 3.39604Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.21601 3.87917V5.8847H9.99546H14.7749V3.87917H5.21601ZM4.79544 2.375C4.21475 2.375 3.74402 2.85603 3.74402 3.4494V7.38887H9.99546H16.2469V3.4494C16.2469 2.85603 15.7762 2.375 15.1955 2.375H4.79544Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.9837 5.38332H15.5199V3.87915H18.4639C18.7556 3.87915 19.0197 4.05519 19.1374 4.32795C19.255 4.60072 19.2039 4.91873 19.0071 5.13872L18.4911 5.71543C18.1852 6.05724 18.2515 6.59758 18.6304 6.85169L18.8677 7.01079C19.1397 7.19318 19.2622 7.53639 19.1691 7.8549C19.0759 8.17341 18.7892 8.39165 18.4639 8.39165H15.5199V6.88748H16.9239C16.7776 6.40015 16.7937 5.86746 16.9837 5.38332Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.01633 5.38332H4.4801V3.87915H1.53612C1.24442 3.87915 0.98025 4.05519 0.862621 4.32795C0.744992 4.60072 0.796106 4.91873 0.992935 5.13872L1.50894 5.71543C1.81477 6.05724 1.74849 6.59758 1.36956 6.85169L1.13231 7.01079C0.860333 7.19318 0.737795 7.53639 0.830938 7.8549C0.92408 8.17341 1.21081 8.39165 1.53612 8.39165H4.4801V6.88748H3.07608C3.22235 6.40015 3.20627 5.86746 3.01633 5.38332Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)]
  }), void 0);
};

var barbell_20 = function barbell_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.6351 7.29169C18.4838 7.29169 19.1666 7.99058 19.1666 8.8527V11.9807C19.1666 12.8429 18.481 13.5417 17.6351 13.5417H16.875V14.3229C16.875 15.6173 15.8464 16.6667 14.5833 16.6667C13.3177 16.6667 12.2916 15.6171 12.2916 14.3229V11.1979H7.70831V14.3229C7.70831 15.6173 6.67972 16.6667 5.41665 16.6667C4.15099 16.6667 3.12498 15.6171 3.12498 14.3229V13.5417H2.36482C1.51899 13.5417 0.833313 12.8429 0.833313 11.9807V8.8527C0.833313 7.99058 1.51615 7.29169 2.36482 7.29169H3.12498V6.51051C3.12498 5.21605 4.15357 4.16669 5.41665 4.16669C6.6823 4.16669 7.70831 5.21629 7.70831 6.51051V9.63544H12.2916V6.51051C12.2916 5.21605 13.3202 4.16669 14.5833 4.16669C15.849 4.16669 16.875 5.21629 16.875 6.51051V7.29169H17.6351ZM4.65281 6.51049V14.3228C4.65281 14.7542 4.99493 15.1042 5.4167 15.1042C5.83715 15.1042 6.18059 14.7532 6.18059 14.3228V6.51049C6.18059 6.0791 5.83847 5.72917 5.4167 5.72917C4.99625 5.72917 4.65281 6.08015 4.65281 6.51049ZM13.8195 6.51049V14.3228C13.8195 14.7542 14.1616 15.1042 14.5834 15.1042C15.0038 15.1042 15.3473 14.7532 15.3473 14.3228V6.51049C15.3473 6.0791 15.0051 5.72917 14.5834 5.72917C14.1629 5.72917 13.8195 6.08015 13.8195 6.51049ZM2.36115 8.85417V11.9792H3.12503V8.85417H2.36115ZM16.875 8.85417V11.9792H17.6389V8.85417H16.875Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var bottle_20 = function bottle_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.2505 2.35617C12.5528 3.05694 13.4823 4.47051 13.6048 5.87265C14.2099 6.21468 14.6185 6.86399 14.6185 7.60872C14.6185 8.1921 14.3678 8.71692 13.9683 9.08136C14.3615 9.35777 14.6185 9.81493 14.6185 10.3321V17.6389C14.6185 18.4826 13.9345 19.1666 13.0907 19.1666H6.14625C5.30248 19.1666 4.61847 18.4826 4.61847 17.6389V10.3321C4.61847 9.81493 4.87544 9.35778 5.26867 9.08136C4.86915 8.71692 4.61847 8.1921 4.61847 7.60872C4.61847 6.96784 4.921 6.39762 5.39104 6.03309C5.45362 4.57949 6.40372 3.08378 7.75563 2.35625C7.87303 1.49605 8.61065 0.833252 9.50308 0.833252C10.3955 0.833252 11.1331 1.49602 11.2505 2.35617ZM9.48508 1.96421C9.04247 1.96421 8.73002 2.64041 8.83748 3.06977L8.87183 3.20699C7.535 3.43795 6.62029 4.49984 6.62029 5.40282H12.398C12.398 4.53532 11.4094 3.52114 10.1146 3.238L10.1567 3.07167C10.2656 2.64183 9.9285 1.96421 9.48508 1.96421ZM5.72705 7.44475C5.72705 6.97464 6.10815 6.59355 6.57825 6.59355H12.6586C13.1287 6.59355 13.5098 6.97464 13.5098 7.44475C13.5098 7.91486 13.1287 8.29595 12.6586 8.29595H6.57825C6.10815 8.29595 5.72705 7.91486 5.72705 7.44475ZM6.16721 9.82499C5.9463 9.82499 5.76721 10.0041 5.76721 10.225V11.8358C5.89186 11.7574 6.03936 11.7121 6.19745 11.7121H7.65511C8.10225 11.7121 8.46474 12.0746 8.46474 12.5217C8.46474 12.9689 8.10226 13.3314 7.65511 13.3314H6.19745C6.03936 13.3314 5.89186 13.2861 5.76721 13.2077V14.2647C5.89186 14.1864 6.03936 14.1411 6.19745 14.1411H7.65511C8.10225 14.1411 8.46474 14.5036 8.46474 14.9507C8.46474 15.3978 8.10226 15.7603 7.65511 15.7603H6.19745C6.03936 15.7603 5.89186 15.715 5.76721 15.6367V17.5777C5.76721 17.7986 5.9463 17.9777 6.16721 17.9777H13.0697C13.2906 17.9777 13.4697 17.7986 13.4697 17.5777V10.225C13.4697 10.0041 13.2906 9.82499 13.0697 9.82499H6.16721Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var calendar_20 = function calendar_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.33333 17.5H11.6667V14.1667H8.33333V17.5ZM11.6667 12.5V9.16667H8.33333V12.5H11.6667ZM13.3333 14.1667V17.5H15.8374C16.2952 17.5 16.6667 17.1275 16.6667 16.6666V14.1667H13.3333ZM16.6667 9.16667H13.3333V12.5H16.6667V9.16667ZM3.33333 14.1667V16.6666C3.33333 17.1271 3.70526 17.5 4.16257 17.5H6.66667V14.1667H3.33333ZM6.66667 12.5V9.16667H3.33333V12.5H6.66667ZM16.6667 5.83342C16.6667 5.37293 16.2947 5 15.8374 5C15.8333 5.46031 15.4634 5.83333 15 5.83333C14.5398 5.83333 14.1667 5.46357 14.1667 5.00016L12.5 5C12.5 5.46031 12.1301 5.83333 11.6667 5.83333C11.2064 5.83333 10.8333 5.46357 10.8333 5.00016L9.16667 5C9.16667 5.46031 8.79678 5.83333 8.33333 5.83333C7.8731 5.83333 7.5 5.46357 7.5 5.00016L5.83333 5C5.83333 5.46031 5.46345 5.83333 5 5.83333C4.53976 5.83333 4.16667 5.46357 4.16667 5.00016C3.70477 5 3.33333 5.37245 3.33333 5.83342V7.5H16.6667V5.83342ZM18.3334 5.83344V16.6666C18.3334 18.047 17.2167 19.1667 15.8374 19.1667H4.16259C2.78379 19.1667 1.66669 18.0466 1.66669 16.6666V5.83344C1.66669 4.45301 2.7833 3.33335 4.16259 3.33335L4.16669 2.49986C4.16669 2.03971 4.53657 1.66669 5.00002 1.66669C5.46026 1.66669 5.83335 2.03645 5.83335 2.49986V3.33335H7.50002V2.49986C7.50002 2.03971 7.86991 1.66669 8.33335 1.66669C8.79359 1.66669 9.16669 2.03645 9.16669 2.49986V3.33335H10.8334V2.49986C10.8334 2.03971 11.2032 1.66669 11.6667 1.66669C12.1269 1.66669 12.5 2.03645 12.5 2.49986V3.33335H14.1667V2.49986C14.1667 2.03971 14.5366 1.66669 15 1.66669C15.4603 1.66669 15.8334 2.03645 15.8334 2.49986V3.33335C17.2162 3.33335 18.3334 4.45348 18.3334 5.83344Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var calendar_24 = function calendar_24(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 0C15.5523 0 16 0.447715 16 1V2H17C18.6569 2 20 3.34315 20 5V17C20 18.6569 18.6569 20 17 20H3C1.34315 20 0 18.6569 0 17V5C0 3.34315 1.34315 2 3 2H4V1C4 0.447715 4.44772 0 5 0C5.55228 0 6 0.447715 6 1V2H14V1C14 0.447715 14.4477 0 15 0ZM18 10H2V17C2 17.5523 2.44772 18 3 18H17C17.5523 18 18 17.5523 18 17V10ZM15 12C15.5523 12 16 12.4477 16 13V15C16 15.5523 15.5523 16 15 16H13C12.4477 16 12 15.5523 12 15V13C12 12.4477 12.4477 12 13 12H15ZM4 4H3C2.44772 4 2 4.44772 2 5V8H18V5C18 4.44772 17.5523 4 17 4H16V5C16 5.55228 15.5523 6 15 6C14.4477 6 14 5.55228 14 5V4H6V5C6 5.55228 5.55228 6 5 6C4.44772 6 4 5.55228 4 5V4Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var camera_24 = function camera_24(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "14",
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 2H13V4.90944V9.09056V12H2L2 2ZM15 11.2143V12C15 13.1046 14.1046 14 13 14H2C0.89543 14 0 13.1046 0 12V2C0 0.89543 0.895431 0 2 0H13C14.1046 0 15 0.895431 15 2V2.78571L17.3273 1.95453C18.6298 1.48935 20 2.45495 20 3.83801V10.162C20 11.5451 18.6298 12.5106 17.3273 12.0455L15 11.2143ZM15 9.09056L18 10.162V3.83801L15 4.90944V9.09056Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var cashbag_20 = function cashbag_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.3906 3.2004C11.1143 3.65896 9.98582 3.72701 9.58112 3.72667C9.17647 3.72701 8.04795 3.65896 6.77165 3.2004C6.86715 3.43594 7.12104 4.03379 7.34611 4.56126H11.8162C12.0413 4.03379 12.2951 3.43594 12.3906 3.2004ZM14.8958 6.64776C14.8958 7.32032 14.5586 7.91855 14.0343 8.30012C15.5088 9.77762 16.6667 11.6783 16.6667 13.3245C16.6667 16.8981 13.6682 19.1667 9.58333 19.1667C5.49844 19.1667 2.5 16.8981 2.5 13.3245C2.5 11.678 3.65819 9.77705 5.133 8.29946C4.60859 7.91747 4.27083 7.31898 4.27083 6.64776C4.27083 5.81811 4.78403 5.10155 5.5284 4.7653L4.33305 1.95033C4.02612 1.22754 4.80666 0.62209 5.57205 0.903951C6.77166 1.34571 8.12532 1.84786 8.64805 1.96284C9.07821 2.05746 9.30402 2.05805 9.58115 2.05749C9.85829 2.05805 10.0841 2.05746 10.5143 1.96284C11.037 1.84786 12.3906 1.34571 13.5903 0.903951C14.3556 0.62209 15.1362 1.22754 14.8293 1.95033L13.6344 4.76421C14.3804 5.10038 14.8958 5.81857 14.8958 6.64776ZM6.5081 9.36768C5.1211 10.669 4.27083 12.1186 4.27083 13.3245C4.27083 15.8856 6.40137 17.4975 9.58333 17.4975C12.7653 17.4975 14.8958 15.8856 14.8958 13.3245C14.8958 12.1186 14.0456 10.669 12.6586 9.36768C12.4181 9.14205 12.1686 8.92952 11.9195 8.73423H7.24715C6.99803 8.92952 6.74858 9.14205 6.5081 9.36768ZM6.04167 6.64774C6.04167 6.87682 6.24128 7.06504 6.48525 7.06504H12.6814C12.9273 7.06504 13.125 6.87868 13.125 6.64774C13.125 6.41867 12.9254 6.23044 12.6814 6.23044H6.48525C6.23937 6.23044 6.04167 6.4168 6.04167 6.64774ZM10.4689 10.4034C10.9579 10.4034 11.3543 10.7771 11.3543 11.238C11.3543 11.6989 10.9579 12.0726 10.4689 12.0726H9.58344C9.09443 12.0726 8.69802 12.4463 8.69802 12.9072C8.69802 13.3681 9.09443 13.7418 9.58344 13.7418H10.4689C10.9579 13.7418 11.3543 14.1155 11.3543 14.5764C11.3543 15.0373 10.9579 15.411 10.4689 15.411H9.58344C8.11643 15.411 6.92719 14.29 6.92719 12.9072C6.92719 11.5244 8.11643 10.4034 9.58344 10.4034H10.4689Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var chat_20 = function chat_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.2753 0.90918C15.5917 0.90918 19.0909 4.4243 19.0909 8.76042C19.0909 9.96798 18.8195 11.1119 18.3347 12.1339L19.0499 15.3281C19.2489 16.2167 18.6912 16.774 17.8053 16.573L14.631 15.8532C13.8481 16.2276 12.9934 16.4751 12.0932 16.5692C10.9642 18.094 9.15131 19.0826 7.1074 19.0826C6.05983 19.0826 5.07295 18.8229 4.20773 18.3644L2.10023 19.0165C1.22592 19.287 0.73288 18.7976 0.999524 17.9215L1.64158 15.8121C1.17416 14.9413 0.909058 13.9458 0.909058 12.8885C0.909058 10.8067 1.93667 8.96489 3.51262 7.84182C3.96542 3.93853 7.26819 0.90918 11.2753 0.90918ZM14.4379 14.1148L17.2364 14.7603L16.6046 11.9389L16.8494 11.4228C17.2401 10.5991 17.4456 9.69605 17.4456 8.7604C17.4456 5.33715 14.6831 2.56205 11.2754 2.56205C8.49854 2.56205 6.15014 4.40473 5.37577 6.93926C5.92535 6.77978 6.50643 6.69428 7.10748 6.69428C10.5307 6.69428 13.3058 9.4675 13.3058 12.8884C13.3058 13.5199 13.2113 14.1294 13.0355 14.7034C13.3399 14.6126 14.4379 14.1148 14.4379 14.1148ZM3.42369 15.6427L2.99982 17.0131L4.37199 16.5889L4.98485 16.9134C5.63282 17.2564 6.35522 17.438 7.10741 17.438C9.61609 17.438 11.6529 15.4046 11.6529 12.8925C11.6529 10.3805 9.61609 8.34707 7.10741 8.34707C4.59872 8.34707 2.56195 10.3805 2.56195 12.8925C2.56195 13.6544 2.74827 14.3856 3.09964 15.0396L3.42369 15.6427ZM7.10747 13.719C6.65104 13.719 6.28103 13.349 6.28103 12.8926C6.28103 12.4362 6.65104 12.0661 7.10747 12.0661C7.56391 12.0661 7.93392 12.4362 7.93392 12.8926C7.93392 13.349 7.56391 13.719 7.10747 13.719ZM9.58672 13.719C9.13029 13.719 8.76027 13.349 8.76027 12.8926C8.76027 12.4362 9.13029 12.0661 9.58672 12.0661C10.0432 12.0661 10.4132 12.4362 10.4132 12.8926C10.4132 13.349 10.0432 13.719 9.58672 13.719ZM4.62812 13.719C4.17169 13.719 3.80168 13.349 3.80168 12.8926C3.80168 12.4362 4.17169 12.0661 4.62812 12.0661C5.08456 12.0661 5.45457 12.4362 5.45457 12.8926C5.45457 13.349 5.08456 13.719 4.62812 13.719Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var check_16 = function check_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.91006 10.4959L3.7071 8.29291C3.31658 7.90239 2.68342 7.90239 2.29289 8.29291C1.90237 8.68343 1.90237 9.3166 2.29289 9.70712L5.29288 12.7071C5.7168 13.131 6.4159 13.0892 6.7863 12.6178L13.7863 4.61786C14.1275 4.18359 14.0521 3.55494 13.6178 3.21372C13.1835 2.87251 12.5549 2.94795 12.2136 3.38222L5.91006 10.4959Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var check_20 = function check_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.70711 9.2929C3.31658 8.90238 2.68342 8.90238 2.29289 9.2929C1.90237 9.68343 1.90237 10.3166 2.29289 10.7071L7.29289 15.7071C7.69802 16.1122 8.36002 16.0948 8.74329 15.669L17.7433 5.66897C18.1128 5.25846 18.0795 4.62617 17.669 4.25671C17.2585 3.88726 16.6262 3.92053 16.2567 4.33104L7.96181 13.5476L3.70711 9.2929Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var checklist_20 = function checklist_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.1019 0.833374C13.5877 0.833374 13.9815 1.22043 13.9815 1.70556L15.74 1.70639C16.7123 1.70639 17.5 2.48595 17.5 3.45229V17.4208C17.5 18.3858 16.7143 19.1667 15.74 19.1667H3.42671C2.45442 19.1667 1.66669 18.3871 1.66669 17.4208V3.45229C1.66669 2.48728 2.4524 1.70639 3.42671 1.70639H5.18521C5.18521 1.22387 5.57564 0.833374 6.06484 0.833374C6.55064 0.833374 6.94446 1.22043 6.94446 1.70556L8.70372 1.70639C8.70372 1.22387 9.09416 0.833374 9.58335 0.833374C10.0692 0.833374 10.463 1.22043 10.463 1.70556L12.2222 1.70639C12.2222 1.22387 12.6127 0.833374 13.1019 0.833374ZM10.463 3.45191C10.463 3.93491 10.0726 4.3254 9.58341 4.3254C9.09761 4.3254 8.70378 3.93835 8.70378 3.45322C8.09771 3.45177 7.50324 3.45175 6.94452 3.45174C6.94452 3.93491 6.55409 4.3254 6.06489 4.3254C5.57909 4.3254 5.18526 3.93835 5.18526 3.45322C4.12296 3.45181 3.42601 3.45226 3.42601 3.45226L3.42677 17.4206L15.7408 17.4208L15.7401 3.45239C15.7401 3.45239 15.0434 3.45231 13.9816 3.45221C13.9816 3.93491 13.5911 4.3254 13.1019 4.3254C12.6161 4.3254 12.2223 3.93835 12.2223 3.45322C11.6636 3.452 11.0691 3.45195 10.463 3.45191ZM9.58333 8.2539C9.58333 7.77174 9.98002 7.38088 10.4667 7.38088H13.9777C14.4656 7.38088 14.8611 7.76838 14.8611 8.2539C14.8611 8.73605 14.4644 9.12691 13.9777 9.12691H10.4667C9.97884 9.12691 9.58333 8.73941 9.58333 8.2539ZM9.58333 13.0556C9.58333 12.5735 9.98002 12.1826 10.4667 12.1826H13.9777C14.4656 12.1826 14.8611 12.5701 14.8611 13.0556C14.8611 13.5378 14.4644 13.9286 13.9777 13.9286H10.4667C9.97884 13.9286 9.58333 13.5411 9.58333 13.0556ZM5.44279 8.87123L4.56316 7.99821C4.21964 7.65728 4.21964 7.10452 4.56316 6.76358C4.90668 6.42265 5.46363 6.42265 5.80714 6.76358L6.06497 7.01947L7.20205 5.89057C7.54556 5.54963 8.10252 5.54963 8.44603 5.89057C8.78955 6.2315 8.78955 6.78426 8.44603 7.1252L6.68677 8.87123C6.34326 9.21216 5.78631 9.21216 5.44279 8.87123ZM5.44279 13.6729L4.56316 12.7999C4.21964 12.4589 4.21964 11.9062 4.56316 11.5652C4.90668 11.2243 5.46363 11.2243 5.80714 11.5652L6.06648 11.8226L7.20205 10.6922C7.54556 10.3513 8.10252 10.3513 8.44603 10.6922C8.78955 11.0331 8.78955 11.5859 8.44603 11.9268L6.68677 13.6729C6.34326 14.0138 5.78631 14.0138 5.44279 13.6729Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var chevron_up_16 = function chevron_up_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M2.96934 11.5919C2.51884 12.0287 1.78845 12.0287 1.33795 11.5919C0.887455 11.1551 0.887455 10.4468 1.33795 10.0099L7.18437 4.4082C7.63487 3.97136 8.36527 3.97136 8.81576 4.4082L14.6622 10.0099C15.1127 10.4468 15.1127 11.1551 14.6622 11.5919C14.2117 12.0287 13.4813 12.0287 13.0308 11.5919L8.00007 6.78113L2.96934 11.5919Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var chevron_down_16 = function chevron_down_16(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M13.0307 4.4081C13.4812 3.97126 14.2116 3.97126 14.662 4.4081C15.1125 4.84494 15.1125 5.55321 14.662 5.99005L8.81563 11.5918C8.36513 12.0286 7.63473 12.0286 7.18424 11.5918L1.33779 5.99005C0.887297 5.55321 0.887297 4.84494 1.33779 4.4081C1.78829 3.97126 2.51869 3.97126 2.96919 4.4081L7.99993 9.21887L13.0307 4.4081Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var chevron_left_16 = function chevron_left_16(_ref3) {
  var outlineColor = _ref3.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M11.5919 13.0307C12.0287 13.4812 12.0287 14.2116 11.5919 14.662C11.1551 15.1125 10.4468 15.1125 10.0099 14.662L4.4082 8.81563C3.97136 8.36513 3.97136 7.63473 4.4082 7.18424L10.0099 1.33779C10.4468 0.887297 11.1551 0.887297 11.5919 1.33779C12.0287 1.78829 12.0287 2.51869 11.5919 2.96919L6.78113 7.99993L11.5919 13.0307Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var chevron_right_16 = function chevron_right_16(_ref4) {
  var outlineColor = _ref4.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M4.4081 2.96934C3.97126 2.51884 3.97126 1.78845 4.4081 1.33795C4.84494 0.887455 5.55321 0.887455 5.99005 1.33795L11.5918 7.18437C12.0286 7.63487 12.0286 8.36527 11.5918 8.81576L5.99005 14.6622C5.55321 15.1127 4.84494 15.1127 4.4081 14.6622C3.97126 14.2117 3.97126 13.4813 4.4081 13.0308L9.21887 8.00007L4.4081 2.96934Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
//  Size 20
var chevron_left_20 = function chevron_left_20(_ref5) {
  var outlineColor = _ref5.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M14.6746 17.3773C15.1085 17.8248 15.1085 18.5503 14.6746 18.9978C14.2406 19.4452 13.5371 19.4452 13.1032 18.9978L5.32544 10.9769C4.89152 10.5295 4.89152 9.80396 5.32544 9.35648L13.1032 1.33565C13.5371 0.888172 14.2406 0.888172 14.6746 1.33565C15.1085 1.78312 15.1085 2.50862 14.6746 2.9561L7.68246 10.1667L14.6746 17.3773Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var chevron_down_20 = function chevron_down_20(_ref6) {
  var outlineColor = _ref6.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M17.3773 5.32544C17.8247 4.89152 18.5502 4.89152 18.9977 5.32544C19.4452 5.75935 19.4452 6.46287 18.9977 6.89678L10.9769 14.6746C10.5294 15.1085 9.80389 15.1085 9.35642 14.6746L1.33559 6.89678C0.888111 6.46287 0.888111 5.75935 1.33559 5.32544C1.78306 4.89152 2.50856 4.89152 2.95604 5.32544L10.1666 12.3175L17.3773 5.32544Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var chevron_right_20 = function chevron_right_20(_ref7) {
  var outlineColor = _ref7.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M5.32544 2.62269C4.89152 2.17521 4.89152 1.44971 5.32544 1.00223C5.75935 0.554757 6.46287 0.554757 6.89678 1.00223L14.6746 9.02307C15.1085 9.47054 15.1085 10.196 14.6746 10.6435L6.89678 18.6644C6.46287 19.1118 5.75935 19.1118 5.32544 18.6644C4.89152 18.2169 4.89152 17.4914 5.32544 17.0439L12.3175 9.83329L5.32544 2.62269Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var chevron_up_20 = function chevron_up_20(_ref8) {
  var outlineColor = _ref8.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M2.62275 14.6746C2.17527 15.1085 1.44977 15.1085 1.00229 14.6746C0.554818 14.2406 0.554818 13.5371 1.00229 13.1032L9.02313 5.32544C9.4706 4.89152 10.1961 4.89152 10.6436 5.32544L18.6644 13.1032C19.1119 13.5371 19.1119 14.2406 18.6644 14.6746C18.2169 15.1085 17.4914 15.1085 17.044 14.6746L9.83335 7.68246L2.62275 14.6746Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var clock_20 = function clock_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.11061 6.32298C9.11061 5.77182 9.55116 5.32501 10.1031 5.32501C10.6513 5.32501 11.0957 5.76791 11.0957 6.32298V10.3158C11.0957 10.8671 10.6556 11.314 10.1041 11.314H8.11714C7.5695 11.314 7.12555 10.8709 7.12555 10.3158C7.12555 9.76454 7.56559 9.31765 8.11714 9.31765H9.11061V6.32298ZM14.2979 17.0971C13.0807 17.8602 11.6432 18.3011 10.1032 18.3011C8.56325 18.3011 7.12568 17.8602 5.9085 17.0971L5.0071 18.6673C4.73328 19.1442 4.12978 19.3093 3.65175 19.0318C3.17703 18.7562 3.01221 18.1495 3.28799 17.6691C3.28799 17.6691 4.3293 15.8614 4.35638 15.8261C2.99738 14.3931 2.16295 12.4524 2.16295 10.3158C2.16295 9.12658 2.42146 7.99805 2.88504 6.98398C2.13938 6.34321 1.66669 5.39056 1.66669 4.32687C1.66669 2.39743 3.22199 0.833313 5.14054 0.833313C6.42419 0.833313 7.54523 1.5335 8.14662 2.57481C8.7725 2.4153 9.42801 2.33055 10.1032 2.33055C10.7137 2.33055 11.3081 2.39985 11.8791 2.53104C12.4864 1.51392 13.5939 0.833313 14.8595 0.833313C16.7781 0.833313 18.3334 2.39743 18.3334 4.32687C18.3334 5.31999 17.9213 6.21632 17.2597 6.85239C17.762 7.90006 18.0434 9.07488 18.0434 10.3158C18.0434 12.4524 17.209 14.3931 15.85 15.8261C15.8771 15.8614 16.9184 17.6691 16.9184 17.6691C17.1942 18.1495 17.0294 18.7562 16.5546 19.0318C16.0766 19.3093 15.4731 19.1442 15.1993 18.6673L14.2979 17.0971ZM5.14053 2.82964C4.31829 2.82964 3.65173 3.49998 3.65173 4.32688C3.65173 4.67055 3.76801 4.99184 3.96656 5.24811C4.59979 4.4735 5.37521 3.82089 6.25268 3.33065C5.97683 3.01987 5.57653 2.82964 5.14053 2.82964ZM16.3483 4.32688C16.3483 3.49998 15.6817 2.82964 14.8595 2.82964C14.4593 2.82964 14.0892 2.98988 13.8179 3.25648C14.6991 3.72645 15.4819 4.35843 16.1268 5.11295C16.268 4.88271 16.3483 4.61252 16.3483 4.32688ZM4.14795 10.3158C4.14795 13.6234 6.81418 16.3048 10.1031 16.3048C13.3921 16.3048 16.0583 13.6234 16.0583 10.3158C16.0583 7.00823 13.3921 4.32688 10.1031 4.32688C6.81418 4.32688 4.14795 7.00823 4.14795 10.3158Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var clock_24 = function clock_24(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM10 4C10.5128 4 10.9355 4.38604 10.9933 4.88338L11 5V9.58579L12.7071 11.2929C13.0976 11.6834 13.0976 12.3166 12.7071 12.7071C12.3466 13.0676 11.7794 13.0953 11.3871 12.7903L11.2929 12.7071L9.29289 10.7071C9.13661 10.5508 9.0374 10.3481 9.00867 10.1314L9 10V5C9 4.44772 9.44771 4 10 4Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var close_16 = function close_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M14.6658 2.94794C15.1114 2.50233 15.1114 1.77985 14.6658 1.33423C14.2202 0.888603 13.4978 0.88859 13.0521 1.3342L8.00003 6.38628L2.94789 1.33422C2.50228 0.888608 1.77982 0.888621 1.33422 1.33424C0.888631 1.77987 0.888644 2.50235 1.33425 2.94796L6.38634 7.99997L1.33423 13.052C0.888624 13.4976 0.888612 14.2201 1.33421 14.6657C1.7798 15.1114 2.50226 15.1114 2.94787 14.6658L8.00003 9.61366L13.0521 14.6657C13.4978 15.1113 14.2202 15.1113 14.6658 14.6657C15.1114 14.2201 15.1114 13.4976 14.6658 13.052L9.61373 7.99997L14.6658 2.94794Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var close_20 = function close_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M18.831 2.78951C19.2785 2.34203 19.2785 1.6165 18.8311 1.16901C18.3836 0.721508 17.6581 0.721495 17.2106 1.16898L9.99998 8.37957L2.78936 1.16898C2.34188 0.721495 1.61637 0.721508 1.16891 1.16901C0.721438 1.6165 0.72145 2.34203 1.16893 2.78951L8.3795 10L1.16893 17.2106C0.72145 17.6581 0.721438 18.3836 1.16891 18.8311C1.61637 19.2786 2.34188 19.2786 2.78936 18.8311L9.99998 11.6205L17.2106 18.8311C17.6581 19.2786 18.3836 19.2786 18.8311 18.8311C19.2785 18.3836 19.2785 17.6581 18.831 17.2106L11.6205 10L18.831 2.78951Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

/* eslint-disable @typescript-eslint/naming-convention */
var diversity_20 = function diversity_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsxs("svg", Object.assign({
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("circle", {
      cx: "24",
      cy: "24",
      r: "24",
      fill: "#C2E7FF"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.0634 22.9533C22.3044 22.8903 22.5501 22.8389 22.7997 22.7995C22.8391 22.55 22.8905 22.3045 22.9534 22.0636C22.2462 20.1262 20.5082 18.6848 18.4032 18.4032C18.6849 20.5081 20.1261 22.246 22.0634 22.9533ZM16.4467 16.4466C17.0227 12.7936 20.1851 10 24.0001 10C27.815 10 30.9775 12.7936 31.5535 16.4466C35.2066 17.0226 38.0002 20.1851 38.0002 24C38.0002 27.815 35.2066 30.9775 31.5535 31.5534C30.9775 35.2065 27.815 38 24.0001 38C20.1852 38 17.0227 35.2065 16.4467 31.5534C12.7936 30.9775 10 27.815 10 24C10 20.1851 12.7936 17.0226 16.4467 16.4466ZM18.4914 16.3991C19.0595 13.8808 21.3101 12 24.0001 12C26.69 12 28.9407 13.8808 29.5088 16.3991C27.214 16.6511 25.2248 17.9185 24.0001 19.7422C22.7754 17.9185 20.7862 16.6511 18.4914 16.3991ZM25.2004 22.7995C25.1611 22.55 25.1097 22.3045 25.0468 22.0636C25.754 20.1262 27.4919 18.6848 29.597 18.4032C29.3153 20.5081 27.874 22.246 25.9368 22.9533C25.6958 22.8903 25.4501 22.8389 25.2004 22.7995ZM25.0468 25.9365C25.1097 25.6955 25.1611 25.45 25.2004 25.2005C25.4501 25.1611 25.6958 25.1096 25.9368 25.0467C27.8741 25.754 29.3153 27.4919 29.597 29.5969C27.492 29.3152 25.754 27.8738 25.0468 25.9365ZM22.9534 25.9365C22.8905 25.6955 22.8391 25.45 22.7997 25.2005C22.5501 25.1611 22.3044 25.1096 22.0634 25.0467C20.1261 25.754 18.6848 27.4919 18.4032 29.5969C20.5082 29.3152 22.2462 27.8738 22.9534 25.9365ZM18.4914 31.601C20.7862 31.3489 22.7754 30.0816 24.0001 28.2578C25.2248 30.0816 27.214 31.3489 29.5088 31.601C28.9406 34.1192 26.69 36 24.0001 36C21.3102 36 19.0595 34.1192 18.4914 31.601ZM16.3991 29.5087C16.6511 27.214 17.9185 25.2247 19.7422 24C17.9185 22.7753 16.6511 20.7861 16.3991 18.4913C13.8808 19.0594 12 21.3101 12 24C12 26.69 13.8808 28.9406 16.3991 29.5087ZM36.0002 24C36.0002 21.3101 34.1194 19.0594 31.6011 18.4913C31.349 20.7861 30.0817 22.7753 28.258 24C30.0817 25.2247 31.3491 27.214 31.6011 29.5087C34.1194 28.9406 36.0002 26.69 36.0002 24Z",
      fill: outlineColor || '#353535'
    }, void 0)]
  }), void 0);
};

/* eslint-disable @typescript-eslint/naming-convention */
var employer_icon_24 = function employer_icon_24() {
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    viewBox: "0 0 24 25"
  }, {
    children: jsx("g", Object.assign({
      fill: "none",
      fillRule: "evenodd",
      stroke: "#FFF",
      strokeLinecap: "round",
      "stroke-linejoin": "round",
      strokeWidth: ".917"
    }, {
      children: jsx("path", {
        d: "M11.844 22.666V19.3H9.907v3.366M7.22 22.703V5.198M18.961 9.386v13.317M9.004 13.06h1.203v-1.484H9.004zM11.606 13.06h1.204v-1.484h-1.204zM9.004 16.893h1.203V15.41H9.004zM4.385 13.06h1.203v-1.484H4.385zM4.385 16.893h1.203V15.41H4.385zM4.385 20.784h1.203V19.3H4.385zM16.21 13.031h1.204v-1.483h-1.203zM16.21 16.865h1.204V15.38h-1.203zM16.21 20.755h1.204v-1.484h-1.203zM11.606 16.893h1.204V15.41h-1.204zM9.004 9.306h1.203V7.823H9.004zM11.606 9.306h1.204V7.823h-1.204zM6.9 5.145h8.083V3.463H6.9zM14.74 9.232h4.502V7.927H14.74M13.19 3.376V1.958h-1.576v1.418M14.664 5.198v17.505M22.73 19.792c0 .5-.43.906-.958.906-.53 0-.958-.406-.958-.906s.429-.906.958-.906c.529 0 .958.405.958.906zM22.433 18.26c0 .345-.296.625-.661.625-.365 0-.661-.28-.661-.625 0-.346.296-.626.66-.626.366 0 .662.28.662.626zM21.772 20.887v1.91M22.987 22.826H1M2.753 10.056v12.638M7.107 9.856H2.285V8.391h4.822"
      }, void 0)
    }), void 0)
  }), void 0);
};

var facebook_16 = function facebook_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsxs("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("title", {
      children: "Check out Fairygodboss on Facebook"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.90455 3.99219H11V2.08438C10.8114 2.05859 10.1614 2 9.40455 2C7.825 2 6.74318 2.99375 6.74318 4.81953V6.5H5V8.63281H6.74318V14H8.87955V8.63281H10.5523L10.8182 6.5H8.87955V5.03047C8.87955 4.41406 9.04545 3.99219 9.90455 3.99219Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)]
  }), void 0);
};
var facebook_20 = function facebook_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsxs("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("title", {
      children: "Check out Fairygodboss on Facebook"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5394 4.65625H14V2.1125C13.7485 2.07812 12.8818 2 11.8727 2C9.76667 2 8.32424 3.325 8.32424 5.75938V8H6V10.8438H8.32424V18H11.1727V10.8438H13.403L13.7576 8H11.1727V6.04063C11.1727 5.21875 11.3939 4.65625 12.5394 4.65625Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)]
  }), void 0);
};

var filter_16 = function filter_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.74509 10.6249V9.74823C7.74509 8.78264 8.56417 7.99987 9.56689 7.99987H11.3944C12.4006 7.99987 13.2162 8.78249 13.2162 9.74823V10.6249L14.576 10.625C15.079 10.625 15.4867 11.0134 15.4867 11.5001C15.4867 11.9833 15.0802 12.3751 14.576 12.3751L13.2162 12.3749V13.2516C13.2162 14.2172 12.3971 15 11.3944 15H9.56689C8.56074 15 7.74509 14.2173 7.74509 13.2516V12.3749L1.81371 12.3751C1.31079 12.3751 0.903095 11.9867 0.903095 11.5001C0.903095 11.0168 1.30957 10.625 1.81371 10.625L7.74509 10.6249ZM2.7209 2.74836C2.7209 1.78277 3.53999 1 4.54271 1H6.37022C7.37638 1 8.19203 1.78262 8.19203 2.74836V3.62503L13.9915 3.62499C14.4944 3.62499 14.9021 4.01338 14.9021 4.5C14.9021 4.98326 14.4957 5.37501 13.9915 5.37501L8.19203 5.37506V6.25173C8.19203 7.21732 7.37295 8.00009 6.37022 8.00009H4.54271C3.53656 8.00009 2.7209 7.21747 2.7209 6.25173V5.37506L1.42405 5.37501C0.921126 5.37501 0.513428 4.98662 0.513428 4.5C0.513428 4.01674 0.919905 3.62499 1.42405 3.62499L2.7209 3.62503V2.74836ZM4.59199 2.74992V6.24997H6.41569V2.74992H4.59199ZM9.57843 9.75005V13.2501H11.4021V9.75005H9.57843Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var filter_20 = function filter_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.4584 13.5185V12.6372C10.4584 11.6665 11.2818 10.8796 12.2898 10.8796H14.127C15.1384 10.8796 15.9584 11.6664 15.9584 12.6372V13.5185H18.2513C18.7569 13.5185 19.1667 13.9089 19.1667 14.3981C19.1667 14.8839 18.7581 15.2778 18.2513 15.2778H15.9584V16.1591C15.9584 17.1298 15.135 17.9167 14.127 17.9167H12.2898C11.2783 17.9167 10.4584 17.1299 10.4584 16.1591V15.2778H1.7488C1.24322 15.2778 0.833374 14.8873 0.833374 14.3981C0.833374 13.9123 1.242 13.5185 1.7488 13.5185H10.4584ZM4.04171 3.8409C4.04171 2.87021 4.86511 2.08331 5.87313 2.08331H7.71029C8.72175 2.08331 9.54171 2.87007 9.54171 3.8409V4.7222H18.2513C18.7569 4.7222 19.1667 5.11264 19.1667 5.60183C19.1667 6.08764 18.7581 6.48146 18.2513 6.48146H9.54171V7.36276C9.54171 8.33345 8.7183 9.12035 7.71029 9.12035H5.87313C4.86166 9.12035 4.04171 8.3336 4.04171 7.36276V6.48146H1.7488C1.24322 6.48146 0.833374 6.09102 0.833374 5.60183C0.833374 5.11603 1.242 4.7222 1.7488 4.7222H4.04171V3.8409ZM5.87498 3.84255V7.36107H7.70831V3.84255H5.87498ZM12.2917 12.6389V16.1574H14.125V12.6389H12.2917Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var fire_16 = function fire_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0198 5.91094C13.106 6.80468 13.7273 7.90052 13.7273 9.40339C13.7273 12.5344 11.1595 15 8.00821 15C4.85408 15 2.27271 12.5327 2.27271 9.40339C2.27271 7.67994 2.66472 6.6148 3.8155 4.84436C4.17964 4.28415 5.0638 4.48816 5.1323 5.1482C5.19386 5.74129 5.38286 6.24613 5.65824 6.63317C5.47457 4.54177 6.42764 2.1897 8.77768 1.07227C9.32175 0.813566 9.92887 1.28953 9.7873 1.86379C9.42041 3.35201 9.79843 4.15267 10.7866 5.01521C10.8107 5.03625 10.9338 5.12283 11.0966 5.23735C11.3915 5.44473 11.8166 5.74372 12.0198 5.91094ZM4.39938 7.26698C4.21077 7.68529 3.98388 8.18851 3.98388 9.38005C3.98388 11.5782 5.79185 13.3062 8.00769 13.3062C10.2195 13.3062 12.0161 11.5811 12.0161 9.38005C12.0161 8.39807 11.631 7.71872 10.8955 7.11356C10.7794 7.01804 10.5073 6.82519 10.2511 6.64367C10.009 6.47204 9.78109 6.31054 9.7129 6.25102C8.82593 5.47678 8.28367 4.65231 8.21002 3.55293C7.76156 3.97957 6.73107 5.30592 7.31189 7.93083C7.40193 8.33775 7.08419 8.72195 6.65762 8.72195C5.81125 8.72195 4.97463 8.09026 4.46332 7.12329C4.4428 7.17067 4.42135 7.21825 4.39938 7.26698Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var fire_20 = function fire_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.264 7.2643C16.6865 8.43467 17.5 9.86971 17.5 11.8377C17.5 15.9379 14.1375 19.1666 10.0108 19.1666C5.88037 19.1666 2.5 15.9357 2.5 11.8377C2.5 9.58085 3.01336 8.18603 4.52033 5.8676C4.99717 5.13398 6.155 5.40114 6.24471 6.26548C6.32532 7.04214 6.57282 7.70324 6.93344 8.21008C6.69291 5.47135 7.94099 2.39125 11.0184 0.92795C11.7309 0.589173 12.5259 1.21246 12.3405 1.96446C11.8601 3.91332 12.3551 4.96181 13.6491 6.09132C13.6807 6.11888 13.8419 6.23226 14.0551 6.38221C14.4412 6.65379 14.9979 7.04532 15.264 7.2643ZM4.95697 8.87818C4.6928 9.46407 4.37501 10.1689 4.37501 11.8378C4.37501 14.9165 6.90727 17.3368 10.0108 17.3368C13.1087 17.3368 15.625 14.9206 15.625 11.8378C15.625 10.4624 15.0856 9.5109 14.0555 8.66331C13.8929 8.52952 13.5117 8.25941 13.153 8.00517C12.8138 7.76478 12.4946 7.53858 12.3991 7.45522C11.1568 6.37082 10.3973 5.21606 10.2942 3.67626C9.66605 4.27382 8.22273 6.13151 9.03624 9.80797C9.16235 10.3779 8.71733 10.916 8.11986 10.916C6.93444 10.916 5.76266 10.0313 5.04651 8.67693C5.01778 8.74329 4.98774 8.80993 4.95697 8.87818Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

/* eslint-disable @typescript-eslint/naming-convention */
var giving_hand_20 = function giving_hand_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsxs("svg", Object.assign({
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("circle", {
      cx: "24",
      cy: "24",
      r: "24",
      fill: "#B394F2",
      fillOpacity: "0.5"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 13.9435C20 12.888 20.8774 12 22 12C22.5185 12 22.9865 12.1903 23.3402 12.5009L24 13.0803L24.6598 12.5009C25.0135 12.1903 25.4815 12 26 12C27.1226 12 28 12.888 28 13.9435C28 14.7817 27.5492 15.7188 26.712 16.6708C25.9626 17.5231 24.9798 18.2983 23.9986 18.9073C23.0136 18.3009 22.0315 17.5262 21.2839 16.674C20.4492 15.7224 20 14.7836 20 13.9435ZM22 10C19.8089 10 18 11.7477 18 13.9435C18 15.476 18.7955 16.8701 19.7804 17.9929C20.7765 19.1284 22.0634 20.0995 23.2806 20.8084C23.5301 20.9567 23.7947 21.0007 24.004 21C24.2139 20.9993 24.4768 20.9535 24.7237 20.8057C25.931 20.0958 27.2166 19.1257 28.2139 17.9916C29.1993 16.871 30 15.4778 30 13.9435C30 11.7477 28.1911 10 26 10C25.2731 10 24.5893 10.1918 24 10.5278C23.4107 10.1918 22.7269 10 22 10ZM12 36H15C16 36 17 35.5 17 34.5C18.844 35.6557 21.6475 37.0178 25 37C28.3983 37.018 31.2089 36.0647 33.9927 34.4802C36.2472 33.197 38.0066 31.6437 38 30.6448C38 28.9494 35.716 27.0228 32.7487 27.0228H28.805C27.8434 25.5973 26.7889 24.9884 25.2056 24.9884C25.2056 24.9884 21.8153 25 21.5 25C19.8981 23.9727 18.0676 23.6384 17 23.5C17 22.5 16 22 15 22H12C11 22 10 22.5 10 24V34C10 35.5 11.0343 36 12 36ZM36 30.5C36 31.221 31.0784 35.1181 24.9927 35.1181C21.7569 35.1181 19.0936 33.7381 17 32.374V25.3589C18.5 25.5 20.7921 26.702 20.8377 26.7385C21.0329 26.8942 21.2571 27 21.5 27L26 27C27 27 28 29 28 29H21C20.374 29 20 29.3257 20 30C20 30.6743 20.374 31 21 31H29C29.7376 31 30.5 31 30.5 30C30.5 30 30.5 29.5 30 29H33C34.5 29 36 29.7789 36 30.5ZM12 24L15 24.0033V34H12V24Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)]
  }), void 0);
};

var heart_16 = function heart_16(_ref) {
  var outlineColor = _ref.outlineColor,
    fillColor = _ref.fillColor;
  return jsxs("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.8 1.5C9.7243 1.5 8.74306 1.90937 8 2.58261C7.25694 1.90937 6.2757 1.5 5.2 1.5C2.8804 1.5 1 3.40354 1 5.75167C1 9.17886 4.485 12.4913 7.70482 14.4239C7.86785 14.5263 8.13467 14.5249 8.29723 14.4225C11.4958 12.4835 15 9.17869 15 5.75167C15 3.40354 13.1196 1.5 10.8 1.5ZM8.00055 12.6391C4.7554 10.4915 2.74684 7.98278 2.74684 5.90729C2.74684 4.43971 3.92209 3.25 5.37184 3.25C6.02778 3.25 6.64296 3.49273 7.12151 3.92632L7.75301 4.49848C7.88951 4.62215 8.106 4.62049 8.24067 4.49848L8.87216 3.92632C9.35072 3.49273 9.96589 3.25 10.6218 3.25C12.0716 3.25 13.2468 4.43971 13.2468 5.90729C13.2468 8.03615 11.2458 10.4915 8.00055 12.6391Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      d: "M2.74684 5.90729C2.74684 7.98278 4.7554 10.4915 8.00055 12.6391C11.2458 10.4915 13.2468 8.03615 13.2468 5.90729C13.2468 4.43971 12.0716 3.25 10.6218 3.25C9.96589 3.25 9.35072 3.49273 8.87216 3.92632L8.24067 4.49848C8.106 4.62049 7.88951 4.62215 7.75301 4.49848L7.12151 3.92632C6.64296 3.49273 6.02778 3.25 5.37184 3.25C3.92209 3.25 2.74684 4.43971 2.74684 5.90729Z",
      fill: fillColor || 'none',
      stroke: fillColor || 'none',
      strokeWidth: "0.1"
    }, void 0)]
  }), void 0);
};
var heart_20 = function heart_20(_ref2) {
  var outlineColor = _ref2.outlineColor,
    fillColor = _ref2.fillColor;
  return jsxs("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.6666 1.66663C12.258 1.66663 10.973 2.19146 9.99998 3.05458C9.02693 2.19146 7.74196 1.66663 6.33331 1.66663C3.29575 1.66663 0.833313 4.10706 0.833313 7.11748C0.833313 11.5113 5.39701 15.758 9.61344 18.2357C9.82692 18.367 10.1763 18.3652 10.3892 18.2339C14.5778 15.748 19.1666 11.5111 19.1666 7.11748C19.1666 4.10706 16.7042 1.66663 13.6666 1.66663ZM10.0051 16.3233C5.47224 13.3865 2.66663 9.95574 2.66663 7.11748C2.66663 5.11053 4.30825 3.48357 6.3333 3.48357C7.24954 3.48357 8.10883 3.81551 8.77729 4.40845L9.65938 5.19089C9.85004 5.36001 10.1524 5.35774 10.3405 5.19089L11.2226 4.40845C11.8911 3.81551 12.7504 3.48357 13.6666 3.48357C15.6917 3.48357 17.3333 5.11053 17.3333 7.11748C17.3333 10.0287 14.5381 13.3865 10.0051 16.3233Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      d: "M2.66669 7.11755C2.66669 9.95581 5.4723 13.3865 10.0052 16.3234C14.5382 13.3865 17.3334 10.0288 17.3334 7.11755C17.3334 5.1106 15.6917 3.48364 13.6667 3.48364C12.7504 3.48364 11.8912 3.81558 11.2227 4.40852L10.3406 5.19096C10.1525 5.35781 9.85009 5.36008 9.65944 5.19096L8.77734 4.40852C8.10889 3.81558 7.2496 3.48364 6.33335 3.48364C4.30831 3.48364 2.66669 5.1106 2.66669 7.11755Z",
      fill: fillColor || 'none',
      stroke: fillColor || 'none',
      strokeWidth: "0.1"
    }, void 0)]
  }), void 0);
};

var heartFilled_16 = function heartFilled_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M8 2.58261C8.74306 1.90937 9.7243 1.5 10.8 1.5C13.1196 1.5 15 3.40354 15 5.75167C15 9.17869 11.4958 12.4835 8.29723 14.4225C8.13467 14.5249 7.86785 14.5263 7.70483 14.4239C4.485 12.4913 1 9.17886 1 5.75167C1 3.40354 2.8804 1.5 5.2 1.5C6.2757 1.5 7.25694 1.90937 8 2.58261Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var heartFilled_20 = function heartFilled_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M10 3.05463C10.9731 2.1915 12.258 1.66667 13.6667 1.66667C16.7042 1.66667 19.1667 4.1071 19.1667 7.11752C19.1667 11.5111 14.5778 15.748 10.3892 18.234C10.1764 18.3653 9.82694 18.367 9.61346 18.2358C5.39703 15.7581 0.833333 11.5114 0.833333 7.11752C0.833333 4.1071 3.29577 1.66667 6.33333 1.66667C7.74198 1.66667 9.02695 2.1915 10 3.05463Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var heartOutline_16 = function heartOutline_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M10.8 1.5C9.7243 1.5 8.74306 1.90937 8 2.58261C7.25694 1.90937 6.2757 1.5 5.2 1.5C2.8804 1.5 1 3.40354 1 5.75167C1 9.17886 4.485 12.4913 7.70482 14.4239C7.86785 14.5263 8.13467 14.5249 8.29723 14.4225C11.4958 12.4835 15 9.17869 15 5.75167C15 3.40354 13.1196 1.5 10.8 1.5ZM8.00055 12.6391C4.7554 10.4915 2.74684 7.98278 2.74684 5.90729C2.74684 4.43971 3.92209 3.25 5.37184 3.25C6.02778 3.25 6.64296 3.49273 7.12151 3.92632L7.75301 4.49848C7.88951 4.62215 8.106 4.62049 8.24067 4.49848L8.87216 3.92632C9.35072 3.49273 9.96589 3.25 10.6218 3.25C12.0716 3.25 13.2468 4.43971 13.2468 5.90729C13.2468 8.03615 11.2458 10.4915 8.00055 12.6391Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var heartOutline_20 = function heartOutline_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M13.6666 1.66663C12.258 1.66663 10.973 2.19146 9.99998 3.05458C9.02693 2.19146 7.74196 1.66663 6.33331 1.66663C3.29575 1.66663 0.833313 4.10706 0.833313 7.11748C0.833313 11.5113 5.39701 15.758 9.61344 18.2357C9.82692 18.367 10.1763 18.3652 10.3892 18.2339C14.5778 15.748 19.1666 11.5111 19.1666 7.11748C19.1666 4.10706 16.7042 1.66663 13.6666 1.66663ZM10.0051 16.3233C5.47224 13.3865 2.66663 9.95574 2.66663 7.11748C2.66663 5.11053 4.30825 3.48357 6.3333 3.48357C7.24954 3.48357 8.10883 3.81551 8.77729 4.40845L9.65938 5.19089C9.85004 5.36001 10.1524 5.35774 10.3405 5.19089L11.2226 4.40845C11.8911 3.81551 12.7504 3.48357 13.6666 3.48357C15.6917 3.48357 17.3333 5.11053 17.3333 7.11748C17.3333 10.0287 14.5381 13.3865 10.0051 16.3233Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var home_icon_24 = function home_icon_24(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    "view-box": "0 0 24 24"
  }, {
    children: jsx("path", {
      fill: outlineColor || _wcImport4.neutral[100],
      fillRule: "evenodd",
      stroke: "#FFF",
      strokeLinecap: "round",
      "stroke-linejoin": "round",
      strokeWidth: "1.2",
      d: "M18.31 6.868V2.375h-2.75v1.936L12 1 1 11.227h1.821V23H21.18V11.227H23z"
    }, void 0)
  }), void 0);
};

var house_20 = function house_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "19",
    height: "20",
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.68 11.5956V14.7399H15.5544C16.0363 14.7399 16.427 15.1434 16.427 15.6373V16.5366H17.2967C17.7812 16.5366 18.1739 16.9354 18.1739 17.435C18.1739 17.9311 17.78 18.3334 17.2967 18.3334H4.36812C3.34201 18.3334 2.45129 17.5681 2.45129 16.5408V10.9351L2.36416 11.0401C2.05108 11.4176 1.49975 11.4626 1.13274 11.1406C0.765716 10.8186 0.721985 10.2516 1.03506 9.87408L7.33608 2.27704C7.99395 1.46511 9.13646 1.46401 9.78874 2.26914L16.0339 9.7989H17.3039C17.7844 9.7989 18.1739 10.1977 18.1739 10.6973C18.1739 11.1934 17.7808 11.5956 17.3039 11.5956H14.68ZM12.9356 8.83261L8.56569 3.56584L4.19582 8.83261C4.19746 8.85505 4.19829 8.87772 4.19829 8.90059V16.5408H12.9331V8.90059C12.9331 8.87772 12.9339 8.85505 12.9356 8.83261ZM6.81869 10.6965C6.81869 10.2008 7.20595 9.79895 7.69134 9.79895H9.43996C9.92191 9.79895 10.3126 10.1972 10.3126 10.6965V12.4949C10.3126 12.9906 9.92535 13.3924 9.43996 13.3924H7.69134C7.20939 13.3924 6.81869 12.9941 6.81869 12.4949V10.6965Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

/* eslint-disable @typescript-eslint/naming-convention */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var info_16 = function info_16() {
  return jsx("svg", Object.assign({
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16C12.866 16 16 12.866 16 9ZM18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9ZM9 4C8.44771 4 8 4.44772 8 5C8 5.55228 8.44771 6 9 6C9.55229 6 10 5.55228 10 5C10 4.44772 9.55229 4 9 4ZM9 7C8.44771 7 8 7.44772 8 8V13C8 13.5523 8.44771 14 9 14C9.55229 14 10 13.5523 10 13V8C10 7.44772 9.55229 7 9 7Z",
      fill: "#727272"
    }, void 0)
  }), void 0);
};

var instagram_16 = function instagram_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsxs("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("title", {
      children: "Check out Fairygodboss on Instagram"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.29505 2H8.70434C9.7095 2.00227 9.94029 2.01113 10.4736 2.03546C11.1123 2.06459 11.5485 2.16603 11.9301 2.31437C12.3247 2.46769 12.6593 2.67287 12.9929 3.00644C13.3265 3.34004 13.5317 3.67467 13.685 4.06924C13.8333 4.45091 13.9348 4.88709 13.9639 5.52576C13.9921 6.14442 13.9995 6.35599 14 7.84142V8.15798C13.9995 9.64339 13.9921 9.85495 13.9639 10.4736C13.9348 11.1123 13.8333 11.5485 13.685 11.9301C13.5317 12.3247 13.3265 12.6593 12.9929 12.9929C12.6593 13.3265 12.3247 13.5317 11.9301 13.685C11.5485 13.8333 11.1123 13.9348 10.4736 13.9639C9.85495 13.9921 9.64339 13.9995 8.15798 14H7.84142C6.35599 13.9995 6.14442 13.9921 5.52576 13.9639C4.88709 13.9348 4.45091 13.8333 4.06924 13.685C3.67467 13.5317 3.34004 13.3265 3.00644 12.9929C2.67287 12.6593 2.46769 12.3247 2.31437 11.9301C2.16603 11.5485 2.06459 11.1123 2.03546 10.4736C2.01113 9.94029 2.00227 9.7095 2 8.70434V7.29505C2.00227 6.28988 2.01113 6.05909 2.03546 5.52576C2.06459 4.88709 2.16603 4.45091 2.31437 4.06924C2.46769 3.67467 2.67287 3.34004 3.00644 3.00644C3.34004 2.67287 3.67467 2.46769 4.06924 2.31437C4.45091 2.16603 4.88709 2.06459 5.52576 2.03546C6.05909 2.01113 6.28988 2.00227 7.29505 2H8.70434H7.29505ZM8.43981 3.08068H7.55955C6.35513 3.08193 6.14446 3.08949 5.57502 3.11547C4.99 3.14214 4.67228 3.23989 4.46085 3.32207C4.18077 3.43092 3.98088 3.56094 3.77093 3.77093C3.56094 3.98088 3.43092 4.18077 3.32207 4.46085C3.23989 4.67228 3.14214 4.99 3.11547 5.57502C3.08949 6.14446 3.08193 6.35513 3.08068 7.55955V8.43981C3.08193 9.64422 3.08949 9.85488 3.11547 10.4243C3.14214 11.0094 3.23989 11.3271 3.32207 11.5385C3.43092 11.8186 3.56097 12.0185 3.77093 12.2284C3.98088 12.4384 4.18077 12.5684 4.46085 12.6773C4.67228 12.7595 4.99 12.8572 5.57502 12.8839C6.20766 12.9127 6.3974 12.9189 7.99969 12.9189C9.60195 12.9189 9.79171 12.9127 10.4243 12.8839C11.0094 12.8572 11.3271 12.7595 11.5385 12.6773C11.8186 12.5684 12.0185 12.4384 12.2284 12.2284C12.4384 12.0185 12.5684 11.8186 12.6773 11.5385C12.7595 11.3271 12.8572 11.0094 12.8839 10.4243C12.9127 9.79161 12.9189 9.60183 12.9189 7.99969C12.9189 6.39752 12.9127 6.20774 12.8839 5.57502C12.8572 4.99 12.7595 4.67228 12.6773 4.46085C12.5684 4.18077 12.4384 3.98088 12.2284 3.77093C12.0185 3.56094 11.8186 3.43092 11.5385 3.32207C11.3271 3.23989 11.0094 3.14214 10.4243 3.11547C9.85488 3.08949 9.64422 3.08193 8.43981 3.08068ZM7.99969 4.99951C9.65664 4.99951 10.9998 6.34272 10.9998 7.99969C10.9998 9.65664 9.65664 10.9998 7.99969 10.9998C6.34272 10.9998 4.99951 9.65664 4.99951 7.99969C4.99951 6.34272 6.34272 4.99951 7.99969 4.99951ZM7.99968 6.05219C6.9241 6.05219 6.05219 6.9241 6.05219 7.99968C6.05219 9.07524 6.9241 9.94715 7.99968 9.94715C9.07524 9.94715 9.94715 9.07524 9.94715 7.99968C9.94715 6.9241 9.07524 6.05219 7.99968 6.05219ZM11.2499 3.99946C11.6641 3.99946 11.9999 4.33527 11.9999 4.74951C11.9999 5.16375 11.6641 5.49954 11.2499 5.49954C10.8356 5.49954 10.4998 5.16375 10.4998 4.74951C10.4998 4.33527 10.8356 3.99946 11.2499 3.99946Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)]
  }), void 0);
};
var instagram_20 = function instagram_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsxs("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("title", {
      children: "Check out Fairygodboss on Instagram"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.06007 2H10.9391C12.2793 2.00303 12.587 2.01484 13.2982 2.04728C14.1497 2.08612 14.7313 2.22138 15.2402 2.41917C15.7663 2.62359 16.2124 2.89715 16.6572 3.34192C17.102 3.78672 17.3756 4.23289 17.58 4.75899C17.7778 5.26787 17.913 5.84946 17.9519 6.70101C17.9895 7.5259 17.9994 7.80798 18 9.78856V10.2106C17.9994 12.1912 17.9895 12.4733 17.9519 13.2982C17.913 14.1497 17.7778 14.7313 17.58 15.2402C17.3756 15.7663 17.102 16.2124 16.6572 16.6572C16.2124 17.102 15.7663 17.3756 15.2402 17.58C14.7313 17.7778 14.1497 17.913 13.2982 17.9519C12.4733 17.9895 12.1912 17.9994 10.2106 18H9.78856C7.80798 17.9994 7.5259 17.9895 6.70101 17.9519C5.84946 17.913 5.26787 17.7778 4.75899 17.58C4.23289 17.3756 3.78672 17.102 3.34192 16.6572C2.89715 16.2124 2.62359 15.7663 2.41917 15.2402C2.22138 14.7313 2.08612 14.1497 2.04728 13.2982C2.01484 12.587 2.00303 12.2793 2 10.9391V9.06007C2.00303 7.71984 2.01484 7.41212 2.04728 6.70101C2.08612 5.84946 2.22138 5.26787 2.41917 4.75899C2.62359 4.23289 2.89715 3.78672 3.34192 3.34192C3.78672 2.89715 4.23289 2.62359 4.75899 2.41917C5.26787 2.22138 5.84946 2.08612 6.70101 2.04728C7.41212 2.01484 7.71984 2.00303 9.06007 2H10.9391H9.06007ZM10.5864 3.44092H9.41276C7.80686 3.44259 7.52597 3.45267 6.76672 3.48731C5.98668 3.52288 5.56306 3.65321 5.28115 3.76278C4.90771 3.90791 4.6412 4.08128 4.36125 4.36125C4.08128 4.6412 3.90791 4.90771 3.76278 5.28115C3.65321 5.56306 3.52288 5.98668 3.48731 6.76672C3.45267 7.52597 3.44259 7.80686 3.44092 9.41276V10.5864C3.44259 12.1923 3.45267 12.4732 3.48731 13.2325C3.52288 14.0125 3.65321 14.4361 3.76278 14.718C3.90791 15.0915 4.08131 15.358 4.36125 15.6379C4.6412 15.9179 4.90771 16.0913 5.28115 16.2364C5.56306 16.346 5.98668 16.4763 6.76672 16.5119C7.61024 16.5504 7.86322 16.5585 9.9996 16.5585C12.1359 16.5585 12.389 16.5504 13.2325 16.5119C14.0125 16.4763 14.4361 16.346 14.718 16.2364C15.0915 16.0913 15.358 15.9179 15.6379 15.6379C15.9179 15.358 16.0913 15.0915 16.2364 14.718C16.346 14.4361 16.4763 14.0125 16.5119 13.2325C16.5504 12.3888 16.5585 12.1358 16.5585 9.9996C16.5585 7.86338 16.5504 7.61033 16.5119 6.76672C16.4763 5.98668 16.346 5.56306 16.2364 5.28115C16.0913 4.90771 15.9179 4.6412 15.6379 4.36125C15.358 4.08128 15.0915 3.90791 14.718 3.76278C14.4361 3.65321 14.0125 3.52288 13.2325 3.48731C12.4732 3.45267 12.1923 3.44259 10.5864 3.44092ZM9.9996 5.99936C12.2089 5.99936 13.9998 7.79031 13.9998 9.9996C13.9998 12.2089 12.2089 13.9998 9.9996 13.9998C7.79031 13.9998 5.99936 12.2089 5.99936 9.9996C5.99936 7.79031 7.79031 5.99936 9.9996 5.99936ZM9.9996 7.40295C8.56549 7.40295 7.40295 8.56549 7.40295 9.9996C7.40295 11.4337 8.56549 12.5962 9.9996 12.5962C11.4337 12.5962 12.5962 11.4337 12.5962 9.9996C12.5962 8.56549 11.4337 7.40295 9.9996 7.40295ZM14.3331 4.66595C14.8855 4.66595 15.3332 5.1137 15.3332 5.66603C15.3332 6.21835 14.8855 6.66607 14.3331 6.66607C13.7809 6.66607 13.3331 6.21835 13.3331 5.66603C13.3331 5.1137 13.7809 4.66595 14.3331 4.66595Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)]
  }), void 0);
};

var job_icon_24 = function job_icon_24(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    viewBox: "0 0 24 25"
  }, {
    children: jsxs("g", Object.assign({
      fill: "none",
      fillRule: "evenodd",
      stroke: "#FFF",
      strokeLinecap: "round",
      "stroke-linejoin": "round",
      strokeWidth: "1.2"
    }, {
      children: [jsx("path", {
        d: "M8.816 4.661c0-1.492 1.36-2.703 3.04-2.703 1.678 0 3.039 1.21 3.039 2.703M6.21 14.392h2.316V11.69H6.211zM15.474 14.392h2.315V11.69h-2.315zM15.184 13.04l-2.444.685a3.375 3.375 0 0 1-1.833-.001l-2.38-.672",
        fill: outlineColor || _wcImport4.neutral[100]
      }, void 0), jsx("path", {
        d: "M6.263 12.5L1 11.19l.579-5.122c0-.627.555-1.136 1.239-1.136h18.364c.684 0 1.24.509 1.24 1.136L23 11.19l-5.216 1.292",
        fill: outlineColor || _wcImport4.neutral[100]
      }, void 0), jsx("path", {
        d: "M3.172 11.902L1 21.795c0 .688.593 1.247 1.324 1.247h19.063c.731 0 1.324-.559 1.324-1.247l-1.95-9.87",
        fill: outlineColor || _wcImport4.neutral[100]
      }, void 0)]
    }), void 0)
  }), void 0);
};

/* eslint-disable @typescript-eslint/naming-convention */
var light_wing_16 = function light_wing_16() {
  return jsxs("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("circle", {
      cx: "8",
      cy: "8",
      r: "8",
      fill: "#D09FD8"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.77906 5.00534C10.8056 4.794 11.3736 4.44634 11.9904 3.625C12.1156 3.625 12.4003 4.15362 12.3732 4.68591L12.3727 4.695C12.3415 5.31252 12.2828 6.47346 10.4892 7.32221C10.8596 7.37402 11.3728 7.34759 11.8596 7.13454C11.8596 7.98623 11.1298 9.58308 8.7252 9.7428C8.85998 10.0622 9.4817 10.1156 9.85986 10.1422C9.48114 10.9408 8.45468 11.4464 7.26554 11.4731C7.14297 11.4758 6.97679 11.4628 6.78656 11.4479C6.36315 11.4148 5.82057 11.3724 5.37437 11.4731C4.64266 11.6382 4.35807 11.7589 3.85783 12.375C3.85783 12.3226 3.83781 12.213 3.80951 12.058C3.63801 11.1188 3.16244 8.5144 4.99612 6.89515C5.03085 6.86447 5.06478 6.83426 5.09823 6.80447C5.81944 6.16233 6.31871 5.71778 9.77906 5.00534ZM9.19133 6.07011C9.86847 5.9307 10.9101 5.69655 11.4833 5.25938C11.3765 5.69548 11.1608 5.90102 10.9267 6.12416C10.8839 6.16494 10.8405 6.2063 10.797 6.24977C10.2979 6.60849 8.8147 7.45168 8.08319 7.78605C8.32755 7.82022 10.2091 8.06422 10.6062 8.10559C10.2008 8.64342 9.31518 9.06308 7.62309 9.09617C7.62309 9.52511 7.92137 10.23 8.43412 10.3673C8.3921 10.3982 8.16533 10.4927 7.43306 10.5465C7.31164 10.5492 7.1625 10.5377 6.99311 10.5247C6.79863 10.5097 6.57744 10.4927 6.34085 10.4927C5.89818 10.4927 5.29415 10.5341 4.7439 10.7947C4.74361 10.7921 4.7433 10.7892 4.74295 10.786C4.71522 10.531 4.49953 8.54837 5.80301 7.45192C5.83654 7.42371 5.8689 7.39632 5.90038 7.36965C6.52934 6.8371 6.81164 6.59806 9.19133 6.07011Z",
      fill: "white"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.4833 5.25928C10.9101 5.69646 9.86844 5.9306 9.19131 6.07001C6.69248 6.62439 6.5063 6.86021 5.80298 7.45182C4.48315 8.56202 4.72084 10.5808 4.74387 10.7946C5.29413 10.534 5.89815 10.4926 6.34082 10.4926C6.7835 10.4926 7.17222 10.5522 7.43303 10.5464C8.1653 10.4926 8.39208 10.3981 8.43409 10.3672C7.92134 10.2299 7.62306 9.52501 7.62306 9.09608C9.31515 9.06298 10.2008 8.64332 10.6062 8.10549C10.209 8.06412 8.32752 7.82012 8.08317 7.78595C8.81467 7.45158 10.2979 6.60839 10.797 6.24967C11.0783 5.96834 11.3569 5.77507 11.4833 5.25928Z",
      fill: "white"
    }, void 0)]
  }), void 0);
};
var dark_wing_16 = function dark_wing_16() {
  return jsxs("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("circle", {
      cx: "8",
      cy: "8",
      r: "8",
      fill: "#982EA9"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.77906 5.00534C10.8056 4.794 11.3736 4.44634 11.9904 3.625C12.1156 3.625 12.4003 4.15362 12.3732 4.68591L12.3727 4.695C12.3415 5.31252 12.2828 6.47346 10.4892 7.32221C10.8596 7.37402 11.3728 7.34759 11.8596 7.13454C11.8596 7.98623 11.1298 9.58308 8.7252 9.7428C8.85998 10.0622 9.4817 10.1156 9.85986 10.1422C9.48114 10.9408 8.45468 11.4464 7.26554 11.4731C7.14297 11.4758 6.97679 11.4628 6.78656 11.4479C6.36315 11.4148 5.82057 11.3724 5.37437 11.4731C4.64266 11.6382 4.35807 11.7589 3.85783 12.375C3.85783 12.3226 3.83781 12.213 3.80951 12.058C3.63801 11.1188 3.16244 8.5144 4.99612 6.89515C5.03085 6.86447 5.06478 6.83426 5.09823 6.80447C5.81944 6.16233 6.31871 5.71778 9.77906 5.00534ZM9.19133 6.07011C9.86847 5.9307 10.9101 5.69655 11.4833 5.25938C11.3765 5.69548 11.1608 5.90102 10.9267 6.12416C10.8839 6.16494 10.8405 6.2063 10.797 6.24977C10.2979 6.60849 8.8147 7.45168 8.08319 7.78605C8.32755 7.82022 10.2091 8.06422 10.6062 8.10559C10.2008 8.64342 9.31518 9.06308 7.62309 9.09617C7.62309 9.52511 7.92137 10.23 8.43412 10.3673C8.3921 10.3982 8.16533 10.4927 7.43306 10.5465C7.31164 10.5492 7.1625 10.5377 6.99311 10.5247C6.79863 10.5097 6.57744 10.4927 6.34085 10.4927C5.89818 10.4927 5.29415 10.5341 4.7439 10.7947C4.74361 10.7921 4.7433 10.7892 4.74295 10.786C4.71522 10.531 4.49953 8.54837 5.80301 7.45192C5.83654 7.42371 5.8689 7.39632 5.90038 7.36965C6.52934 6.8371 6.81164 6.59806 9.19133 6.07011Z",
      fill: "white"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.4833 5.25928C10.9101 5.69646 9.86844 5.9306 9.19131 6.07001C6.69248 6.62439 6.5063 6.86021 5.80298 7.45182C4.48315 8.56202 4.72084 10.5808 4.74387 10.7946C5.29413 10.534 5.89815 10.4926 6.34082 10.4926C6.7835 10.4926 7.17222 10.5522 7.43303 10.5464C8.1653 10.4926 8.39208 10.3981 8.43409 10.3672C7.92134 10.2299 7.62306 9.52501 7.62306 9.09608C9.31515 9.06298 10.2008 8.64332 10.6062 8.10549C10.209 8.06412 8.32752 7.82012 8.08317 7.78595C8.81467 7.45158 10.2979 6.60839 10.797 6.24967C11.0783 5.96834 11.3569 5.77507 11.4833 5.25928Z",
      fill: "white"
    }, void 0)]
  }), void 0);
};

var location_16 = function location_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.1215 12.6039C12.6586 10.7275 13.6 8.66343 13.6 6.55999C13.6 3.37883 11.0928 0.799988 8.00002 0.799988C4.90723 0.799988 2.40002 3.37883 2.40002 6.55999C2.40002 8.66343 3.34142 10.7275 4.87851 12.6039C6.01109 13.9865 7.43849 15.2 8.00002 15.2C8.56156 15.2 9.98896 13.9865 11.1215 12.6039ZM7.52715 13.295C7.0108 12.8561 6.45592 12.2947 5.94916 11.6761C4.60554 10.0358 3.80005 8.26973 3.80005 6.55999C3.80005 4.17412 5.68045 2.23999 8.00005 2.23999C10.3196 2.23999 12.2 4.17412 12.2 6.55999C12.2 8.26973 11.3946 10.0358 10.0509 11.6761C9.54418 12.2947 8.98929 12.8561 8.47295 13.295C8.29501 13.4463 8.00005 13.6695 8.00005 13.6695C8.00005 13.6695 7.73483 13.4716 7.52715 13.295ZM8.00003 4.54815C6.89546 4.54815 6.00003 5.44358 6.00003 6.54815C6.00003 7.65272 6.89546 8.54815 8.00003 8.54815C9.1046 8.54815 10 7.65272 10 6.54815C10 5.44358 9.1046 4.54815 8.00003 4.54815Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var location_20 = function location_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17 8.2C17 10.8293 15.8233 13.4094 13.9019 15.7549C12.4862 17.4832 10.7019 19 10 19C9.29808 19 7.51383 17.4832 6.09811 15.7549C4.17675 13.4094 3 10.8293 3 8.2C3 4.22355 6.13401 1 10 1C13.866 1 17 4.22355 17 8.2ZM7.43644 14.5951C8.06989 15.3684 8.76349 16.0701 9.40893 16.6188C9.66852 16.8395 10 17.0869 10 17.0869C10 17.0869 10.3688 16.8079 10.5912 16.6188C11.2366 16.0701 11.9302 15.3684 12.5637 14.5951C14.2432 12.5448 15.25 10.3372 15.25 8.2C15.25 5.21767 12.8995 2.8 10 2.8C7.10055 2.8 4.75005 5.21767 4.75005 8.2C4.75005 10.3372 5.75691 12.5448 7.43644 14.5951ZM7.375 8.2C7.375 6.70883 8.55025 5.5 10 5.5C11.4497 5.5 12.625 6.70883 12.625 8.2C12.625 9.69117 11.4497 10.9 10 10.9C8.55025 10.9 7.375 9.69117 7.375 8.2ZM10 7.3C10.4833 7.3 10.875 7.70295 10.875 8.2C10.875 8.69706 10.4833 9.1 10 9.1C9.5168 9.1 9.12505 8.69706 9.12505 8.2C9.12505 7.70295 9.5168 7.3 10 7.3Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var magnifyingGlass_16 = function magnifyingGlass_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.7025 13.5963C14.9827 13.8765 14.9859 14.5058 14.7025 14.7892C14.421 15.0707 13.8388 15.0699 13.5581 14.7892L9.57013 10.8528C8.7966 11.4028 7.72492 11.8104 6.49214 11.8104C3.50692 11.8104 1.08691 9.39045 1.08691 6.40522C1.08691 3.42 3.50692 1 6.49214 1C9.47736 1 11.8974 3.42 11.8974 6.40522C11.8974 7.638 11.4847 8.77439 10.7899 9.68376L14.7025 13.5963ZM6.49132 10.1277C8.57372 10.1277 10.2618 8.43957 10.2618 6.35717C10.2618 4.27478 8.57372 2.58666 6.49132 2.58666C4.40893 2.58666 2.72081 4.27478 2.72081 6.35717C2.72081 8.43957 4.40893 10.1277 6.49132 10.1277Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var magnifyingGlass_20_light = function magnifyingGlass_20_light() {
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.8878 17.5367C19.2594 17.9083 19.2606 18.5095 18.8848 18.8853C18.5116 19.2585 17.9085 19.2605 17.5363 18.8883L12.3481 13.6999C11.1423 14.6212 9.63541 15.1685 8.00071 15.1685C4.04223 15.1685 0.833252 11.9594 0.833252 8.00076C0.833252 4.04212 4.04223 0.833008 8.00071 0.833008C11.9592 0.833008 15.1682 4.04212 15.1682 8.00076C15.1682 9.63552 14.6209 11.1425 13.6996 12.3484L18.8878 17.5367ZM8.00074 13.2574C10.9036 13.2574 13.2569 10.904 13.2569 8.00101C13.2569 5.098 10.9036 2.74465 8.00074 2.74465C5.09786 2.74465 2.74461 5.098 2.74461 8.00101C2.74461 10.904 5.09786 13.2574 8.00074 13.2574Z",
      fill: "#868686"
    }, void 0)
  }), void 0);
};
var magnifyingGlass_20 = function magnifyingGlass_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.8879 17.5364C19.2594 17.908 19.2607 18.5091 18.8849 18.8849C18.5117 19.2582 17.9085 19.2601 17.5364 18.8879L12.3482 13.6998C11.1423 14.621 9.63547 15.1683 8.00077 15.1683C4.04229 15.1683 0.833313 11.9593 0.833313 8.00083C0.833313 4.04236 4.04229 0.833374 8.00077 0.833374C11.9593 0.833374 15.1682 4.04236 15.1682 8.00083C15.1682 9.63553 14.621 11.1424 13.6997 12.3483L18.8879 17.5364ZM8.00075 13.257C10.9036 13.257 13.2569 10.9038 13.2569 8.00088C13.2569 5.098 10.9036 2.74474 8.00075 2.74474C5.09787 2.74474 2.74462 5.098 2.74462 8.00088C2.74462 10.9038 5.09787 13.257 8.00075 13.257Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var magnifyingGlass_24 = function magnifyingGlass_24(_ref3) {
  var outlineColor = _ref3.outlineColor;
  return jsx("svg", Object.assign({
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M30.2206 28.058C30.815 28.6525 30.8171 29.6144 30.2158 30.2157C29.6186 30.8129 28.6536 30.816 28.0581 30.2205L19.7571 21.9191C17.8277 23.3932 15.4167 24.2688 12.8012 24.2688C6.46762 24.2688 1.33325 19.1343 1.33325 12.8004C1.33325 6.46661 6.46762 1.33203 12.8012 1.33203C19.1348 1.33203 24.2691 6.46661 24.2691 12.8004C24.2691 15.416 23.3935 17.8272 21.9195 19.7566L30.2206 28.058ZM12.8011 21.211C17.4457 21.211 21.2109 17.4456 21.2109 12.8008C21.2109 8.15602 17.4457 4.39067 12.8011 4.39067C8.15651 4.39067 4.3913 8.15602 4.3913 12.8008C4.3913 17.4456 8.15651 21.211 12.8011 21.211Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var medical_20 = function medical_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.33331 0.833313C5.05819 0.833313 5.64581 1.41902 5.64581 2.14473V3.93261C5.64581 4.65689 5.05671 5.24403 4.33331 5.24403C3.63879 5.24403 3.07026 4.70634 3.02387 4.023C2.76077 4.17488 2.58331 4.46077 2.58331 4.7882V8.25395H10.4583V4.7882C10.4583 4.46039 10.281 4.17453 10.0178 4.02278C9.97128 4.705 9.40144 5.24403 8.70831 5.24403C7.98344 5.24403 7.39581 4.65832 7.39581 3.93261V2.14473C7.39581 1.42046 7.98491 0.833313 8.70831 0.833313C9.43319 0.833313 10.0208 1.41902 10.0208 2.14473C11.2622 2.38863 12.2083 3.47678 12.2083 4.7882V8.75561C12.2083 11.437 10.0708 13.4992 7.40791 13.4992L7.39581 16.2043C7.39581 17.0643 8.32393 17.6856 9.15408 17.2597C9.47673 17.0942 10.7048 16.0382 11.1795 15.63L11.1795 15.63L11.1798 15.6297C11.2732 15.5494 11.3374 15.4942 11.3597 15.4759C12.0112 14.9407 12.5869 14.6234 13.2198 14.5442C13.5694 13.4967 14.5515 12.7423 15.7083 12.7423C17.1581 12.7423 18.3333 13.9271 18.3333 15.3887C18.3333 16.8503 17.1581 18.0351 15.7083 18.0351C14.5917 18.0351 13.638 17.3323 13.2586 16.3415C13.0435 16.4173 12.7881 16.5782 12.4651 16.8436C12.4509 16.8553 12.409 16.8912 12.3457 16.9454L12.3455 16.9456C11.907 17.3215 10.4385 18.5803 9.94782 18.8321C7.9219 19.8715 5.64581 18.3477 5.64581 16.2043V13.4992C2.99464 13.4896 0.833313 11.4339 0.833313 8.75561V4.7882C0.833313 3.4771 1.77981 2.38878 3.02081 2.17926C3.02081 1.42046 3.60991 0.833313 4.33331 0.833313ZM2.8596 10.0183C3.34609 11.0604 4.42266 11.752 5.66453 11.752H7.40798C8.6502 11.752 9.70996 11.0602 10.1875 10.0183H2.8596ZM16.5833 15.3887C16.5833 15.8759 16.1915 16.2708 15.7083 16.2708C15.225 16.2708 14.8333 15.8759 14.8333 15.3887C14.8333 14.9015 15.225 14.5065 15.7083 14.5065C16.1915 14.5065 16.5833 14.9015 16.5833 15.3887Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

/* eslint-disable @typescript-eslint/naming-convention */
var megaphone_20 = function megaphone_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsxs("svg", Object.assign({
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("circle", {
      cx: "24",
      cy: "24",
      r: "24",
      fill: "#FDBE61",
      fillOpacity: "0.6"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.7486 12.6359L24 10.8549L22.2515 12.6359C21.3362 13.5682 20.0234 13.9948 18.735 13.7785L16.2735 13.3654L15.9058 15.834C15.7133 17.1262 14.9019 18.243 13.7325 18.8253L11.4983 19.9379L12.6518 22.1513C13.2556 23.3098 13.2556 24.6902 12.6518 25.8487L11.4983 28.0621L13.7325 29.1746C14.9019 29.757 15.7133 30.8738 15.9058 32.166L16.2735 34.6346L18.735 34.2215C20.0234 34.0052 21.3362 34.4318 22.2515 35.3641L24 37.1451L25.7486 35.3641C26.6638 34.4318 27.9766 34.0052 29.2651 34.2215L31.7265 34.6346L32.0943 32.166C32.2867 30.8738 33.0981 29.757 34.2676 29.1746L36.5018 28.0621L35.3482 25.8487C34.7444 24.6902 34.7444 23.3098 35.3482 22.1513L36.5018 19.9379L34.2676 18.8253C33.0981 18.243 32.2867 17.1262 32.0943 15.834L31.7265 13.3654L29.2651 13.7785C27.9766 13.9948 26.6638 13.5682 25.7486 12.6359ZM25.4272 9.45374C24.6433 8.65523 23.3568 8.65523 22.5728 9.45374L20.8243 11.2348C20.3667 11.7009 19.7103 11.9142 19.066 11.8061L16.6046 11.3929C15.501 11.2077 14.4602 11.9639 14.2953 13.0707L13.9276 15.5394C13.8314 16.1855 13.4257 16.7439 12.841 17.035L10.6067 18.1476C9.60506 18.6464 9.2075 19.87 9.72469 20.8623L10.8783 23.0756C11.1802 23.6549 11.1802 24.3451 10.8783 24.9244L9.72468 27.1377C9.2075 28.13 9.60506 29.3536 10.6067 29.8524L12.841 30.965C13.4257 31.2561 13.8314 31.8145 13.9276 32.4606L14.2953 34.9293C14.4602 36.0361 15.501 36.7923 16.6046 36.607L19.0661 36.1939C19.7103 36.0858 20.3667 36.2991 20.8243 36.7652L22.5728 38.5463C23.3568 39.3448 24.6433 39.3448 25.4272 38.5463L27.1758 36.7652C27.6334 36.2991 28.2898 36.0858 28.934 36.1939L31.3955 36.607C32.499 36.7923 33.5399 36.0361 33.7047 34.9293L34.0724 32.4606C34.1687 31.8145 34.5744 31.2561 35.1591 30.965L37.3933 29.8524C38.395 29.3536 38.7925 28.13 38.2754 27.1377L37.1218 24.9244C36.8199 24.3451 36.8199 23.6549 37.1218 23.0756L38.2754 20.8623C38.7925 19.87 38.395 18.6464 37.3933 18.1476L35.1591 17.035C34.5744 16.7439 34.1687 16.1855 34.0724 15.5394L33.7047 13.0707C33.5399 11.9639 32.499 11.2077 31.3955 11.3929L28.934 11.8061C28.2898 11.9142 27.6334 11.7009 27.1758 11.2348L25.4272 9.45374ZM24 32C28.4183 32 32 28.4183 32 24C32 19.5817 28.4183 16 24 16C19.5817 16 16 19.5817 16 24C16 28.4183 19.5817 32 24 32ZM24 34C29.5229 34 34 29.5228 34 24C34 18.4771 29.5229 14 24 14C18.4772 14 14 18.4771 14 24C14 29.5228 18.4772 34 24 34ZM19.7071 24.2929L21.9101 26.4959L27.5959 20.1685C27.9371 19.7342 28.5658 19.6588 29 20C29.4343 20.3412 29.5097 20.9699 29.1685 21.4041L22.7863 28.6178C22.4159 29.0892 21.7168 29.131 21.2929 28.7071L18.2929 25.7071C17.9024 25.3166 17.9024 24.6834 18.2929 24.2929C18.6834 23.9024 19.3166 23.9024 19.7071 24.2929Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)]
  }), void 0);
};

/* eslint-disable @typescript-eslint/naming-convention */
var menu_32 = function menu_32(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsxs("svg", Object.assign({
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M27.52 22.4C28.2269 22.4 28.8 23.1163 28.8 24C28.8 24.8837 28.2269 25.6 27.52 25.6H4.48001C3.77309 25.6 3.20001 24.8837 3.20001 24C3.20001 23.1163 3.77309 22.4 4.48001 22.4H27.52Z",
      fill: outlineColor || _wcImport4.white
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M27.52 14.4C28.2269 14.4 28.8 15.1163 28.8 16C28.8 16.8837 28.2269 17.6 27.52 17.6H4.48001C3.77309 17.6 3.20001 16.8837 3.20001 16C3.20001 15.1163 3.77309 14.4 4.48001 14.4H27.52Z",
      fill: outlineColor || _wcImport4.white
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M27.52 6.4C28.2269 6.4 28.8 7.11634 28.8 8C28.8 8.88366 28.2269 9.6 27.52 9.6H4.48001C3.77309 9.6 3.20001 8.88366 3.20001 8C3.20001 7.11634 3.77309 6.4 4.48001 6.4H27.52Z",
      fill: outlineColor || _wcImport4.white
    }, void 0)]
  }), void 0);
};

var minus_16 = function minus_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("rect", {
      x: "2",
      y: "7",
      width: "12",
      height: "2",
      rx: "1",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var minus_20 = function minus_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("rect", {
      x: "2",
      y: "9",
      width: "16",
      height: "2",
      rx: "1",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var money_20 = function money_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.27239 17.5414H1.97824C1.34592 17.5414 0.833333 17.0103 0.833333 16.3575V9.22554C0.833333 8.57166 1.34583 8.04159 1.97824 8.04159H4.27239C4.7909 8.04159 5.22891 8.39872 5.36977 8.88726C6.06877 8.98221 7.29076 9.32385 8.33962 10.0287C8.54604 10.0287 10.7659 10.0207 10.7659 10.0207C11.8026 10.0207 12.6159 10.6259 13.2455 11.604H15.7312C17.6741 11.604 19.1667 12.8097 19.1667 13.9729C19.171 14.6583 18.019 15.724 16.5428 16.6044C14.7201 17.6916 12.6125 18.3454 10.3874 18.3331C8.19224 18.3453 6.36309 17.9037 5.15573 17.1108C4.94575 17.3738 4.62803 17.5414 4.27239 17.5414ZM10.3867 16.7498C14.5838 16.7266 17.5046 14.1271 17.5046 13.8867C17.5046 13.6464 16.6719 13.1874 15.7306 13.1874H14.0023C14.0788 13.4088 14.1375 13.612 14.1797 13.7866C14.3005 14.2864 13.9358 14.7707 13.4386 14.7707H7.32665C6.90471 14.7707 6.56266 14.4162 6.56266 13.979C6.56266 13.5418 6.90471 13.1874 7.32665 13.1874H12.2926C12.2926 13.1874 11.7834 11.6041 10.7653 11.6041H8.09065C7.92689 11.6041 7.76747 11.5495 7.63588 11.4485C7.6051 11.4249 6.58461 10.7195 5.41667 10.4976V15.3157C6.2882 16.3282 8.44102 16.7606 10.3867 16.7498ZM3.8889 9.62706L2.36115 9.62494V15.9582H3.8889V9.62706ZM15.3489 10.4166C14.0833 10.4166 13.0573 9.35333 13.0573 8.04167C13.0573 6.73002 14.0833 5.66671 15.3489 5.66671C16.6145 5.66671 17.6405 6.73002 17.6405 8.04167C17.6405 9.35333 16.6145 10.4166 15.3489 10.4166ZM15.349 8.83327C15.7709 8.83327 16.1129 8.47883 16.1129 8.04161C16.1129 7.6044 15.7709 7.24996 15.349 7.24996C14.9272 7.24996 14.5852 7.6044 14.5852 8.04161C14.5852 8.47883 14.9272 8.83327 15.349 8.83327ZM10.0009 7.24993C8.73525 7.24993 7.70925 6.18662 7.70925 4.87496C7.70925 3.56331 8.73525 2.5 10.0009 2.5C11.2665 2.5 12.2925 3.56331 12.2925 4.87496C12.2925 6.18662 11.2665 7.24993 10.0009 7.24993ZM10.0011 5.66656C10.423 5.66656 10.765 5.31213 10.765 4.87491C10.765 4.43769 10.423 4.08325 10.0011 4.08325C9.57926 4.08325 9.23726 4.43769 9.23726 4.87491C9.23726 5.31213 9.57926 5.66656 10.0011 5.66656Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

/* eslint-disable @typescript-eslint/naming-convention */
var network_icon_24 = function network_icon_24() {
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    viewBox: "0 0 24 25"
  }, {
    children: jsx("g", Object.assign({
      fill: "none",
      fillRule: "evenodd",
      stroke: "#FFF",
      strokeLinecap: "round",
      "stroke-linejoin": "round",
      strokeWidth: "1.2"
    }, {
      children: jsx("path", {
        d: "M1 8.515c0 1.063.9 1.925 2.01 1.925 1.11 0 2.009-.862 2.009-1.925 0-1.064-.9-1.926-2.01-1.926C1.9 6.59 1 7.451 1 8.515zM18.981 21.116c0 1.064.9 1.926 2.01 1.926 1.11 0 2.009-.862 2.009-1.926s-.9-1.926-2.01-1.926c-1.11 0-2.009.862-2.009 1.926zM3.116 21.116c0 1.064.9 1.926 2.01 1.926 1.11 0 2.009-.862 2.009-1.926s-.9-1.926-2.01-1.926c-1.11 0-2.01.862-2.01 1.926zM10.537 13.535c0 1.482 1.254 2.683 2.8 2.683 1.546 0 2.8-1.201 2.8-2.683 0-1.481-1.254-2.683-2.8-2.683-1.546 0-2.8 1.202-2.8 2.683zM15.685 4.641c0 1.482 1.254 2.683 2.8 2.683 1.546 0 2.8-1.201 2.8-2.683 0-1.481-1.254-2.683-2.8-2.683-1.546 0-2.8 1.202-2.8 2.683zM4.62 9.665l6.098 2.922M14.567 11.126l2.606-4.115M15.314 15.434l4.332 4.253M11.36 15.434l-4.887 4.253"
      }, void 0)
    }), void 0)
  }), void 0);
};

var notification_icon_24 = function notification_icon_24(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "28",
    height: "34",
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.33349 30.3333C1.15973 30.3333 0.374717 29.163 0.766457 28.0976L0.842778 27.9212L2.76847 24.0698C3.49747 22.6119 3.91194 21.0191 3.98754 19.3948L4.00016 18.8523V13.6666C4.00016 8.71148 7.60413 4.59813 12.3338 3.8048L12.3335 1.99992C12.3335 1.07944 13.0797 0.333252 14.0002 0.333252C14.9206 0.333252 15.6668 1.07944 15.6668 1.99992L15.6682 3.80507C20.2657 4.57704 23.7991 8.48612 23.9919 13.2557L24.0002 13.6666V18.8523C24.0002 20.4824 24.3417 22.0923 25.0005 23.579L25.2318 24.0698L27.1575 27.9212C27.6825 28.9711 26.9869 30.1965 25.8587 30.3226L25.6668 30.3333H17.3335C17.3335 32.1742 15.8411 33.6666 14.0002 33.6666C12.1592 33.6666 10.6668 32.1742 10.6668 30.3333H2.33349ZM14.0007 6.99993C10.4303 6.99993 7.51553 9.80655 7.34216 13.3339L7.334 13.6666V18.8524C7.334 20.987 6.87842 23.0947 6.00033 25.0355L5.75041 25.5606L5.03072 26.9999H22.9706L22.2509 25.5606C21.2963 23.6513 20.7612 21.5623 20.6786 19.4338L20.6673 18.8524V13.6666C20.6673 9.9847 17.6826 6.99993 14.0007 6.99993Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var palmTree_20 = function palmTree_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.1334 8.33386C11.7035 8.24279 11.2817 8.52004 11.1913 8.95312C11.1009 9.3862 11.3761 9.81111 11.806 9.90218C12.3072 10.0083 12.5621 10.2333 12.6935 10.5732C12.7535 10.7285 12.7836 10.8991 12.791 11.0648C11.7195 11.747 10.9934 12.6615 10.5834 13.7421C10.1423 14.9046 10.1033 16.1156 10.2962 17.2343C10.3371 17.4712 10.3795 17.6496 10.4113 17.7583C10.5355 18.1828 10.9778 18.4255 11.3991 18.3004C11.8205 18.1753 12.0614 17.7297 11.9372 17.3052C11.9219 17.2528 11.8935 17.1334 11.8636 16.96C11.7155 16.1013 11.7456 15.1677 12.0694 14.3144C12.3781 13.5007 12.9343 12.8267 13.8051 12.3194C13.9643 12.323 14.1503 12.3389 14.3581 12.3729C14.8 12.4453 15.2342 12.5851 15.6351 12.8059C16.1251 13.0759 16.5421 13.4542 16.8714 13.9629C17.1113 14.3336 17.6042 14.4382 17.9722 14.1965C18.3401 13.9547 18.4439 13.4583 18.204 13.0876C17.7271 12.3507 17.1125 11.7932 16.3983 11.3998C16.1214 11.2473 15.8364 11.1229 15.5466 11.0238C16.0844 10.8167 16.6442 10.81 17.2285 11.0583C17.6333 11.2303 18.0998 11.0392 18.2706 10.6314C18.4413 10.2237 18.2516 9.75369 17.8469 9.58168C17.036 9.23708 16.249 9.1853 15.5073 9.35966C15.5796 8.78431 15.5226 8.20317 15.2991 7.63119C15.2275 7.4482 15.1394 7.26994 15.0344 7.09711C14.8051 6.71964 14.3155 6.60091 13.9408 6.83192C13.5661 7.06293 13.4482 7.5562 13.6775 7.93368C13.7343 8.02707 13.7811 8.12187 13.8188 8.21831C13.9651 8.59272 13.9756 9.00274 13.8772 9.42654C13.5005 8.88608 12.9183 8.50013 12.1334 8.33386ZM2.763 4.75323C2.11815 5.06808 1.52851 5.5535 1.00599 6.216C0.732708 6.56249 0.789997 7.06656 1.13395 7.34187C1.4779 7.61717 1.97827 7.55946 2.25156 7.21296C2.6288 6.73466 3.0317 6.40297 3.45683 6.1954C4.05808 5.90185 4.70345 5.85617 5.35555 5.99699C4.67267 6.54939 4.19795 7.27326 4.04218 8.17893C3.96718 8.61499 4.25728 9.02973 4.69014 9.10528C5.12299 9.18084 5.53469 8.88859 5.60969 8.45254C5.70055 7.92424 5.99781 7.50252 6.45926 7.16366C6.63968 7.03117 6.83423 6.91999 7.03062 6.83002C7.44273 7.68115 7.72143 8.6403 7.87708 9.69196C8.15977 11.602 8.02521 13.6714 7.62656 15.6786C7.53938 16.1176 7.44613 16.5171 7.35324 16.8685C7.29844 17.0758 7.25678 17.2185 7.23472 17.2882C7.10118 17.7098 7.33221 18.1607 7.75073 18.2952C8.16925 18.4297 8.61677 18.197 8.7503 17.7754C8.77999 17.6816 8.8289 17.5141 8.89054 17.2809C8.99173 16.8981 9.09256 16.4661 9.18651 15.993C9.6182 13.8194 9.76416 11.5746 9.45055 9.45562C9.27188 8.24842 8.94743 7.13202 8.46003 6.12614C9.14779 6.03948 9.94402 6.16191 10.8011 6.62048C11.1891 6.82805 11.6707 6.67948 11.8767 6.28863C12.0828 5.89777 11.9353 5.41265 11.5473 5.20508C10.5254 4.65835 9.53617 4.45906 8.63714 4.50298C9.37114 3.41096 10.4503 2.97137 12.1415 3.47587C12.5628 3.60152 13.0053 3.35938 13.1301 2.93504C13.2548 2.5107 13.0144 2.06485 12.5932 1.9392C10.3079 1.25751 8.5887 1.89696 7.47553 3.38505C7.28217 2.984 6.87396 2.70753 6.40165 2.70753C5.74269 2.70753 5.2085 3.24567 5.2085 3.9095C5.2085 4.06777 5.23887 4.21889 5.29405 4.35728C4.45039 4.24121 3.59423 4.34739 2.763 4.75323Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var people_24 = function people_24(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "16",
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 10H6C7.63573 10 9.08801 10.7855 10.0002 11.9998C10.864 10.8494 12.2129 10.0839 13.7433 10.0065L14 10H15C17.7614 10 20 12.2386 20 15C20 15.5523 19.5523 16 19 16C18.4872 16 18.0645 15.614 18.0067 15.1166L17.9949 14.8237C17.907 13.3072 16.6928 12.093 15.1763 12.0051L15 12H14C12.3431 12 11 13.3431 11 15C11 15.5128 10.614 15.9355 10.1166 15.9933L10 16C9.48716 16 9.06449 15.614 9.00673 15.1166L8.99491 14.8237C8.90704 13.3072 7.69275 12.093 6.17627 12.0051L6 12H5C3.34315 12 2 13.3431 2 15C2 15.5523 1.55228 16 1 16C0.447715 16 0 15.5523 0 15C0 12.3112 2.12231 10.1182 4.78311 10.0046L5 10ZM5 0C7.20914 0 9 1.79086 9 4C9 6.20914 7.20914 8 5 8C2.79086 8 1 6.20914 1 4C1 1.79086 2.79086 0 5 0ZM15 0C17.2091 0 19 1.79086 19 4C19 6.20914 17.2091 8 15 8C12.7909 8 11 6.20914 11 4C11 1.79086 12.7909 0 15 0ZM5 2C3.89543 2 3 2.89543 3 4C3 5.10457 3.89543 6 5 6C6.10457 6 7 5.10457 7 4C7 2.89543 6.10457 2 5 2ZM15 2C13.8954 2 13 2.89543 13 4C13 5.10457 13.8954 6 15 6C16.1046 6 17 5.10457 17 4C17 2.89543 16.1046 2 15 2Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var piggyBank_20 = function piggyBank_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.05259 6.26736C1.95419 5.90701 1.72348 5.63191 1.27892 5.43172C0.895451 5.25903 0.727166 4.81383 0.903047 4.43733C1.07893 4.06083 1.53237 3.8956 1.91584 4.06828C2.78041 4.45762 3.41757 5.16453 3.59001 6.15624C4.03916 5.91157 4.52797 5.72854 5.0446 5.61879C5.17795 3.87452 6.66164 2.5 8.47231 2.5C10.1243 2.5 11.5041 3.64418 11.8345 5.16944L13.853 3.93762C14.5415 3.51746 15.3472 3.9525 15.3472 4.7504C15.3472 4.7504 15.3472 6.30656 15.3389 6.43565C16.3148 7.10162 17.041 8.07523 17.3959 9.25C17.5665 9.25 18.0199 9.25 18.0199 9.25C18.6495 9.25 19.1666 9.75179 19.1666 10.3733V13.3767C19.1666 13.9947 18.6519 14.5 18.0199 14.5C18.0199 14.5 16.1111 14.5 16.0323 14.4959C15.6984 14.8068 15.3472 15.0552 15.3472 15.0552V16.3741C15.3472 16.9925 14.8356 17.5 14.2026 17.5H11.9086C11.278 17.5 10.764 16.9949 10.764 16.3741V16H7.70843V16.3741C7.70843 16.9925 7.19679 17.5 6.56374 17.5H4.26983C3.63915 17.5 3.12514 16.9949 3.12514 16.3741C3.12514 16.3741 3.1175 15.1807 3.1175 15.0541C1.70477 14.084 0.833498 12.4912 0.833498 10.75C0.833498 9.53763 1.25195 8.42135 1.9548 7.53272C1.95976 7.51769 2.21315 6.85536 2.05259 6.26736ZM11.3309 7.74999H11.5313C11.9486 7.74999 12.2917 8.08578 12.2917 8.49999C12.2917 8.91709 11.9513 9.24999 11.5313 9.24999H5.41326C4.99595 9.24999 4.65289 8.91421 4.65289 8.49999C4.65289 8.08289 4.99332 7.74999 5.41326 7.74999H5.61368C5.47718 7.54978 5.36192 7.33443 5.27107 7.10704C3.60066 7.50772 2.36125 8.98651 2.36125 10.75C2.36125 13.2575 4.65289 14.2152 4.65289 14.2152V16H6.18065V14.5H12.2917L12.2802 16L13.8195 16.0037V14.2153C13.8195 14.2153 14.7763 13.7559 15.3666 13C16.2751 13 17.6389 13.0113 17.6389 13.0113V10.75C17.6389 10.75 16.5712 10.75 16.1652 10.75C16.0323 8.14788 13.8195 7.28479 13.8195 7.28479V5.72845L11.729 6.99999C11.618 7.26702 11.4887 7.51861 11.3309 7.74999ZM13.8195 10.75C13.3976 10.75 13.0556 10.4142 13.0556 9.99998C13.0556 9.58577 13.3976 9.24998 13.8195 9.24998C14.2414 9.24998 14.5834 9.58577 14.5834 9.99998C14.5834 10.4142 14.2414 10.75 13.8195 10.75ZM8.47241 7.74999C9.52711 7.74999 10.3821 6.91052 10.3821 5.87499C10.3821 4.83946 9.52711 3.99999 8.47241 3.99999C7.41771 3.99999 6.5627 4.83946 6.5627 5.87499C6.5627 6.91052 7.41771 7.74999 8.47241 7.74999Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var pills_20 = function pills_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.09597 1.90448C8.52653 0.473921 10.8499 0.477937 12.279 1.90695C13.7109 3.33887 13.7122 5.65916 12.2814 7.08993L7.09105 12.2803C5.66048 13.7109 3.33707 13.7069 1.90806 12.2778C0.476134 10.8459 0.474818 8.52563 1.9056 7.09486L7.09597 1.90448ZM11.3424 17.8242C9.55252 16.0343 9.55252 13.1323 11.3424 11.3424C13.1323 9.55252 16.0343 9.55252 17.8242 11.3424C19.6141 13.1323 19.6141 16.0343 17.8242 17.8242C16.0343 19.6141 13.1323 19.6141 11.3424 17.8242ZM16.5279 16.5279C15.6812 17.3745 14.4198 17.5537 13.3976 17.0654L17.0654 13.3976C17.5537 14.4198 17.3745 15.6812 16.5279 16.5279ZM15.7691 12.1013C14.7469 11.613 13.4855 11.7922 12.6389 12.6389C11.7922 13.4855 11.613 14.7469 12.1013 15.7691L15.7691 12.1013ZM8.38984 8.38878L5.79712 5.79605L8.39231 3.20087C9.1054 2.48777 10.268 2.48877 10.9826 3.20333C11.6989 3.91966 11.6995 5.07914 10.985 5.79359L8.38984 8.38878Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var pinterest_16 = function pinterest_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M8.00493 2C4.68863 2 2 4.68421 2 7.99507C2 10.5362 3.58154 12.7072 5.81548 13.5806C5.76111 13.1069 5.71663 12.3766 5.83525 11.8586C5.94398 11.3898 6.53706 8.87829 6.53706 8.87829C6.53706 8.87829 6.35913 8.51809 6.35913 7.99013C6.35913 7.15625 6.84348 6.53454 7.44645 6.53454C7.96045 6.53454 8.20756 6.91941 8.20756 7.37829C8.20756 7.89145 7.88137 8.66118 7.70839 9.37665C7.56506 9.97368 8.00987 10.4622 8.59801 10.4622C9.66555 10.4622 10.486 9.33717 10.486 7.71875C10.486 6.2829 9.45303 5.28125 7.97527 5.28125C6.26523 5.28125 5.26194 6.55921 5.26194 7.88158C5.26194 8.39474 5.45963 8.94737 5.70675 9.24836C5.75617 9.30757 5.76111 9.36184 5.74628 9.42105C5.7018 9.60855 5.59801 10.0181 5.57825 10.102C5.55353 10.2105 5.48928 10.2352 5.37561 10.1809C4.62438 9.83059 4.15486 8.74013 4.15486 7.85691C4.15486 5.96711 5.52882 4.23026 8.12354 4.23026C10.2043 4.23026 11.8253 5.71053 11.8253 7.69408C11.8253 9.76151 10.5206 11.4243 8.71168 11.4243C8.10378 11.4243 7.53047 11.1086 7.33771 10.7336C7.33771 10.7336 7.03623 11.8783 6.9621 12.1595C6.82865 12.6826 6.46292 13.3339 6.21581 13.7336C6.77923 13.9063 7.37231 14 7.99504 14C11.3113 14 14 11.3158 14 8.00493C14.0099 4.68421 11.3212 2 8.00493 2Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var pinterest_20 = function pinterest_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M10.0066 2C5.59213 2 2.01318 5.57895 2.01318 9.99342C2.01318 13.3816 4.11845 16.2763 7.09213 17.4408C7.01976 16.8092 6.96055 15.8355 7.11845 15.1447C7.26318 14.5197 8.05266 11.1711 8.05266 11.1711C8.05266 11.1711 7.81581 10.6908 7.81581 9.98684C7.81581 8.875 8.46055 8.04605 9.26318 8.04605C9.94739 8.04605 10.2763 8.55921 10.2763 9.17105C10.2763 9.85526 9.84213 10.8816 9.61187 11.8355C9.42108 12.6316 10.0132 13.2829 10.7961 13.2829C12.2171 13.2829 13.3092 11.7829 13.3092 9.625C13.3092 7.71053 11.9342 6.375 9.96713 6.375C7.69082 6.375 6.35529 8.07895 6.35529 9.84211C6.35529 10.5263 6.61845 11.2632 6.94739 11.6645C7.01318 11.7434 7.01976 11.8158 7.00003 11.8947C6.94082 12.1447 6.80266 12.6908 6.77634 12.8026C6.74345 12.9474 6.65792 12.9803 6.50661 12.9079C5.5066 12.4408 4.8816 10.9868 4.8816 9.80921C4.8816 7.28947 6.71055 4.97368 10.1645 4.97368C12.9342 4.97368 15.0921 6.94737 15.0921 9.59211C15.0921 12.3487 13.3553 14.5658 10.9474 14.5658C10.1382 14.5658 9.37503 14.1447 9.11845 13.6447C9.11845 13.6447 8.71713 15.1711 8.61845 15.5461C8.44082 16.2434 7.95397 17.1118 7.62503 17.6447C8.37503 17.875 9.1645 18 9.99345 18C14.4079 18 17.9869 14.4211 17.9869 10.0066C18 5.57895 14.4211 2 10.0066 2Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var ratingWing_16 = function ratingWing_16(_ref) {
  var outlineColor = _ref.outlineColor,
    fillColor = _ref.fillColor,
    percentageFilledProp = _ref.percentageFilledProp;
  var percentageFilled = percentageFilledProp || 0;
  var percentage = percentageFilled < 0 ? 0 : percentageFilled > 1 ? 1 : percentageFilled;
  var randomId = Math.round(Math.random() * 100000);
  return jsxs("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("defs", {
      children: jsxs("linearGradient", Object.assign({
        id: randomId,
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "0"
      }, {
        children: [jsx("stop", {
          id: "stop1",
          offset: percentage,
          stopColor: fillColor || _wcImport4.primary[60]
        }, void 0), jsx("stop", {
          id: "stop2",
          offset: percentage,
          stopColor: "transparent"
        }, void 0)]
      }), void 0)
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.8465 3.20857C12.489 2.87042 13.3978 2.31417 14.3847 1.00003C14.585 1.00003 15.0406 1.84582 14.9971 2.69748L14.9964 2.71203C14.9465 3.70006 14.8526 5.55756 11.9827 6.91557C12.5754 6.99847 13.3965 6.95617 14.1754 6.6153C14.1754 7.97801 13.0077 10.533 9.16035 10.7885C9.37599 11.2996 10.3708 11.3849 10.9758 11.4275C10.3699 12.7053 8.72751 13.5143 6.8249 13.557C6.62878 13.5613 6.3629 13.5405 6.05853 13.5167C5.38107 13.4637 4.51294 13.3958 3.79903 13.557C2.62828 13.8212 2.17294 14.0142 1.37256 15C1.37256 14.9162 1.34053 14.7408 1.29525 14.4928C1.02085 12.9901 0.259942 8.82307 3.19383 6.23227C3.24939 6.18318 3.30367 6.13484 3.3572 6.08719C4.51113 5.05975 5.30997 4.34848 10.8465 3.20857ZM9.90617 4.9122C10.9896 4.68915 12.6562 4.31451 13.5733 3.61503C13.4024 4.31279 13.0573 4.64166 12.6827 4.99869C12.6143 5.06393 12.5448 5.13011 12.4753 5.19966C11.6767 5.77362 9.30355 7.12271 8.13314 7.65771C8.52411 7.71238 11.5346 8.10278 12.17 8.16897C11.5213 9.0295 10.1043 9.70095 7.39698 9.75391C7.39698 10.4402 7.87422 11.568 8.69463 11.7878C8.6274 11.8372 8.26456 11.9884 7.09292 12.0744C6.89866 12.0787 6.66004 12.0604 6.389 12.0395C6.07783 12.0156 5.72394 11.9884 5.34539 11.9884C4.63711 11.9884 3.67068 12.0546 2.79027 12.4716C2.78981 12.4674 2.7893 12.4627 2.78875 12.4576C2.74438 12.0497 2.39927 8.87743 4.48485 7.1231C4.5385 7.07797 4.59027 7.03414 4.64065 6.99148C5.64697 6.13938 6.09866 5.75693 9.90617 4.9122Z",
      fill: outlineColor || _wcImport4.primary[60]
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.5732 3.61499C12.6562 4.31447 10.9895 4.68911 9.90613 4.91216C5.908 5.79918 5.61012 6.17648 4.48481 7.12306C2.37308 8.89939 2.75338 12.1294 2.79023 12.4716C3.67064 12.0545 4.63708 11.9883 5.34535 11.9883C6.05363 11.9883 6.6756 12.0836 7.09288 12.0744C8.26452 11.9883 8.62736 11.8371 8.69459 11.7877C7.87419 11.5679 7.39694 10.4402 7.39694 9.75387C10.1043 9.70091 11.5213 9.02945 12.17 8.16893C11.5345 8.10274 8.52407 7.71234 8.1331 7.65766C9.30351 7.12267 11.6767 5.77358 12.4752 5.19962C12.9254 4.7495 13.3711 4.44025 13.5732 3.61499Z",
      fill: "url(#".concat(randomId, ")"),
      stroke: fillColor || _wcImport4.primary[60],
      strokeLinejoin: "round"
    }, void 0)]
  }), void 0);
};
var ratingWing_20 = function ratingWing_20(_ref2) {
  var outlineColor = _ref2.outlineColor,
    fillColor = _ref2.fillColor,
    percentageFilledProp = _ref2.percentageFilledProp;
  var percentageFilled = percentageFilledProp || 0;
  var percentage = percentageFilled < 0 ? 0 : percentageFilled > 1 ? 1 : percentageFilled;
  var randomId = Math.round(Math.random() * 100000);
  return jsxs("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("defs", {
      children: jsxs("linearGradient", Object.assign({
        id: randomId,
        x1: "0",
        y1: "0",
        x2: "1",
        y2: "0"
      }, {
        children: [jsx("stop", {
          id: "stop1",
          offset: percentage,
          stopColor: fillColor || _wcImport4.primary[60]
        }, void 0), jsx("stop", {
          id: "stop2",
          offset: percentage,
          stopColor: "transparent"
        }, void 0)]
      }), void 0)
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.7269 3.72661C15.8774 3.28387 17.0672 2.55557 18.3593 0.834991C18.6216 0.834991 19.2181 1.94237 19.1612 3.05744L19.1602 3.07649C19.0948 4.37011 18.9719 6.8021 15.2145 8.58012C15.9905 8.68866 17.0655 8.63328 18.0853 8.18698C18.0853 9.97115 16.5564 13.3163 11.5192 13.6509C11.8015 14.3201 13.1039 14.4318 13.8961 14.4875C13.1028 16.1606 10.9525 17.2197 8.46141 17.2756C8.20464 17.2813 7.85652 17.254 7.458 17.2229C6.57102 17.1535 5.43439 17.0646 4.49968 17.2756C2.96684 17.6216 2.37067 17.8743 1.32274 19.165C1.32274 19.0552 1.2808 18.8256 1.22152 18.5009C0.862248 16.5334 -0.133995 11.0776 3.7073 7.68549C3.78004 7.62122 3.85112 7.55793 3.9212 7.49553C5.43202 6.15033 6.47793 5.21907 13.7269 3.72661ZM12.5692 5.54356C14.1106 5.22622 16.2797 4.77131 17.5844 3.77614C17.2969 4.95026 17.0238 5.35522 16.3834 5.99562C15.5568 6.83043 12.4669 8.22382 10.5975 9.06684C10.337 9.18435 10.1001 9.29117 9.89636 9.38429L9.93354 9.38949C10.6253 9.48625 14.9037 10.0847 15.7901 10.1771C14.8671 11.4013 13.1531 12.1924 9.3013 12.2678C9.3537 12.3809 9.41729 12.5622 9.49437 12.782C9.76366 13.5496 10.1976 14.7867 10.8944 15.23C10.7987 15.3002 10.2336 15.611 8.56673 15.7335C8.29035 15.7396 7.95085 15.7135 7.56524 15.6838C7.12254 15.6498 6.61904 15.611 6.08047 15.611C5.07278 15.611 3.69781 15.7052 2.44523 16.2985C2.44458 16.2925 2.44385 16.2858 2.44306 16.2786C2.37993 15.6983 1.88894 11.185 4.85615 8.68907C4.93248 8.62486 5.00613 8.56249 5.07781 8.5018C6.50954 7.2895 7.15216 6.74537 12.5692 5.54356Z",
      fill: outlineColor || _wcImport4.primary[60]
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.5844 3.77612C16.2797 4.7713 14.1106 5.22621 12.5692 5.54354C6.88096 6.80552 6.45715 7.34232 4.85614 8.68905C1.85173 11.2163 2.39278 15.8118 2.44522 16.2985C3.6978 15.7052 5.07277 15.611 6.08046 15.611C7.08815 15.611 7.97303 15.7466 8.56672 15.7334C10.2336 15.611 10.7987 15.3002 10.8943 15.2299C9.9982 14.6598 9.53673 12.7763 9.30129 12.2678C13.1531 12.1924 14.8671 11.4013 15.79 10.177C14.886 10.0829 10.4526 9.46207 9.89635 9.38427C11.5615 8.62313 15.4416 6.94679 16.3834 5.99561C17.0238 5.35521 17.2969 4.95025 17.5844 3.77612Z",
      fill: "url(#".concat(randomId, ")"),
      stroke: fillColor || _wcImport4.primary[60],
      strokeLinejoin: "round"
    }, void 0)]
  }), void 0);
};

var ratingWingFilled_16 = function ratingWingFilled_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M14.3847 1.00003C13.3978 2.31417 12.489 2.87042 10.8465 3.20857C5.05316 4.40136 4.44721 5.12482 3.19383 6.23227C-0.224177 9.25057 1.37256 14.4082 1.37256 15C2.17294 14.0142 2.62828 13.8212 3.79903 13.557C4.8337 13.3234 6.19228 13.571 6.8249 13.557C8.72751 13.5143 10.3699 12.7053 10.9758 11.4275C10.3708 11.3849 9.37599 11.2996 9.16035 10.7885C13.0077 10.533 14.1754 7.97801 14.1754 6.6153C13.3965 6.95617 12.5754 6.99847 11.9827 6.91557C14.8667 5.55087 14.9473 3.68174 14.9971 2.69748C15.0406 1.84582 14.585 1.00003 14.3847 1.00003Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var ratingWingFilled_20 = function ratingWingFilled_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M18.3593 0.834991C17.0672 2.55557 15.8774 3.28387 13.7269 3.72661C6.1417 5.2883 5.34834 6.23551 3.7073 7.68549C-0.767845 11.6373 1.32274 18.3901 1.32274 19.165C2.37067 17.8743 2.96684 17.6216 4.49968 17.2756C5.85435 16.9698 7.63313 17.2939 8.46141 17.2756C10.9525 17.2197 13.1028 16.1606 13.8961 14.4875C13.1039 14.4318 11.8015 14.3201 11.5192 13.6509C16.5564 13.3163 18.0853 9.97115 18.0853 8.18698C17.0655 8.63328 15.9905 8.68866 15.2145 8.58012C18.9904 6.79334 19.096 4.34611 19.1612 3.05744C19.2181 1.94237 18.6216 0.834991 18.3593 0.834991Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var ratingWingOutline_16 = function ratingWingOutline_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.8465 3.20857C12.489 2.87042 13.3978 2.31417 14.3847 1.00003C14.585 1.00003 15.0406 1.84582 14.9971 2.69748L14.9964 2.71203C14.9465 3.70006 14.8526 5.55756 11.9827 6.91557C12.5754 6.99847 13.3965 6.95617 14.1754 6.6153C14.1754 7.97801 13.0077 10.533 9.16035 10.7885C9.37599 11.2996 10.3708 11.3849 10.9758 11.4275C10.3699 12.7053 8.72751 13.5143 6.8249 13.557C6.62878 13.5613 6.3629 13.5405 6.05853 13.5167C5.38107 13.4637 4.51294 13.3958 3.79903 13.557C2.62828 13.8212 2.17294 14.0142 1.37256 15C1.37256 14.9162 1.34053 14.7408 1.29525 14.4928C1.02085 12.9901 0.259942 8.82307 3.19383 6.23227C3.24939 6.18318 3.30367 6.13484 3.3572 6.08719C4.51113 5.05975 5.30997 4.34848 10.8465 3.20857ZM9.90617 4.9122C10.9896 4.68915 12.6562 4.31451 13.5733 3.61503C13.4024 4.31279 13.0573 4.64166 12.6827 4.99869C12.6143 5.06393 12.5448 5.13011 12.4753 5.19966C11.6767 5.77362 9.30355 7.12271 8.13314 7.65771C8.52411 7.71238 11.5346 8.10278 12.17 8.16897C11.5213 9.0295 10.1043 9.70095 7.39698 9.75391C7.39698 10.4402 7.87422 11.568 8.69463 11.7878C8.6274 11.8372 8.26456 11.9884 7.09292 12.0744C6.89866 12.0787 6.66004 12.0604 6.389 12.0395C6.07783 12.0156 5.72394 11.9884 5.34539 11.9884C4.63711 11.9884 3.67068 12.0546 2.79027 12.4716C2.78981 12.4674 2.7893 12.4627 2.78875 12.4576C2.74438 12.0497 2.39927 8.87743 4.48485 7.1231C4.5385 7.07797 4.59027 7.03414 4.64065 6.99148C5.64697 6.13938 6.09866 5.75693 9.90617 4.9122Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var ratingWingOutline_20 = function ratingWingOutline_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.7269 3.72661C15.8774 3.28387 17.0672 2.55557 18.3593 0.834991C18.6216 0.834991 19.2181 1.94237 19.1612 3.05744L19.1602 3.07649C19.0948 4.37011 18.9719 6.8021 15.2145 8.58012C15.9905 8.68866 17.0655 8.63328 18.0853 8.18698C18.0853 9.97115 16.5564 13.3163 11.5192 13.6509C11.8015 14.3201 13.1039 14.4318 13.8961 14.4875C13.1028 16.1606 10.9525 17.2197 8.46141 17.2756C8.20464 17.2813 7.85652 17.254 7.458 17.2229C6.57102 17.1535 5.43439 17.0646 4.49968 17.2756C2.96684 17.6216 2.37067 17.8743 1.32274 19.165C1.32274 19.0552 1.2808 18.8256 1.22152 18.5009C0.862248 16.5334 -0.133995 11.0776 3.7073 7.68549C3.78004 7.62122 3.85112 7.55793 3.9212 7.49553C5.43202 6.15033 6.47793 5.21907 13.7269 3.72661ZM12.5692 5.54356C14.1106 5.22622 16.2797 4.77131 17.5844 3.77614C17.2969 4.95026 17.0238 5.35522 16.3834 5.99562C15.5568 6.83043 12.4669 8.22382 10.5975 9.06684C10.337 9.18435 10.1001 9.29117 9.89636 9.38429L9.93354 9.38949C10.6253 9.48625 14.9037 10.0847 15.7901 10.1771C14.8671 11.4013 13.1531 12.1924 9.3013 12.2678C9.3537 12.3809 9.41729 12.5622 9.49437 12.782C9.76366 13.5496 10.1976 14.7867 10.8944 15.23C10.7987 15.3002 10.2336 15.611 8.56673 15.7335C8.29035 15.7396 7.95085 15.7135 7.56524 15.6838C7.12254 15.6498 6.61904 15.611 6.08047 15.611C5.07278 15.611 3.69781 15.7052 2.44523 16.2985C2.44458 16.2925 2.44385 16.2858 2.44306 16.2786C2.37993 15.6983 1.88894 11.185 4.85615 8.68907C4.93248 8.62486 5.00613 8.56249 5.07781 8.5018C6.50954 7.2895 7.15216 6.74537 12.5692 5.54356Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

/* eslint-disable @typescript-eslint/naming-convention */
var resources_icon_24 = function resources_icon_24() {
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    viewBox: "0 0 24 25"
  }, {
    children: jsxs("g", Object.assign({
      fill: "none",
      fillRule: "evenodd",
      stroke: "#FFF",
      strokeLinecap: "round",
      "stroke-linejoin": "round",
      strokeWidth: "1.2"
    }, {
      children: [jsx("path", {
        d: "M1 20.535c7.016-2.676 11 .59 11 .59s3.984-3.266 11-.59V3.971c-7.016-2.677-11 .59-11 .59S8.016 1.293 1 3.97v16.564zM12.125 5.059c-.12.158 0 14.995 0 14.995"
      }, void 0), jsx("path", {
        d: "M19.362 2.86v8.625L17.655 9.86l-1.706 1.626V2.86"
      }, void 0)]
    }), void 0)
  }), void 0);
};

/* eslint-disable @typescript-eslint/naming-convention */
var review_icon_24 = function review_icon_24() {
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    viewBox: "0 0 24 25"
  }, {
    children: jsx("path", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#FFF",
      "stroke-linejoin": "round",
      strokeWidth: "1.2",
      d: "M13.595 6.738C8.887 8.51 3.48 8.482 1.977 13.87.6 18.806 4.105 23.284 4.105 23.284c1.4-2.906 6.303-1.8 9.567-3.854-.567-.163-2.081-.789-2.59-1.241 1.464.337 3.932.292 5.54-.75-.83.129-3.008-.123-3.405-.439 1.727.046 4.974-1.151 5.478-2.009-.43.088-3.277.3-3.917-.006 1.831-.77 4.36-1.87 5.022-4.23-.494.538-2.894 1.117-3.855 1.392 1.37-.637 4.114-3.35 4.138-4.903-.68.615-1.455.812-2.404 1.323 1.593-1.476 3.438-3.48 3.56-6.8-1.075 1.052-3.042 3.24-7.644 4.971z"
    }, void 0)
  }), void 0);
};

var ribbon_20 = function ribbon_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.70292 13.893L7.4908 14.2487C7.21736 14.7071 6.61468 14.8658 6.13728 14.599C5.66318 14.334 5.50145 13.7461 5.77395 13.2892L5.94235 13.0069C5.68092 12.825 5.4331 12.626 5.20063 12.4115L3.57381 15.1389L4.79625 15.0624C5.46928 15.0204 6.16614 15.4103 6.46475 15.9948L7.01849 17.0789L8.74463 14.1581C8.38711 14.0955 8.03913 14.0064 7.70292 13.893ZM3.0486 7.54941C3.0486 3.84021 6.1551 0.833313 9.98716 0.833313C13.8192 0.833313 16.9257 3.84021 16.9257 7.54941C16.9257 8.70519 16.6241 9.7928 16.0929 10.7425L19.0199 15.6497C19.4462 16.3643 18.89 17.2155 18.0438 17.1626L15.2499 16.9882L13.9942 19.4257C13.6288 20.141 12.5882 20.2179 12.1525 19.4874L9.99998 15.8787L7.84747 19.4874C7.41175 20.2179 6.37115 20.141 6.00576 19.4257L4.7596 16.9862L1.95614 17.1626C1.10992 17.2155 0.553791 16.3643 0.980074 15.6497L3.89388 10.7646C3.35494 9.80971 3.0486 8.71418 3.0486 7.54941ZM12.9927 17.0583L13.5352 15.995C13.8338 15.4104 14.5307 15.0205 15.2037 15.0625L16.4218 15.1386L14.7893 12.3973C14.5525 12.6171 14.2996 12.8208 14.0325 13.0066L14.2012 13.2893C14.4737 13.7462 14.3119 14.3341 13.8378 14.5991C13.3604 14.8659 12.7578 14.7072 12.4843 14.2488L12.2721 13.8929C11.9451 14.0033 11.6069 14.0906 11.2597 14.1529L12.9927 17.0583ZM9.98724 12.3467C12.7244 12.3467 14.9434 10.1989 14.9434 7.54949C14.9434 4.90006 12.7244 2.75228 9.98724 2.75228C7.25006 2.75228 5.03113 4.90006 5.03113 7.54949C5.03113 10.1989 7.25006 12.3467 9.98724 12.3467ZM10.041 9.46835L8.59157 10.2059C8.10498 10.4536 7.78601 10.2282 7.87878 9.70466L8.1556 8.14244L6.98297 7.03606C6.58931 6.66463 6.71218 6.30137 7.25524 6.22499L8.87576 5.99706L9.60048 4.5757C9.84378 4.09853 10.2387 4.09938 10.4815 4.5757L11.2063 5.99706L12.8268 6.22499C13.3708 6.3015 13.492 6.6653 13.0991 7.03606L11.9264 8.14244L12.2033 9.70466C12.2962 10.2291 11.9762 10.4531 11.4905 10.2059L10.041 9.46835Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

/* eslint-disable @typescript-eslint/naming-convention */
var scales_20 = function scales_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsxs("svg", Object.assign({
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("circle", {
      cx: "24",
      cy: "24",
      r: "24",
      fill: "#C4CBD8",
      fillOpacity: "0.5"
    }, void 0), jsx("mask", Object.assign({
      id: "path-2-inside-1_1_7852",
      fill: "white"
    }, {
      children: jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.5 12.5C21.5 11.1193 22.6193 10 24 10C25.3807 10 26.5 11.1193 26.5 12.5V32H21.5V12.5ZM23.5 12.8158C23.5 12.5396 23.7239 12.3158 24 12.3158C24.2761 12.3158 24.5 12.5396 24.5 12.8158V32H23.5V12.8158ZM30 35C30 34.4477 29.5523 34 29 34H19C18.4477 34 18 34.4477 18 35H30ZM19 32C17.3431 32 16 33.3431 16 35V35.3H12.85C12.3806 35.3 12 35.6805 12 36.15C12 36.6194 12.3806 37 12.85 37L16 37H18H30H32L35.15 37C35.6194 37 36 36.6194 36 36.15C36 35.6805 35.6194 35.3 35.15 35.3H32V35C32 33.3431 30.6569 32 29 32H19Z"
      }, void 0)
    }), void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.5 12.5C21.5 11.1193 22.6193 10 24 10C25.3807 10 26.5 11.1193 26.5 12.5V32H21.5V12.5ZM23.5 12.8158C23.5 12.5396 23.7239 12.3158 24 12.3158C24.2761 12.3158 24.5 12.5396 24.5 12.8158V32H23.5V12.8158ZM30 35C30 34.4477 29.5523 34 29 34H19C18.4477 34 18 34.4477 18 35H30ZM19 32C17.3431 32 16 33.3431 16 35V35.3H12.85C12.3806 35.3 12 35.6805 12 36.15C12 36.6194 12.3806 37 12.85 37L16 37H18H30H32L35.15 37C35.6194 37 36 36.6194 36 36.15C36 35.6805 35.6194 35.3 35.15 35.3H32V35C32 33.3431 30.6569 32 29 32H19Z",
      fill: "#353535"
    }, void 0), jsx("path", {
      d: "M26.5 32V33H27.5V32H26.5ZM21.5 32H20.5V33H21.5V32ZM24.5 32V33H25.5V32H24.5ZM23.5 32H22.5V33H23.5V32ZM30 35V36H31V35H30ZM18 35H17V36H18V35ZM16 35.3V36.3H17V35.3H16ZM12.85 37L12.85 36H12.85V37ZM16 37L16 38H16V37ZM32 37V38H32L32 37ZM35.15 37V36H35.15L35.15 37ZM32 35.3H31V36.3H32V35.3ZM24 9C22.067 9 20.5 10.567 20.5 12.5H22.5C22.5 11.6716 23.1716 11 24 11V9ZM27.5 12.5C27.5 10.567 25.933 9 24 9V11C24.8284 11 25.5 11.6716 25.5 12.5H27.5ZM27.5 32V12.5H25.5V32H27.5ZM21.5 33H26.5V31H21.5V33ZM20.5 12.5V32H22.5V12.5H20.5ZM24 11.3158C23.1716 11.3158 22.5 11.9873 22.5 12.8158H24.5C24.5 13.0919 24.2761 13.3158 24 13.3158V11.3158ZM25.5 12.8158C25.5 11.9873 24.8284 11.3158 24 11.3158V13.3158C23.7239 13.3158 23.5 13.0919 23.5 12.8158H25.5ZM25.5 32V12.8158H23.5V32H25.5ZM23.5 33H24.5V31H23.5V33ZM22.5 12.8158V32H24.5V12.8158H22.5ZM29 35H31C31 33.8954 30.1046 33 29 33V35ZM19 35H29V33H19V35ZM19 35V33C17.8954 33 17 33.8954 17 35H19ZM30 34H18V36H30V34ZM17 35C17 33.8954 17.8954 33 19 33V31C16.7909 31 15 32.7909 15 35H17ZM17 35.3V35H15V35.3H17ZM12.85 36.3H16V34.3H12.85V36.3ZM13 36.15C13 36.2328 12.9328 36.3 12.85 36.3V34.3C11.8283 34.3 11 35.1283 11 36.15H13ZM12.85 36C12.9328 36 13 36.0671 13 36.15H11C11 37.1717 11.8283 38 12.85 38V36ZM16 36L12.85 36L12.85 38L16 38L16 36ZM18 36H16V38H18V36ZM30 36H18V38H30V36ZM32 36H30V38H32V36ZM35.15 36L32 36L32 38L35.15 38L35.15 36ZM35 36.15C35 36.0671 35.0672 36 35.15 36V38C36.1717 38 37 37.1717 37 36.15H35ZM35.15 36.3C35.0672 36.3 35 36.2328 35 36.15H37C37 35.1283 36.1717 34.3 35.15 34.3V36.3ZM32 36.3H35.15V34.3H32V36.3ZM31 35V35.3H33V35H31ZM29 33C30.1046 33 31 33.8954 31 35H33C33 32.7909 31.2091 31 29 31V33ZM19 33H29V31H19V33Z",
      fill: outlineColor || _wcImport4.neutral[100],
      mask: "url(#path-2-inside-1_1_7852)"
    }, void 0), jsx("path", {
      d: "M13 16.6117C13 16.6117 14 17.8117 16 17.8117C18 17.8117 20 16 22.5 16M35 16.6117C35 16.6117 34 17.8117 32 17.8117C30 17.8117 28 16 25.5 16",
      stroke: "#353535",
      strokeWidth: "2",
      strokeLinecap: "round"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M30.5489 18.0502L31.9379 18.7627L33.4229 18.0001C34.052 19.2253 34.9631 21.048 35.8795 23.0747C35.9563 23.2445 36.0048 23.445 35.9968 23.6623C35.9188 25.7596 34.1209 27.3682 31.9988 27.3682C29.8766 27.3682 28.0787 25.7596 28.0008 23.6623C27.9927 23.4451 28.0412 23.2445 28.118 23.0747C29.0221 21.0754 29.9208 19.2746 30.5489 18.0502ZM30.1212 22.7857C30.8214 21.2825 31.4912 19.9407 31.9988 18.9486C32.5063 19.9407 33.1761 21.2825 33.8763 22.7857H30.1212ZM29.944 24.4857C30.3164 25.175 31.0787 25.6682 31.9988 25.6682C32.9188 25.6682 33.6811 25.175 34.0536 24.4857H29.944Z",
      fill: "#353535"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.5489 18.0502L15.9379 18.7627L17.4229 18.0001C18.052 19.2253 18.9631 21.048 19.8795 23.0747C19.9563 23.2445 20.0048 23.445 19.9968 23.6623C19.9188 25.7596 18.1209 27.3682 15.9988 27.3682C13.8766 27.3682 12.0787 25.7596 12.0008 23.6623C11.9927 23.4451 12.0412 23.2445 12.118 23.0747C13.0221 21.0754 13.9208 19.2746 14.5489 18.0502ZM14.1212 22.7857C14.8214 21.2825 15.4912 19.9407 15.9988 18.9486C16.5063 19.9407 17.1761 21.2825 17.8763 22.7857H14.1212ZM13.944 24.4857C14.3164 25.175 15.0787 25.6682 15.9988 25.6682C16.9188 25.6682 17.6811 25.175 18.0536 24.4857H13.944Z",
      fill: "#353535"
    }, void 0)]
  }), void 0);
};

var settings_16 = function settings_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.2957 3.30741L10.8012 3.61089C10.8012 3.61089 12.3103 3.33993 12.398 3.33168C12.8547 3.27405 13.3465 3.52636 13.5763 3.93567L14.2097 5.06433C14.4404 5.47537 14.4073 6.04178 14.1404 6.40016C14.0784 6.48989 13.0973 7.69866 13.0973 7.69866C13.0973 7.69866 13.1035 7.78793 13.1035 8C13.1035 8.1022 13.095 8.30553 13.095 8.30553C13.095 8.30553 14.0784 9.51011 14.1292 9.58409C14.406 9.96211 14.4394 10.5264 14.2097 10.9357L13.5763 12.0643C13.3456 12.4754 12.8521 12.7291 12.4125 12.67C12.4089 12.6696 10.793 12.3883 10.793 12.3883L10.2957 12.69C10.2957 12.69 9.76787 14.1703 9.731 14.2525C9.55115 14.6881 9.09283 15 8.63342 15H7.36654C6.90511 15 6.44481 14.6872 6.27658 14.2701C6.23207 14.1701 5.70283 12.6845 5.70283 12.6845L5.19575 12.387C5.19575 12.387 3.68948 12.6601 3.6018 12.6684C3.14516 12.726 2.65339 12.4736 2.42369 12.0643L1.79025 10.9357C1.55953 10.5246 1.5927 9.95813 1.8597 9.59973C1.92167 9.51002 2.9037 8.30028 2.9037 8.30028C2.9037 8.30028 2.89648 8.21213 2.89648 8C2.89648 7.8998 2.90467 7.70042 2.90467 7.70042C2.90467 7.70042 1.92167 6.48998 1.87089 6.416C1.59404 6.03797 1.56052 5.47364 1.79025 5.06433L2.42369 3.93567C2.65438 3.52463 3.14777 3.27091 3.58294 3.32952C3.68948 3.33987 5.21066 3.61245 5.21066 3.61245L5.71012 3.30702C5.71012 3.30702 6.23207 1.82986 6.26894 1.74768C6.44876 1.31202 6.90709 1 7.36654 1H8.63342C9.09481 1 9.5551 1.31269 9.72334 1.72969C9.76787 1.8297 10.2957 3.30741 10.2957 3.30741ZM9.09634 4.56984L9.01096 4.276C8.8868 3.84873 8.53485 2.88007 8.49735 2.78941C8.47562 2.73685 7.52437 2.73687 7.50264 2.78943C7.46516 2.8801 7.11327 3.84873 6.98913 4.27594L6.90375 4.5698L6.62952 4.69014C6.37038 4.80385 6.12564 4.94962 5.90045 5.12391L5.66187 5.30856L5.37139 5.23758C4.94938 5.13447 3.9573 4.96355 3.86216 4.95161C3.80701 4.94469 3.33138 5.79217 3.36479 5.83784C3.42241 5.91661 4.06225 6.7148 4.35999 7.03913L4.56445 7.26186L4.52896 7.56603C4.51226 7.70915 4.50383 7.85396 4.50383 8C4.50383 8.14604 4.51226 8.29085 4.52896 8.43397L4.56445 8.73814L4.35999 8.96087C4.06225 9.2852 3.42241 10.0834 3.36479 10.1622C3.33138 10.2078 3.80701 11.0553 3.86216 11.0484C3.9573 11.0365 4.94938 10.8655 5.37139 10.7624L5.66187 10.6914L5.90045 10.8761C6.12564 11.0504 6.37038 11.1961 6.62952 11.3099L6.90375 11.4302L6.98913 11.7241C7.11327 12.1513 7.46516 13.1199 7.50264 13.2106C7.52437 13.2631 8.47562 13.2632 8.49735 13.2106C8.53485 13.1199 8.8868 12.1513 9.01096 11.724L9.09634 11.4302L9.37055 11.3098C9.62969 11.1961 9.87442 11.0503 10.0996 10.876L10.3382 10.6914L10.6287 10.7623C11.0506 10.8654 12.0427 11.0364 12.1378 11.0483C12.1704 11.0524 12.6686 10.2078 12.6352 10.1621C12.5776 10.0834 11.9378 9.2851 11.64 8.96073L11.4355 8.738L11.471 8.43385C11.4877 8.29077 11.4961 8.146 11.4961 8C11.4961 7.854 11.4877 7.70923 11.471 7.56615L11.4355 7.262L11.64 7.03927C11.9378 6.7149 12.5776 5.91664 12.6352 5.83786C12.6686 5.79219 12.193 4.94473 12.1378 4.95166C12.0427 4.9636 11.0506 5.13457 10.6287 5.23767L10.3382 5.30865L10.0996 5.12398C9.87442 4.94969 9.62969 4.80391 9.37055 4.69019L9.09634 4.56984ZM8 9.5C8.80531 9.5 9.45814 8.82843 9.45814 8C9.45814 7.17157 8.80531 6.5 8 6.5C7.19469 6.5 6.54186 7.17157 6.54186 8C6.54186 8.82843 7.19469 9.5 8 9.5Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var settings_20 = function settings_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.0063 3.85492L13.6682 4.25233C13.6682 4.25233 15.6445 3.89751 15.7594 3.8867C16.3574 3.81124 17.0015 4.14164 17.3023 4.67765L18.1318 6.15564C18.4339 6.69391 18.3906 7.43565 18.041 7.90495C17.9599 8.02245 16.6751 9.60537 16.6751 9.60537C16.6751 9.60537 16.6832 9.72227 16.6832 9.99998C16.6832 10.1338 16.672 10.4001 16.672 10.4001C16.672 10.4001 17.9599 11.9775 18.0263 12.0744C18.3888 12.5694 18.4326 13.3084 18.1318 13.8443L17.3023 15.3223C17.0002 15.8606 16.354 16.1928 15.7783 16.1154C15.7736 16.115 13.6576 15.7465 13.6576 15.7465L13.0063 16.1416C13.0063 16.1416 12.3151 18.0801 12.2668 18.1877C12.0313 18.7582 11.4311 19.1666 10.8295 19.1666H9.1705C8.56625 19.1666 7.96348 18.757 7.74318 18.2109C7.68489 18.0799 6.99184 16.1344 6.99184 16.1344L6.32781 15.7449C6.32781 15.7449 4.3553 16.1025 4.24048 16.1133C3.64251 16.1887 2.99853 15.8583 2.69772 15.3223L1.86822 13.8443C1.56609 13.306 1.60953 12.5642 1.95917 12.0949C2.04032 11.9774 3.32631 10.3932 3.32631 10.3932C3.32631 10.3932 3.31686 10.2778 3.31686 9.99998C3.31686 9.86877 3.32758 9.60767 3.32758 9.60767C3.32758 9.60767 2.04032 8.02257 1.97382 7.9257C1.61127 7.43066 1.56738 6.69166 1.86822 6.15564L2.69772 4.67765C2.99982 4.13938 3.64593 3.80713 4.21579 3.88388C4.3553 3.89743 6.34733 4.25438 6.34733 4.25438L7.00138 3.85441C7.00138 3.85441 7.68489 1.92003 7.73317 1.81242C7.96865 1.24192 8.56884 0.833313 9.1705 0.833313H10.8295C11.4337 0.833313 12.0365 1.24279 12.2568 1.78885C12.3151 1.91983 13.0063 3.85492 13.0063 3.85492ZM11.5369 5.19148L11.4172 4.77957C11.2431 4.18062 10.7498 2.82273 10.6972 2.69563C10.6667 2.62196 9.33326 2.62199 9.3028 2.69567C9.25025 2.82277 8.75697 4.18062 8.58295 4.7795L8.46325 5.19142L8.07883 5.36012C7.71557 5.51953 7.37248 5.72387 7.05681 5.96819L6.72236 6.22704L6.31516 6.12754C5.72358 5.98299 4.33286 5.74339 4.19949 5.72666C4.12218 5.71696 3.45543 6.90498 3.50226 6.96899C3.58303 7.07942 4.47998 8.19834 4.89735 8.65299L5.18398 8.96522L5.13423 9.39161C5.11082 9.59224 5.099 9.79524 5.099 9.99996C5.099 10.2047 5.11082 10.4077 5.13423 10.6083L5.18398 11.0347L4.89735 11.3469C4.47998 11.8016 3.58303 12.9205 3.50226 13.0309C3.45543 13.0949 4.12218 14.283 4.19949 14.2733C4.33286 14.2565 5.72358 14.0169 6.31516 13.8724L6.72236 13.7729L7.05681 14.0317C7.37248 14.276 7.71557 14.4804 8.07883 14.6398L8.46325 14.8085L8.58295 15.2204C8.75697 15.8193 9.25025 17.1771 9.3028 17.3043C9.33326 17.3779 10.6667 17.378 10.6972 17.3043C10.7498 17.1772 11.2431 15.8193 11.4172 15.2203L11.5369 14.8084L11.9213 14.6397C12.2845 14.4803 12.6276 14.276 12.9433 14.0316L13.2777 13.7728L13.685 13.8723C14.2765 14.0168 15.6671 14.2564 15.8005 14.2732C15.8461 14.2789 16.5446 13.0949 16.4978 13.0309C16.417 12.9205 15.5201 11.8014 15.1026 11.3467L14.816 11.0345L14.8658 10.6081C14.8891 10.4076 14.901 10.2046 14.901 9.99996C14.901 9.7953 14.8891 9.59236 14.8658 9.39178L14.816 8.96541L15.1026 8.65319C15.5201 8.19848 16.417 7.07946 16.4978 6.96902C16.5446 6.905 15.8778 5.71701 15.8005 5.72672C15.6671 5.74347 14.2765 5.98313 13.685 6.12766L13.2777 6.22716L12.9433 5.96829C12.6276 5.72396 12.2845 5.51961 11.9213 5.36019L11.5369 5.19148ZM10 12.75C8.52362 12.75 7.32676 11.5188 7.32676 9.99998C7.32676 8.48119 8.52362 7.24998 10 7.24998C11.4764 7.24998 12.6733 8.48119 12.6733 9.99998C12.6733 11.5188 11.4764 12.75 10 12.75ZM9.99997 10.9167C10.4921 10.9167 10.8911 10.5063 10.8911 10C10.8911 9.49374 10.4921 9.08334 9.99997 9.08334C9.50784 9.08334 9.10889 9.49374 9.10889 10C9.10889 10.5063 9.50784 10.9167 9.99997 10.9167Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var settings_slider_16 = function settings_slider_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.74509 10.6249V9.74823C7.74509 8.78264 8.56417 7.99987 9.56689 7.99987H11.3944C12.4006 7.99987 13.2162 8.78249 13.2162 9.74823V10.6249L14.576 10.625C15.079 10.625 15.4867 11.0134 15.4867 11.5001C15.4867 11.9833 15.0802 12.3751 14.576 12.3751L13.2162 12.3749V13.2516C13.2162 14.2172 12.3971 15 11.3944 15H9.56689C8.56074 15 7.74509 14.2173 7.74509 13.2516V12.3749L1.81371 12.3751C1.31079 12.3751 0.903095 11.9867 0.903095 11.5001C0.903095 11.0168 1.30957 10.625 1.81371 10.625L7.74509 10.6249ZM2.7209 2.74836C2.7209 1.78277 3.53999 1 4.54271 1H6.37022C7.37638 1 8.19203 1.78262 8.19203 2.74836V3.62503L13.9915 3.62499C14.4944 3.62499 14.9021 4.01338 14.9021 4.5C14.9021 4.98326 14.4957 5.37501 13.9915 5.37501L8.19203 5.37506V6.25173C8.19203 7.21732 7.37295 8.00009 6.37022 8.00009H4.54271C3.53656 8.00009 2.7209 7.21747 2.7209 6.25173V5.37506L1.42405 5.37501C0.921126 5.37501 0.513428 4.98662 0.513428 4.5C0.513428 4.01674 0.919905 3.62499 1.42405 3.62499L2.7209 3.62503V2.74836ZM4.59199 2.74992V6.24997H6.41569V2.74992H4.59199ZM9.57843 9.75005V13.2501H11.4021V9.75005H9.57843Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var stock_20 = function stock_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.5834 4.50083C14.0771 4.50083 13.6667 4.09042 13.6667 3.58416C13.6667 3.0779 14.0771 2.6675 14.5834 2.6675H17.2571C17.7524 2.62928 18.25 3.00357 18.25 3.58332V6.33332C18.25 6.83959 17.8396 7.24999 17.3334 7.24999C16.8271 7.24999 16.4167 6.83959 16.4167 6.33332V5.80271L12.4815 9.73151C12.1236 10.0895 11.5432 10.0895 11.1852 9.73151L8.5476 7.09394L5.36167 15.8132C5.18867 16.289 4.66272 16.5345 4.18694 16.3615C3.71115 16.1885 3.4657 15.6625 3.63871 15.1867L7.30521 5.10341C7.53439 4.47312 8.34064 4.29425 8.81487 4.76848L11.8436 7.79724L15.1261 4.50083H14.5834ZM2.66665 17.3333H18.2512C18.7568 17.3333 19.1666 17.7402 19.1666 18.25C19.1666 18.7563 18.758 19.1667 18.2512 19.1667H1.74874C1.49616 19.1667 1.26747 19.0651 1.10184 18.8999C0.935747 18.7331 0.833313 18.5044 0.833313 18.2513V1.74877C0.833313 1.24319 1.24019 0.833344 1.74998 0.833344C2.25624 0.833344 2.66665 1.24197 2.66665 1.74877V17.3333Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var stroller_20 = function stroller_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsxs("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      d: "M2.05054 11.4375C2.05054 10.471 2.83404 9.6875 3.80054 9.6875H16.5833C17.5498 9.6875 18.3333 10.471 18.3333 11.4375H2.05054Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.3727 14.7917C14.5552 14.7917 13.8925 15.4446 13.8925 16.25C13.8925 17.0555 14.5552 17.7084 15.3727 17.7084C16.1903 17.7084 16.853 17.0555 16.853 16.25C16.853 15.4446 16.1903 14.7917 15.3727 14.7917ZM12.4122 16.25C12.4122 14.6392 13.7377 13.3334 15.3727 13.3334C17.0078 13.3334 18.3332 14.6392 18.3332 16.25C18.3332 17.8609 17.0078 19.1667 15.3727 19.1667C13.7377 19.1667 12.4122 17.8609 12.4122 16.25Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.19162 15.8362C8.08714 16.1932 9.10394 16.3959 10.1919 16.3959C11.2798 16.3959 12.2966 16.1932 13.1921 15.8362C13.1661 15.9702 13.1525 16.1085 13.1525 16.25C13.1525 16.586 13.2294 16.9043 13.3668 17.1888C12.3861 17.524 11.3115 17.7084 10.1919 17.7084C9.0723 17.7084 7.99766 17.524 7.01699 17.1888C7.15439 16.9043 7.23129 16.586 7.23129 16.25C7.23129 16.1085 7.21766 15.9702 7.19162 15.8362ZM4.67717 14.087C3.95056 13.2405 3.53073 12.2237 3.53073 11.1459H2.05048C2.05048 12.4909 2.54536 13.7277 3.38864 14.7564C3.72206 14.4051 4.17169 14.1621 4.67717 14.087ZM16.9951 14.7564C16.6617 14.4051 16.2121 14.1621 15.7066 14.087C16.4332 13.2405 16.853 12.2237 16.853 11.1459H18.3333C18.3333 12.4909 17.8384 13.7277 16.9951 14.7564Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.01099 14.7917C4.19346 14.7917 3.53073 15.4446 3.53073 16.25C3.53073 17.0555 4.19346 17.7084 5.01099 17.7084C5.82851 17.7084 6.49124 17.0555 6.49124 16.25C6.49124 15.4446 5.82851 14.7917 5.01099 14.7917ZM2.05048 16.25C2.05048 14.6392 3.37594 13.3334 5.01099 13.3334C6.64603 13.3334 7.97149 14.6392 7.97149 16.25C7.97149 17.8609 6.64603 19.1667 5.01099 19.1667C3.37594 19.1667 2.05048 17.8609 2.05048 16.25Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.3052 4.49964C14.3196 3.6413 12.8455 3.12496 10.932 3.12496V1.66663C13.1061 1.66663 14.9625 2.25477 16.2856 3.407C17.6196 4.56875 18.3333 6.23686 18.3333 8.22913H16.853C16.853 6.59703 16.2799 5.34847 15.3052 4.49964Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      d: "M10.1919 2.39579C10.1919 1.99309 10.5895 1.66663 11.08 1.66663C11.5706 1.66663 11.9682 1.99309 11.9682 2.39579V8.22913C11.9682 8.63183 11.5706 8.95829 11.08 8.95829C10.5895 8.95829 10.1919 8.63183 10.1919 8.22913V2.39579Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      d: "M10.1919 8.375C10.1919 7.89175 10.5233 7.5 10.932 7.5H17.5932C18.0019 7.5 18.3333 7.89175 18.3333 8.375C18.3333 8.85825 18.0019 9.25 17.5932 9.25H10.932C10.5233 9.25 10.1919 8.85825 10.1919 8.375Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      d: "M2.34656 5.3125H4.12286V8.22917C4.12286 8.63187 3.72522 8.95833 3.23471 8.95833C2.7442 8.95833 2.34656 8.63187 2.34656 8.22917V5.3125Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      d: "M1.45837 5.16663C1.45837 4.68338 1.78974 4.29163 2.1985 4.29163H3.67876C4.08752 4.29163 4.41888 4.68338 4.41888 5.16663C4.41888 5.64988 4.08752 6.04163 3.67876 6.04163H2.1985C1.78974 6.04163 1.45837 5.64988 1.45837 5.16663Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)]
  }), void 0);
};

var support_20 = function support_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsxs("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.27237 17.5415H1.97822C1.3459 17.5415 0.833313 17.0104 0.833313 16.3575V9.22558C0.833313 8.5717 1.34581 8.04163 1.97822 8.04163H4.27237C4.79088 8.04163 5.22888 8.39876 5.36975 8.8873C6.06875 8.98225 7.29074 9.32389 8.3396 10.0287C8.54602 10.0287 10.7659 10.0208 10.7659 10.0208C11.8025 10.0208 12.6159 10.626 13.2455 11.6041H15.7312C17.6741 11.6041 19.1667 12.8097 19.1666 13.973C19.171 14.6583 18.019 15.7241 16.5428 16.6045C14.7201 17.6917 12.6124 18.3455 10.3873 18.3331C8.19222 18.3453 6.36307 17.9038 5.15571 17.1108C4.94573 17.3739 4.62801 17.5415 4.27237 17.5415ZM10.3867 16.7497C14.5838 16.7265 17.5046 14.127 17.5046 13.8866C17.5046 13.6463 16.6719 13.1873 15.7305 13.1873H14.0023C14.0787 13.4087 14.1374 13.6119 14.1796 13.7865C14.3005 14.2863 13.9358 14.7706 13.4386 14.7706H7.3266C6.90466 14.7706 6.56261 14.4161 6.56261 13.9789C6.56261 13.5417 6.90466 13.1873 7.3266 13.1873H12.2926C12.2926 13.1873 11.7834 11.6039 10.7653 11.6039H8.09059C7.92684 11.6039 7.76742 11.5494 7.63583 11.4484C7.60505 11.4248 6.58456 10.7194 5.41662 10.4975V15.3156C6.28815 16.3281 8.44097 16.7605 10.3867 16.7497ZM3.88885 9.62706L2.36109 9.62494V15.9582H3.88885V9.62706Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      d: "M11.1459 3.02742C11.5108 2.69944 11.9926 2.5 12.5209 2.5C13.66 2.5 14.5834 3.42736 14.5834 4.57133C14.5834 6.2409 12.8626 7.85092 11.2918 8.79557C11.212 8.84547 11.081 8.84614 11.0009 8.79625C9.41976 7.85474 7.70837 6.24098 7.70837 4.57133C7.70837 3.42736 8.63179 2.5 9.77087 2.5C10.2991 2.5 10.781 2.69944 11.1459 3.02742Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)]
  }), void 0);
};

var thumbsUp_16 = function thumbsUp_16(_ref) {
  var outlineColor = _ref.outlineColor,
    fillColor = _ref.fillColor;
  return jsxs("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.02148 13.185C1.02148 14.1705 1.80235 14.9677 2.7656 14.9677C2.7656 14.9677 9.39542 14.9739 10.6433 14.9677C13.3587 14.9977 13.5919 14.1405 14.0664 12.3955L14.0684 12.3882C14.3412 11.385 14.9162 9.26603 14.9258 9.21546C15.2387 7.71637 14.1181 6.40728 12.6004 6.40728L11.6526 6.40707C11.6462 6.40707 11.6394 6.40707 11.6324 6.40707C11.3743 6.40718 10.7343 6.40745 10.7343 6.25176C10.7343 6.25176 10.7454 6.10712 10.7929 5.81426C10.809 5.71522 10.8238 5.62529 10.8374 5.54249C10.9374 4.93542 10.9744 4.7111 10.9855 4.07963C10.9985 3.34101 10.5139 2.36923 9.74281 1.75364C9.32753 1.4221 8.69246 1.11328 8.69246 1.11328C8.27607 0.907529 7.83684 1.0667 7.52987 1.74645C7.52987 1.74645 5.98697 5.17248 5.77875 5.59865C5.76428 5.62827 5.75051 5.65767 5.7369 5.68675C5.55462 6.07613 5.3996 6.40728 3.94386 6.40728H2.76562C1.80322 6.40728 1.02151 7.20542 1.02151 8.18997L1.02148 13.185ZM10.6012 13.3491C11.0111 13.3491 11.876 13.3491 12.2982 12.9269L12.4972 12.1818C12.5312 12.0481 12.5548 11.9581 12.5784 11.8682L12.5784 11.8681C12.6048 11.7675 12.6311 11.6671 12.672 11.5056H12.0078C11.5247 11.5056 11.1331 11.109 11.1331 10.6121C11.1331 10.1187 11.5197 9.71864 12.0078 9.71864H13.1227C13.1573 9.58101 13.1847 9.47791 13.2091 9.3862L13.2091 9.38616L13.2091 9.38612C13.2562 9.20918 13.2919 9.07462 13.3464 8.81629C13.4291 8.42404 13.219 8.16084 12.8091 8.16084L11.6712 8.16062C10.3308 8.16053 8.94564 7.96991 9.11841 6.74844C9.14887 6.5331 9.21372 6.19943 9.25285 5.99809L9.25285 5.99807L9.25286 5.99804C9.26725 5.924 9.27816 5.86786 9.2826 5.84208C9.40643 5.20526 9.45707 4.92599 9.48821 4.75425L9.48823 4.75411L9.48824 4.75409C9.50674 4.65203 9.51836 4.58796 9.53437 4.50934L9.58564 3.93354C9.5903 3.66883 9.4032 3.44017 9.22691 3.22472L9.22281 3.21971C8.96489 2.90448 8.64938 2.7062 8.64938 2.7062L7.11637 6.17927C6.65741 7.14773 5.83688 7.65191 4.90557 7.90794V13.352C7.48056 13.3513 10.3441 13.3503 10.6012 13.3491ZM2.63582 8.15669C2.99726 8.15669 3.37105 8.14528 3.74342 8.1106V13.3523L3.03393 13.3525L2.63582 13.3526V8.15669Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      d: "M12.2982 12.927C11.876 13.3492 11.0111 13.3492 10.6011 13.3492C10.3441 13.3504 7.48055 13.3514 4.90556 13.3521V7.90804C5.83686 7.65201 6.6574 7.14783 7.11636 6.17936L8.64937 2.7063C8.64937 2.7063 8.96488 2.90457 9.2228 3.21981L9.2269 3.22482C9.40319 3.44026 9.59029 3.66893 9.58563 3.93363L9.53436 4.50943C9.51834 4.58809 9.50671 4.6522 9.48819 4.75434C9.45706 4.92608 9.40642 5.20536 9.28259 5.84218C9.27815 5.86795 9.26723 5.92409 9.25285 5.99813C9.21371 6.19948 9.14886 6.53318 9.1184 6.74854C8.94563 7.97 10.3307 8.16063 11.6711 8.16072L12.8091 8.16093C13.219 8.16093 13.4291 8.42414 13.3464 8.81639C13.2919 9.07475 13.2561 9.20931 13.2091 9.38629C13.1847 9.478 13.1573 9.58111 13.1226 9.71874H12.0078C11.5197 9.71874 11.1331 10.1188 11.1331 10.6122C11.1331 11.1091 11.5247 11.5057 12.0078 11.5057H12.672C12.6311 11.6672 12.6048 11.7676 12.5784 11.8682C12.5548 11.9582 12.5312 12.0482 12.4972 12.1819L12.2982 12.927Z",
      fill: fillColor || 'none',
      stroke: fillColor || 'none',
      strokeWidth: "0.1"
    }, void 0), jsx("path", {
      d: "M3.74341 8.11069C3.37104 8.14538 2.99725 8.15679 2.6358 8.15679V13.3527L3.03392 13.3526C3.26084 13.3526 3.49834 13.3525 3.74341 13.3524V8.11069Z",
      fill: fillColor || 'none',
      stroke: fillColor || 'none',
      strokeWidth: "0.1"
    }, void 0)]
  }), void 0);
};
var thumbsUp_20 = function thumbsUp_20(_ref2) {
  var outlineColor = _ref2.outlineColor,
    fillColor = _ref2.fillColor;
  return jsxs("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.6418 17.3753C14.5802 17.3967 15.5407 16.9956 16.03 16.0337H15.6767C15.1931 16.0337 14.8011 15.6367 14.8011 15.1393C14.8011 14.6454 15.1881 14.245 15.6767 14.245H16.5512C16.6233 13.9614 16.7005 13.6567 16.7779 13.3507H16.1131C15.6296 13.3507 15.2376 12.9537 15.2376 12.4563C15.2376 11.9624 15.6245 11.562 16.1131 11.562H17.229C17.3305 11.1584 17.3978 10.8901 17.4011 10.8763C17.4839 10.4837 17.2736 10.2202 16.8633 10.2202L13.7128 10.22C12.3711 10.2199 11.3819 8.99414 11.647 7.6388C11.656 7.59276 11.9075 6.29148 11.924 6.19552C12.1045 5.14868 12.1892 4.40074 12.1823 3.97507L12.1823 3.91292C12.187 3.64591 12.0284 3.36131 11.611 3.02804C11.5641 2.99058 11.2571 2.80025 11.2571 2.80025L8.74021 8.37351C8.27377 9.40639 7.18288 10.1524 6.07125 10.2161V17.3788C8.84106 17.3781 12.3028 17.3769 12.6418 17.3753ZM4.32528 10.2205H2.57898L2.57932 17.3797C2.57932 17.3797 3.28599 17.3795 4.32528 17.3793V10.2205ZM2.579 19.1639C1.61492 19.1639 0.833374 18.366 0.833374 17.3796V10.216C0.833374 9.23064 1.61577 8.43181 2.579 8.43181H5.91759C6.40151 8.43181 6.94723 8.04901 7.15564 7.62247C7.36404 7.19593 9.87088 1.60996 9.87088 1.60996C10.1781 0.929624 10.971 0.634258 11.6329 0.976254C11.6329 0.976254 12.2686 1.28535 12.6842 1.61718C13.4559 2.23329 13.9444 3.01423 13.928 3.94518C13.9376 4.53438 13.8337 5.40247 13.6434 6.50655C13.5926 6.8016 13.3586 7.99193 13.3586 7.99193C13.311 8.23502 13.4697 8.43131 13.7129 8.43133L16.8635 8.43154C18.3825 8.43154 19.4242 9.74203 19.1109 11.2424C19.1014 11.293 18.0013 15.8184 17.8024 16.3436C17.0617 18.3977 15.3444 19.194 12.6229 19.1639C11.3739 19.1701 2.579 19.1639 2.579 19.1639Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.6417 17.3753C14.5802 17.3967 15.5406 16.9956 16.0299 16.0337H15.6766C15.1931 16.0337 14.8011 15.6367 14.8011 15.1393C14.8011 14.6454 15.188 14.245 15.6766 14.245H16.5511C16.6232 13.9614 16.7004 13.6567 16.7779 13.3507H16.1131C15.6296 13.3507 15.2376 12.9537 15.2376 12.4563C15.2376 11.9624 15.6245 11.562 16.1131 11.562H17.229C17.3305 11.1584 17.3978 10.8901 17.4011 10.8763C17.4839 10.4837 17.2736 10.2202 16.8633 10.2202L13.7127 10.22C12.3711 10.2199 11.3819 8.99412 11.6469 7.63878C11.656 7.59275 11.9075 6.29146 11.924 6.1955C12.1045 5.14867 12.1892 4.40073 12.1822 3.97505L12.1823 3.9129C12.187 3.64589 12.0284 3.36129 11.611 3.02802C11.564 2.99056 11.2571 2.80023 11.2571 2.80023L8.74019 8.37349C8.27374 9.40637 7.18286 10.1524 6.07123 10.2161L6.07123 17.3788C8.84103 17.3781 12.3028 17.3768 12.6417 17.3753Z",
      fill: fillColor || 'none',
      stroke: fillColor || 'none',
      strokeWidth: "0.1"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.32528 10.2205H2.57898L2.57932 17.3797C2.57932 17.3797 3.28599 17.3795 4.32528 17.3793V10.2205Z",
      fill: fillColor || 'none',
      stroke: fillColor || 'none',
      strokeWidth: "0.1"
    }, void 0)]
  }), void 0);
};

var thumbsUpFilled_16 = function thumbsUpFilled_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M2.76561 14.9677C1.80236 14.9677 1.0215 14.1705 1.0215 13.185L1.02152 8.19C1.02152 7.20545 1.80324 6.40731 2.76563 6.40731H3.94387C5.50833 6.40731 5.57053 6.02485 5.77876 5.59868C5.98699 5.17251 7.52988 1.74647 7.52988 1.74647C7.83685 1.06673 8.27609 0.907557 8.69247 1.11331C8.69247 1.11331 9.32754 1.42213 9.74283 1.75367C10.5139 2.36926 10.9985 3.34104 10.9855 4.07965C10.9729 4.79725 10.9269 4.98907 10.7929 5.81429C10.7454 6.10715 10.7343 6.25179 10.7343 6.25179C10.7343 6.41173 11.4097 6.40708 11.6526 6.4071L12.6004 6.40731C14.1181 6.40731 15.2388 7.71639 14.9258 9.21549C14.9162 9.26605 14.3412 11.385 14.0684 12.3882C13.5925 14.1381 13.3625 14.9978 10.6434 14.9677C9.39543 14.974 2.76561 14.9677 2.76561 14.9677Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var thumbsUpFilled_20 = function thumbsUpFilled_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      d: "M2.57899 19.1639C1.61491 19.1639 0.833364 18.366 0.833364 17.3796V10.216C0.833364 9.23063 1.61576 8.4318 2.57899 8.4318H5.91758C6.4015 8.4318 6.94722 8.049 7.15562 7.62246C7.36403 7.19592 9.87087 1.60995 9.87087 1.60995C10.1781 0.929614 10.971 0.634247 11.6329 0.976243C11.6329 0.976243 12.2686 1.28534 12.6842 1.61717C13.4559 2.23328 13.9444 3.01422 13.928 3.94517C13.9376 4.53437 13.8337 5.40246 13.6434 6.50654C13.5926 6.80159 13.3586 7.99192 13.3586 7.99192C13.311 8.23501 13.4697 8.4313 13.7129 8.43132L16.8634 8.43153C18.3825 8.43153 19.4242 9.74202 19.1109 11.2424C19.1014 11.293 18.0013 15.8184 17.8024 16.3436C17.0617 18.3976 15.3444 19.194 12.6229 19.1638C11.3739 19.1701 2.57899 19.1639 2.57899 19.1639Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var thumbsUpOutline_16 = function thumbsUpOutline_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.02148 13.185C1.02148 14.1705 1.80235 14.9677 2.7656 14.9677C2.7656 14.9677 9.39542 14.9739 10.6433 14.9677C13.3587 14.9977 13.5919 14.1405 14.0664 12.3955L14.0684 12.3882C14.3412 11.385 14.9162 9.26603 14.9258 9.21546C15.2387 7.71637 14.1181 6.40728 12.6004 6.40728L11.6526 6.40707C11.6462 6.40707 11.6394 6.40707 11.6324 6.40707C11.3743 6.40718 10.7343 6.40745 10.7343 6.25176C10.7343 6.25176 10.7454 6.10712 10.7929 5.81426C10.809 5.71522 10.8238 5.62529 10.8374 5.54249C10.9374 4.93542 10.9744 4.7111 10.9855 4.07963C10.9985 3.34101 10.5139 2.36923 9.74281 1.75364C9.32753 1.4221 8.69246 1.11328 8.69246 1.11328C8.27607 0.907529 7.83684 1.0667 7.52987 1.74645C7.52987 1.74645 5.98697 5.17248 5.77875 5.59865C5.76428 5.62827 5.75051 5.65767 5.7369 5.68675C5.55462 6.07613 5.3996 6.40728 3.94386 6.40728H2.76562C1.80322 6.40728 1.02151 7.20542 1.02151 8.18997L1.02148 13.185ZM10.6012 13.3491C11.0111 13.3491 11.876 13.3491 12.2982 12.9269L12.4972 12.1818C12.5312 12.0481 12.5548 11.9581 12.5784 11.8682L12.5784 11.8681C12.6048 11.7675 12.6311 11.6671 12.672 11.5056H12.0078C11.5247 11.5056 11.1331 11.109 11.1331 10.6121C11.1331 10.1187 11.5197 9.71864 12.0078 9.71864H13.1227C13.1573 9.58101 13.1847 9.47791 13.2091 9.3862L13.2091 9.38616L13.2091 9.38612C13.2562 9.20918 13.2919 9.07462 13.3464 8.81629C13.4291 8.42404 13.219 8.16084 12.8091 8.16084L11.6712 8.16062C10.3308 8.16053 8.94564 7.96991 9.11841 6.74844C9.14887 6.5331 9.21372 6.19943 9.25285 5.99809L9.25285 5.99807L9.25286 5.99804C9.26725 5.924 9.27816 5.86786 9.2826 5.84208C9.40643 5.20526 9.45707 4.92599 9.48821 4.75425L9.48823 4.75411L9.48824 4.75409C9.50674 4.65203 9.51836 4.58796 9.53437 4.50934L9.58564 3.93354C9.5903 3.66883 9.4032 3.44017 9.22691 3.22472L9.22281 3.21971C8.96489 2.90448 8.64938 2.7062 8.64938 2.7062L7.11637 6.17927C6.65741 7.14773 5.83688 7.65191 4.90557 7.90794V13.352C7.48056 13.3513 10.3441 13.3503 10.6012 13.3491ZM2.63582 8.15669C2.99726 8.15669 3.37105 8.14528 3.74342 8.1106V13.3523L3.03393 13.3525L2.63582 13.3526V8.15669Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};
var thumbsUpOutline_20 = function thumbsUpOutline_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.6418 17.3753C14.5802 17.3967 15.5407 16.9956 16.03 16.0337H15.6767C15.1931 16.0337 14.8011 15.6367 14.8011 15.1393C14.8011 14.6454 15.1881 14.245 15.6767 14.245H16.5512C16.6233 13.9614 16.7005 13.6567 16.7779 13.3507H16.1131C15.6296 13.3507 15.2376 12.9537 15.2376 12.4563C15.2376 11.9624 15.6245 11.562 16.1131 11.562H17.229C17.3305 11.1584 17.3978 10.8901 17.4011 10.8763C17.4839 10.4837 17.2736 10.2202 16.8633 10.2202L13.7128 10.22C12.3711 10.2199 11.3819 8.99414 11.647 7.6388C11.656 7.59276 11.9075 6.29148 11.924 6.19552C12.1045 5.14868 12.1892 4.40074 12.1823 3.97507L12.1823 3.91292C12.187 3.64591 12.0284 3.36131 11.611 3.02804C11.5641 2.99058 11.2571 2.80025 11.2571 2.80025L8.74021 8.37351C8.27377 9.40639 7.18288 10.1524 6.07125 10.2161V17.3788C8.84106 17.3781 12.3028 17.3769 12.6418 17.3753ZM4.32528 10.2205H2.57898L2.57932 17.3797C2.57932 17.3797 3.28599 17.3795 4.32528 17.3793V10.2205ZM2.579 19.1639C1.61492 19.1639 0.833374 18.366 0.833374 17.3796V10.216C0.833374 9.23064 1.61577 8.43181 2.579 8.43181H5.91759C6.40151 8.43181 6.94723 8.04901 7.15564 7.62247C7.36404 7.19593 9.87088 1.60996 9.87088 1.60996C10.1781 0.929624 10.971 0.634258 11.6329 0.976254C11.6329 0.976254 12.2686 1.28535 12.6842 1.61718C13.4559 2.23329 13.9444 3.01423 13.928 3.94518C13.9376 4.53438 13.8337 5.40247 13.6434 6.50655C13.5926 6.8016 13.3586 7.99193 13.3586 7.99193C13.311 8.23502 13.4697 8.43131 13.7129 8.43133L16.8635 8.43154C18.3825 8.43154 19.4242 9.74203 19.1109 11.2424C19.1014 11.293 18.0013 15.8184 17.8024 16.3436C17.0617 18.3977 15.3444 19.194 12.6229 19.1639C11.3739 19.1701 2.579 19.1639 2.579 19.1639Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

/* eslint-disable @typescript-eslint/naming-convention */
var thumbsUpConviser_20 = function thumbsUpConviser_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsxs("svg", Object.assign({
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsxs("g", Object.assign({
      clipPath: "url(#clip0_1_7892)"
    }, {
      children: [jsx("circle", {
        cx: "24",
        cy: "24",
        r: "24",
        fill: "#1FA5A4",
        fillOpacity: "0.4"
      }, void 0), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.477 33.9961H13.4756C13.2533 33.9961 13 33.8007 13 33.4657V23.3064C13 22.9727 13.2545 22.7761 13.4756 22.7761H16V33.9976L15.4533 33.9973L14.0163 33.9964L13.6175 33.9962L13.5129 33.9961L13.4861 33.9961L13.4793 33.9961L13.4776 33.9961H13.4772C13.4771 33.9961 13.477 33.9961 13.4756 35.9961L13.477 33.9961ZM11 33.4657C11 34.8645 12.1084 35.9961 13.4756 35.9961C13.4756 35.9961 25.9484 36.0049 27.7197 35.996C31.5793 36.0387 34.0148 34.9094 35.0652 31.9964C35.3472 31.2515 36.9074 24.8338 36.9209 24.762C37.3652 22.6342 35.8879 20.7757 33.7336 20.7757L29.2655 20.7754C28.9206 20.7753 28.6956 20.497 28.763 20.1522C28.763 20.1522 29.0949 18.4641 29.167 18.0457C29.4369 16.4799 29.5842 15.2488 29.5706 14.4132C29.5938 13.0929 28.9011 11.9854 27.8066 11.1117C27.2172 10.6411 26.3158 10.2027 26.3158 10.2027C25.377 9.7177 24.2526 10.1366 23.8168 11.1014C23.8168 11.1014 20.2617 19.0233 19.9661 19.6283C19.6706 20.2332 18.8966 20.7761 18.2103 20.7761H13.4756C12.1096 20.7761 11 21.9089 11 23.3064V33.4657ZM18 33.9986L19.9341 33.9994C23.2777 34.0005 26.831 34.0005 27.7097 33.9961L27.7258 33.996L27.7418 33.9962C29.5029 34.0157 30.7039 33.7598 31.5171 33.3334C32.2621 32.9427 32.8146 32.342 33.1838 31.318L33.1892 31.3031L33.1948 31.2883C33.1948 31.2883 33.1948 31.2882 33.1949 31.2879L33.1952 31.287C33.1989 31.2757 33.2262 31.1919 33.2811 31H31C30.4477 31 30 30.5523 30 30C30 29.4477 30.4477 29 31 29H33.8105C33.9223 28.562 34.0389 28.0995 34.1536 27.6414C34.2081 27.4232 34.2616 27.2086 34.3135 27H32C31.4477 27 31 26.5523 31 26C31 25.4477 31.4477 25 32 25H34.8061L34.8564 24.7941L34.8568 24.7927C34.9216 24.5273 34.9579 24.379 34.9555 24.3919L34.9591 24.3725L34.9631 24.3532C35.1558 23.4306 34.5814 22.7757 33.7336 22.7757H33.7334L29.2654 22.7754C28.5343 22.7753 27.8018 22.4668 27.3032 21.8491C26.8073 21.2345 26.6639 20.4653 26.8002 19.7684L26.8006 19.7664L28.7629 20.1522L26.8006 19.7664L26.8006 19.7664L26.8006 19.7662L26.8008 19.7653L26.8015 19.7618L26.8043 19.7478L26.8148 19.6939L26.8532 19.498C26.8853 19.3339 26.9288 19.1109 26.9745 18.8751C27.0683 18.3914 27.1644 17.8896 27.1961 17.706C27.464 16.1514 27.5812 15.0795 27.5708 14.4458L27.5703 14.4119L27.5709 14.378C27.5799 13.8678 27.3386 13.2972 26.5588 12.6747C26.3898 12.5397 26.1269 12.3744 25.8587 12.2234C25.7481 12.1611 25.6493 12.1083 25.5746 12.0693L25.488 12.2622L25.0811 13.1683C24.743 13.9207 24.2891 14.9304 23.826 15.9591C22.9128 17.9872 21.9291 20.1665 21.7631 20.5063C21.4315 21.1849 20.8968 21.7237 20.3461 22.0918C19.7992 22.4573 19.0528 22.7761 18.2103 22.7761H18V33.9986Z",
        fill: outlineColor || _wcImport4.neutral[100]
      }, void 0)]
    }), void 0), jsx("defs", {
      children: jsx("clipPath", Object.assign({
        id: "clip0_1_7892"
      }, {
        children: jsx("rect", {
          width: "48",
          height: "48",
          fill: "white"
        }, void 0)
      }), void 0)
    }, void 0)]
  }), void 0);
};

var tooth_20 = function tooth_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.57733 1.58182C9.57733 1.58182 9.63182 1.52682 10.1102 1.33685C11.1135 0.938497 12.2129 0.744902 13.3634 0.872153C16.0745 1.17201 18.3333 3.45938 18.3333 6.31137C18.3333 8.63998 17.7715 11.705 16.9038 14.2968C15.8953 17.3095 14.7308 19.1683 13.2611 19.1667C11.9335 19.1652 10.8065 17.8695 9.57161 15.0199C8.29737 17.9476 7.21399 19.1721 5.87747 19.1506C4.54095 19.1291 3.26412 17.2693 2.26078 14.2727C1.39381 11.6835 0.833313 8.62789 0.833313 6.2993C0.833313 3.43347 3.09887 1.18574 5.80045 0.871157C7.73421 0.645985 9.57733 1.58182 9.57733 1.58182ZM12.1817 3.93969C12.4639 4.3612 12.3504 4.93126 11.928 5.21295C11.5056 5.49464 10.9344 5.38129 10.6521 4.95978C10.4362 4.63728 8.8003 2.43716 5.98204 2.64956C4.18104 2.78529 2.67303 4.41175 2.67303 6.29932C2.67303 8.41651 3.19815 11.2792 4.00566 13.6909C4.73726 15.8758 5.63204 17.3105 5.90726 17.3149C6.18335 17.3194 7.81244 14.8629 8.55648 12.4133C8.89411 11.3016 10.248 11.3519 10.5952 12.4375C11.4826 15.2127 12.9726 17.3305 13.2632 17.3308C13.2947 17.3308 14.2494 16.4889 15.1591 13.7151C15.9526 11.2954 16.4938 8.42871 16.4938 6.31139C16.4938 4.43506 14.9703 2.85192 13.1556 2.65121C12.5154 2.5804 11.888 2.67859 11.291 2.86477C11.6199 3.18963 11.919 3.54743 12.1817 3.93969ZM7.27201 4.46342C7.27201 3.95644 6.8602 3.54546 6.35219 3.54546C4.82819 3.54546 3.59273 4.77841 3.59273 6.29934C3.59273 6.80631 4.00455 7.2173 4.51255 7.2173C5.02056 7.2173 5.43237 6.80631 5.43237 6.29934C5.43237 5.79236 5.84419 5.38138 6.35219 5.38138C6.8602 5.38138 7.27201 4.97039 7.27201 4.46342Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

/* eslint-disable @typescript-eslint/naming-convention */
var trophy_icon_20 = function trophy_icon_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsxs("svg", Object.assign({
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("circle", {
      cx: "24",
      cy: "24",
      r: "24",
      fill: "#E3C5E7",
      fillOpacity: "0.7"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M30.9782 13.0001L23.9989 13.0002L17.0196 13.0001C17.1206 15.0629 17.4371 18.345 18.3883 21.2684C19.5731 24.9099 21.3643 27.0001 23.9989 27.0001C26.6334 27.0001 28.4247 24.9099 29.6095 21.2684C30.5606 18.345 30.8772 15.0629 30.9782 13.0001ZM33.0157 11.969C33.0272 11.4253 32.5884 11.0001 32.0446 11.0001L23.9989 11.0002L15.9531 11.0001C15.4093 11.0001 14.9706 11.4253 14.982 11.969C14.9881 12.2589 14.9989 12.6061 15.0172 13H12.9863C11.8573 13 10.9386 13.9396 11.0032 15.089C11.083 16.5082 11.3954 19.1593 12.6122 21.6131C13.7753 23.9586 15.7939 26.1653 19.1983 26.8756C19.721 27.4332 20.3081 27.9037 20.9678 28.2591V32H19.9678C18.3109 32 16.9678 33.3432 16.9678 35V36V36.0005C16.4304 36.0176 16 36.4585 16 37C16 37.5415 16.4304 37.9825 16.9678 37.9995V38H17H18.9678H28.9678H30.9678H31C31.5523 38 32 37.5523 32 37C32 36.4477 31.5523 36 31 36H30.9678V35C30.9678 33.3432 29.6246 32 27.9678 32H26.9678V28.2921C27.6528 27.9331 28.2606 27.4506 28.7996 26.8755C32.2036 26.1649 34.2219 23.9584 35.3849 21.6131C36.6017 19.1593 36.9141 16.5082 36.9939 15.089C37.0585 13.9396 36.1398 13 35.0108 13H32.9806C32.9989 12.6061 33.0096 12.2589 33.0157 11.969ZM28.9678 36V35C28.9678 34.4477 28.5201 34 27.9678 34H26.9678H25.9678H21.9678H20.9678H19.9678C19.4155 34 18.9678 34.4477 18.9678 35V36H28.9678ZM22.9678 32V28.9241C23.2977 28.9741 23.6412 29.0001 23.9989 29.0001C24.3341 29.0001 24.6569 28.9772 24.9678 28.9332V32H22.9678ZM17.3339 24.0422C15.9849 21.1958 15.4046 17.6684 15.1566 15H13.0014C13.077 16.3123 13.3682 18.6359 14.404 20.7246C15.053 22.0335 15.9808 23.2305 17.3339 24.0422ZM33.5931 20.7246C32.9442 22.0331 32.0167 23.2299 30.6642 24.0416C32.0129 21.1953 32.5932 17.6682 32.8411 15H34.9957C34.9201 16.3123 34.6288 18.6359 33.5931 20.7246Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)]
  }), void 0);
};

var trophy_20 = function trophy_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.49907 1.74998V2.66665H2.19291C1.41802 2.66665 0.79701 3.30612 0.835098 4.0404C0.834764 4.29797 0.85593 4.71372 0.918964 5.23709C1.02312 6.10191 1.21156 6.96781 1.50872 7.78629C2.40396 10.2521 4.10639 11.8127 6.72958 11.8219C6.90038 12.3673 7.04184 12.9739 7.13352 13.6689C5.66847 13.7274 4.49907 14.9352 4.49907 16.4166V18.2461C4.49907 18.7533 4.91026 19.1666 5.41748 19.1666H14.5744C15.0819 19.1666 15.4928 18.7545 15.4928 18.2461V16.4166C15.4928 14.9661 14.3668 13.7732 12.9408 13.6734C13.0295 12.9763 13.1669 12.3681 13.3327 11.8214C15.9213 11.7884 17.6043 10.233 18.4925 7.78629C18.7897 6.96781 18.9781 6.10191 19.0823 5.23709C19.1453 4.71372 19.1665 4.29797 19.165 4.08735C19.2042 3.30612 18.5832 2.66665 17.8083 2.66665H15.4928V1.74998C15.4928 1.24273 15.0816 0.833313 14.5744 0.833313H5.41748C4.90997 0.833313 4.49907 1.24372 4.49907 1.74998ZM14.3627 9.36021C14.9548 8.15733 15.4926 7.06481 15.4926 5.41668V4.50134L17.3125 4.50695C17.3125 4.50695 17.2846 4.83778 17.263 5.01778C17.1744 5.75337 17.0148 6.4864 16.7702 7.16037C16.2244 8.66373 15.3723 9.61568 14.0998 9.8994C14.1876 9.71588 14.2757 9.53686 14.3627 9.36021ZM6.34232 17.3333L13.6604 17.3419V16.4166C13.6604 15.9117 13.2496 15.5 12.7469 15.5H7.24479C6.74052 15.5 6.33125 15.9099 6.33125 16.4166L6.34232 17.3333ZM7.01453 7.96272C6.5205 6.95214 6.33125 6.29829 6.33125 5.4167V2.6667H13.6615C13.661 2.89587 13.6604 3.58337 13.6604 5.4167C13.6604 6.30778 13.4754 6.96793 12.9946 7.98338C12.9272 8.1256 12.7226 8.54323 12.6017 8.78985L12.6016 8.79002L12.6011 8.79104L12.5127 8.97183C11.7348 10.579 11.2729 11.9618 11.0899 13.6618C11.4427 13.6618 8.97697 13.6667 8.97697 13.6667C8.97697 13.6667 8.587 11.1021 7.51203 8.95098C7.50172 8.93035 7.46703 8.8618 7.42011 8.76908L7.42 8.76885L7.41989 8.76863C7.29507 8.52196 7.08395 8.10474 7.01453 7.96272ZM13.6627 2.6667C13.6627 2.6667 13.6621 2.43754 13.6615 2.6667H13.6627ZM2.68837 4.50692C2.68837 4.50692 2.71623 4.83775 2.7379 5.01775C2.8265 5.75334 2.98602 6.48638 3.23071 7.16034C3.78225 8.67948 4.64653 9.63557 5.94127 9.90808C5.84923 9.72152 5.75678 9.53962 5.66557 9.36018C5.05418 8.1573 4.49888 7.06478 4.49888 5.41665V4.50134L2.68837 4.50692ZM9.99582 7.70831C11.0078 7.70831 11.8281 6.8875 11.8281 5.87498C11.8281 4.86246 11.0078 4.04165 9.99582 4.04165C8.98387 4.04165 8.16353 4.86246 8.16353 5.87498C8.16353 6.8875 8.98387 7.70831 9.99582 7.70831Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var twitter_16 = function twitter_16(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsxs("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("title", {
      children: "Check out Fairygodboss on Twitter"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.7665 5.74296C12.7741 5.84139 12.7741 5.93985 12.7741 6.03828C12.7741 9.04061 10.2995 12.5 5.77666 12.5C4.38325 12.5 3.08884 12.1273 2 11.4805C2.19798 11.5016 2.38831 11.5086 2.59391 11.5086C3.74364 11.5086 4.80203 11.15 5.64722 10.5383C4.56599 10.5172 3.6599 9.86329 3.34771 8.96328C3.5 8.98436 3.65228 8.99843 3.81219 8.99843C4.033 8.99843 4.25383 8.97029 4.4594 8.9211C3.3325 8.71014 2.48729 7.79609 2.48729 6.69218V6.66407C2.81469 6.83282 3.19543 6.93829 3.59896 6.95233C2.93652 6.54451 2.50253 5.84843 2.50253 5.06092C2.50253 4.63905 2.62433 4.25234 2.83754 3.91483C4.04821 5.29296 5.86802 6.19294 7.90862 6.2914C7.87055 6.12265 7.8477 5.94688 7.8477 5.7711C7.8477 4.51952 8.94416 3.5 10.3071 3.5C11.0152 3.5 11.6548 3.77422 12.1041 4.21719C12.6599 4.11875 13.1929 3.9289 13.665 3.66875C13.4822 4.19611 13.0939 4.63908 12.5838 4.92031C13.0787 4.87111 13.5584 4.74452 14 4.56876C13.665 5.01874 13.2462 5.4195 12.7665 5.74296Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)]
  }), void 0);
};
var twitter_20 = function twitter_20(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsxs("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("title", {
      children: "Check out Fairygodboss on Twitter"
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.3554 6.99061C16.3655 7.12186 16.3655 7.25313 16.3655 7.38437C16.3655 11.3875 13.066 16 7.03555 16C5.17767 16 3.45179 15.5031 2 14.6406C2.26397 14.6687 2.51775 14.6781 2.79188 14.6781C4.32485 14.6781 5.73605 14.2 6.86296 13.3844C5.42133 13.3563 4.2132 12.4844 3.79694 11.2844C4 11.3125 4.20304 11.3312 4.41626 11.3312C4.71067 11.3312 5.00511 11.2937 5.2792 11.2281C3.77666 10.9469 2.64972 9.72812 2.64972 8.25624V8.21876C3.08625 8.44376 3.59391 8.58438 4.13195 8.60311C3.24869 8.05935 2.67003 7.13124 2.67003 6.08123C2.67003 5.51874 2.83244 5.00311 3.11672 4.55311C4.73095 6.39061 7.15736 7.59059 9.87816 7.72186C9.82741 7.49686 9.79694 7.26251 9.79694 7.02813C9.79694 5.35936 11.2589 4 13.0761 4C14.0203 4 14.8731 4.36562 15.4721 4.95625C16.2132 4.82501 16.9238 4.57187 17.5533 4.225C17.3096 4.92814 16.7919 5.51877 16.1117 5.89374C16.7716 5.82815 17.4112 5.65936 18 5.42501C17.5534 6.02499 16.995 6.55934 16.3554 6.99061Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)]
  }), void 0);
};

var wheelchair_20 = function wheelchair_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.6066 15.9848H17.5386C17.9775 15.9848 18.3333 16.3379 18.3333 16.7803C18.3333 17.2196 17.9806 17.5757 17.5386 17.5757H16.6066C16.279 18.5026 15.3951 19.1666 14.356 19.1666C13.0381 19.1666 11.9697 18.0982 11.9697 16.7803C11.9697 15.7412 12.6337 14.8573 13.5606 14.5297V13.5984H9.41863C9.52591 13.9777 9.58331 14.378 9.58331 14.7916C9.58331 17.2079 7.62456 19.1666 5.20831 19.1666C2.79207 19.1666 0.833313 17.2079 0.833313 14.7916C0.833313 12.647 2.3764 10.8628 4.41286 10.4888V4.05501C4.41286 3.61511 4.05546 3.25754 3.6174 3.25754H2.02649C1.58718 3.25754 1.23104 2.9014 1.23104 2.46208C1.23104 2.02276 1.58718 1.66663 2.02649 1.66663H3.6174C4.93427 1.66663 6.00377 2.73665 6.00377 4.05501V6.43935H11.9708C13.7271 6.43935 15.1515 7.86432 15.1515 9.62143V14.5297C15.8296 14.7693 16.367 15.3068 16.6066 15.9848ZM6.00382 8.03029V10.4888C7.03596 10.6784 7.94135 11.2302 8.58335 12.0076H13.5606V9.62147C13.5606 8.74284 12.8484 8.03029 11.9709 8.03029H6.00382ZM2.42421 14.7917C2.42421 16.3293 3.67069 17.5758 5.20831 17.5758C6.74592 17.5758 7.9924 16.3293 7.9924 14.7917C7.9924 13.5305 7.15378 12.4652 6.00376 12.1229V14.7917C6.00376 15.231 5.64762 15.5872 5.20831 15.5872C4.76899 15.5872 4.41285 15.231 4.41285 14.7917V12.1229C3.26283 12.4652 2.42421 13.5305 2.42421 14.7917ZM14.356 17.5758C14.7954 17.5758 15.1515 17.2197 15.1515 16.7804C15.1515 16.341 14.7954 15.9849 14.356 15.9849C13.9167 15.9849 13.5606 16.341 13.5606 16.7804C13.5606 17.2197 13.9167 17.5758 14.356 17.5758Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var whistle_20 = function whistle_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.75 6.33331H7.25C7.75626 6.33331 8.16667 6.74372 8.16667 7.24998V8.16665H10.9167V7.24998C10.9167 6.74372 11.3271 6.33331 11.8333 6.33331H12.75C16.2938 6.33331 19.1667 9.20615 19.1667 12.75C19.1667 16.2938 16.2938 19.1666 12.75 19.1666C9.43418 19.1666 6.70578 16.6516 6.36842 13.4251C6.15536 13.3439 1.46012 11.7863 1.46012 11.7863C1.08581 11.6615 0.833333 11.3112 0.833333 10.9166V7.24998C0.833333 6.74372 1.24374 6.33331 1.75 6.33331ZM6.33329 9.08332V8.16666H2.67121L2.66663 10.2621L7.53983 11.8804C7.91415 12.0051 8.16663 12.3554 8.16663 12.75C8.16663 15.2813 10.2187 17.3333 12.75 17.3333C15.2813 17.3333 17.3333 15.2813 17.3333 12.75C17.3333 10.2187 15.2813 8.16666 12.75 8.16666V9.08332C12.75 9.58958 12.3396 9.99999 11.8333 9.99999H7.24996C6.7437 9.99999 6.33329 9.58958 6.33329 9.08332ZM12.75 16.4167C12.2437 16.4167 11.8333 16.0063 11.8333 15.5C11.8333 14.9937 12.2437 14.5833 12.75 14.5833C13.7625 14.5833 14.5833 13.7625 14.5833 12.75C14.5833 12.2437 14.9937 11.8333 15.5 11.8333C16.0062 11.8333 16.4166 12.2437 16.4166 12.75C16.4166 14.7751 14.775 16.4167 12.75 16.4167ZM8.62498 1.74982C8.62498 1.24366 9.03186 0.833333 9.54165 0.833333C10.0479 0.833333 10.4583 1.24007 10.4583 1.74982V4.50018C10.4583 5.00634 10.0514 5.41667 9.54165 5.41667C9.03539 5.41667 8.62498 5.00993 8.62498 4.50018V1.74982ZM13.0277 5.04888C12.7243 5.45415 12.1498 5.53673 11.7445 5.23332C11.3392 4.92991 11.2567 4.35542 11.5601 3.95014L12.9329 2.11642C13.2363 1.71115 13.8108 1.62857 14.2161 1.93198C14.6213 2.23538 14.7039 2.80988 14.4005 3.21515L13.0277 5.04888ZM7.52503 3.94959C7.82874 4.35462 7.7466 4.92918 7.34156 5.2329C6.93652 5.53661 6.36196 5.45447 6.05825 5.04943L4.68325 3.21571C4.37953 2.81067 4.46167 2.23611 4.86671 1.9324C5.27175 1.62868 5.84631 1.71082 6.15003 2.11586L7.52503 3.94959Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var wide_logo_24 = function wide_logo_24(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "151",
    height: "24",
    "view-box": "0 0 151 24"
  }, {
    children: jsxs("g", Object.assign({
      fill: "none",
      fillRule: "evenodd"
    }, {
      children: [jsx("path", {
        fill: outlineColor || 'white',
        d: "M19.674.871V23.22h3.377v-9.576h4.63v-3.196h-4.63V4.042h5.382V.872zM36.019 15.293l-1.29-9.305-1.288 9.305h2.578zm3.412 0l1.098 7.926h-3.413l-.656-4.743h-3.449l-.668 4.743h-3.4l1.097-7.9L32.427.87h4.63l2.374 14.422zM41.933 23.219h3.377V.871h-3.377zM51.166 4.042v6.405h.775c.47 0 .792-.03.967-.09.612-.232.919-.709.919-1.43V5.575c0-1.023-.49-1.534-1.468-1.534h-1.193zM47.788.872h4.917c3 0 4.499 1.568 4.499 4.704v3.35c0 1.968-.887 3.265-2.661 3.892l3.794 10.401h-3.699l-3.043-9.833-.43.064v9.769h-3.377V.871zM61.138.871l2.303 8.713L65.744.87h3.58l-4.093 12.67-.096.283v9.395h-3.377v-9.395l-.107-.284L57.558.871zM80.131 18.927c0 3.128-1.619 4.696-4.857 4.704-3.23 0-4.845-1.567-4.845-4.704V5.253c0-3.127 1.615-4.69 4.845-4.69 3.238 0 4.857 1.563 4.857 4.69v3.003h-3.377V5.253c0-1.005-.49-1.508-1.468-1.508h-.024c-.97 0-1.455.503-1.455 1.508v13.674c0 1.006.489 1.508 1.467 1.508.987 0 1.48-.502 1.48-1.508v-5.245h-1.468v-3.183h4.845v8.428zM88.397 5.253c0-1.005-.49-1.508-1.468-1.508h-.024c-.97 0-1.456.503-1.456 1.508v13.674c0 1.006.49 1.508 1.468 1.508.986 0 1.48-.502 1.48-1.508V5.253zm3.377 13.674c0 3.128-1.62 4.696-4.857 4.704-3.23 0-4.845-1.567-4.845-4.704V5.253c0-3.127 1.615-4.69 4.845-4.69 3.238 0 4.857 1.563 4.857 4.69v13.674zM123.683 5.253c0-1.005-.49-1.508-1.468-1.508h-.024c-.97 0-1.456.503-1.456 1.508v13.674c0 1.006.49 1.508 1.468 1.508.987 0 1.48-.502 1.48-1.508V5.253zm3.377 13.674c0 3.128-1.619 4.696-4.857 4.704-3.23 0-4.845-1.567-4.845-4.704V5.253c0-3.127 1.615-4.69 4.845-4.69 3.238 0 4.857 1.563 4.857 4.69v13.674zM97.33 4.042v15.994h1.48c.979 0 1.468-.503 1.468-1.508V5.576c0-1.023-.49-1.534-1.468-1.534h-1.48zM93.955.872h5.202c3 0 4.5 1.568 4.5 4.704v12.952c0 3.119-1.572 4.683-4.714 4.691h-4.988V.871zM109.212 13.643v6.393h1.48c.978 0 1.468-.503 1.468-1.508V15.15c0-.713-.307-1.181-.92-1.405-.174-.068-.497-.103-.966-.103h-1.062zm0-9.601v6.405h1.062c.47 0 .792-.03.967-.09.612-.232.919-.709.919-1.43V5.575c0-1.023-.49-1.534-1.468-1.534h-1.48zm-3.377-3.17h5.203c2.999 0 4.499 1.568 4.499 4.704v3.35c0 1.47-.617 2.51-1.85 3.12 1.233.61 1.85 1.645 1.85 3.105v3.377c0 3.119-1.572 4.683-4.714 4.691h-4.988V.871zM140.644 5.253c0-3.127 1.615-4.69 4.845-4.69 3.237 0 4.857 1.563 4.857 4.69v3.003h-3.378V5.253c0-1.005-.489-1.508-1.467-1.508h-.024c-.971 0-1.456.503-1.456 1.508v2.024c0 .996 1.054 2.216 3.162 3.66 2.108 1.435 3.163 3.157 3.163 5.168v2.822c0 3.137-1.616 4.704-4.845 4.704-3.238-.008-4.857-1.576-4.857-4.704v-3.003h3.377v3.003c0 1.006.493 1.508 1.48 1.508.978 0 1.467-.502 1.467-1.508v-2.551c0-1.083-1.054-2.346-3.162-3.79-2.108-1.434-3.162-3.178-3.162-5.232v-2.1zM129.001 5.253c0-3.127 1.615-4.69 4.845-4.69 3.238 0 4.857 1.563 4.857 4.69v3.003h-3.377V5.253c0-1.005-.49-1.508-1.468-1.508h-.024c-.97 0-1.456.503-1.456 1.508v2.024c0 .996 1.054 2.216 3.163 3.66 2.108 1.435 3.162 3.157 3.162 5.168v2.822c0 3.137-1.615 4.704-4.845 4.704-3.238-.008-4.857-1.576-4.857-4.704v-3.003h3.377v3.003c0 1.006.493 1.508 1.48 1.508.978 0 1.468-.502 1.468-1.508v-2.551c0-1.083-1.055-2.346-3.163-3.79-2.108-1.434-3.162-3.178-3.162-5.232v-2.1z"
      }, void 0), jsx("path", {
        fill: outlineColor || 'white',
        d: "M8.98 4.11c-.012-.005-.118-.076-.132-.068-.02.011-.046.07-.058.091-.045.075-.074.146-.115.224a.754.754 0 0 1-.035.06c-.008.013-.019.039-.033.041-.012.003-.018-.012-.024-.023a.648.648 0 0 1-.106-.292 1.512 1.512 0 0 1-.003-.155c.003-.09.012-.18.025-.268.003-.016.023-.184.034-.184.106.002.176-.036.207-.121.039.21.068.433.241.486l-.002.21M5.367 13.85l-.814-.716c.025-.149.135-.33.345-.328-.14.235.035.28.093.295-.004.122.043.183.144.175.023.08.01.2.198.163-.007.193.127.173.249.14.063.113-.083.254-.215.27m10.584-2.363l-.057-.084-.097-.13c-.03-.042-.053-.09-.086-.13a3.211 3.211 0 0 0-.067-.077l-.024-.026a.813.813 0 0 0-.184-.137c-.203-.105-.464-.109-.655-.204-.259-.13-.537-.409-.723-.578-.216-.197-.469-.4-.655-.579-.126-.122-.24-.255-.367-.376-.08-.078-.168-.148-.248-.226-.078-.078-.145-.168-.224-.246a.765.765 0 0 0-.171-.128c-.046-.024-.055-.075-.081-.115a.796.796 0 0 0-.08-.102c-.053-.058-.135-.106-.175-.172-.119-.195-.203-.408-.333-.598a1.802 1.802 0 0 0-.055-.077c-.01-.011-.058-.057-.058-.07.01-.219-.154-.36-.206-.578-.02-.084.021-.198 0-.307-.022-.111-.123-.206-.138-.306-.025-.16.028-.312-.023-.47a1.092 1.092 0 0 0-.246-.399.462.462 0 0 0-.145-.118c-.3-.157-.352-.56-.55-.817.14-.343.232-.62.427-.828.178-.022.48.049.606-.125.056-.129-.035-.213-.035-.306.008-.146.088-.242 0-.34-.006-.008.052-.06.059-.065.044-.031.102-.05.131-.099.042-.07-.006-.117-.052-.166-.049-.052-.101-.095-.145-.15a.517.517 0 0 1-.059-.092c-.013-.027-.04-.078-.037-.109.014-.224.142-.232.138-.408a.57.57 0 0 0-.064-.227c-.072-.142-.204-.257-.331-.35a1.209 1.209 0 0 0-.468-.206c-.227-.045-.458-.097-.692-.086-.327.014-.605.184-.808.432a1.35 1.35 0 0 0-.29.811c-.006.256.1.457.069.647-.068.003-.178.115-.104.238-.696.085-.353 1.06-.034 1.361-.192.208-.362.437-.551.647C6.44 3.748 5.055 2.245 4.135.285c-.029.38.088.837.212 1.157-.218-.091-.359-.33-.419-.545-.163.87.577 1.574.366 1.706-.133-.041-.311-.264-.389-.362-.212 1.316.506 1.489.471 2.297-.038.142-.224.047-.314.073.258.527.665.942 1.244 1.153-.22.224-.43.34-.994.319.51.641 1.506.82 2.166 1.314-.597.093-1.166.34-1.89.193.288.539 1.08.601 1.77.607.01.056-.477.454-1.011.442.335.243.66.335 1.073.38-.116.527-.402 1.11-.562 1.679-.082.29-.082.596-.138.868-.075.36-.31.544-.448.8-.135-.055-.316-.008-.422.062-.136.09-.259.188-.28.36l-.223-.17-.311-.32-.093.01-.411-.317v.002l-.332-.257-.525-.03-.171.262c-.718 1.055-1.422 2.076-2.125 3.154l.327.26-.04.048.096.077.04-.049.043.034c1.181.943 2.416 1.855 3.6 2.795l.013.012-.043.049.094.08.041-.048.304.268c.057-.04.133-.089.172-.114.073-.006.125-.005.28-.009.014 0 .109-.157.121-.175l.124-.177.24-.35c.157-.226.313-.454.471-.68.157-.222.312-.447.468-.67.159-.229.324-.454.476-.687.095-.144.214-.274.3-.423.04-.07.09-.162.054-.238-.04-.084-.127-.13-.199-.191l-.397-.305-.417-.43-.125.013-.507-.39c.259-.073.425-.49.299-.742.086-.247.092-.413.109-.608.031-.37-.022-.74.099-.89.155.018.4.022.607.035.202-.919.507-1.587.81-2.365.168-.081.336-.145.413-.175.037.89-.293 1.567-.396 2.234-.088.57-.085 1.292-.172 1.837.086.063.217.075.314.094.03.641-.202 1.337-.314 1.948.174.014.183-.137.31-.17.177 1.12-.87 1.857-.965 3.267-.055.81.016 1.582-.069 2.314-.05.427-.244.683-.379.919-.206.361-.073.434-.207 1.395.211.03.396.086.62.102.023-.216.01-.485.035-.68.524.061.793.666 1.378.748.161.023.403.012.586 0 .188-.012.39 0 .565-.086.266-.13-.214-.298-.312-.33a4.64 4.64 0 0 0-.24-.071c-.065-.018-.16-.024-.22-.057-.178-.1-.236-.3-.379-.51-.118-.175-.287-.321-.344-.443-.405-.863.014-1.936.31-2.723.215-.572.25-1.222.448-1.701.125-.305.363-.565.482-.85.155-.373.15-.72.276-1.056.176-.034.254-.042.413-.068.318.438.787 1.015.827 1.702.03.527-.144 1.045-.103 1.531.075.894.56 1.732.792 2.518.096.326.023.65.034.987.018.49.29.62.483.885.118.163.178.252.295.428.163-.1.328-.238.448-.34-.125-.162-.213-.27-.347-.488.423-.196.844.062 1.223-.008.267-.137.567-.333.758-.477.107-.08.236-.18.345-.272.066-.056.13-.121.198-.178.103-.086.048-.125-.01-.163-.065-.043-.166-.01-.235.004-.177.035-.343.109-.518.15a.896.896 0 0 1-.331.017c-.149-.022-.582-.15-.861-.238-.799-.255-.76-1.962-.69-2.995.03-.434-.149-1.045-.137-1.566.006-.291.057-.537.034-.714-.052-.396-.33-.786-.379-1.055-.01-.056.04-.113.035-.17-.023-.22-.15-.476-.207-.715-.068-.285-.144-.563-.172-.783.069.014.163.07.31.034-.13-.646-.453-1.497-.517-2.314-.029-.361-.006-.778-.069-1.123-.055-.303-.202-.525-.035-.748.704.7 1.413 1.395 2.171 2.041.11-.09.26-.265.482-.306.222.11.413.262.594.427.153.14.303.283.489.38.132.068.236.168.346.267.033.03.164.126.187.033.013-.052-.031-.102-.065-.136-.027-.027-.11-.08-.08-.126.025-.04.048 0 .048 0s.127.134.207.207c.033.03.074.02.105-.006.014-.012.024-.037.038-.046.015-.01.034-.003.053-.005.036-.003.074.004.1-.026.023-.026.036-.08.083-.073.02.003.057.031.092-.011.06-.074-.038-.192-.08-.25l.018.017"
      }, void 0)]
    }), void 0)
  }), void 0);
};
var wide_logo_32 = function wide_logo_32(_ref2) {
  var outlineColor = _ref2.outlineColor;
  return jsxs("svg", Object.assign({
    width: "204",
    height: "33",
    viewBox: "0 0 204 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.0825 0.631348V31.4923H30.6556V18.2687H36.9255V13.8549H30.6556V5.00951H37.9435V0.631348H26.0825Z",
      fill: outlineColor || 'white'
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M48.2154 20.5468L46.4701 7.69697L44.7249 20.5468H48.2154ZM52.837 20.5468L54.3236 31.4923H49.702L48.8133 24.9429H44.1432L43.2382 31.4923H38.6328L40.1195 20.5824L43.3514 0.631348H49.6212L52.837 20.5468Z",
      fill: outlineColor || 'white'
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M56.2251 31.4923H60.7982V0.631348H56.2251V31.4923Z",
      fill: outlineColor || 'white'
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M68.7264 5.00955V13.8549H69.7768C70.4123 13.8549 70.8486 13.8136 71.0857 13.7303C71.9151 13.41 72.33 12.7515 72.33 11.7548V7.12748C72.33 5.71565 71.6674 5.00955 70.3423 5.00955H68.7264ZM64.1533 0.631348H70.811C74.8723 0.631348 76.9031 2.79683 76.9031 7.1275V11.7549C76.9031 14.4721 75.7017 16.2637 73.2995 17.1297L78.4382 31.4923H73.4288L69.3082 17.9128L68.7264 18.0018V31.4923H64.1533V0.631348Z",
      fill: outlineColor || 'white'
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M82.2301 0.631348L85.3489 12.6625L88.4676 0.631348H93.3155L87.7728 18.1263L87.6435 18.5179V31.4923H83.0704V18.5179L82.925 18.1263L77.3823 0.631348H82.2301Z",
      fill: outlineColor || 'white'
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M107.95 25.4744C107.95 29.8127 105.709 31.9875 101.229 31.9995C96.7603 31.9995 94.5259 29.8247 94.5259 25.4744V6.50682C94.5259 2.16882 96.7603 -0.000488281 101.229 -0.000488281C105.709 -0.000488281 107.95 2.16882 107.95 6.50682V10.6722H103.277V6.50682C103.277 5.11241 102.6 4.41517 101.246 4.41517H101.213C99.8699 4.41517 99.1986 5.11241 99.1986 6.50682V25.4744C99.1986 26.8688 99.8756 27.566 101.229 27.566C102.594 27.566 103.277 26.8688 103.277 25.4744V18.1984H101.246V13.7827H107.95V25.4744Z",
      fill: outlineColor || 'white'
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M119.33 6.67073C119.33 5.28529 118.653 4.59254 117.299 4.59254H117.266C115.923 4.59254 115.252 5.28529 115.252 6.67073V25.5164C115.252 26.9018 115.929 27.5946 117.283 27.5946C118.647 27.5946 119.33 26.9018 119.33 25.5164V6.67073ZM124.003 25.5164C124.003 29.8268 121.763 31.9876 117.283 31.9996C112.814 31.9996 110.579 29.8387 110.579 25.5164V6.67074C110.579 2.36062 112.814 0.205322 117.283 0.205322C121.763 0.205322 124.003 2.36062 124.003 6.67074V25.5164Z",
      fill: outlineColor || 'white'
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M166.926 6.84536C166.926 5.46608 166.264 4.7764 164.939 4.7764H164.906C163.592 4.7764 162.935 5.46608 162.935 6.84536V25.6072C162.935 26.9864 163.597 27.6761 164.922 27.6761C166.258 27.6761 166.926 26.9864 166.926 25.6072V6.84536ZM171.712 25.5164C171.712 29.8268 169.472 31.9876 164.992 31.9996C160.523 31.9996 158.289 29.8387 158.289 25.5164V6.67074C158.289 2.36062 160.523 0.205322 164.992 0.205322C169.472 0.205322 171.712 2.36062 171.712 6.67074V25.5164Z",
      fill: outlineColor || 'white'
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M131.242 5.00955V27.0963H133.245C134.57 27.0963 135.233 26.4022 135.233 25.014V7.12748C135.233 5.71565 134.57 5.00955 133.245 5.00955H131.242ZM126.668 0.631348H133.714C137.775 0.631348 139.806 2.79683 139.806 7.1275V25.014C139.806 29.321 137.678 31.4807 133.423 31.4923H126.668V0.631348Z",
      fill: outlineColor || 'white'
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M147.33 18.2687V27.0963H149.334C150.659 27.0963 151.322 26.4022 151.322 25.014V20.351C151.322 19.3664 150.907 18.7198 150.078 18.4111C149.84 18.3163 149.404 18.2687 148.769 18.2687H147.33ZM147.33 5.00955V13.8549H148.769C149.404 13.8549 149.84 13.8135 150.078 13.7303C150.907 13.41 151.322 12.7515 151.322 11.7548V7.12748C151.322 5.71565 150.659 5.00955 149.334 5.00955H147.33ZM142.757 0.631348H149.803C153.864 0.631348 155.895 2.79683 155.895 7.1275V11.7549C155.895 13.7837 155.06 15.2196 153.39 16.0618C155.06 16.9045 155.895 18.3341 155.895 20.3511V25.014C155.895 29.321 153.767 31.4807 149.512 31.4923H142.757V0.631348Z",
      fill: outlineColor || 'white'
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M189.894 6.68264C189.894 2.36394 192.081 0.204346 196.455 0.204346C200.839 0.204346 203.032 2.36394 203.032 6.68264V10.8295H198.459V6.68264C198.459 5.29444 197.796 4.6003 196.471 4.6003H196.439C195.124 4.6003 194.467 5.29444 194.467 6.68264V9.47685C194.467 10.8534 195.894 12.538 198.749 14.5314C201.604 16.513 203.032 18.8918 203.032 21.6682V25.5658C203.032 29.8968 200.845 32.062 196.471 32.062C192.086 32.05 189.894 29.8848 189.894 25.5658V21.419H194.467V25.5658C194.467 26.954 195.135 27.6482 196.471 27.6482C197.796 27.6482 198.459 26.954 198.459 25.5658V22.042C198.459 20.5469 197.031 18.8028 194.176 16.8094C191.321 14.8281 189.894 12.4196 189.894 9.58362V6.68264Z",
      fill: outlineColor || 'white'
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M174.128 6.68264C174.128 2.36394 176.315 0.204346 180.689 0.204346C185.073 0.204346 187.266 2.36394 187.266 6.68264V10.8295H182.692V6.68264C182.692 5.29444 182.03 4.6003 180.705 4.6003H180.673C179.358 4.6003 178.701 5.29444 178.701 6.68264V9.47685C178.701 10.8534 180.128 12.538 182.983 14.5314C185.838 16.513 187.266 18.8918 187.266 21.6682V25.5658C187.266 29.8968 185.078 32.062 180.705 32.062C176.32 32.05 174.128 29.8848 174.128 25.5658V21.419H178.701V25.5658C178.701 26.954 179.369 27.6482 180.705 27.6482C182.03 27.6482 182.692 26.954 182.692 25.5658V22.042C182.692 20.5469 181.265 18.8028 178.41 16.8094C175.555 14.8281 174.128 12.4196 174.128 9.58362V6.68264Z",
      fill: outlineColor || 'white'
    }, void 0), jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.2241 4.77984C12.2097 4.77428 12.0669 4.69552 12.0485 4.70421C12.0222 4.71673 11.9875 4.78206 11.9708 4.80512C11.9105 4.88824 11.8723 4.96711 11.818 5.05282C11.8032 5.07618 11.7876 5.09897 11.7705 5.12078C11.7597 5.13443 11.7453 5.16264 11.7263 5.1655C11.7102 5.16798 11.7027 5.15185 11.6943 5.14011C11.6225 5.03879 11.5636 4.94172 11.5528 4.81625C11.548 4.75904 11.5465 4.7015 11.5487 4.64422C11.5525 4.54425 11.5651 4.4453 11.5829 4.34687C11.586 4.32912 11.6131 4.14351 11.6283 4.14366C11.7687 4.14584 11.8628 4.10289 11.9046 4.00913C11.9565 4.24258 11.9954 4.48878 12.227 4.54726C12.227 4.6071 12.2241 4.72008 12.2241 4.77984ZM7.31143 18.6451L6.12833 17.7323C6.14723 17.5235 6.27925 17.2593 6.56712 17.2421C6.3993 17.5819 6.64256 17.6272 6.7236 17.6416C6.73045 17.8129 6.80008 17.8916 6.9373 17.8712C6.97714 17.9808 6.97025 18.1482 7.22403 18.077C7.23325 18.347 7.41495 18.3044 7.57753 18.247C7.67521 18.397 7.49023 18.6084 7.31143 18.6451ZM21.3361 15.6141C21.3177 15.5865 21.277 15.5247 21.2571 15.4965C21.2138 15.4352 21.1681 15.3755 21.1245 15.3142C21.0834 15.2564 21.0512 15.1888 21.0064 15.1343C20.9764 15.0979 20.9457 15.0623 20.9146 15.0269C20.9037 15.0146 20.8932 15.0015 20.8813 14.9901C20.8055 14.9166 20.7231 14.8493 20.6295 14.7998C20.3514 14.653 19.9945 14.6482 19.7326 14.5152C19.3775 14.335 18.9964 13.9456 18.7412 13.7088C18.4457 13.4346 18.0993 13.1528 17.8443 12.9024C17.6716 12.7327 17.5152 12.5471 17.3419 12.3782C17.2311 12.2702 17.111 12.1725 17.0021 12.0627C16.8943 11.9538 16.8033 11.8296 16.6951 11.721C16.6246 11.6502 16.547 11.5908 16.4598 11.5424C16.3977 11.5078 16.385 11.4376 16.3492 11.382C16.3165 11.3312 16.2798 11.2836 16.2393 11.2389C16.1675 11.1593 16.0554 11.0916 16.0004 10.9997C15.8374 10.7275 15.7225 10.4305 15.5439 10.166C15.5195 10.1299 15.4941 10.0942 15.4678 10.0594C15.4554 10.0427 15.3888 9.97961 15.3895 9.96131C15.4022 9.65632 15.1774 9.45827 15.1063 9.15484C15.0791 9.03859 15.1354 8.87961 15.1063 8.72795C15.0765 8.57283 14.9384 8.44031 14.9175 8.30103C14.8839 8.07812 14.9561 7.86555 14.8855 7.64478C14.8189 7.43667 14.6953 7.25016 14.549 7.08995C14.479 7.01333 14.4411 6.97307 14.3509 6.92533C13.9387 6.70703 13.868 6.14559 13.5956 5.78682C13.7884 5.30853 13.9142 4.92115 14.1818 4.63256C14.4257 4.60093 14.8387 4.69979 15.0119 4.45858C15.0886 4.27875 14.9647 4.16135 14.9647 4.03165C14.9754 3.82748 15.0844 3.69432 14.9647 3.55726C14.9555 3.54672 15.0359 3.47392 15.0451 3.46727C15.1057 3.42339 15.1847 3.39757 15.225 3.32902C15.2826 3.23107 15.2157 3.16591 15.1529 3.0974C15.0863 3.02483 15.0148 2.96547 14.9543 2.88757C14.9233 2.84767 14.8958 2.80494 14.8738 2.75943C14.8556 2.72207 14.8203 2.65157 14.8231 2.60857C14.8427 2.2963 15.0176 2.28464 15.0119 2.03933C15.0095 1.93538 14.97 1.81495 14.9242 1.72297C14.8256 1.52544 14.6449 1.36539 14.4707 1.23573C14.2844 1.097 14.0579 0.994319 13.8299 0.94797C13.5183 0.884713 13.2016 0.81326 12.8817 0.827543C12.4332 0.847435 12.0523 1.08483 11.7749 1.43095C11.5244 1.74358 11.3853 2.15932 11.3769 2.5611C11.3694 2.91809 11.5152 3.1971 11.4714 3.46242C11.3789 3.46644 11.2274 3.62251 11.3297 3.79446C10.3755 3.91282 10.8449 5.27249 11.2825 5.69197C11.0198 5.9814 10.7867 6.30055 10.5272 6.59325C8.30363 4.82718 6.40691 2.73258 5.1456 -0.000488281C5.10625 0.52928 5.266 1.1673 5.43672 1.61237C5.1376 1.48605 4.94495 1.15389 4.86232 0.853403C4.63808 2.06698 5.65305 3.04735 5.36391 3.23115C5.18096 3.17382 4.93711 2.86355 4.83089 2.72716C4.53977 4.56138 5.52441 4.80196 5.47603 5.92917C5.42334 6.12662 5.16916 5.99437 5.04528 6.02994C5.39907 6.76547 5.95636 7.34402 6.75061 7.63687C6.44793 7.94945 6.16053 8.11126 5.38755 8.08162C6.08666 8.97609 7.45209 9.2247 8.35565 9.91384C7.53785 10.0431 6.75849 10.3882 5.76715 10.1826C6.16057 10.9337 7.24633 11.0207 8.19047 11.0286C8.20619 11.1076 7.53741 11.6611 6.80572 11.6453C7.26597 11.9833 7.71051 12.1117 8.27698 12.175C8.11767 12.9091 7.72591 13.7211 7.50593 14.5152C7.39381 14.9199 7.39456 15.3454 7.31708 15.7249C7.21482 16.2261 6.89179 16.4837 6.70341 16.8396C6.51915 16.7634 6.27012 16.8288 6.1251 16.9266C5.93937 17.0518 5.77111 17.1885 5.74154 17.4297L5.43636 17.1911L5.00984 16.7448L4.88315 16.7585L4.31944 16.3178L4.31992 16.3202L3.86509 15.9621L3.1452 15.9206L2.91062 16.2861C1.92712 17.7566 0.963026 19.1789 0 20.682L0.447187 21.044L0.392788 21.1119L0.524708 21.2186L0.578948 21.1507L0.637306 21.1979C2.25605 22.5124 3.94764 23.7833 5.57042 25.0936L5.58863 25.11L5.52992 25.1782L5.65792 25.2894L5.71469 25.2234L6.131 25.5977C6.20919 25.5413 6.31249 25.4731 6.36704 25.4376C6.46586 25.4302 6.5382 25.4316 6.75061 25.4257C6.76898 25.4252 6.89915 25.2066 6.91602 25.1818C6.97236 25.0995 7.02905 25.0173 7.08539 24.935C7.19613 24.7733 7.30465 24.6101 7.41491 24.4482C7.63005 24.1321 7.84298 23.8143 8.06057 23.5C8.27579 23.1893 8.48713 22.8757 8.70097 22.564C8.91884 22.2464 9.14499 21.9318 9.35391 21.6082C9.48365 21.4073 9.64634 21.2252 9.76432 21.0173C9.81927 20.9207 9.88903 20.7916 9.83907 20.6862C9.78368 20.5694 9.6638 20.5055 9.56616 20.4197C9.56616 20.4197 9.02217 19.9944 9.02245 19.9942L8.45008 19.3953L8.27952 19.4138L7.58472 18.8706C7.93879 18.7681 8.16684 18.1876 7.99374 17.8358C8.11173 17.4919 8.12055 17.2601 8.14324 16.9879C8.18616 16.4722 8.11371 15.9561 8.27892 15.7486C8.49137 15.7723 8.82774 15.7782 9.11094 15.796C9.38832 14.5152 9.80573 13.5847 10.2203 12.4992C10.4505 12.3865 10.6806 12.2976 10.7869 12.256C10.8367 13.4957 10.3849 14.4404 10.2439 15.3691C10.1232 16.1645 10.1274 17.1702 10.0079 17.9307C10.1256 18.018 10.3059 18.0344 10.4387 18.0612C10.4798 18.9555 10.1623 19.9248 10.0079 20.7769C10.2474 20.7962 10.2589 20.5863 10.4327 20.5397C10.6753 22.1013 9.24215 23.1281 9.11094 25.0936C9.03564 26.2222 9.13347 27.2992 9.01655 28.3193C8.94834 28.9144 8.68173 29.2708 8.49727 29.6002C8.21522 30.1037 8.39698 30.205 8.21407 31.5451C8.50317 31.5866 8.75648 31.6641 9.06379 31.6874C9.09471 31.3864 9.07558 31.0114 9.11094 30.7386C9.82822 30.8249 10.1972 31.6672 10.9993 31.7823C11.2195 31.8139 11.5517 31.7982 11.8018 31.7823C12.0589 31.7659 12.3375 31.7808 12.5756 31.6624C12.9409 31.4808 12.2824 31.2466 12.1492 31.2019C12.0408 31.1655 11.931 31.1334 11.8208 31.103C11.7308 31.0782 11.5992 31.0693 11.5185 31.0232C11.275 30.8844 11.1956 30.6055 10.9993 30.3117C10.8367 30.0685 10.6055 29.865 10.5272 29.695C9.97309 28.4927 10.5472 26.9959 10.952 25.9001C11.2468 25.1022 11.2962 24.1963 11.5657 23.5283C11.7372 23.1031 12.0638 22.7415 12.2266 22.3423C12.4386 21.8229 12.4334 21.341 12.6043 20.8718C12.8462 20.8243 12.9525 20.8125 13.1708 20.7769C13.6061 21.387 14.2489 22.1915 14.3038 23.1488C14.3459 23.8839 14.1061 24.6066 14.1621 25.2834C14.2654 26.5297 14.9308 27.6974 15.2479 28.7937C15.3792 29.2475 15.2789 29.7 15.2951 30.1694C15.3187 30.8513 15.6925 31.0337 15.956 31.4028C16.1184 31.6301 16.2001 31.754 16.3611 31.9995C16.5841 31.8599 16.8096 31.6675 16.9747 31.5252C16.8036 31.2999 16.6818 31.1478 16.4989 30.8454C17.0787 30.5715 17.6551 30.9312 18.1747 30.8335C18.5406 30.6437 18.9517 30.3705 19.2133 30.1694C19.3601 30.0565 19.5366 29.9187 19.6854 29.7899C19.7759 29.7115 19.8631 29.6208 19.9569 29.5417C20.0984 29.4223 20.0231 29.3671 19.9434 29.314C19.8546 29.255 19.716 29.302 19.6218 29.3206C19.3785 29.3689 19.1521 29.4721 18.911 29.5287C18.7631 29.5633 18.6089 29.5753 18.458 29.5527C18.2542 29.5222 17.6602 29.3447 17.2778 29.2207C16.1843 28.8659 16.2359 26.4859 16.3336 25.0462C16.3747 24.442 16.1293 23.5897 16.1449 22.8641C16.1535 22.4579 16.224 22.1153 16.1921 21.8679C16.1207 21.316 15.7399 20.7729 15.6728 20.3974C15.6588 20.3194 15.7278 20.2397 15.72 20.1602C15.6897 19.8552 15.5148 19.4969 15.4367 19.164C15.3435 18.7665 15.2401 18.3788 15.2007 18.073C15.2953 18.0924 15.4249 18.1708 15.6255 18.1204C15.448 17.2188 15.0055 16.0326 14.9175 14.8947C14.8784 14.3908 14.9091 13.8095 14.8231 13.3293C14.7474 12.9071 14.5469 12.5977 14.7758 12.2857C15.7402 13.2616 16.7109 14.231 17.7499 15.1319C17.8994 15.0054 18.1052 14.7616 18.4108 14.705C18.7142 14.8591 18.9761 15.0695 19.2244 15.3006C19.4334 15.4951 19.6396 15.6948 19.894 15.829C20.0755 15.9248 20.2173 16.0641 20.3677 16.2016C20.414 16.2439 20.5932 16.3779 20.6244 16.2485C20.6421 16.1753 20.5814 16.1063 20.5351 16.0579C20.4989 16.02 20.3848 15.9458 20.425 15.883C20.4604 15.8276 20.4918 15.883 20.4918 15.883C20.4918 15.883 20.665 16.0688 20.7751 16.1716C20.8206 16.214 20.8765 16.2 20.9195 16.1624C20.9385 16.1458 20.9519 16.1116 20.971 16.0984C20.9919 16.084 21.0177 16.0939 21.0431 16.092C21.0925 16.0882 21.1452 16.0972 21.181 16.0555C21.2121 16.0192 21.23 15.9448 21.2943 15.9542C21.3219 15.9581 21.3731 15.9976 21.4203 15.9383C21.5018 15.8359 21.3679 15.6706 21.3116 15.5909C21.3105 15.5895 21.337 15.6157 21.3361 15.6141Z",
      fill: outlineColor || 'white'
    }, void 0)]
  }), void 0);
};

var woman_20 = function woman_20(_ref) {
  var outlineColor = _ref.outlineColor;
  return jsx("svg", Object.assign({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.1046 15.065C14.3562 15.9496 13.8201 16.6667 12.9053 16.6667H12.3087L12.2287 17.5106C12.142 18.4252 11.3267 19.1667 10.4146 19.1667H8.75221C7.83697 19.1667 7.02431 18.4206 6.93804 17.5106L6.85804 16.6667H6.26145C5.34753 16.6667 4.81008 15.9514 5.06216 15.065L6.26557 10.8333V8.33159C6.26557 7.41208 7.00745 6.66667 7.92291 6.66667H11.2439C12.1592 6.66667 12.9012 7.41522 12.9012 8.33159V10.8333L14.1046 15.065ZM7.09503 3.33333C7.09503 1.95262 8.20911 0.833333 9.5834 0.833333C10.9577 0.833333 12.0718 1.95262 12.0718 3.33333C12.0718 4.71405 10.9577 5.83333 9.5834 5.83333C8.20911 5.83333 7.09503 4.71405 7.09503 3.33333ZM11.2423 11.0668V8.3316C11.2423 8.33417 7.92289 8.33334 7.92289 8.33334C7.92365 8.33334 7.92446 11.0668 7.92446 11.0668L6.79555 15H7.95371C8.18166 15 8.38394 15.1846 8.4058 15.4152L8.58945 17.3526C8.59482 17.4092 8.69415 17.5 8.75219 17.5H10.4146C10.4732 17.5 10.5718 17.41 10.5773 17.3526L10.7609 15.4152C10.7827 15.1859 10.9871 15 11.2139 15H12.3745L11.2423 11.0668ZM10.4129 3.33333C10.4129 2.8731 10.0415 2.5 9.58342 2.5C9.12533 2.5 8.75397 2.8731 8.75397 3.33333C8.75397 3.79357 9.12533 4.16667 9.58342 4.16667C10.0415 4.16667 10.4129 3.79357 10.4129 3.33333Z",
      fill: outlineColor || _wcImport4.neutral[100]
    }, void 0)
  }), void 0);
};

var size16 = {
  arrow_right_16: arrow_right_16,
  check_16: check_16,
  chevron_up_16: chevron_up_16,
  chevron_down_16: chevron_down_16,
  chevron_left_16: chevron_left_16,
  chevron_right_16: chevron_right_16,
  close_16: close_16,
  facebook_16: facebook_16,
  filter_16: filter_16,
  fire_16: fire_16,
  heart_16: heart_16,
  heartFilled_16: heartFilled_16,
  heartOutline_16: heartOutline_16,
  info_16: info_16,
  instagram_16: instagram_16,
  light_wing_16: light_wing_16,
  dark_wing_16: dark_wing_16,
  location_16: location_16,
  magnifyingGlass_16: magnifyingGlass_16,
  minus_16: minus_16,
  pinterest_16: pinterest_16,
  ratingWing_16: ratingWing_16,
  ratingWingFilled_16: ratingWingFilled_16,
  ratingWingOutline_16: ratingWingOutline_16,
  settings_16: settings_16,
  settings_slider_16: settings_slider_16,
  thumbsUp_16: thumbsUp_16,
  thumbsUpFilled_16: thumbsUpFilled_16,
  thumbsUpOutline_16: thumbsUpOutline_16,
  twitter_16: twitter_16
};
var size20 = {
  alarmClock_20: alarmClock_20,
  arrow_right_20: arrow_right_20,
  baby_20: baby_20,
  badge_20: badge_20,
  barbell_20: barbell_20,
  bottle_20: bottle_20,
  calendar_20: calendar_20,
  cashbag_20: cashbag_20,
  chat_20: chat_20,
  check_20: check_20,
  checklist_20: checklist_20,
  chevron_up_20: chevron_up_20,
  chevron_down_20: chevron_down_20,
  chevron_left_20: chevron_left_20,
  chevron_right_20: chevron_right_20,
  clock_20: clock_20,
  close_20: close_20,
  diversity_20: diversity_20,
  facebook_20: facebook_20,
  filter_20: filter_20,
  fire_20: fire_20,
  giving_hand_20: giving_hand_20,
  heart_20: heart_20,
  heartFilled_20: heartFilled_20,
  heartOutline_20: heartOutline_20,
  house_20: house_20,
  instagram_20: instagram_20,
  location_20: location_20,
  minus_20: minus_20,
  magnifyingGlass_20: magnifyingGlass_20,
  magnifyingGlass_20_light: magnifyingGlass_20_light,
  medical_20: medical_20,
  megaphone_20: megaphone_20,
  money_20: money_20,
  palmTree_20: palmTree_20,
  pills_20: pills_20,
  piggyBank_20: piggyBank_20,
  pinterest_20: pinterest_20,
  ratingWing_20: ratingWing_20,
  ratingWingFilled_20: ratingWingFilled_20,
  ratingWingOutline_20: ratingWingOutline_20,
  ribbon_20: ribbon_20,
  scales_20: scales_20,
  settings_20: settings_20,
  stock_20: stock_20,
  stroller_20: stroller_20,
  support_20: support_20,
  thumbsUp_20: thumbsUp_20,
  thumbsUpConviser_20: thumbsUpConviser_20,
  thumbsUpFilled_20: thumbsUpFilled_20,
  thumbsUpOutline_20: thumbsUpOutline_20,
  tooth_20: tooth_20,
  trophy_20: trophy_20,
  trophy_icon_20: trophy_icon_20,
  twitter_20: twitter_20,
  wheelchair_20: wheelchair_20,
  whistle_20: whistle_20,
  woman_20: woman_20
};
var size24 = {
  camera_24: camera_24,
  calendar_24: calendar_24,
  clock_24: clock_24,
  people_24: people_24,
  wide_logo_24: wide_logo_24,
  magnifyingGlass_24: magnifyingGlass_24,
  home_icon_24: home_icon_24,
  job_icon_24: job_icon_24,
  review_icon_24: review_icon_24,
  network_icon_24: network_icon_24,
  advice_icon_24: advice_icon_24,
  resources_icon_24: resources_icon_24,
  notification_icon_24: notification_icon_24,
  employer_icon_24: employer_icon_24
};
var size32 = {
  wide_logo_32: wide_logo_32,
  menu_32: menu_32
};
// Icons Listed Alphabetically
var IconPaths = Object.assign(Object.assign(Object.assign(Object.assign({}, size16), size20), size24), size32);

var Icon = function Icon(_ref) {
  var variant = _ref.variant,
    outlineColor = _ref.outlineColor,
    fillColor = _ref.fillColor,
    percentageFilledProp = _ref.percentageFilledProp;
  return IconPaths[variant] && jsx(Fragment, {
    children: IconPaths[variant]({
      outlineColor: outlineColor,
      fillColor: fillColor,
      percentageFilledProp: percentageFilledProp
    })
  }, void 0);
};
Icon.displayName = 'Icon';
var Icon$1 = Icon;

var _excluded$k = ["id", "children", "color", "size", "checked", "disabled", "hasError", "label", "caption", "onClick", "indeterminateState"];
var CheckboxWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Checkbox__CheckboxWrapper",
  componentId: "sc-1cxbhdh-0"
})(["display:flex;align-items:flex-start;"]);
var Checkbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var id = _ref.id;
    _ref.children;
    var color = _ref.color,
    size = _ref.size,
    checked = _ref.checked,
    disabled = _ref.disabled,
    hasError = _ref.hasError,
    label = _ref.label,
    caption = _ref.caption,
    onClick = _ref.onClick,
    indeterminateState = _ref.indeterminateState,
    others = _objectWithoutProperties(_ref, _excluded$k);
  var iconPath = '';
  switch (true) {
    case indeterminateState && size !== 'small':
      iconPath = 'minus_20';
      break;
    case indeterminateState:
      iconPath = 'minus_16';
      break;
    case size !== 'small':
      iconPath = 'check_20';
      break;
    default:
      iconPath = 'check_16';
  }
  var textStyleVariant;
  switch (true) {
    case disabled:
      textStyleVariant = 'disabled';
      break;
    case hasError:
      textStyleVariant = 'error';
      break;
    default:
      textStyleVariant = 'default';
  }
  var randomId = Math.round(Math.random() * 100000);
  return /*#__PURE__*/jsxs(CheckboxWrapper, {
    children: [/*#__PURE__*/jsxs(_StyledCheckBoxContainer, Object.assign({
      ref: ref,
      checkboxContainerVariant: "".concat(size, "ContainerVariant"),
      checked: checked
    }, others, {
      children: [/*#__PURE__*/jsx(HiddenInput$2, {
        className: "styled-checkbox-input",
        id: id || randomId,
        color: hasError ? 'error' : color,
        checked: checked // if error uncheck
        ,
        disabled: disabled,
        onChange: onClick,
        type: "checkbox",
        "data-qa": "checkbox"
      }), /*#__PURE__*/jsx(StyledCheckbox, Object.assign({
        size: size
      }, others, {
        htmlFor: id || randomId
      })), checked ? /*#__PURE__*/jsx(Icon$1, {
        className: "styled-check",
        variant: iconPath,
        fillColor: _wcImport4.neutral[0],
        outlineColor: _wcImport4.neutral[0]
      }) : null]
    })), label || caption ? /*#__PURE__*/jsxs(TextWrapper$1, {
      textStyleVariant: textStyleVariant,
      children: [label ? /*#__PURE__*/jsx(CheckboxLabel, {
        htmlFor: id || randomId,
        size: size,
        children: label
      }) : null, caption ? /*#__PURE__*/jsx(CheckboxCaption, {
        hasLabel: !!(label != null && label.length) > 0,
        size: size,
        children: caption
      }) : null]
    }) : null]
  });
});
Checkbox.displayName = 'Checkbox';

// define available checkbox variants
var sizeVariants$3 = ['small', 'medium', 'large'];
var colorVariants$3 = ['purple', 'blue'];
Checkbox.propTypes = {
  color: PropTypes.oneOf(colorVariants$3),
  size: PropTypes.oneOf(sizeVariants$3),
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  label: PropTypes.string,
  caption: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  indeterminateState: PropTypes.bool
};
Checkbox.defaultProps = {
  color: 'purple',
  size: 'small',
  checked: false,
  disabled: false,
  hasError: false,
  label: null,
  caption: null,
  indeterminateState: false
};
var _StyledCheckBoxContainer = /*#__PURE__*/styled(CheckBoxContainer).withConfig({
  displayName: "Checkbox___StyledCheckBoxContainer",
  componentId: "sc-1cxbhdh-1"
})({
  'svg': {
    position: 'absolute',
    top: '2px',
    zIndex: '3',
    left: '2px',
    pointerEvents: 'none'
  },
  '@media screen and (max-width: 601px)': {
    'svg': {
      top: '0px',
      left: '0px'
    }
  }
});

var DefaultContainer = /*#__PURE__*/styled('div').withConfig({
  displayName: "DefaultContainer",
  componentId: "sc-gsyfsf-0"
})(["width:'inherit';height:'inherit';"]);
var DefaultContainer$1 = DefaultContainer;

var _excluded$j = ["label", "labelIndicator", "inverted", "limitWidth", "action"];
var Container = /*#__PURE__*/styled('div').withConfig({
  displayName: "FilterInner__Container",
  componentId: "sc-bn0qvu-0"
})(["", ";"], function (props) {
  return css({
    display: 'flex',
    'align-items': 'center',
    'justify-content': props.inverted ? 'flex-end' : 'space-between',
    flexDirection: props.inverted ? 'row-reverse' : 'row',
    marginLeft: '8px'
  });
});
var getStyledLabelCss = function getStyledLabelCss(props) {
  if (props != null && props.limitWidth) {
    return Object.assign({
      maxWidth: '140',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }, (props == null ? void 0 : props.limitWidth) && {
      maxWidth: "".concat(props.maxSize, "px")
    });
  }
  return {
    display: 'flex',
    alignItems: 'center'
  };
};
var StyledLabel$1 = /*#__PURE__*/styled('div').withConfig({
  displayName: "FilterInner__StyledLabel",
  componentId: "sc-bn0qvu-1"
})(["", ";"], function (props) {
  return css(Object.assign({}, getStyledLabelCss(props)));
});
var Action = /*#__PURE__*/styled('div').withConfig({
  displayName: "FilterInner__Action",
  componentId: "sc-bn0qvu-2"
})(["", ";"], function (props) {
  return css(Object.assign({}, props.inverted && {
    marginRight: '12px'
  }, !props.inverted && {
    marginLeft: props.limitWidth ? '8px' : '16px'
  }));
});
var FilterInner = function FilterInner(_ref) {
  var label = _ref.label,
    labelIndicator = _ref.labelIndicator,
    inverted = _ref.inverted,
    limitWidth = _ref.limitWidth,
    action = _ref.action,
    props = _objectWithoutProperties(_ref, _excluded$j);
  var _useViewport = useViewport(),
    isXS = _useViewport.isXS;
  var maxSize = !isXS ? 80 : 126;
  return /*#__PURE__*/jsxs(Container, Object.assign({
    inverted: inverted,
    "data-qa": "filter-dropdown-item"
  }, props, {
    children: [/*#__PURE__*/jsxs(StyledLabel$1, {
      limitWidth: limitWidth,
      maxSize: maxSize,
      "data-qa": "filter-item-label",
      children: [label, labelIndicator ? labelIndicator : null]
    }), /*#__PURE__*/jsx(Action, {
      limitWidth: limitWidth,
      inverted: inverted,
      children: action
    })]
  }));
};
FilterInner.displayName = 'FilterInner';
FilterInner.propTypes = {
  action: PropTypes.any,
  inverted: PropTypes.bool,
  label: PropTypes.any,
  labelIndicator: PropTypes.any,
  limitWidth: PropTypes.bool
};
FilterInner.defaultProps = {
  action: null,
  inverted: false,
  labelIndicator: null,
  limitWidth: false
};
var FilterInner$1 = FilterInner;

var _excluded$i = ["label", "checked", "onPress", "inverted"];
var CheckboxSelect = function CheckboxSelect(_ref) {
  var label = _ref.label,
    checked = _ref.checked,
    onPress = _ref.onPress,
    inverted = _ref.inverted,
    props = _objectWithoutProperties(_ref, _excluded$i);
  var action = useMemo(function () {
    return /*#__PURE__*/jsx(_StyledCheckbox, {
      onClick: function onClick() {
        return null;
      },
      checked: checked,
      color: "blue",
      size: "medium",
      $_css: css({
        div: {
          // hack, this looks odd in storybook but works in front-end
          height: '20px',
          width: '20px',
          borderRadius: '3px',
          borderColor: "".concat(checked ? _wcImport4.secondary[60] : _wcImport4.neutral[50], " !important"),
          background: "".concat(checked ? _wcImport4.secondary[60] : _wcImport4.neutral[0], " !important")
        }
      })
    });
  }, [checked]);
  return /*#__PURE__*/jsx(DefaultContainer$1, {
    onClick: onPress,
    children: /*#__PURE__*/jsx(FilterInner$1, Object.assign({
      label: label,
      action: action,
      inverted: inverted
    }, props))
  });
};
CheckboxSelect.displayName = 'CheckboxSelect';
CheckboxSelect.propTypes = {
  label: PropTypes.any,
  checked: PropTypes.bool.isRequired,
  onPress: PropTypes.func.isRequired,
  inverted: PropTypes.bool
};
CheckboxSelect.defaultProps = {
  inverted: true
};
var CheckboxSelect$1 = CheckboxSelect;
var _StyledCheckbox = /*#__PURE__*/styled(Checkbox).withConfig({
  displayName: "CheckboxSelect___StyledCheckbox",
  componentId: "sc-vv9s1y-0"
})(["", ""], function (p) {
  return p.$_css;
});

var CheckboxFilter = function CheckboxFilter(_ref) {
  var label = _ref.label,
    checked = _ref.checked,
    onClick = _ref.onClick,
    inverted = _ref.inverted;
  var handleChecked = function handleChecked() {
    onClick();
  };
  return /*#__PURE__*/jsx(_StyledFilterTriggerContainer, {
    "data-qa": "checkbox-button",
    _onPress: handleChecked,
    active: checked,
    children: /*#__PURE__*/jsx(CheckboxSelect$1, {
      label: label,
      checked: checked,
      inverted: inverted,
      onPress: function onPress() {
        return null;
      }
    })
  });
};
CheckboxFilter.displayName = 'CheckboxFilter';
CheckboxFilter.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onClick: PropTypes.func,
  inverted: PropTypes.bool
};
CheckboxFilter.defaultProps = {
  inverted: true,
  checked: false
};
var CheckboxFilter$1 = CheckboxFilter;
var _StyledFilterTriggerContainer = /*#__PURE__*/styled(FilterTriggerContainer$1).withConfig({
  displayName: "CheckboxFilter___StyledFilterTriggerContainer",
  componentId: "sc-10qskxp-0"
})({
  paddingLeft: '8px'
});

var _excluded$h = ["label", "labelIndicator", "open", "onPress", "inverted", "action", "limitWidth"];
var PopupSelect = function PopupSelect(_ref) {
  var label = _ref.label,
    labelIndicator = _ref.labelIndicator,
    open = _ref.open,
    onPress = _ref.onPress,
    inverted = _ref.inverted,
    action = _ref.action,
    limitWidth = _ref.limitWidth,
    props = _objectWithoutProperties(_ref, _excluded$h);
  var _useState = useState('chevron_down_16'),
    _useState2 = _slicedToArray(_useState, 2),
    iconVariant = _useState2[0],
    setIconVariant = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    popupAction = _useState4[0],
    setPopupAction = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  useEffect(function () {
    setPopupAction(action);
  }, [action]);
  useEffect(function () {
    setIsOpen(open);
  }, [open]);
  var _useViewport = useViewport(),
    isXS = _useViewport.isXS;
  useEffect(function () {
    setIconVariant(!isXS ? 'chevron_right_16' : isOpen ? 'chevron_up_16' : 'chevron_down_16');
  }, [isOpen, isXS]);
  var handlePress = useCallback(function () {
    onPress(!isOpen);
    setIsOpen(!isOpen);
  }, [onPress, setIsOpen, isOpen]);
  var actionIcon = popupAction ? popupAction : /*#__PURE__*/jsx(Icon$1, {
    fillColor: "none",
    outlineColor: "#374660",
    variant: iconVariant
  });
  return /*#__PURE__*/jsx(DefaultContainer$1, {
    onClick: function onClick(e) {
      e.persist();
      handlePress();
    },
    children: /*#__PURE__*/jsx(FilterInner$1, Object.assign({
      label: label,
      labelIndicator: labelIndicator,
      action: actionIcon,
      inverted: inverted,
      limitWidth: limitWidth
    }, props))
  });
};
PopupSelect.displayName = 'PopupSelect';
PopupSelect.propTypes = {
  label: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onPress: PropTypes.func.isRequired,
  inverted: PropTypes.bool,
  labelIndicator: PropTypes.any,
  action: PropTypes.any,
  limitWidth: PropTypes.bool
};
PopupSelect.defaultProps = {
  inverted: false,
  labelIndicator: null,
  action: null,
  limitWidth: false
};
var PopupSelect$1 = PopupSelect;

var uncurryThis$d = functionUncurryThis;
var PROPER_FUNCTION_NAME$2 = functionName.PROPER;
var redefine$7 = redefine$a.exports;
var anObject$a = anObject$j;
var isPrototypeOf$4 = objectIsPrototypeOf;
var $toString$2 = toString$e;
var fails$9 = fails$n;
var regExpFlags$1 = regexpFlags$1;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var n$ToString = RegExpPrototype$1[TO_STRING];
var getFlags$1 = uncurryThis$d(regExpFlags$1);

var NOT_GENERIC = fails$9(function () { return n$ToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$2 && n$ToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine$7(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject$a(this);
    var p = $toString$2(R.source);
    var rf = R.flags;
    var f = $toString$2(rf === undefined && isPrototypeOf$4(RegExpPrototype$1, R) && !('flags' in RegExpPrototype$1) ? getFlags$1(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

var GREY_CHIP_VARIANT = 'grey';
var PURPLE_CHIP_VARIANT = 'purple';
var GREEN_CHIP_VARIANT = 'green';
var YELLOW_CHIP_VARIANT = 'yellow';
var RED_CHIP_VARIANT = 'red';

var getSafeValue = function getSafeValue(value) {
  if (value && value < 0) return 0;
  return value;
};
var formatValue = function formatValue(value) {
  var safeValue = getSafeValue(value);
  if (safeValue) return safeValue.toString();
  return '';
};
var styleProps$c = compose(shadow, position, grid, typography$1, space$1, layout, flexbox, border, position, background, display, margin, textAlign);
var getColor = function getColor() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : GREY_CHIP_VARIANT;
  var isSelected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var inverted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var info = _wcImport4.info,
    neutral = _wcImport4.neutral,
    success = _wcImport4.success,
    secondary = _wcImport4.secondary,
    warning = _wcImport4.warning,
    alert = _wcImport4.alert;
  var darkColor,
    lightColor = undefined;
  if (color === GREY_CHIP_VARIANT) {
    darkColor = secondary[70];
    lightColor = secondary[20];
  }
  if (color === PURPLE_CHIP_VARIANT) {
    darkColor = info.text;
    lightColor = info.light;
  }
  if (color === GREEN_CHIP_VARIANT) {
    darkColor = success.text;
    lightColor = success.light;
  }
  if (color === YELLOW_CHIP_VARIANT) {
    darkColor = warning.text;
    lightColor = warning.light;
  }
  if (color === RED_CHIP_VARIANT) {
    darkColor = alert.text;
    lightColor = alert.light;
  }
  if (inverted) {
    return {
      color: neutral[0],
      backgroundColor: darkColor,
      borderColor: darkColor
    };
  }
  if (isSelected && !inverted) {
    return {
      color: darkColor,
      backgroundColor: lightColor,
      borderColor: darkColor
    };
  }
  return {
    color: darkColor,
    backgroundColor: lightColor,
    borderColor: lightColor
  };
};
var getPadding = function getPadding(spacing) {
  if (spacing === 'none') return undefined;
  if (spacing === 'compact') return '0 4px';
  return '0 8px';
};
var variantToColorMap = {
  primary: GREY_CHIP_VARIANT,
  info: PURPLE_CHIP_VARIANT,
  success: GREEN_CHIP_VARIANT,
  warning: YELLOW_CHIP_VARIANT,
  error: RED_CHIP_VARIANT
};
var getSize = function getSize(fontSize, height, spacing) {
  return {
    fontSize: "".concat(fontSize / baseFontSize(), "rem"),
    fontStyle: 'inherit',
    lineHeight: height / fontSize,
    letterSpacing: '-0.025em',
    borderRadius: height + 2,
    padding: getPadding(spacing),
    minWidth: height
  };
};
var StyledChip = /*#__PURE__*/styled('span').withConfig({
  displayName: "basic-chip__StyledChip",
  componentId: "sc-2jfw15-0"
})({
  fontWeight: 600,
  borderStyle: 'solid',
  borderWidth: '1px',
  cursor: 'default',
  pointerEvents: 'none',
  display: 'inline-flex',
  position: 'relative',
  overflow: 'hidden',
  justifyContent: 'center'
}, function (_ref) {
  var color = _ref.color,
    isSelected = _ref.isSelected,
    inverted = _ref.inverted;
  return styledCss(getColor(color, isSelected, inverted));
}, function (_ref2) {
  var _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'small' : _ref2$size,
    spacing = _ref2.spacing;
  switch (size) {
    case 'small':
      return styledCss(getSize(12, 14, spacing));
    case 'medium':
      return styledCss(getSize(14, 18, spacing));
    case 'large':
      return styledCss(getSize(14, 18, spacing));
    default:
      return;
  }
}, function (_ref3) {
  var _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'small' : _ref3$size;
  switch (size) {
    case 'small':
      return styledCss({
        px: '8x',
        py: '3px'
      });
    case 'medium':
      return styledCss({
        px: '12px',
        py: '3px'
      });
    case 'large':
      return styledCss({
        px: '16px',
        py: '7px'
      });
    default:
      return;
  }
}, styleProps$c);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var BasicChip = /*#__PURE__*/forwardRef(function (props, ref) {
  var id = props.id,
    _props$inverted = props.inverted,
    inverted = _props$inverted === void 0 ? false : _props$inverted,
    _props$isSelected = props.isSelected,
    isSelected = _props$isSelected === void 0 ? false : _props$isSelected,
    _props$size = props.size,
    size = _props$size === void 0 ? 'small' : _props$size,
    text = props.text,
    testId = props.testId,
    variant = props.variant;
  var isNumber = typeof text === 'number';
  var getSpacing = function getSpacing(value) {
    if (isNumber && formatValue(value).length === 1) return 'none';
    if (isNumber && formatValue(value).length > 1) return 'compact';
    return undefined;
  };
  var color = variantToColorMap[variant];
  return jsx(StyledChip, Object.assign({
    ref: ref,
    id: id,
    "data-testid": testId,
    isSelected: isSelected,
    inverted: inverted,
    color: color || GREY_CHIP_VARIANT,
    size: size,
    spacing: isNumber ? getSpacing(text) : undefined
  }, props, {
    children: isNumber ? formatValue(text) : text
  }), void 0);
});
BasicChip.displayName = 'BasicChip';
var BasicChip$1 = BasicChip;

var wellKnownSymbol$e = wellKnownSymbol$l;
var create$2 = objectCreate;
var definePropertyModule$2 = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$e('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  definePropertyModule$2.f(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$2(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var $$a = _export;
var $includes = arrayIncludes.includes;
var addToUnscopables$1 = addToUnscopables$2;

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$a({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('includes');

var global$n = global$Q;
var isRegExp$1 = isRegexp;

var TypeError$9 = global$n.TypeError;

var notARegexp = function (it) {
  if (isRegExp$1(it)) {
    throw TypeError$9("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$d = wellKnownSymbol$l;

var MATCH$1 = wellKnownSymbol$d('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$9 = _export;
var uncurryThis$c = functionUncurryThis;
var notARegExp$1 = notARegexp;
var requireObjectCoercible$5 = requireObjectCoercible$b;
var toString$8 = toString$e;
var correctIsRegExpLogic$1 = correctIsRegexpLogic;

var stringIndexOf$2 = uncurryThis$c(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$9({ target: 'String', proto: true, forced: !correctIsRegExpLogic$1('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$2(
      toString$8(requireObjectCoercible$5(this)),
      toString$8(notARegExp$1(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

var headingVariant = variant({
  prop: 'variant',
  scale: 'typography.headingVariants',
  variants: {
    "default": {}
  }
});
var styleProps$b = compose(headingVariant, background, border, color$1, position, grid, space$1, layout, flexbox, shadow, typography$1, display, textAlign);
var variantMap$1 = {
  heading2xl: 'h1',
  headingXl: 'h2',
  headingLg: 'h3',
  headingMd: 'h4',
  headingSm: 'h5',
  headingXs: 'h6'
};
var headingResetStyles = {
  margin: 0
};
var Markup$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "heading__Markup",
  componentId: "sc-3mcy9a-0"
})(headingResetStyles, styleProps$b);
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 */
var Heading = function Heading(_a) {
  var children = _a.children,
    variant = _a.variant,
    id = _a.id,
    testId = _a.testId,
    as = _a.as,
    rest = __rest(_a, ["children", "variant", "id", "testId", "as"]);
  if (process.env.NODE_ENV !== 'production' && as && typeof as !== 'string') {
    throw new Error('`as` prop should be a string.');
  }
  var renderAs = as || variantMap$1[variant];
  return jsx(Markup$1, Object.assign({
    id: id,
    "data-testid": testId,
    variant: variant,
    as: renderAs
  }, rest, {
    children: children
  }), void 0);
};
var Heading$1 = Heading;

var textVariant = variant({
  prop: 'variant',
  scale: 'typography.textVariants',
  variants: {
    "default": {}
  }
});
var styleProps$a = compose(background, border, color$1, position, grid, space$1, layout, flexbox, shadow, typography$1, display, textAlign, textVariant);
var variantMap = {
  bodyLg: 'p',
  bodyMd: 'p',
  bodySm: 'p',
  labelLg: 'span',
  labelMd: 'span',
  labelSm: 'span',
  labelXs: 'span'
};
var Markup = /*#__PURE__*/styled.div.withConfig({
  displayName: "text__Markup",
  componentId: "sc-rds2vf-0"
})(styleProps$a);
/**
 * __Text__
 *
 * Text is a typography component used to display text in different sizes and formats.
 *
 */
var Text = function Text(_a) {
  var children = _a.children,
    _a$variant = _a.variant,
    variant = _a$variant === void 0 ? 'bodyMd' : _a$variant,
    id = _a.id,
    testId = _a.testId,
    as = _a.as,
    rest = __rest(_a, ["children", "variant", "id", "testId", "as"]);
  if (process.env.NODE_ENV !== 'production' && as && typeof as !== 'string') {
    throw new Error('`as` prop should be a string.');
  }
  var renderAs = as || variantMap[variant];
  return jsx(Markup, Object.assign({
    id: id,
    "data-testid": testId,
    variant: variant,
    as: renderAs
  }, rest, {
    children: children
  }), void 0);
};
var Text$1 = Text;

var _excluded$g = ["children"];
var variants$2 = variant({
  prop: 'variant',
  scale: 'view.viewVariants',
  variants: {
    "default": {}
  }
});
var styleProps$9 = compose(variants$2, shadow, position, grid, typography$1, space$1, layout, flexbox, border, fontSize, fontWeight, position, color$1, background, display);
var Styled$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "View__Styled",
  componentId: "sc-tbps05-0"
})(["", ""], styleProps$9);
var View = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    others = _objectWithoutProperties(_ref, _excluded$g);
  return /*#__PURE__*/jsx(Styled$1, Object.assign({
    ref: ref
  }, others, {
    children: children
  }));
});
View.displayName = 'View';

// define available view variants
var viewVariants = ['default'];
View.propTypes = {
  variant: PropTypes.oneOf(viewVariants)
};
View.defaultProps = {
  variant: 'default'
};

var _excluded$f = ["label", "isSelected"];
var matchingQueryPrefix = function matchingQueryPrefix(query, text) {
  var maxCommonString = '';
  for (var i = 1; i < query.length; i += 1) {
    var subQuery = query.slice(0, i);
    if (text.includes(subQuery) && subQuery.length > maxCommonString.length) {
      maxCommonString = subQuery;
    } else {
      break;
    }
  }
  return maxCommonString;
};
var renderHighlightedSuggestion = function renderHighlightedSuggestion(_ref) {
  var suggestion = _ref.suggestion,
    value = _ref.value;
  var normalizedSuggestion = suggestion.toLowerCase();
  var normalizedValue = value.toLowerCase();
  var suggestionAsHtml = '';

  // Try to match full query
  var matchIndex = normalizedSuggestion.indexOf(normalizedValue);
  var matchingPrefix = normalizedValue;
  if (matchIndex === -1) {
    // Try to match prefix
    matchingPrefix = matchingQueryPrefix(normalizedValue, normalizedSuggestion);
    matchIndex = normalizedSuggestion.indexOf(matchingPrefix);
  }
  if (matchIndex !== -1) {
    var boldText = suggestion.slice(matchIndex, matchIndex + matchingPrefix.length);
    var startText = suggestion.slice(0, matchIndex);
    var endText = suggestion.slice(matchIndex + matchingPrefix.length);
    suggestionAsHtml += "".concat(startText, "<strong>").concat(boldText, "</strong>").concat(endText);
  } else {
    suggestionAsHtml += "".concat(suggestion);
  }
  return suggestionAsHtml;
};
var customStyles$1 = {
  container: function container(base) {
    return Object.assign({}, base, {
      margin: '16px'
    });
  },
  control: function control(base) {
    return Object.assign({}, base, {
      minWidth: '270px',
      marginTop: '4px',
      height: '40px',
      border: '1px solid #868686',
      color: _wcImport4.neutral_70
    });
  },
  menu: function menu(base) {
    return Object.assign({}, base, {
      border: 'none',
      borderTopRightRadius: '0px',
      borderTopLeftRadius: '0px',
      borderTop: '1px solid #C3C3C3',
      borderBottomRightRadius: '6px',
      borderBottomLeftRadius: '6px',
      width: '302px',
      marginLeft: '-16px',
      marginTop: '16px',
      boxShadow: '0 4px 8px rgb(53 53 53 / 20%)'
    });
  },
  menuList: function menuList(base) {
    return Object.assign({}, base, {
      border: 'none',
      borderTopRightRadius: '0px',
      borderTopLeftRadius: '0px',
      borderBottomRightRadius: '6px',
      borderBottomLeftRadius: '6px',
      boxShadow: 'none',
      marginBottom: '4px',
      maxHeight: '408px'
    });
  },
  indicatorsContainer: function indicatorsContainer(base) {
    return Object.assign({}, base, {
      position: 'absolute',
      left: '16px',
      top: '50%',
      marginTop: -10,
      opacity: '0.9'
    });
  },
  input: function input(base) {
    return Object.assign({}, base, {
      font: 'Open Sans',
      fontSize: '16px',
      color: _wcImport4.neutral[80],
      paddingInlineStart: '35px'
    });
  },
  placeholder: function placeholder(base) {
    return Object.assign({}, base, {
      font: 'Open Sans',
      fontSize: '16px',
      color: _wcImport4.neutral[70],
      marginLeft: '40px'
    });
  },
  option: function option(base) {
    return Object.assign({}, base, {
      backgroundColor: _wcImport4.neutral[0],
      color: _wcImport4.neutral[100],
      '&:hover': {
        background: _wcImport4.secondary[10],
        color: _wcImport4.neutral[80]
      }
    });
  },
  singleValue: function singleValue(base) {
    return Object.assign({}, base, {
      color: _wcImport4.neutral[80]
    });
  }
};
var customStylesMobile = {
  container: function container(base) {
    return Object.assign({}, base, {
      borderBottom: "solid 1px ".concat(_wcImport4.neutral[30])
    });
  },
  control: function control(base) {
    return Object.assign({}, base, customStyles$1.control(), {
      margin: '5px 16px 16px 16px'
    });
  },
  menu: function menu(base, _ref2) {
    var selectProps = _ref2.selectProps;
    var _toolbarHeight = (selectProps == null ? void 0 : selectProps.toolbarHeight) || 0;
    return Object.assign({}, base, {
      margin: '16px 0px 0px 0px',
      boxShadow: 'none',
      borderRadius: 'unset',
      borderTop: "solid 1px ".concat(_wcImport4.neutral[30]),
      position: 'initial',
      height: "calc(100vh - 184px + env(safe-area-inset-bottom) - ".concat(_toolbarHeight >= 0 ? _toolbarHeight : 0, "px)")
    });
  },
  menuList: function menuList(base, _ref3) {
    var selectProps = _ref3.selectProps;
    var _toolbarHeight = (selectProps == null ? void 0 : selectProps.toolbarHeight) || 0;
    return Object.assign({}, base, {
      height: '100%',
      maxHeight: "calc(100vh - 184px + env(safe-area-inset-bottom) - ".concat(_toolbarHeight >= 0 ? _toolbarHeight : 0, "px)")
    });
  },
  input: function input(base) {
    return Object.assign({}, base, customStyles$1.input());
  },
  placeholder: function placeholder(base) {
    return Object.assign({}, base, customStyles$1.placeholder());
  },
  indicatorsContainer: function indicatorsContainer(base) {
    return Object.assign({}, base, customStyles$1.indicatorsContainer());
  },
  option: function option(base) {
    return Object.assign({}, base, customStyles$1.option(), {
      backgroundColor: _wcImport4.neutral[0],
      color: _wcImport4.neutral[80],
      '&:hover': {
        background: _wcImport4.secondary[10],
        color: _wcImport4.neutral[80]
      }
    });
  },
  singleValue: function singleValue(base) {
    return Object.assign({}, base, {
      color: _wcImport4.neutral[80]
    });
  }
};
var NoOptionsMessage = function NoOptionsMessage() {
  return /*#__PURE__*/jsxs(_StyledDefaultContainer$1, {
    children: [/*#__PURE__*/jsx(_StyledText$1, {
      $_css: fontWeights.semiBold,
      $_css2: _wcImport4.neutral[100],
      children: "No results found"
    }), /*#__PURE__*/jsx(_StyledText2, {
      $_css3: _wcImport4.neutral[100],
      children: "Try adjusting your search to find what you're looking for"
    })]
  });
};
var PopupOption = function PopupOption(_ref4) {
  var _props$data;
  var label = _ref4.label,
    isSelected = _ref4.isSelected,
    props = _objectWithoutProperties(_ref4, _excluded$f);
  var inputValue = props.selectProps.inputValue;
  var _label = label;
  if (inputValue) {
    _label = renderHighlightedSuggestion({
      suggestion: _label,
      value: inputValue
    });
  }
  return /*#__PURE__*/jsx(View, {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "18px",
    color: _wcImport4.neutral_100,
    children: /*#__PURE__*/jsx(components.Option, Object.assign({}, props, {
      children: /*#__PURE__*/jsx(CheckboxSelect$1, {
        label: props != null && (_props$data = props.data) != null && _props$data.count ? /*#__PURE__*/jsx("div", {
          dangerouslySetInnerHTML: {
            __html: "".concat(_label, "  (").concat(props.data.count, ")")
          }
        }) : label,
        checked: isSelected,
        onPress: function onPress() {
          return null;
        }
      })
    }))
  });
};
var MagnifierSvg = function MagnifierSvg() {
  return /*#__PURE__*/jsx(Icon$1, {
    variant: 'magnifyingGlass_20',
    outlineColor: _wcImport4.neutral[70]
  });
};
var _StyledDefaultContainer$1 = styled(DefaultContainer$1)({
  margin: '15px 30px'
});
var _StyledText$1 = styled(Text$1)(function (p) {
  return {
    fontWeight: p.$_css,
    margin: '0px',
    paddingBottom: '0px',
    color: p.$_css2
  };
});
var _StyledText2 = /*#__PURE__*/styled(Text$1).withConfig({
  displayName: "styles___StyledText2",
  componentId: "sc-1v367be-0"
})(function (p) {
  return {
    margin: '0px',
    color: p.$_css3
  };
});

var Popup = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var options = _ref.options,
    selectionChange = _ref.selectionChange,
    isMobile = _ref.isMobile,
    maxMenuHeightMobile = _ref.maxMenuHeightMobile,
    isMulti = _ref.isMulti,
    menuListHeader = _ref.menuListHeader,
    onClear = _ref.onClear,
    placeholder = _ref.placeholder,
    inverted = _ref.inverted,
    menuIsOpen = _ref.menuIsOpen,
    selection = _ref.defaultValue,
    placement = _ref.placement;
  var _useState = useState(selection),
    _useState2 = _slicedToArray(_useState, 2),
    defaultSelection = _useState2[0],
    setDefaultSelection = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    key = _useState4[0],
    setKey = _useState4[1];
  useEffect(function () {
    setDefaultSelection(selection);

    //Force element reRender since we dont have a way of doing it from the ouside on clear
    if (!selection.length) {
      setKey(function (previousKey) {
        return previousKey + 1;
      });
    }
  }, [selection]);
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    toolbarHeight = _useState6[0],
    setToolbarHeight = _useState6[1];
  var bodyRef = useRef();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  var bodyHeightListener = useCallback(function () {
    var rootElement = bodyRef.current;
    if (!rootElement) {
      return;
    }
    var viewPortH = rootElement == null ? void 0 : rootElement.getBoundingClientRect().height;
    var windowH = window.innerHeight;
    var browserUiBarsH = viewPortH - windowH + 127;
    if (browserUiBarsH > -1) {
      setToolbarHeight(browserUiBarsH);
    }
  }, [bodyRef]);
  useEffect(function () {
    window.addEventListener('resize', bodyHeightListener, true);
    bodyHeightListener();
    return function () {
      window.removeEventListener('resize', bodyHeightListener);
    };
  }, [bodyHeightListener]);
  return /*#__PURE__*/jsx("div", {
    ref: bodyRef,
    children: /*#__PURE__*/jsx(Select, {
      defaultValue: defaultSelection || [],
      closeMenuOnSelect: false,
      controlShouldRenderValue: false,
      hideSelectedOptions: false,
      isClearable: false,
      onChange: function onChange(e) {
        selectionChange(e);
      },
      options: options,
      menuIsOpen: menuIsOpen,
      maxMenuHeight: isMobile ? maxMenuHeightMobile : 494,
      menuPlacement: placement,
      styles: isMobile ? customStylesMobile : customStyles$1,
      inverted: inverted,
      onBlur: function onBlur() {
        return null;
      },
      components: {
        Option: PopupOption,
        DropdownIndicator: MagnifierSvg,
        IndicatorSeparator: null,
        NoOptionsMessage: NoOptionsMessage
      },
      toolbarHeight: toolbarHeight,
      theme: function theme(_theme) {
        return Object.assign({}, _theme, {
          colors: Object.assign({}, _theme.colors, {
            primary: '#9DA9BF'
          })
        });
      },
      ref: ref,
      isMulti: isMulti,
      menuListHeader: menuListHeader,
      onClear: onClear,
      placeholder: placeholder
    })
  }, key);
});
Popup.displayName = 'Popup';
var Popup$1 = Popup;

var useMountTransition = function useMountTransition(isMounted, unmountDelay) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isTransitioning = _useState2[0],
    setIsTransitioning = _useState2[1];
  useEffect(function () {
    var timeoutId;
    if (isMounted && !isTransitioning) {
      setIsTransitioning(true);
    } else if (!isMounted && isTransitioning) {
      timeoutId = setTimeout(function () {
        return setIsTransitioning(false);
      }, unmountDelay);
    }
    return function () {
      clearTimeout(timeoutId);
    };
  }, [unmountDelay, isMounted, isTransitioning]);
  return isTransitioning;
};
var useMountTransition$1 = useMountTransition;

var _excluded$e = ["id", "fullWidth", "addExtraHeight", "isOpen", "onClose", "position", "removeWhenClosed", "speed", "selector", "useFocusTrap", "appendToParent"];
var styleProps$8 = compose(background, border, color$1, position, grid, space$1, layout, flexbox, shadow, typography$1, display, textAlign);
var DrawerContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "Drawer__DrawerContainer",
  componentId: "sc-fb27m3-0"
})(["", ""], function (props) {
  return css({
    '--transition-speed': props.speed
  });
});
var DrawerBody = /*#__PURE__*/styled.div.withConfig({
  displayName: "Drawer__DrawerBody",
  componentId: "sc-fb27m3-1"
})(["", " ", ""], function (props) {
  return css(Object.assign({
    background: '#fff',
    width: props.containerSize,
    height: "calc(100vh - ".concat(props.addExtraHeight, "px + env(safe-area-inset-bottom))"),
    overflow: 'auto',
    position: 'fixed',
    'box-shadow': '0 0 15px rgba(0, 0, 0, 0.5)',
    transition: 'transform var(--transition-speed) ease',
    willChange: 'transform',
    'z-index': '1000',
    role: props.role
  }, props.position === 'left' && {
    top: 0,
    left: 0,
    transform: !(props["in"] && props.open) ? 'translateX(-65em)' : 'translateX(0)'
  }, props.position === 'right' && {
    top: 0,
    right: 0,
    transform: !(props["in"] && props.open) ? 'translateX(60em)' : 'translateX(0)'
  }, props.position === 'top' && {
    top: 0,
    left: 0,
    right: 0,
    width: '100%',
    transform: !(props["in"] && props.open) ? 'translateY(-100%)' : 'translateY(0)',
    height: props.containerSize
  }, props.position === 'bottom' && {
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    transform: !(props["in"] && props.open) ? 'translateY(100%)' : 'translateY(0)',
    height: props.containerSize
  }));
}, styleProps$8);
function createPortalRoot(uid) {
  var drawerRoot = document.createElement('div');
  drawerRoot.setAttribute('id', uid);
  return drawerRoot;
}
function Drawer(_ref) {
  var id = _ref.id,
    fullWidth = _ref.fullWidth,
    addExtraHeight = _ref.addExtraHeight,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    position = _ref.position,
    removeWhenClosed = _ref.removeWhenClosed,
    speed = _ref.speed,
    selector = _ref.selector,
    useFocusTrap = _ref.useFocusTrap,
    _ref$appendToParent = _ref.appendToParent,
    appendToParent = _ref$appendToParent === void 0 ? null : _ref$appendToParent,
    props = _objectWithoutProperties(_ref, _excluded$e);
  var containerSize = fullWidth ? '100%' : props.width ? props.width : '350px';
  var bodyRef = selector;
  var documentBodyRef = useRef(document.querySelector('body'));
  var portalRootRef = useRef(document.getElementById(id) || createPortalRoot(id));
  var isTransitioning = useMountTransition$1(isOpen, speed * 1000);

  // Append portal root on mount
  useEffect(function () {
    if (appendToParent) bodyRef.current.appendChild(portalRootRef.current);else bodyRef.current.appendChild(portalRootRef.current);
    var portal = portalRootRef.current;
    var bodyEl = bodyRef.current;
    return function () {
      portal.remove();
      bodyEl.style.overflow = '';
    };
  }, [bodyRef, appendToParent]);

  // Prevent page scrolling when the drawer is open
  useEffect(function () {
    var body = documentBodyRef.current;
    var updatePageScroll = function updatePageScroll() {
      if (isOpen) {
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = '';
        onClose();
      }
    };
    updatePageScroll();
    return function () {
      body.style.overflow = '';
      onClose();
    };
  }, [isOpen, documentBodyRef, onClose]);
  if (!isTransitioning && removeWhenClosed && !isOpen) {
    return null;
  }
  var doPortal = function doPortal() {
    return /*#__PURE__*/createPortal( /*#__PURE__*/jsx(FocusTrap, {
      active: isOpen && useFocusTrap,
      children: /*#__PURE__*/jsx(DrawerContainer, {
        speed: "".concat(speed, "s"),
        "aria-hidden": isOpen ? 'false' : 'true',
        children: /*#__PURE__*/jsx(DrawerBody, Object.assign({
          containerSize: containerSize,
          position: position,
          role: "dialog",
          open: isOpen,
          addExtraHeight: addExtraHeight,
          "in": isTransitioning ? 1 : 0
        }, props, {
          children: /*#__PURE__*/jsx("div", {
            tabIndex: "0",
            children: props.children
          })
        }))
      })
    }), portalRootRef.current);
  };
  if (!isTransitioning && removeWhenClosed && !isOpen) {
    return null;
  }
  return doPortal();
}
Drawer.displayName = 'Drawer';
Drawer.propTypes = {
  id: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  position: PropTypes.string,
  addExtraHeight: PropTypes.number,
  speed: PropTypes.number,
  removeWhenClosed: PropTypes.bool,
  useFocusTrap: PropTypes.bool
};
Drawer.defaultProps = {
  fullWidth: false,
  isOpen: false,
  onClose: function onClose() {
    return null;
  },
  position: 'left',
  speed: 0.35,
  addExtraHeight: 0,
  removeWhenClosed: true,
  useFocusTrap: true
};

var CircleContainer = /*#__PURE__*/styled('div').withConfig({
  displayName: "CircleContainer",
  componentId: "sc-2tl9ya-0"
})(["", ";"], function (props) {
  return css(Object.assign({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    'border-radius': '50%',
    width: '26px',
    height: '26px',
    ':hover': {
      background: _wcImport4.secondary[30]
    }
  }, props));
});
var CircleContainer$1 = CircleContainer;

var _excluded$d = ["_css"];
var InputContainer$1 = function InputContainer(_ref) {
  var _css = _ref._css,
    props = _objectWithoutProperties(_ref, _excluded$d);
  return /*#__PURE__*/jsx(_StyledDiv$4, Object.assign({
    "data-qa": "filter-input"
  }, props, {
    $_css2: _wcImport4.neutral_30,
    $_css3: _css
  }));
};
var _StyledDiv$4 = /*#__PURE__*/styled("div").withConfig({
  displayName: "InputContainer___StyledDiv",
  componentId: "sc-1ql0ctg-0"
})(function (p) {
  return Object.assign({
    backgroundColor: 'white',
    position: 'absolute',
    zIndex: 2,
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
    borderColor: p.$_css2,
    marginTop: '4px',
    boxShadow: '0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%)'
  }, p.$_css3);
});

var _excluded$c = ["children", "isOpen", "target", "onClose"];
var Blanket$1 = function Blanket(props) {
  return /*#__PURE__*/jsx(_StyledDiv$3, Object.assign({}, props));
};
var DropdownContainer = function DropdownContainer(_ref) {
  var children = _ref.children,
    isOpen = _ref.isOpen,
    target = _ref.target,
    onClose = _ref.onClose,
    others = _objectWithoutProperties(_ref, _excluded$c);
  return /*#__PURE__*/jsxs(_StyledDiv2, {
    children: [target, isOpen ? /*#__PURE__*/jsx(InputContainer$1, Object.assign({}, others, {
      children: children
    })) : null, isOpen ? /*#__PURE__*/jsx(Blanket$1, {
      onClick: onClose
    }) : null]
  });
};
var _StyledDiv$3 = styled("div")({
  bottom: 0,
  left: 0,
  top: 0,
  right: 0,
  position: 'fixed',
  zIndex: 1
});
var _StyledDiv2 = /*#__PURE__*/styled("div").withConfig({
  displayName: "DropdownContainer___StyledDiv2",
  componentId: "sc-kubhgu-0"
})({
  position: 'relative'
});

var _excluded$b = ["label", "labelName", "open", "onFilterPress", "options", "selection", "selectionChange", "isMulti", "inverted", "popupSelectProps", "selector", "onClear", "onClose", "filterRightAlign", "placement", "limitWidth"];
var PopupFilter = function PopupFilter(_ref) {
  var label = _ref.label,
    labelName = _ref.labelName,
    open = _ref.open,
    onFilterPress = _ref.onFilterPress,
    options = _ref.options,
    selection = _ref.selection,
    selectionChange = _ref.selectionChange,
    isMulti = _ref.isMulti,
    inverted = _ref.inverted,
    popupSelectProps = _ref.popupSelectProps,
    selector = _ref.selector,
    onClear = _ref.onClear;
    _ref.onClose;
    var filterRightAlign = _ref.filterRightAlign,
    placement = _ref.placement,
    limitWidth = _ref.limitWidth,
    props = _objectWithoutProperties(_ref, _excluded$b);
  var ref = useRef(null);
  var _useState = useState(open),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    popupSelection = _useState4[0],
    setPopupSelection = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    filterLabel = _useState6[0],
    setFilterLabel = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    active = _useState8[0],
    setActive = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    labelIndicator = _useState10[0],
    setLabelIndicator = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    action = _useState12[0],
    setAction = _useState12[1];
  var _useViewport = useViewport(),
    isXS = _useViewport.isXS;
  useEffect(function () {
    setIsOpen(open);
  }, [open]);
  useEffect(function () {
    setFilterLabel(label);
  }, [label]);
  useEffect(function () {
    setPopupSelection(selection);
  }, [selection]);
  var onFilterClear = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    setPopupSelection([]);
    selectionChange([]);
    if (onClear) {
      onClear();
    }
  }, [onClear, selectionChange]);
  useEffect(function () {
    setActive(popupSelection.length > 0);
    var length = popupSelection.length;
    if (length === 0) {
      setAction(null);
      setLabelIndicator(null);
      setFilterLabel(labelName);
    } else {
      setAction(isXS ? /*#__PURE__*/jsx(CircleContainer$1, {
        children: /*#__PURE__*/jsx(View, {
          onClick: onFilterClear,
          children: /*#__PURE__*/jsx(Icon$1, {
            variant: "close_16",
            outlineColor: _wcImport4.secondary[60]
          })
        })
      }) : null);
      if (popupSelection.length > 1) {
        setLabelIndicator( /*#__PURE__*/jsx(_StyledBasicChip, {
          ml: "8px",
          text: popupSelection.length,
          inverted: true
        }));
        setFilterLabel(labelName);
      } else if (popupSelection.length === 1) {
        setLabelIndicator(null);
        setFilterLabel(popupSelection[0].label);
      }
    }
  }, [popupSelection, isXS, labelName, onFilterClear]);
  var handlePress = useCallback(function () {
    onFilterPress(!isOpen);
    if (open === null) {
      setIsOpen(!isOpen);
    }
  }, [isOpen, onFilterPress, open]);
  var onSelectionChange = useCallback(function (values) {
    setPopupSelection(values);
    selectionChange(values);
  }, [selectionChange]);
  var containerRef = useRef();
  var _useState13 = useState(),
    _useState14 = _slicedToArray(_useState13, 2),
    containerWidth = _useState14[0],
    setContainerWidth = _useState14[1];
  useEffect(function () {
    if (containerRef.current) {
      var _containerRef$current, _containerRef$current2;
      var width = containerRef == null ? void 0 : (_containerRef$current = containerRef.current) == null ? void 0 : (_containerRef$current2 = _containerRef$current.getBoundingClientRect()) == null ? void 0 : _containerRef$current2.width;
      if (containerWidth !== width) {
        setContainerWidth(width);
      }
    }
  }, [containerRef, containerWidth]);
  var renderFilterTrigger = function renderFilterTrigger() {
    return /*#__PURE__*/jsx(FilterTriggerContainer$1, Object.assign({
      active: active,
      ref: containerRef,
      _onPress: function _onPress() {
        return handlePress();
      },
      limitWidth: limitWidth
    }, props, {
      children: /*#__PURE__*/jsx(PopupSelect$1, {
        label: filterLabel,
        labelIndicator: labelIndicator,
        open: isOpen,
        onPress: function onPress() {
          return null;
        },
        inverted: inverted,
        action: action,
        limitWidth: limitWidth
      })
    }));
  };
  var handlers = useSwipeable({
    onSwipedRight: function onSwipedRight() {
      return setIsOpen(false);
    }
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [!isXS && /*#__PURE__*/jsxs(Fragment, {
      children: [renderFilterTrigger(), /*#__PURE__*/jsx(_StyledDrawer$2, {
        id: labelName,
        isOpen: isOpen,
        selector: selector,
        fullWidth: true,
        position: 'right',
        $_css: _wcImport4.neutral[100],
        children: /*#__PURE__*/jsxs("div", Object.assign({}, handlers, {
          style: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
          },
          children: [/*#__PURE__*/jsxs(View, {
            children: [/*#__PURE__*/jsx(_StyledDefaultContainer, {
              children: /*#__PURE__*/jsxs(_StyledView$8, {
                onClick: function onClick(e) {
                  e == null ? void 0 : e.preventDefault();
                  handlePress();
                },
                children: [labelName, /*#__PURE__*/jsx(Icon$1, {
                  variant: "chevron_left_20",
                  outlineColor: _wcImport4.neutral_50
                })]
              })
            }), /*#__PURE__*/jsx(Popup$1, Object.assign({
              menuIsOpen: isOpen,
              defaultValue: popupSelection,
              isMulti: isMulti,
              options: options,
              selectionChange: onSelectionChange,
              menuListHeader: labelName,
              onClear: function onClear() {
                return onFilterClear();
              },
              onClose: function onClose() {
                return handlePress();
              },
              isMobile: !isXS,
              placeholder: "Search ".concat(labelName.toLowerCase()),
              placement: placement
            }, popupSelectProps, {
              ref: ref
            }))]
          }), /*#__PURE__*/jsx(_StyledView2$5, {
            children: /*#__PURE__*/jsx(Button$1, {
              mt: "16px",
              left: '5%',
              width: '90%',
              height: '48px',
              onPress: onFilterClear,
              variant: 'secondary',
              children: "Clear"
            })
          })]
        }))
      })]
    }), isXS && /*#__PURE__*/jsx(DropdownContainer, {
      isOpen: isOpen,
      menuLabel: labelName,
      onClose: handlePress,
      target: renderFilterTrigger(),
      _css: {
        left: filterRightAlign && containerWidth ? "".concat(containerWidth - 302, "px") : null
      },
      children: /*#__PURE__*/jsx(Popup$1, Object.assign({
        menuIsOpen: isOpen,
        defaultValue: popupSelection,
        isMulti: isMulti,
        options: options,
        selectionChange: onSelectionChange,
        menuListHeader: labelName,
        onClear: onFilterClear
      }, popupSelectProps, {
        placeholder: "Search ".concat(labelName.toLowerCase()),
        placement: placement,
        ref: ref
      }))
    })]
  });
};
PopupFilter.displayName = 'PopupFilter';
PopupFilter.propTypes = {
  label: PropTypes.string.isRequired,
  labelName: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onPress: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  selection: PropTypes.any,
  selectionChange: PropTypes.func,
  isMulti: PropTypes.bool,
  inverted: PropTypes.bool,
  popupSelectProps: PropTypes.object,
  selector: PropTypes.object,
  filterRightAlign: PropTypes.bool,
  placement: PropTypes.oneOf(['bottom', 'top', 'auto']),
  limitWidth: PropTypes.bool
};
PopupFilter.defaultProps = {
  selection: [],
  selectionChange: function selectionChange() {
    return null;
  },
  isMulti: false,
  inverted: false,
  popupSelectProps: {},
  selector: {},
  placement: 'bottom',
  limitWidth: false
};
var PopupFilter$1 = PopupFilter;
var _StyledBasicChip = styled(BasicChip$1)({
  minWidth: '20px',
  minHeight: '20px',
  alignItems: 'center',
  fontSize: '13px'
});
var _StyledDrawer$2 = styled(Drawer)(function (p) {
  return {
    '*': {
      '-webkit-tap-highlight-color': 'transparent',
      outline: 'none',
      fontFamily: "'Open Sans', sans-serif",
      color: p.$_css
    }
  };
});
var _StyledDefaultContainer = styled(DefaultContainer$1)({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: '12px',
  marginLeft: '30px',
  lineHeight: '1.3'
});
var _StyledView$8 = styled(View)({
  ':hover': {
    cursor: 'pointer'
  },
  'svg': {
    position: 'absolute',
    left: '16px',
    top: '12px'
  }
});
var _StyledView2$5 = /*#__PURE__*/styled(View).withConfig({
  displayName: "PopupFilter___StyledView2",
  componentId: "sc-ds88t4-0"
})({
  paddingBottom: 'calc(16px + env(safe-area-inset-bottom))'
});

var StyledInput$1 = /*#__PURE__*/styled.input.withConfig({
  displayName: "helpers__StyledInput",
  componentId: "sc-1lqpta9-0"
})(["", ""], function (props) {
  return styledCss({
    boxSizing: 'border-box',
    lineHeight: 'inherit',
    margin: '0px',
    touchAction: 'manipulation',
    backgroundColor: _wcImport4.white,
    border: 'none',
    color: _wcImport4.neutral_100,
    fontFamily: openSans(),
    fontSize: baseFontSize(),
    outline: 'none',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    height: '48px',
    fontWeight: fontWeights.regular,
    borderRadius: '6px',
    paddingInlineEnd: props.showRightIcon ? '45px' : '10px',
    paddingInlineStart: props.showLeftIcon ? '45px' : '10px',
    '&::placeholder': {
      color: _wcImport4.neutral[100],
      fontSize: baseFontSize(),
      fontWeight: fontWeights.regular
    }
  });
});
var InputContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "helpers__InputContainer",
  componentId: "sc-1lqpta9-1"
})(["", ""], function () {
  return styledCss({
    position: 'relative'
  });
});
var getIconContainerStyling = function getIconContainerStyling(_ref) {
  var left = _ref.left,
    right = _ref.right,
    leftIconCursor = _ref.leftIconCursor,
    rightIconCursor = _ref.rightIconCursor;
  var style = {
    display: 'none'
  };
  if (left) {
    style = Object.assign({}, style, {
      cursor: leftIconCursor,
      display: 'inline-block',
      left: '17px'
    });
  } else if (right) {
    style = {
      cursor: rightIconCursor,
      display: 'inline-block',
      right: '17px'
    };
  }
  return style;
};
var InputIconContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "helpers__InputIconContainer",
  componentId: "sc-1lqpta9-2"
})(["", ""], function (props) {
  var calculatedStyles = getIconContainerStyling(props);
  return styledCss(Object.assign({
    position: 'absolute',
    top: '50%',
    marginTop: '-9px'
  }, calculatedStyles));
});

var _excluded$a = ["changeHandler", "value", "iconName", "hasIcon", "variant", "useLeftIcon", "leftIconName", "leftIconCursor", "leftIconProps", "leftIconClick", "useRightIcon", "rightIconCursor", "rightIconName", "rightIconProps", "rightIconClick", "dataQa"];
var InputField = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var changeHandler = _ref.changeHandler,
    value = _ref.value;
    _ref.iconName;
    _ref.hasIcon;
    _ref.variant;
    var useLeftIcon = _ref.useLeftIcon,
    leftIconName = _ref.leftIconName,
    leftIconCursor = _ref.leftIconCursor,
    leftIconProps = _ref.leftIconProps,
    leftIconClick = _ref.leftIconClick,
    useRightIcon = _ref.useRightIcon,
    rightIconCursor = _ref.rightIconCursor,
    rightIconName = _ref.rightIconName,
    rightIconProps = _ref.rightIconProps,
    rightIconClick = _ref.rightIconClick,
    dataQa = _ref.dataQa,
    others = _objectWithoutProperties(_ref, _excluded$a);
  var handleChange = function handleChange(e) {
    changeHandler(e);
  };
  return /*#__PURE__*/jsxs(InputContainer, {
    children: [useLeftIcon && leftIconName && /*#__PURE__*/jsx(InputIconContainer, {
      leftIconCursor: leftIconCursor,
      onClick: leftIconClick,
      left: true,
      children: /*#__PURE__*/jsx(Icon$1, Object.assign({
        variant: leftIconName
      }, leftIconProps))
    }), /*#__PURE__*/jsx(StyledInput$1, Object.assign({
      "data-qa": "".concat(dataQa, "-input"),
      ref: ref,
      onChange: handleChange,
      value: value,
      showLeftIcon: useLeftIcon && leftIconName,
      showRightIcon: useRightIcon && rightIconName
    }, others)), useRightIcon && rightIconName && /*#__PURE__*/jsx(InputIconContainer, {
      "data-qa": "".concat(dataQa, "-right-icon"),
      rightIconCursor: rightIconCursor,
      onClick: rightIconClick,
      right: true,
      children: /*#__PURE__*/jsx(Icon$1, Object.assign({
        variant: rightIconName
      }, rightIconProps))
    })]
  });
});
InputField.displayName = 'InputField';
InputField.propTypes = {
  changeHandler: PropTypes.func,
  value: PropTypes.string,
  useLeftIcon: PropTypes.bool,
  leftIconName: PropTypes.string,
  leftIconCursor: PropTypes.string,
  leftIconProps: PropTypes.any,
  leftIconClick: PropTypes.func,
  useRightIcon: PropTypes.bool,
  rightIconCursor: PropTypes.string,
  rightIconName: PropTypes.string,
  rightIconProps: PropTypes.any,
  rightIconClick: PropTypes.func
};
InputField.defaultProps = {
  value: '',
  useLeftIcon: false,
  leftIconName: '',
  leftIconCursor: 'default',
  leftIconProps: {},
  leftIconClick: function leftIconClick() {
    return null;
  },
  useRightIcon: false,
  rightIconCursor: 'default',
  rightIconName: '',
  rightIconProps: {},
  rightIconClick: function rightIconClick() {
    return null;
  }
};
InputField.displayName = 'InputField';

var global$m = global$Q;

var nativePromiseConstructor = global$m.Promise;

var redefine$6 = redefine$a.exports;

var redefineAll$2 = function (target, src, options) {
  for (var key in src) redefine$6(target, key, src[key], options);
  return target;
};

var global$l = global$Q;
var isCallable$9 = isCallable$m;

var String$3 = global$l.String;
var TypeError$8 = global$l.TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$9(argument)) return argument;
  throw TypeError$8("Can't set " + String$3(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$b = functionUncurryThis;
var anObject$9 = anObject$j;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$b(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$9(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$6 = hasOwnProperty_1;
var wellKnownSymbol$c = wellKnownSymbol$l;

var TO_STRING_TAG$1 = wellKnownSymbol$c('toStringTag');

var setToStringTag$5 = function (it, TAG, STATIC) {
  if (it && !hasOwn$6(it = STATIC ? it : it.prototype, TO_STRING_TAG$1)) {
    defineProperty$2(it, TO_STRING_TAG$1, { configurable: true, value: TAG });
  }
};

var getBuiltIn$2 = getBuiltIn$8;
var definePropertyModule$1 = objectDefineProperty;
var wellKnownSymbol$b = wellKnownSymbol$l;
var DESCRIPTORS$3 = descriptors;

var SPECIES$1 = wellKnownSymbol$b('species');

var setSpecies$2 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$2(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule$1.f;

  if (DESCRIPTORS$3 && Constructor && !Constructor[SPECIES$1]) {
    defineProperty(Constructor, SPECIES$1, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var global$k = global$Q;
var isPrototypeOf$3 = objectIsPrototypeOf;

var TypeError$7 = global$k.TypeError;

var anInstance$3 = function (it, Prototype) {
  if (isPrototypeOf$3(Prototype, it)) return it;
  throw TypeError$7('Incorrect invocation');
};

var uncurryThis$a = functionUncurryThis;
var aCallable$4 = aCallable$6;

var bind$7 = uncurryThis$a(uncurryThis$a.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$4(fn);
  return that === undefined ? fn : bind$7 ? bind$7(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var iterators = {};

var wellKnownSymbol$a = wellKnownSymbol$l;
var Iterators$4 = iterators;

var ITERATOR$7 = wellKnownSymbol$a('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$2 = function (it) {
  return it !== undefined && (Iterators$4.Array === it || ArrayPrototype[ITERATOR$7] === it);
};

var classof$2 = classof$7;
var getMethod$4 = getMethod$7;
var Iterators$3 = iterators;
var wellKnownSymbol$9 = wellKnownSymbol$l;

var ITERATOR$6 = wellKnownSymbol$9('iterator');

var getIteratorMethod$4 = function (it) {
  if (it != undefined) return getMethod$4(it, ITERATOR$6)
    || getMethod$4(it, '@@iterator')
    || Iterators$3[classof$2(it)];
};

var global$j = global$Q;
var call$a = functionCall;
var aCallable$3 = aCallable$6;
var anObject$8 = anObject$j;
var tryToString$1 = tryToString$4;
var getIteratorMethod$3 = getIteratorMethod$4;

var TypeError$6 = global$j.TypeError;

var getIterator$3 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$3(argument) : usingIterator;
  if (aCallable$3(iteratorMethod)) return anObject$8(call$a(iteratorMethod, argument));
  throw TypeError$6(tryToString$1(argument) + ' is not iterable');
};

var call$9 = functionCall;
var anObject$7 = anObject$j;
var getMethod$3 = getMethod$7;

var iteratorClose$2 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$7(iterator);
  try {
    innerResult = getMethod$3(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$9(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$7(innerResult);
  return value;
};

var global$i = global$Q;
var bind$6 = functionBindContext;
var call$8 = functionCall;
var anObject$6 = anObject$j;
var tryToString = tryToString$4;
var isArrayIteratorMethod$1 = isArrayIteratorMethod$2;
var lengthOfArrayLike$2 = lengthOfArrayLike$4;
var isPrototypeOf$2 = objectIsPrototypeOf;
var getIterator$2 = getIterator$3;
var getIteratorMethod$2 = getIteratorMethod$4;
var iteratorClose$1 = iteratorClose$2;

var TypeError$5 = global$i.TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$1 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$6(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose$1(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$6(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$2(iterable);
    if (!iterFn) throw TypeError$5(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod$1(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$2(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$2(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator$2(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = call$8(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$1(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$2(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$8 = wellKnownSymbol$l;

var ITERATOR$5 = wellKnownSymbol$8('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$5] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$5] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var userAgent$2 = engineUserAgent;

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var classof$1 = classofRaw$1;
var global$h = global$Q;

var engineIsNode = classof$1(global$h.process) == 'process';

var global$g = global$Q;
var apply$1 = functionApply;
var bind$5 = functionBindContext;
var isCallable$8 = isCallable$m;
var hasOwn$5 = hasOwnProperty_1;
var fails$8 = fails$n;
var html = html$2;
var arraySlice$2 = arraySlice$4;
var createElement = documentCreateElement$2;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var set = global$g.setImmediate;
var clear = global$g.clearImmediate;
var process$3 = global$g.process;
var Dispatch = global$g.Dispatch;
var Function$1 = global$g.Function;
var MessageChannel = global$g.MessageChannel;
var String$2 = global$g.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global$g.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn$5(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$g.postMessage(String$2(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = arraySlice$2(arguments, 1);
    queue[++counter] = function () {
      apply$1(isCallable$8(fn) ? fn : Function$1(fn), undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$3.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$5(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$g.addEventListener &&
    isCallable$8(global$g.postMessage) &&
    !global$g.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails$8(post)
  ) {
    defer = post;
    global$g.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var userAgent$1 = engineUserAgent;
var global$f = global$Q;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && global$f.Pebble !== undefined;

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$e = global$Q;
var bind$4 = functionBindContext;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver = global$e.MutationObserver || global$e.WebKitMutationObserver;
var document$2 = global$e.document;
var process$2 = global$e.process;
var Promise$1 = global$e.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$1(global$e, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$2.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$4(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$2.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind$4(macrotask, global$e);
    notify$1 = function () {
      macrotask(flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var newPromiseCapability$2 = {};

var aCallable$2 = aCallable$6;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$2(resolve);
  this.reject = aCallable$2(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var anObject$5 = anObject$j;
var isObject$3 = isObject$a;
var newPromiseCapability$1 = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$5(C);
  if (isObject$3(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var global$d = global$Q;

var hostReportErrors$1 = function (a, b) {
  var console = global$d.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$1 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var engineIsBrowser = typeof window == 'object';

var $$8 = _export;
var global$c = global$Q;
var getBuiltIn$1 = getBuiltIn$8;
var call$7 = functionCall;
var NativePromise = nativePromiseConstructor;
var redefine$5 = redefine$a.exports;
var redefineAll$1 = redefineAll$2;
var setPrototypeOf$2 = objectSetPrototypeOf;
var setToStringTag$4 = setToStringTag$5;
var setSpecies$1 = setSpecies$2;
var aCallable$1 = aCallable$6;
var isCallable$7 = isCallable$m;
var isObject$2 = isObject$a;
var anInstance$2 = anInstance$3;
var inspectSource = inspectSource$4;
var iterate = iterate$1;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var speciesConstructor = speciesConstructor$2;
var task = task$1.set;
var microtask = microtask$1;
var promiseResolve = promiseResolve$1;
var hostReportErrors = hostReportErrors$1;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$1;
var InternalStateModule$4 = internalState;
var isForced$1 = isForced_1;
var wellKnownSymbol$7 = wellKnownSymbol$l;
var IS_BROWSER = engineIsBrowser;
var IS_NODE$1 = engineIsNode;
var V8_VERSION = engineV8Version;

var SPECIES = wellKnownSymbol$7('species');
var PROMISE = 'Promise';

var getInternalState$2 = InternalStateModule$4.get;
var setInternalState$4 = InternalStateModule$4.set;
var getInternalPromiseState = InternalStateModule$4.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromisePrototype = NativePromisePrototype;
var TypeError$4 = global$c.TypeError;
var document$1 = global$c.document;
var process$1 = global$c.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$c.dispatchEvent);
var NATIVE_REJECTION_EVENT = isCallable$7(global$c.PromiseRejectionEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED$1 = isForced$1(PROMISE, function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED$1 || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject$2(it) && isCallable$7(then = it.then) ? then : false;
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$4('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            call$7(then, result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$c.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global$c['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$7(task, global$c, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE$1) {
          process$1.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$7(task, global$c, function () {
    var promise = state.facade;
    if (IS_NODE$1) {
      process$1.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$3 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$4("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$7(then, value,
            bind$3(internalResolve, wrapper, state),
            bind$3(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED$1) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance$2(this, PromisePrototype);
    aCallable$1(executor);
    call$7(Internal, this);
    var state = getInternalState$2(this);
    try {
      executor(bind$3(internalResolve, state), bind$3(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromisePrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$4(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll$1(PromisePrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reactions = state.reactions;
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = isCallable$7(onFulfilled) ? onFulfilled : true;
      reaction.fail = isCallable$7(onRejected) && onRejected;
      reaction.domain = IS_NODE$1 ? process$1.domain : undefined;
      state.parent = true;
      reactions[reactions.length] = reaction;
      if (state.state != PENDING) notify(state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState$2(promise);
    this.promise = promise;
    this.resolve = bind$3(internalResolve, state);
    this.reject = bind$3(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$7(NativePromise) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine$5(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$7(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine$5(NativePromisePrototype, 'catch', PromisePrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf$2) {
      setPrototypeOf$2(NativePromisePrototype, PromisePrototype);
    }
  }
}

$$8({ global: true, wrap: true, forced: FORCED$1 }, {
  Promise: PromiseConstructor
});

setToStringTag$4(PromiseConstructor, PROMISE, false);
setSpecies$1(PROMISE);

PromiseWrapper = getBuiltIn$1(PROMISE);

// statics
$$8({ target: PROMISE, stat: true, forced: FORCED$1 }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    call$7(capability.reject, undefined, r);
    return capability.promise;
  }
});

$$8({ target: PROMISE, stat: true, forced: FORCED$1 }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

$$8({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$7($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      iterate(iterable, function (promise) {
        call$7($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var _excluded$9 = ["value", "googlePlaceAPITypes", "googlePlaceAPIComponentRestrictions", "changeHandler", "coordinates"];
var LocationInput = function LocationInput(_ref) {
  var value = _ref.value,
    googlePlaceAPITypes = _ref.googlePlaceAPITypes,
    googlePlaceAPIComponentRestrictions = _ref.googlePlaceAPIComponentRestrictions,
    changeHandler = _ref.changeHandler,
    incomingCoordenates = _ref.coordinates,
    others = _objectWithoutProperties(_ref, _excluded$9);
  var inputRef = useRef();
  var containerRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isGoogleSet = _useState2[0],
    setIsGoogleSet = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    googleField = _useState4[0],
    setGoogleField = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    fieldMoved = _useState6[0],
    setFieldMoved = _useState6[1];
  var _useState7 = useState(incomingCoordenates || {
      lat: null,
      lng: null
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    coordinates = _useState8[0],
    setCoordinates = _useState8[1];
  var handleChange = useCallback(function (location) {
    changeHandler(location);
  }, [changeHandler]);
  var handleInputChange = function handleInputChange(e) {
    if (googleField && !fieldMoved) {
      relocatePacContainer(googleField);
      setFieldMoved(true);
    }
    handleChange({
      coordinates: {
        lat: null,
        lng: null
      },
      value: e.target.value
    });
  };
  var relocatePacContainer = function relocatePacContainer(autocomplete) {
    var _autocomplete$gm_acce, _autocomplete$gm_acce2, _autocomplete$gm_acce3, _autocomplete$gm_acce4, _autocomplete$gm_acce5, _autocomplete$gm_acce6;
    var pacContainer = (_autocomplete$gm_acce = autocomplete.gm_accessors_) == null ? void 0 : (_autocomplete$gm_acce2 = _autocomplete$gm_acce.place) == null ? void 0 : (_autocomplete$gm_acce3 = _autocomplete$gm_acce2.Tj) == null ? void 0 : (_autocomplete$gm_acce4 = _autocomplete$gm_acce3.gm_accessors_) == null ? void 0 : (_autocomplete$gm_acce5 = _autocomplete$gm_acce4.input) == null ? void 0 : (_autocomplete$gm_acce6 = _autocomplete$gm_acce5.Tj) == null ? void 0 : _autocomplete$gm_acce6.o;
    if (pacContainer) {
      var locInput = autocomplete.gm_accessors_.place.Tj.gm_accessors_.input.Tj.g;
      var locInputBoundingRect = locInput.getBoundingClientRect();
      var pacClon = pacContainer.cloneNode();
      pacClon.style.top = locInputBoundingRect.height;
      pacClon.style.left = 0;
      pacClon.style.zIndex = 8000;
      pacClon.style.height = 150;
      pacClon.style.overflowX = "scroll";
      containerRef.current.appendChild(pacClon);
      // eslint-disable-next-line no-param-reassign
      autocomplete.gm_accessors_.place.Tj.gm_accessors_.input.Tj.o = pacClon;
      document.body.removeChild(pacContainer);
      return true;
    }
    return false;
  };
  var setUpGoogle = useCallback(function () {
    if (window.google && window.google.maps && !isGoogleSet && inputRef != null && inputRef.current) {
      var element = inputRef.current;
      var autocomplete = new google.maps.places.Autocomplete(element, {
        types: googlePlaceAPITypes,
        componentRestrictions: googlePlaceAPIComponentRestrictions
      });
      autocomplete.setFields(['address_components', 'formatted_address', 'geometry']);
      autocomplete.addListener('place_changed', function () {
        var place = autocomplete.getPlace();
        var lat = place.geometry.location.lat();
        var lng = place.geometry.location.lng();
        var value = place.formatted_address;
        setCoordinates({
          lat: lat,
          lng: lng
        });
        handleChange({
          coordinates: coordinates,
          value: value
        });
      });
      setGoogleField(autocomplete);
      setIsGoogleSet(true);
    }
  }, [googlePlaceAPITypes, googlePlaceAPIComponentRestrictions, handleChange, isGoogleSet, coordinates, inputRef]);
  var loadGoogleScript = useCallback(function () {
    var script = document.createElement('script');
    script.onload = function () {
      setUpGoogle();
    };
    script.src = "https://maps.googleapis.com/maps/api/js?v=3.47.6&key=AIzaSyBFts9V0cwwsvKe6JdP8VcD9FLuYp5iWxU&libraries=places";
    document.head.appendChild(script);
  }, [setUpGoogle]);
  useEffect(function () {
    if (!window.google && !window._googleMapsStartedLoading) {
      window._googleMapsStartedLoading = true;
      loadGoogleScript();
    } else {
      setTimeout(function () {
        setUpGoogle();
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var handleRightIconClick = function handleRightIconClick() {
    handleChange({
      coordinates: {
        lat: null,
        lng: null
      },
      value: ''
    });
  };
  var rightIconProps = function rightIconProps() {
    if (value !== '' && value !== null) {
      return {
        useRightIcon: true,
        rightIconCursor: 'pointer',
        rightIconName: 'close_16',
        rightIconProps: {
          outlineColor: _wcImport4.neutral[50]
        },
        rightIconClick: handleRightIconClick
      };
    }
    return {};
  };
  return /*#__PURE__*/jsx(_StyledDiv$2, {
    "data-qa": "Jobs-Searchbar-Location",
    ref: containerRef,
    className: 'location-input-container',
    children: /*#__PURE__*/jsx(_StyledInputField$2, Object.assign({
      ref: inputRef,
      value: value,
      changeHandler: handleInputChange,
      useLeftIcon: true,
      leftIconName: 'location_16',
      placeholder: 'City, State or Country'
    }, rightIconProps(), {
      "data-qa": "Jobs-Searchbar-Location-input",
      dataQa: "Location"
    }, others))
  });
};
LocationInput.displayName = 'LocationInput';
LocationInput.propTypes = {
  /**
   * Handler for the input changes, ({value, coordinates: {lat, lng}}) => {...}
   */
  changeHandler: PropTypes.func.isRequired,
  /**
   * the value of the input
   */
  value: PropTypes.string,
  /**
   * the types field for the google places autocomplete variable. (i.e. ['(regions)'])
   */
  googlePlaceAPITypes: PropTypes.any,
  /**
   * any restrictions for the google places api definiton (i.e. {country: "us"})
   */
  googlePlaceAPIComponentRestrictions: PropTypes.any
};
LocationInput.defaultProps = {
  value: '',
  googlePlaceAPITypes: [],
  googlePlaceAPIComponentRestrictions: {
    country: []
  }
};
var _StyledDiv$2 = styled("div")({
  position: 'relative'
});
var _StyledInputField$2 = /*#__PURE__*/styled(InputField).withConfig({
  displayName: "LocationInput___StyledInputField",
  componentId: "sc-1i3tl1d-0"
})({
  input: {
    height: "50px"
  }
});

var SuggestionInner = /*#__PURE__*/styled.p.withConfig({
  displayName: "Suggestion__SuggestionInner",
  componentId: "sc-1g614j6-0"
})(["", ""], function () {
  return styledCss({
    marginBottom: '0px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    margin: '16px 0px'
  });
});
var SuggestionContainer = /*#__PURE__*/styled.div.attrs({
  dataQa: 'autocomplete-item'
}).withConfig({
  displayName: "Suggestion__SuggestionContainer",
  componentId: "sc-1g614j6-1"
})(["", ""], function (props) {
  return styledCss(Object.assign({
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    backgroundColor: _wcImport4.neutral[0],
    color: '#000000',
    lineHeight: '24px',
    fontSize: '16',
    paddingLeft: '18px',
    paddingRight: '18px'
  }, props.isFocused && {
    backgroundColor: _wcImport4.secondary[10]
  }));
});
var Suggestion = function Suggestion(_ref) {
  var suggestion = _ref.label,
    isFocused = _ref.isFocused,
    inputValue = _ref.inputValue;
  var matchingQueryPrefix = function matchingQueryPrefix(query, text) {
    var maxCommonString = '';
    for (var i = 1; i < query.length; i += 1) {
      var subQuery = query.slice(0, i);
      if (text.includes(subQuery) && subQuery.length > maxCommonString.length) {
        maxCommonString = subQuery;
      } else {
        break;
      }
    }
    return maxCommonString;
  };
  var renderHighlightedSuggestion = function renderHighlightedSuggestion(suggestion) {
    var normalizedSuggestion = suggestion.toLowerCase();
    var normalizedValue = inputValue.toLowerCase();
    var suggestionHtml;

    // Try to match full query
    var matchIndex = normalizedSuggestion.indexOf(normalizedValue);
    var matchingPrefix = normalizedValue;
    if (matchIndex === -1) {
      // Try to match prefix
      matchingPrefix = matchingQueryPrefix(normalizedValue, normalizedSuggestion);
      matchIndex = normalizedSuggestion.indexOf(matchingPrefix);
    }
    if (matchIndex !== -1) {
      var boldText = suggestion.slice(matchIndex, matchIndex + matchingPrefix.length);
      var startText = suggestion.slice(0, matchIndex);
      var endText = suggestion.slice(matchIndex + matchingPrefix.length);
      suggestionHtml = /*#__PURE__*/jsxs(SuggestionInner, {
        isFocused: isFocused,
        children: [startText, /*#__PURE__*/jsx("strong", {
          children: boldText
        }), endText]
      });
    } else {
      suggestionHtml = /*#__PURE__*/jsx(SuggestionInner, {
        isFocused: isFocused,
        children: suggestion
      });
    }
    return suggestionHtml;
  };
  return /*#__PURE__*/jsx(SuggestionContainer, {
    isFocused: isFocused,
    suggestion: suggestion,
    children: renderHighlightedSuggestion(suggestion)
  });
};
Suggestion.propTypes = {
  isFocused: PropTypes.bool,
  inputValue: PropTypes.string,
  label: PropTypes.string
};
Suggestion.defaultProps = {
  isFocused: false,
  inputValue: '',
  label: ''
};
var Suggestion$1 = Suggestion;

var _excluded$8 = ["value", "changeHandler", "placeholder"];
var styleProps$7 = compose(shadow, position, grid, typography$1, space$1, layout, flexbox, border, position, color$1, shadow, background);
var AutocompleteWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "JobSearchAutocompleteInput__AutocompleteWrapper",
  componentId: "sc-1hma1t3-0"
})(["", " ", ";"], function () {
  return styledCss({
    position: 'relative',
    width: '100%'
  });
}, styleProps$7);
var JobSearchAutocompleteInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var value = _ref.value,
    changeHandler = _ref.changeHandler,
    placeholder = _ref.placeholder,
    others = _objectWithoutProperties(_ref, _excluded$8);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    suggestions = _useState2[0],
    setSuggestions = _useState2[1];
  var handleChange = function handleChange(e) {
    changeHandler(e);
  };
  var getSuggestions = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _data$suggestions, _data$suggestions$com, results, data, newSuggestions;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return axios.get("/jobs/autocomplete", {
            params: {
              query: value
            }
          });
        case 3:
          results = _context.sent;
          data = results.data;
          if ((data == null ? void 0 : data.query) === value && ((_data$suggestions = data.suggestions) == null ? void 0 : (_data$suggestions$com = _data$suggestions.completionResults) == null ? void 0 : _data$suggestions$com.length) > 0) {
            newSuggestions = data.suggestions.completionResults.map(function (completionResult) {
              return completionResult.suggestion;
            });
            setSuggestions(newSuggestions);
          }
          _context.next = 11;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          console.log("Unable to get suggestions".concat(_context.t0));
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  })), [value]);
  useEffect(function () {
    if ((value == null ? void 0 : value.length) > 0) {
      getSuggestions();
    } else {
      setSuggestions([]);
    }
  }, [value, getSuggestions]);
  var handleRightIconClick = function handleRightIconClick() {
    handleChange({
      target: {
        value: ''
      }
    });
  };
  var rightIconProps = function rightIconProps() {
    if (value !== '' && value !== null) {
      return {
        useRightIcon: true,
        rightIconCursor: 'pointer',
        rightIconName: 'close_16',
        rightIconProps: {
          outlineColor: _wcImport4.neutral[50]
        },
        rightIconClick: handleRightIconClick
      };
    }
    return {};
  };
  return /*#__PURE__*/jsx(AutocompleteWrapper, Object.assign({
    ref: ref,
    "data-qa": "autocomplete-component"
  }, others, {
    children: /*#__PURE__*/jsx(Autocomplete, {
      wrapperStyle: {
        width: '100%',
        position: 'relative'
      },
      id: "autocomplete",
      items: suggestions,
      placeholder: 'placeholder',
      getItemValue: function getItemValue(item) {
        return item;
      },
      inputProps: {
        onChange: function onChange(e) {
          changeHandler(e);
        }
      },
      menuStyle: {
        borderRadius: '5px',
        boxShadow: '0 2px 6px rgb(0 0 0 / 30%)',
        background: 'white',
        fontSize: '16px',
        position: 'absolute',
        top: '48px',
        left: '0px',
        overflow: 'auto',
        zIndex: '5',
        width: '100%'
      },
      renderInput: function renderInput(inputProps) {
        return /*#__PURE__*/jsx(InputField, Object.assign({
          value: value,
          placeholder: placeholder,
          useLeftIcon: true,
          leftIconName: 'magnifyingGlass_16',
          changehandler: function changehandler() {
            return null;
          }
        }, rightIconProps(), inputProps));
      },
      value: value,
      onChange: function onChange(e) {
        return handleChange(e);
      },
      onSelect: function onSelect(value) {
        return handleChange({
          target: {
            value: value
          }
        });
      },
      autoHighlight: false,
      renderItem: function renderItem(item, isHighlighted) {
        return /*#__PURE__*/jsx("div", {
          "data-qa": "autocomplete-dropdown",
          children: /*#__PURE__*/jsx(Suggestion$1, {
            label: item,
            isFocused: isHighlighted,
            inputValue: value
          })
        }, item);
      }
    })
  }));
});
JobSearchAutocompleteInput.displayName = 'JobSearchAutocompleteInput';
JobSearchAutocompleteInput.propTypes = {
  /**
   * The value of the input
   */
  value: PropTypes.string,
  /**
   * change handler for the input
   */
  changeHandler: PropTypes.func.isRequired,
  /**
   * input Placeholder
   */
  placeholder: PropTypes.string
};
JobSearchAutocompleteInput.defaultProps = {
  value: '',
  placeholder: 'Search for Job title or Keyword'
};

var uncurryThis$9 = functionUncurryThis;

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
var thisNumberValue$1 = uncurryThis$9(1.0.valueOf);

var global$b = global$Q;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$6;
var toString$7 = toString$e;
var requireObjectCoercible$4 = requireObjectCoercible$b;

var RangeError$2 = global$b.RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
  var str = toString$7(requireObjectCoercible$4(this));
  var result = '';
  var n = toIntegerOrInfinity$2(count);
  if (n < 0 || n == Infinity) throw RangeError$2('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

var $$7 = _export;
var global$a = global$Q;
var uncurryThis$8 = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$6;
var thisNumberValue = thisNumberValue$1;
var $repeat = stringRepeat;
var fails$7 = fails$n;

var RangeError$1 = global$a.RangeError;
var String$1 = global$a.String;
var floor$4 = Math.floor;
var repeat = uncurryThis$8($repeat);
var stringSlice$7 = uncurryThis$8(''.slice);
var un$ToFixed = uncurryThis$8(1.0.toFixed);

var pow$1 = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow$1(x, n - 1, acc * x) : pow$1(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor$4(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor$4(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = String$1(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = fails$7(function () {
  return un$ToFixed(0.00008, 3) !== '0.000' ||
    un$ToFixed(0.9, 0) !== '1' ||
    un$ToFixed(1.255, 2) !== '1.25' ||
    un$ToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails$7(function () {
  // V8 ~ Android 4.3-
  un$ToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$$7({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity$1(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    if (fractDigits < 0 || fractDigits > 20) throw RangeError$1('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String$1(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow$1(2, 69, 1)) - 69;
      z = e < 0 ? number * pow$1(2, -e, 1) : number / pow$1(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow$1(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice$7(result, 0, k - fractDigits) + '.' + stringSlice$7(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

var circleVariants = variant({
  prop: 'variant',
  scale: 'progressCircle.circle',
  variants: {
    "default": {}
  }
});
var groupVariants = variant({
  prop: 'variant',
  scale: 'progressCircle.group',
  variants: {
    "default": {}
  }
});
var labelVariants = variant({
  prop: 'variant',
  scale: 'progressCircle.label',
  variants: {
    "default": {}
  }
});
var composeVariables = [shadow, position, grid, typography$1, space$1, layout, flexbox, border, position, color$1, shadow, background];
var circleStyleProps = compose.apply(void 0, [circleVariants].concat(composeVariables));
var groupStyleProps = compose.apply(void 0, [groupVariants].concat(composeVariables));
var labelStyleProps = compose.apply(void 0, [labelVariants].concat(composeVariables));
var StyledCircle = /*#__PURE__*/styled.circle.withConfig({
  displayName: "helpers__StyledCircle",
  componentId: "sc-1byy06d-0"
})(["", ""], circleStyleProps);
var StyledLabel = /*#__PURE__*/styled.div.withConfig({
  displayName: "helpers__StyledLabel",
  componentId: "sc-1byy06d-1"
})(["", ""], labelStyleProps);
var StyledGroup = /*#__PURE__*/styled.g.withConfig({
  displayName: "helpers__StyledGroup",
  componentId: "sc-1byy06d-2"
})(["", ""], groupStyleProps);
var cleanPercentage = function cleanPercentage(percentage) {
  var tooLow = !Number.isFinite(+percentage) || percentage < 0;
  var tooHigh = percentage > 100;
  return tooLow ? 0 : tooHigh ? 100 : +percentage;
};
var Circle = function Circle(_ref) {
  var variant = _ref.variant,
    pct = _ref.pct;
  if (!pct && typeof pct === 'number') console.log('pct', pct);
  var r = 30;
  var circ = 2 * Math.PI * r;
  var strokePct = (100 - pct) * circ / 100;
  return /*#__PURE__*/jsx(StyledCircle, {
    variant: variant,
    strokeDasharray: circ,
    strokeDashoffset: pct || !pct && typeof pct === 'number' ? strokePct : 0,
    strokeLinecap: "round",
    r: "30",
    cy: "35",
    cx: "35"
  });
};

var _excluded$7 = ["percentage", "variant"];
var variants$1 = variant({
  prop: 'variant',
  scale: 'progressCircle.svg',
  variants: {
    "default": {}
  }
});
var styleProps$6 = compose(variants$1, shadow, position, grid, typography$1, space$1, layout, flexbox, border, position, color$1, shadow, background);
var StyledSVG = /*#__PURE__*/styled.svg.withConfig({
  displayName: "ProgressCircle__StyledSVG",
  componentId: "sc-1kvpmbd-0"
})(["", ""], styleProps$6);
var ProgressCircle = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var percentage = _ref.percentage,
    variant = _ref.variant,
    others = _objectWithoutProperties(_ref, _excluded$7);
  var pct = cleanPercentage(percentage);
  return /*#__PURE__*/jsxs(View, Object.assign({
    position: "relative"
  }, others, {
    ref: ref,
    children: [/*#__PURE__*/jsx(StyledLabel, {
      variant: variant,
      children: /*#__PURE__*/jsxs(View, {
        fontSize: "18px"
        // @TODO: Update when Open Sans is rolled out
        ,
        fontFamily: openSans(),
        fontWeight: "700",
        lineHeight: "24px",
        margin: "0",
        children: [pct.toFixed(0), "%"]
      })
    }), /*#__PURE__*/jsx(StyledSVG, {
      variant: variant,
      children: /*#__PURE__*/jsxs(StyledGroup, {
        variant: variant,
        children: [/*#__PURE__*/jsx(Circle, {
          variant: "".concat(variant, "Background")
        }), /*#__PURE__*/jsx(Circle, {
          variant: variant,
          pct: pct
        })]
      })
    })]
  }));
});
ProgressCircle.displayName = 'ProgressCircle';

// define available progressCircle variants
var progressCircleVariants = ['rating'];
ProgressCircle.propTypes = {
  variant: PropTypes.oneOf(progressCircleVariants)
};
ProgressCircle.defaultProps = {
  variant: 'rating'
};

var customStyles = {
  control: function control(base, state) {
    return Object.assign({}, base, {
      dataQa: 'pagination',
      height: 48,
      width: 95,
      border: state.selectProps.menuIsOpen ? "1px solid ".concat(_wcImport4.neutral[30]) : "1px solid ".concat(_wcImport4.neutral[30]),
      boxShadow: 'none',
      borderColor: _wcImport4.neutral[30],
      boxSizing: 'border-box',
      borderRadius: 6,
      color: _wcImport4.neutral[80],
      '&:hover': {
        borderColor: _wcImport4.neutral[30]
      }
    });
  },
  menu: function menu(base) {
    return Object.assign({}, base, {
      border: "1px solid ".concat(_wcImport4.neutral[30]),
      boxShadow: '0px 4px 8px rgba(26, 26, 26, 0.2)',
      borderRadius: 6,
      marginTop: 4,
      marginBottom: 4
    });
  },
  option: function option(base, state) {
    return Object.assign({}, base, {
      backgroundColor: state.isSelected ? _wcImport4.secondary[30] : 'white',
      color: _wcImport4.neutral[80],
      '&:hover': {
        background: _wcImport4.secondary[10],
        color: _wcImport4.neutral[80]
      }
    });
  },
  singleValue: function singleValue(base) {
    return Object.assign({}, base, {
      color: _wcImport4.neutral[80]
    });
  }
};
var DropdownIndicator = function DropdownIndicator(props) {
  var menuIsOpen = props.selectProps.menuIsOpen;
  var iconVariant = menuIsOpen ? 'chevron_up_16' : 'chevron_down_16';
  return /*#__PURE__*/jsx(components.DropdownIndicator, Object.assign({}, props, {
    children: /*#__PURE__*/jsx(Icon$1, {
      fillColor: "none",
      outlineColor: "#374660",
      variant: iconVariant
    })
  }));
};

var Control = function Control(props) {
  return /*#__PURE__*/jsx("div", {
    "data-qa": "pagination-control",
    children: /*#__PURE__*/jsx(components.Control, Object.assign({}, props))
  });
};
var PaginationSelect = function PaginationSelect(_ref) {
  var options = _ref.options,
    defaultPage = _ref.defaultPage,
    menuPlacement = _ref.menuPlacement,
    _onChange = _ref.onChange;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOption = _useState2[0],
    setSelectedOption = _useState2[1];
  useEffect(function () {
    var defaultOption = defaultPage ? options.find(function (x) {
      return x.value === +defaultPage;
    }) : null;
    setSelectedOption(defaultOption);
  }, [defaultPage, options]);
  return /*#__PURE__*/jsx(Select, {
    "data-qa": "pagination-select",
    defaultValue: selectedOption,
    onChange: function onChange(e) {
      setSelectedOption(e);
      _onChange(e.value);
    },
    options: options,
    value: selectedOption,
    maxMenuHeight: 160,
    menuPlacement: menuPlacement,
    styles: customStyles,
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      DropdownIndicator: DropdownIndicator,
      Control: Control
    }
  });
};
var DropDownContainer = /*#__PURE__*/styled('div').withConfig({
  displayName: "Pagination__DropDownContainer",
  componentId: "sc-19etbhl-0"
})(["width:274px;position:relative;"]);
var DropDown = /*#__PURE__*/styled('div').withConfig({
  displayName: "Pagination__DropDown",
  componentId: "sc-19etbhl-1"
})(["display:flex;align-items:center;"]);
var Pagination = function Pagination(_ref2) {
  var total = _ref2.total,
    page = _ref2.page,
    menuPlacement = _ref2.menuPlacement,
    onChange = _ref2.onChange;
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    elements = _useState4[0],
    setElemetns = _useState4[1];
  useEffect(function () {
    var options = [];
    for (var i = 1; i <= total; i++) {
      options.push({
        label: i,
        value: i
      });
    }
    setElemetns(options);
  }, [total]);
  var handlePageChange = function handlePageChange(p) {
    onChange(p);
  };
  var getButtonCustomStyles = function getButtonCustomStyles(position, disabled) {
    var customStyles = {
      height: '40px',
      width: '85px',
      padding: '10px 12px'
    };
    if (position === 'left') {
      customStyles = Object.assign({}, customStyles, {
        marginRight: '4px'
      });
    } else {
      customStyles = Object.assign({}, customStyles, {
        marginLeft: '4px'
      });
    }
    if (!disabled) {
      customStyles = Object.assign({}, customStyles, {
        '&:hover': {
          backgroundColor: _wcImport4.secondary[20]
        }
      });
    }
    return customStyles;
  };
  return /*#__PURE__*/jsx(DropDownContainer, {
    children: /*#__PURE__*/jsxs(DropDown, {
      children: [/*#__PURE__*/jsx(_StyledButton$a, {
        "data-qa": "pagination-previous",
        leftIcon: /*#__PURE__*/jsx(Icon$1, {
          fillColor: "none",
          outlineColor: "#374660",
          variant: "chevron_left_16"
        }),
        onPress: function onPress() {
          var goTo = parseInt(page) - 1;
          handlePageChange(goTo);
        },
        variant: "secondaryText",
        disabled: page.toString() === '1',
        $_css: getButtonCustomStyles('left', page.toString() === '1'),
        children: "Prev"
      }), /*#__PURE__*/jsx(PaginationSelect, {
        total: total,
        defaultPage: page,
        options: elements,
        onChange: function onChange(value) {
          handlePageChange(value);
        },
        menuPlacement: menuPlacement
      }), /*#__PURE__*/jsx(_StyledButton2$5, {
        "data-qa": "pagination-next",
        rightIcon: /*#__PURE__*/jsx(Icon$1, {
          fillColor: "none",
          outlineColor: "#374660",
          variant: "chevron_right_16"
        }),
        onPress: function onPress() {
          var goTo = parseInt(page) + 1;
          handlePageChange(goTo);
        },
        variant: "secondaryText",
        disabled: page.toString() === total.toString(),
        marginLeft: "4px",
        height: "40px",
        width: "85px",
        padding: "10px 12px",
        $_css2: getButtonCustomStyles('right', page.toString() === total.toString()),
        children: "Next"
      })]
    })
  });
};
Pagination.displayName = 'Pagination';
Pagination.propTypes = {
  total: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  page: PropTypes.number,
  menuPlacement: PropTypes.oneOf(['bottom', 'top', 'auto'])
};
Pagination.defaultProps = {
  page: 1,
  menuPlacement: 'auto'
};
var Pagination$1 = Pagination;
var _StyledButton$a = /*#__PURE__*/styled(Button$1).withConfig({
  displayName: "Pagination___StyledButton",
  componentId: "sc-19etbhl-2"
})(["", ""], function (p) {
  return p.$_css;
});
var _StyledButton2$5 = /*#__PURE__*/styled(Button$1).withConfig({
  displayName: "Pagination___StyledButton2",
  componentId: "sc-19etbhl-3"
})(["", ""], function (p) {
  return p.$_css2;
});

var preventEvent = function preventEvent(e) {
  e.preventDefault();
};
var variants = variant({
  prop: 'variant',
  scale: 'link.linkVariants',
  variants: {
    "default": {}
  }
});
var styleProps$5 = compose(variants, shadow, position, grid, typography$1, space$1, layout, flexbox, border, position, color$1, shadow, background);
var StyledLink = /*#__PURE__*/styled('a').withConfig({
  displayName: "Link__StyledLink",
  componentId: "sc-sgb34o-0"
})(styleProps$5);
var BaseLink = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'inline' : _props$variant,
    _props$target = props.target,
    target = _props$target === void 0 ? '_blank' : _props$target,
    href = props.href,
    _props$icon = props.icon,
    icon = _props$icon === void 0 ? false : _props$icon,
    testId = props.testId,
    onClick = props.onClick,
    onMouseDown = props.onMouseDown,
    rest = __rest(props, ["children", "variant", "target", "href", "icon", "testId", "onClick", "onMouseDown"]);
  var hrefString = href;
  if (!children) {
    return null;
  }
  return jsxs(StyledLink, Object.assign({
    "data-testid": testId
  }, rest, {
    href: hrefString ? hrefString : undefined,
    variant: variant,
    // safari mobile bug fix
    onTouchStart: preventEvent,
    target: target,
    onMouseDown: onMouseDown,
    onClick: onClick,
    ref: ref
  }, {
    children: [children, variant === 'standalone' && icon && jsx(Icon$1, {
      variant: "chevron_right_16"
    }, void 0)]
  }), void 0);
});
BaseLink.displayName = 'BaseLink';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var Link = /*#__PURE__*/forwardRef(function (props, ref) {
  // const router = useRouter();
  var href = props.href,
    children = props.children,
    rest = __rest(props, ["href", "children"]);
  if (!children) {
    return null;
  }
  var hrefString = href;
  return jsx(BaseLink, Object.assign({}, rest, {
    href: hrefString ? hrefString : undefined,
    ref: ref
  }, {
    children: children
  }), void 0);
});
Link.displayName = 'Link';
var Link$1 = Link;

var InfoButtonContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var handleClick = _ref.handleClick;
  return /*#__PURE__*/jsx(Button$1, {
    ref: ref,
    width: '32px',
    onPress: handleClick,
    "aria-label": "ratings info",
    leftIcon: /*#__PURE__*/jsx(Icon$1, {
      outlineColor: "#353535",
      variant: "info_16"
    }),
    variant: "secondaryText"
  });
});
InfoButtonContainer.displayName = 'InfoButtonContainer';
InfoButtonContainer.propTypes = {
  handleClick: PropTypes.func.isRequired
};

var _excluded$6 = ["text", "isOpen", "onClose"];
var TextContainer = function TextContainer(_ref) {
  var text = _ref.text,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    others = _objectWithoutProperties(_ref, _excluded$6);
  var wrapperRef = useRef(null);
  function useOutsideAlerter(ref) {
    useEffect(function () {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          onClose();
        }
      }
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return function () {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(wrapperRef);
  return /*#__PURE__*/jsx(_StyledDiv$1, {
    children: isOpen ? /*#__PURE__*/jsx(_StyledView$7, Object.assign({
      "data-qa": "popover-text",
      fontSize: "14px",
      lineHeight: "24px",
      fontWeight: "400",
      marginTop: "7px",
      ref: wrapperRef
    }, others, {
      $_css: _wcImport4.neutral_30,
      $_css2: _wcImport4.neutral_100,
      children: text
    })) : null
  });
};
var _StyledDiv$1 = styled("div")({
  position: 'absolute'
});
var _StyledView$7 = /*#__PURE__*/styled(View).withConfig({
  displayName: "TextContainer___StyledView",
  componentId: "sc-12p75zg-0"
})(function (p) {
  return {
    backgroundColor: 'white',
    position: 'absolute',
    zIndex: 2,
    borderRadius: '4px',
    borderColor: p.$_css,
    color: p.$_css2,
    marginTop: '4px',
    padding: '12px 10px',
    width: '328px',
    height: '72px',
    boxShadow: '0px 4px 8px rgba(53, 53, 53, 0.2)'
  };
});

var PopOver = function PopOver(_ref) {
  var _ref$message = _ref.message,
    message = _ref$message === void 0 ? '' : _ref$message;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuIsOpen = _useState2[0],
    setMenuIsOpen = _useState2[1];
  var bodyRef = useRef();
  var handleClick = function handleClick() {
    setMenuIsOpen(!menuIsOpen);
  };
  var expansionHandler = function expansionHandler(state) {
    setMenuIsOpen(state);
  };
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    jsxs(View, Object.assign({
      onMouseEnter: function onMouseEnter() {
        return expansionHandler(true);
      },
      onMouseLeave: function onMouseLeave() {
        return expansionHandler(false);
      }
    }, {
      children: [jsx(InfoButtonContainer
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      , {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        handleClick: handleClick,
        ref: bodyRef
      }, void 0), menuIsOpen && jsx(TextContainer, {
        text: message,
        isOpen: menuIsOpen,
        onClose: function onClose() {
          return setMenuIsOpen(false);
        }
      }, void 0)]
    }), void 0)
  );
};
PopOver.displayName = 'PopOver';
var PopOver$1 = PopOver;

function useRoveFocus(size) {
  var open = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentFocus = _useState2[0],
    setCurrentFocus = _useState2[1];
  var _useState3 = useState(open),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var handleKeyDown = useCallback(function (e) {
    if (e.keyCode === 40) {
      // Down arrow
      e.preventDefault();
      setCurrentFocus(currentFocus === size - 1 ? 0 : currentFocus + 1);
    } else if (e.keyCode === 38) {
      // Up arrow
      e.preventDefault();
      setCurrentFocus(currentFocus === 0 ? size - 1 : currentFocus - 1);
    }
  }, [size, currentFocus, setCurrentFocus]);
  useEffect(function () {
    document.addEventListener('keydown', handleKeyDown, true);
    return function () {
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [handleKeyDown]);
  return [currentFocus, setCurrentFocus, isOpen, setIsOpen];
}

var StyledItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "MenuItem__StyledItem",
  componentId: "sc-8cc7w8-0"
})(["", ";"], function (props) {
  return css(Object.assign({
    display: 'flex',
    alignItems: 'center',
    minHeight: '48px',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignContent: 'center',
    justifyContent: 'flex-start',
    minWidth: '160px',
    color: '#353535',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#f0f2f5'
    },
    ':focus-visible': {
      border: '0px none',
      outline: 'none',
      backgroundColor: '#ECF2FE'
    },
    ':focus': {
      border: '0px none',
      outline: 'none',
      backgroundColor: '#ECF2FE'
    }
  }, props));
});
var StyledMenuIconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "MenuItem__StyledMenuIconWrapper",
  componentId: "sc-8cc7w8-1"
})(["", ";"], function (props) {
  return css(Object.assign({
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '8px 8px 8px 16px',
    cursor: 'pointer',
    ':focus': {
      outline: 'none'
    }
  }, props));
});
var StyledMenuItemContentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "MenuItem__StyledMenuItemContentWrapper",
  componentId: "sc-8cc7w8-2"
})(["", ";"], function (props) {
  return css(Object.assign({
    fontSize: '14px',
    margin: '8px 16px 8px 8px',
    color: '#353535',
    cursor: 'pointer',
    ':focus': {
      outline: 'none'
    }
  }, props));
});
function MenuItem(_ref) {
  var itemId = _ref.itemId,
    itemIconChild = _ref.itemIconChild,
    itemText = _ref.itemText,
    focus = _ref.focus,
    onClick = _ref.onClick,
    _ref$noClose = _ref.noClose,
    noClose = _ref$noClose === void 0 ? false : _ref$noClose,
    visibilityHandler = _ref.visibilityHandler;
  var ref = useRef(null);
  useEffect(function () {
    if (focus) {
      ref.current.focus();
    }
  }, [focus, itemText]);
  var handleKeyPress = function handleKeyPress(e) {
    var isEvent = e.target; //this might need to be finetuned
    if (isEvent) {
      e.stopPropagation();
      if (e.keyCode === 13 || e.key === 13) {
        handleItemClick(e);
      }
    }
  };
  var handleItemClick = function handleItemClick(e) {
    var isEvent = e.target; //this might need to be finetuned
    if (isEvent && typeof onClick == 'function') {
      onClick({
        itemId: itemId,
        itemText: itemText
      });
      if (!noClose) visibilityHandler(false);
    }
  };
  return /*#__PURE__*/jsxs(StyledItem, {
    tabIndex: 0,
    role: "button",
    ref: ref,
    onTouchStart: function onTouchStart() {
      return null;
    },
    onClick: handleItemClick,
    onKeyDown: handleKeyPress,
    children: [/*#__PURE__*/jsx(StyledMenuIconWrapper, {
      children: itemIconChild
    }), /*#__PURE__*/jsx(StyledMenuItemContentWrapper, {
      children: itemText
    })]
  });
}

var _excluded$5 = ["items", "children", "onVisibilityChange", "isOpen", "useParentToggle", "anyWhereClose"];
var StyledMenu = /*#__PURE__*/styled.ul.withConfig({
  displayName: "Menu__StyledMenu",
  componentId: "sc-8xpd0m-0"
})(["position:absolute;border-radius:4px;padding:8px 0px;box-shadow:0px 4px 8px rgba(53,53,53,0.2);z-index:2;background-color:white;margin-top:8px;width:max-content;"]);
var Blanket = function Blanket(props) {
  return /*#__PURE__*/jsx(_StyledDiv, Object.assign({}, props));
};
var Menu = /*#__PURE__*/forwardRef(function (props, ref) {
  var items = props.items,
    children = props.children,
    onVisibilityChange = props.onVisibilityChange,
    _props$isOpen = props.isOpen,
    open = _props$isOpen === void 0 ? false : _props$isOpen,
    _props$useParentToggl = props.useParentToggle,
    useParentToggle = _props$useParentToggl === void 0 ? false : _props$useParentToggl,
    _props$anyWhereClose = props.anyWhereClose,
    anyWhereClose = _props$anyWhereClose === void 0 ? true : _props$anyWhereClose,
    otherPops = _objectWithoutProperties(props, _excluded$5);
  var _useRoveFocus = useRoveFocus(items.length),
    _useRoveFocus2 = _slicedToArray(_useRoveFocus, 4),
    focus = _useRoveFocus2[0],
    setFocus = _useRoveFocus2[1],
    isOpen = _useRoveFocus2[2],
    setIsOpen = _useRoveFocus2[3];
  var handleVisibilityChange = function handleVisibilityChange() {
    var visibility = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (onVisibilityChange) {
      onVisibilityChange(visibility);
    }
    setIsOpen(visibility);
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(View, Object.assign({
      "data-qa": "menu-wrapper",
      className: "menu-wrapper",
      ref: ref,
      position: "relative"
    }, otherPops, {
      onClick: function onClick() {
        if (anyWhereClose) handleVisibilityChange(!isOpen);else handleVisibilityChange(true);
      },
      children: [children, /*#__PURE__*/jsx("div", {
        style: {
          display: !useParentToggle && isOpen || useParentToggle && open ? 'block' : 'none'
        },
        children: /*#__PURE__*/jsx(StyledMenu, {
          role: "menu",
          children: items.map(function (item, i) {
            return /*#__PURE__*/jsx(MenuItem, Object.assign({
              setFocus: setFocus,
              index: i,
              focus: focus === i,
              tabIndex: focus ? 0 : -1
            }, item, {
              visibilityHandler: handleVisibilityChange
            }), item.itemText + i);
          })
        })
      })]
    })), isOpen ? /*#__PURE__*/jsx(Blanket, {
      onClick: function onClick() {
        handleVisibilityChange();
      }
    }) : null]
  });
});
Menu.defaultProps = {
  onVisibilityChange: null
};
Menu.propTypes = {
  Items: PropTypes.arrayOf(PropTypes.shape({
    itemId: PropTypes.string.isRequired,
    itemIconChild: PropTypes.element,
    itemText: PropTypes.string.isRequired,
    onClick: PropTypes.func
  }).isRequired),
  onVisibilityChange: PropTypes.func
};
Menu.displayName = 'Menu';
var Menu$1 = Menu;
var _StyledDiv = /*#__PURE__*/styled("div").withConfig({
  displayName: "Menu___StyledDiv",
  componentId: "sc-8xpd0m-1"
})({
  bottom: 0,
  left: 0,
  top: 0,
  right: 0,
  position: 'fixed',
  zIndex: 1
});

var _excluded$4 = ["rating", "children"];
var styleProps$4 = compose(shadow, position, grid, typography$1, space$1, layout, flexbox, border, position, color$1, shadow, background);
var Styled = /*#__PURE__*/styled.div.withConfig({
  displayName: "Ratings__Styled",
  componentId: "sc-xsmcjn-0"
})(["", ""], styleProps$4);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var Ratings = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var rating = _ref.rating;
    _ref.children;
    var others = _objectWithoutProperties(_ref, _excluded$4);
  var WingIcons = function WingIcons() {
    var components = [];
    var wholeNumbers = Math.floor(rating);
    var remainder = rating - wholeNumbers;
    for (var i = 0; i < wholeNumbers; i++) {
      components.push( /*#__PURE__*/jsx(Icon$1, {
        pr: "6px",
        variant: "ratingWing_20",
        percentageFilledProp: 1
      }));
    }
    if (remainder) {
      components.push( /*#__PURE__*/jsx(Icon$1, {
        pr: "6px",
        variant: "ratingWing_20",
        percentageFilledProp: remainder
      }));
    }
    return components;
  };
  return /*#__PURE__*/jsx(Styled, Object.assign({
    ref: ref
  }, others, {
    children: /*#__PURE__*/jsxs(View, {
      display: "flex",
      alignItems: "baseline",
      children: [/*#__PURE__*/jsx(WingIcons, {}), /*#__PURE__*/jsx(View
      // @TODO: Update when Open Sans is rolled out
      , {
        fontFamily: oswald(),
        fontSize: "28px",
        fontWeight: 300,
        lineHeight: "40px",
        letterSpacing: "-0.47px",
        margin: "0",
        pl: "5px",
        children: rating
      })]
    })
  }));
});
Ratings.displayName = 'Ratings';
Ratings.propTypes = {
  rating: PropTypes.number
};
Ratings.defaultProps = {};

var _excluded$3 = ["icon", "variant", "subtext", "children"],
  _excluded2 = ["children"];
var composeItems = [shadow, position, grid, typography$1, space$1, layout, flexbox, border, position, color$1, shadow, background];
var ulVariants = variant({
  prop: 'variant',
  scale: 'list.list',
  variants: {
    "default": {}
  }
});
var styleListProps = compose.apply(void 0, [ulVariants].concat(composeItems));
var StyledList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "List__StyledList",
  componentId: "sc-n5bmo7-0"
})(["", ""], styleListProps);
var listItemVariant = variant({
  prop: 'variant',
  scale: 'list.item',
  variants: {
    "default": {}
  }
});
var styleListItemProps = compose.apply(void 0, [listItemVariant].concat(composeItems));
var StyledListItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "List__StyledListItem",
  componentId: "sc-n5bmo7-1"
})(["", ""], styleListItemProps);
var ListItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
    variant = _ref.variant,
    subtext = _ref.subtext,
    children = _ref.children,
    others = _objectWithoutProperties(_ref, _excluded$3);
  if (icon) {
    return /*#__PURE__*/jsxs(StyledListItem, Object.assign({
      ref: ref,
      variant: variant
    }, others, {
      children: [/*#__PURE__*/jsx(View, {
        children: icon
      }), /*#__PURE__*/jsxs(View, {
        pt: "4px",
        pl: "10px",
        children: [/*#__PURE__*/jsx(View, {
          as: "span",
          fontSize: "16px",
          lineHeight: "24px",
          margin: "0",
          children: children
        }), subtext && /*#__PURE__*/jsx(View, {
          as: "span",
          fontSize: "13px",
          lineHeight: "16px",
          color: "neutral.80",
          margin: "8px 0 0 0",
          children: subtext
        })]
      })]
    }));
  }
  return /*#__PURE__*/jsx(StyledListItem, Object.assign({
    ref: ref,
    variant: variant
  }, others, {
    children: /*#__PURE__*/jsx(Text$1, {
      as: "span",
      children: children
    })
  }));
});
ListItem.displayName = 'ListItem';
var List = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    others = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/jsx(StyledList, Object.assign({
    ref: ref
  }, others, {
    children: children
  }));
});
List.displayName = 'List';

// define available list variants
var listVariants = ['bullet', 'icon'];
List.propTypes = {
  variant: PropTypes.oneOf(listVariants)
};
List.defaultProps = {
  variant: 'bullet'
};

/**
 * __Grid context__
 *
 * Provides contextual information which is used by both
 * the `Grid` and its `GridColumn` children.
 *
 * @internal
 */
var GridContext = /*#__PURE__*/createContext({
  isRoot: true,
  isNested: false,
  removeGutterPadding: false,
  spacing: defaultSpacing
});

var styleProps$3 = compose(background, display, flexbox, margin, padding, position, flex, flexDirection, shadow, typography$1, margin, space$1, border, width, height, minWidth, minHeight, maxWidth, maxHeight, display, verticalAlign, overflow, overflowX, overflowY);
var StyledPage = /*#__PURE__*/styled('div').withConfig({
  displayName: "page__StyledPage",
  componentId: "sc-16w657t-0"
})(system({
  gridSpacing: {
    properties: ['paddingLeft', 'paddingRight'],
    transform: function transform(value) {
      return value ? "".concat(value, "px") : undefined;
    }
  },
  gridMargin: {
    properties: ['marginLeft', 'marginRight'],
    transform: function transform(value) {
      if (value === 'auto') {
        return 'auto';
      }
      return value ? "-".concat(value, "px") : undefined;
    }
  }
}), styleProps$3);
/**
 * __Page__
 *
 * Used to build page layouts.
 */
var Page = function Page(_a) {
  var children = _a.children,
    layout = _a.layout,
    testId = _a.testId,
    others = __rest(_a, ["children", "layout", "testId"]);
  return jsx(StyledPage, Object.assign({
    maxWidth: layout === 'fixed' ? {
      xs: '548px',
      md: '1152px'
    } : undefined,
    margin: layout === 'fixed' ? '0 auto' : undefined,
    "data-testid": testId
  }, others, {
    children: children
  }), void 0);
};

/**
 * __Page__
 *
 * Wrapper for a page containing a grid layout.
 */
var PageWrapper = function PageWrapper(_a) {
  var layout = _a.layout,
    testId = _a.testId,
    children = _a.children,
    _a$removeGutterPaddin = _a.removeGutterPadding,
    pageRemoveGutter = _a$removeGutterPaddin === void 0 ? false : _a$removeGutterPaddin,
    others = __rest(_a, ["layout", "testId", "children", "removeGutterPadding"]);
  /**
   * isRoot is `true` only in the default context (i.e. no ancestor Grid).
   */
  var _useContext = useContext(GridContext),
    isRoot = _useContext.isRoot,
    removeGutterPadding = _useContext.removeGutterPadding;
  var contextValue = useMemo(function () {
    return {
      isRoot: true,
      isNested: !isRoot,
      spacing: removeGutterPadding || pageRemoveGutter ? undefined : defaultSpacing,
      removeGutterPadding: removeGutterPadding || pageRemoveGutter
    };
  }, [isRoot, pageRemoveGutter, removeGutterPadding]);
  return jsx(Page, Object.assign({
    layout: layout,
    testId: testId
  }, others, {
    children: jsx(GridContext.Provider, Object.assign({
      value: contextValue
    }, {
      children: children
    }), void 0)
  }), void 0);
};
var PageWrapper$1 = PageWrapper;

var styleProps$2 = compose(background, display, flexbox, margin, padding, position, flex, flexDirection, shadow, typography$1, space$1, border, width, height, minWidth, minHeight, maxWidth, maxHeight, display, verticalAlign, overflow, overflowX, overflowY);
var StyledGrid = /*#__PURE__*/styled('div').withConfig({
  displayName: "grid__StyledGrid",
  componentId: "sc-h0ltfc-0"
})({
  display: 'flex',
  boxSizing: 'border-box',
  margin: '0 auto',
  position: 'relative',
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  width: 'auto'
}, system({
  gridSpacing: {
    properties: ['paddingLeft', 'paddingRight'],
    transform: function transform(value) {
      return value ? "".concat(value, "px") : undefined;
    }
  },
  gridMargin: {
    properties: ['marginLeft', 'marginRight'],
    transform: function transform(value) {
      if (value === 'auto') {
        return 'auto';
      }
      return value ? "-".concat(value, "px") : undefined;
    }
  }
}), styleProps$2);
var Grid$1 = function Grid(_a) {
  var _a$layout = _a.layout,
    layout = _a$layout === void 0 ? defaultLayout : _a$layout,
    testId = _a.testId,
    children = _a.children,
    props = __rest(_a, ["layout", "testId", "children"]);
  var _useContext = useContext(GridContext),
    isNested = _useContext.isNested,
    spacing = _useContext.spacing;
  return jsx(StyledGrid, Object.assign({
    maxWidth: layout === 'fixed' ? {
      xs: '548px',
      md: '1152px'
    } : undefined,
    gridSpacing: !isNested ? spacing : undefined,
    gridMargin: isNested ? spacing : 'auto',
    "data-testid": testId
  }, props, {
    children: children
  }), void 0);
};

/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 */
var GridWrapper = function GridWrapper(_a) {
  var _a$spacing = _a.spacing,
    spacing = _a$spacing === void 0 ? defaultSpacing : _a$spacing,
    layout = _a.layout,
    testId = _a.testId,
    children = _a.children,
    _a$removeGutterPaddin = _a.removeGutterPadding,
    gridRemoveGutter = _a$removeGutterPaddin === void 0 ? false : _a$removeGutterPaddin,
    props = __rest(_a, ["spacing", "layout", "testId", "children", "removeGutterPadding"]);
  /**
   * isRoot is `true` only in the default context (i.e. no ancestor Grid).
   */
  var _useContext = useContext(GridContext),
    isRoot = _useContext.isRoot,
    removeGutterPadding = _useContext.removeGutterPadding;
  var contextValue = useMemo(function () {
    return {
      isRoot: false,
      isNested: !isRoot,
      spacing: removeGutterPadding || gridRemoveGutter ? undefined : spacing,
      removeGutterPadding: removeGutterPadding || gridRemoveGutter
    };
  }, [spacing, isRoot, removeGutterPadding, gridRemoveGutter]);
  return jsx(GridContext.Provider, Object.assign({
    value: contextValue
  }, {
    children: jsx(Grid$1, Object.assign({
      layout: layout,
      testId: testId
    }, props, {
      children: children
    }), void 0)
  }), void 0);
};
var Grid = GridWrapper;

var styleProps$1 = compose(background, display, flexbox, margin, padding, position, flex, flexDirection, shadow, typography$1, space$1, border, width, height, minWidth, minHeight, maxWidth, maxHeight, display, verticalAlign, overflow, overflowX, overflowY);
var StyledColumn = /*#__PURE__*/styled('div').withConfig({
  displayName: "grid-column__StyledColumn",
  componentId: "sc-1daj0ht-0"
})({
  boxSizing: 'border-box',
  flex: '1 0 auto',
  wordWrap: 'break-word',
  maxWidth: '100%'
}, system({
  transition: true,
  offset: {
    property: 'marginLeft',
    transform: function transform(value) {
      return value ? "".concat(100 / 12 * value, "%") : undefined;
    }
  },
  gridSpacing: {
    properties: ['paddingLeft', 'paddingRight'],
    transform: function transform(value) {
      return value ? "".concat(value, "px") : undefined;
    }
  },
  size: {
    properties: ['maxWidth', 'flexBasis'],
    transform: function transform(value) {
      return value ? "".concat(100 / 12 * value, "%") : undefined;
    }
  }
}), styleProps$1);
var GridColumn = function GridColumn(_a) {
  var children = _a.children,
    size = _a.size,
    testId = _a.testId,
    props = __rest(_a, ["children", "size", "testId"]);
  var _useContext = useContext(GridContext),
    spacing = _useContext.spacing;
  return jsx(StyledColumn, Object.assign({
    gridSpacing: spacing,
    size: size,
    "data-testid": testId
  }, props, {
    children: children
  }), void 0);
};
var GridColumn$1 = GridColumn;

var styleProps = compose(shadow, position, grid, typography$1, space$1, layout, flexbox, border, position, color$1, background, display);

// Color Variant
var displayColorVariant = variant({
  prop: 'color',
  scale: 'switch.displayColorVariant',
  variants: {
    // need one member to enable theming
    "default": {}
  }
});

// Size variant for switch display
var displaySizeVariant = variant({
  prop: 'size',
  scale: 'switch.displaySizeVariant',
  variants: {
    // need one member to enable theming
    "default": {}
  }
});

// Hidden Variant
var hiddenSizeVariant = variant({
  prop: 'size',
  scale: 'switch.hiddenInputVariants',
  variants: {
    // need one member to enable theming
    "default": {}
  }
});

//  Switch Container Varinat
var switchInputContainerVariant = variant({
  prop: 'size',
  scale: 'switch.switchInputContainerVariant',
  variants: {
    // need one member to enable theming
    "default": {}
  }
});

// Swtich Label Variant
var switchLabelVariant = variant({
  prop: 'size',
  scale: 'switch.switchLabelVariant',
  variants: {
    // need one member to enable theming
    "default": {}
  }
});

// Switch Wrapper
var SwitchWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "helpers__SwitchWrapper",
  componentId: "sc-tqa4z2-0"
})(["display:flex;align-items:center;", ""], styleProps);

//  Switch Container Input ================
var switchInputContainerProps = compose(switchInputContainerVariant);
var SwitchInputContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "helpers__SwitchInputContainer",
  componentId: "sc-tqa4z2-1"
})(["", ""], switchInputContainerProps);

//  Hidden Input ================
var inputProps = compose(displayColorVariant, hiddenSizeVariant);
var HiddenInput$1 = /*#__PURE__*/styled.input.attrs({
  className: 'styled-input'
}).withConfig({
  displayName: "helpers__HiddenInput",
  componentId: "sc-tqa4z2-2"
})(["", ""], inputProps);

// Styled Switch
var switchDisplayProps = compose(displaySizeVariant);
var StyledSwitch = /*#__PURE__*/styled.div.withConfig({
  displayName: "helpers__StyledSwitch",
  componentId: "sc-tqa4z2-3"
})(["", ""], switchDisplayProps);

// Switch Label Props
var switchLabelProps = compose(switchLabelVariant);
var SwitchLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "helpers__SwitchLabel",
  componentId: "sc-tqa4z2-4"
})(["", ";", ""], function (props) {
  return styledCss({
    margin: "".concat(props.labelMargin || '0 0 0 0')
  });
}, switchLabelProps);

var _excluded$2 = ["id", "children", "size", "color", "disabled", "onChange", "checked", "label", "labelMargin"];
var Switch = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var id = _ref.id;
    _ref.children;
    var size = _ref.size,
    color = _ref.color,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    checked = _ref.checked,
    label = _ref.label,
    labelMargin = _ref.labelMargin,
    others = _objectWithoutProperties(_ref, _excluded$2);
  var randomId = Math.round(Math.random() * 100000);
  return /*#__PURE__*/jsxs(SwitchWrapper, Object.assign({}, others, {
    children: [label ? /*#__PURE__*/jsx(SwitchLabel, {
      size: size,
      labelMargin: labelMargin,
      children: label
    }) : null, /*#__PURE__*/jsxs(SwitchInputContainer, {
      ref: ref,
      size: size,
      checked: checked,
      children: [/*#__PURE__*/jsx(HiddenInput$1, {
        type: "checkbox",
        id: id || randomId,
        size: size,
        color: color,
        checked: checked,
        disabled: disabled,
        onChange: onChange
      }), /*#__PURE__*/jsx(StyledSwitch, {
        size: size,
        htmlFor: id || randomId
      }), /*#__PURE__*/jsx(Icon$1, {
        className: "toggle-svg-container",
        variant: checked ? 'check_16' : 'close_16',
        outlineColor: _wcImport4.neutral[0]
      })]
    })]
  }));
});
Switch.displayName = 'Switch';

// define available switch variants
var colorVariants$2 = ['purple'];
var sizeVariants$2 = ['medium', 'large'];
Switch.propTypes = {
  color: PropTypes.oneOf(colorVariants$2),
  size: PropTypes.oneOf(sizeVariants$2),
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  labelMargin: PropTypes.string
};
Switch.defaultProps = {
  color: 'purple',
  size: 'medium',
  checked: false,
  disabled: false,
  label: null
};

var HeaderLink = function HeaderLink(_ref) {
  var emitMetric = _ref.emitMetric,
    metricLocation = _ref.metricLocation,
    text = _ref.text,
    href = _ref.href,
    disabled = _ref.disabled,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    className = _ref.className,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? {
      _: 'block'
    } : _ref$display,
    _ref$openInNewTab = _ref.openInNewTab,
    openInNewTab = _ref$openInNewTab === void 0 ? false : _ref$openInNewTab,
    _ref$noMarginRight = _ref.noMarginRight,
    noMarginRight = _ref$noMarginRight === void 0 ? false : _ref$noMarginRight;
  var fireMetric = function fireMetric() {
    if (emitMetric) {
      emitMetric({
        misc_event_type: "top-nav-".concat(metricLocation, "-click"),
        misc_event_count: 1
      });
    }
  };
  var margin = small ? '10px' : '21px';
  return /*#__PURE__*/jsx(_StyledLink$2, {
    target: openInNewTab ? "_blank" : "_self",
    variant: "single",
    href: href,
    mt: margin,
    mb: margin,
    className: "header-link ".concat(className),
    onClick: fireMetric,
    fontSize: {
      _: '16px'
    },
    fontWeight: {
      _: '400'
    },
    fontFamily: "Open Sans",
    display: display,
    title: text,
    $_css: disabled ? '0' : '1',
    $_css2: disabled ? 'opacity 0.15s ease-out' : 'none',
    $_css3: noMarginRight ? '0px' : '15px',
    $_css4: noMarginRight ? '0px' : '21px',
    children: text
  });
};
var _StyledLink$2 = /*#__PURE__*/styled(Link$1).withConfig({
  displayName: "HeaderLink___StyledLink",
  componentId: "sc-1b5hn03-0"
})(function (p) {
  return {
    textDecoration: 'none',
    color: 'white !important',
    opacity: p.$_css,
    transition: p.$_css2,
    transitionDelay: '0.4s',
    height: '26px',
    lineHeight: '26px',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    marginLeft: '15px',
    marginRight: p.$_css3,
    ':hover': {
      textShadow: ' 0 0 0.65px #fff, 0 0 0.65px #fff'
    },
    '@media (min-width: 1440px)': {
      marginLeft: '21px',
      marginRight: p.$_css4
    }
  };
});

var HeaderMenuLinks = function HeaderMenuLinks(_ref) {
  var emitMetric = _ref.emitMetric,
    metricLocation = _ref.metricLocation,
    _ref$userMenu = _ref.userMenu,
    userMenu = _ref$userMenu === void 0 ? false : _ref$userMenu,
    text = _ref.text,
    className = _ref.className,
    href = _ref.href,
    _ref$additionalPaddin = _ref.additionalPadding,
    additionalPadding = _ref$additionalPaddin === void 0 ? 0 : _ref$additionalPaddin,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? {
      _: 'block'
    } : _ref$display,
    useOldBreakPoints = _ref.useOldBreakPoints,
    _ref$alertText = _ref.alertText,
    alertText = _ref$alertText === void 0 ? 0 : _ref$alertText,
    _ref$isLast = _ref.isLast,
    isLast = _ref$isLast === void 0 ? false : _ref$isLast,
    _ref$openInNewTab = _ref.openInNewTab,
    openInNewTab = _ref$openInNewTab === void 0 ? false : _ref$openInNewTab;
  var _trueViewPort = trueViewPort(useOldBreakPoints),
    isSM = _trueViewPort.isSM;
  var fireMetric = function fireMetric() {
    if (emitMetric) {
      var type = userMenu ? 'user-nav' : 'mobile-hamburger-click';
      var suffix = userMenu ? '-click' : '';
      emitMetric({
        misc_event_type: "".concat(type, "-").concat(metricLocation).concat(suffix),
        misc_event_count: 1
      });
    }
  };
  var leftPadding = 22 + additionalPadding;
  var leftText = text === 'Network' ? '93px' : '99px';
  if (isSM) {
    leftText = text === 'Network' ? '100px' : '106px';
  }
  return /*#__PURE__*/jsxs(_StyledLink$1, {
    target: openInNewTab ? "_blank" : "_self",
    variant: "single",
    href: href,
    className: className,
    pt: {
      _: '15px'
    },
    pb: {
      _: '16px'
    },
    pl: {
      _: "".concat(leftPadding, "px")
    },
    ml: _defineProperty({
      _: '24px'
    }, "".concat(useOldBreakPoints ? "old" : '', "md"), '0px'),
    mr: _defineProperty({
      _: '24px'
    }, "".concat(useOldBreakPoints ? "old" : '', "md"), '0px'),
    fontSize: _defineProperty({
      _: '18px'
    }, "".concat(useOldBreakPoints ? "old" : '', "md"), '16px'),
    fontWeight: "400",
    onClick: fireMetric,
    display: display,
    $_css: isLast ? "1px solid ".concat(_wcImport4.neutral[40], " !important") : 'none',
    $_css2: isSM ? 'transparent' : "#F0F2F5 !important",
    $_css3: !isSM ? '1px solid #B394F2 !important' : "1px solid ".concat(_wcImport4.neutral[40], " !important"),
    children: [text, alertText > 0 && /*#__PURE__*/jsx(_StyledView$6, {
      width: {
        _: '12px'
      },
      height: {
        _: '12px'
      },
      $_css4: leftText,
      children: alertText
    })]
  });
};
var _StyledLink$1 = styled(Link$1)(function (p) {
  return {
    position: 'relative',
    borderBottom: p.$_css,
    ':hover': {
      backgroundColor: p.$_css2,
      fontWeight: '700',
      borderTop: p.$_css3
    }
  };
});
var _StyledView$6 = /*#__PURE__*/styled(View).withConfig({
  displayName: "HeaderMenuLinks___StyledView",
  componentId: "sc-1klpxxv-0"
})(function (p) {
  return {
    color: '#ffffff',
    fontWeight: '400',
    fontSize: '8px',
    letterSpacing: '-0.4px',
    lineHeight: '11px',
    background: '#BD79C8',
    borderRadius: '50%',
    position: 'absolute',
    textAlign: 'center',
    left: p.$_css4,
    top: '17px'
  };
});

var HeaderItems = function HeaderItems(useoldBreakPoints, errorPage) {
  var md = _defineProperty({
    _: 'none'
  }, "".concat(useoldBreakPoints ? "old" : '', "md"), 'block');
  var lg = _defineProperty({
    _: 'none'
  }, "".concat(useoldBreakPoints ? "old" : '', "lg"), 'block');
  return [{
    metricLocation: 'home',
    text: 'Community',
    className: 'anchor home',
    href: '/community/feed',
    inputWidth: 700,
    display: md
  }, {
    metricLocation: 'jobs',
    text: 'Jobs',
    className: 'anchor jobs',
    href: '/jobs/filter',
    inputWidth: 800,
    display: md
  }, {
    metricLocation: 'advice',
    text: 'Advice',
    className: 'anchor advice',
    href: '/advice',
    inputWidth: 875,
    display: md
  }, {
    metricLocation: 'events',
    text: 'Events',
    className: 'anchor events',
    href: '/events',
    inputWidth: 950,
    display: md
  }, {
    metricLocation: 'reviews',
    text: 'Reviews',
    className: 'anchor reviews',
    href: '/company-reviews',
    inputWidth: 992,
    display: errorPage ? md : lg
  }];
};
var headerMenuItemsBelowFaqs = function headerMenuItemsBelowFaqs() {
  return [{
    metricLocation: 'privacy',
    text: 'Privacy Policy',
    href: '/privacy-policy'
  }, {
    metricLocation: 'terms',
    text: 'Terms & Conditions',
    href: '/terms-and-conditions'
  }];
};
var headerMenuLinksItems = function headerMenuLinksItems(isClient) {
  return [{
    metricLocation: isClient ? 'clients' : 'employers',
    text: isClient ? 'For Clients' : 'For Employers',
    href: isClient ? '/employers/dashboard' : '/employers'
  }, {
    metricLocation: 'coach-connect',
    text: 'Coach Connect',
    href: 'https://www.themuse.com/coaching?source=FGB',
    openInNewTab: true
  }, {
    metricLocation: 'reviews',
    text: 'Reviews',
    href: '/company-reviews'
  }, {
    metricLocation: 'about',
    text: 'About Fairygodboss',
    href: '/company-overview/fairygodboss-inc'
  }, {
    metricLocation: 'careers',
    text: 'Careers @ Fairygodboss',
    href: '/company/jobs/fairygodboss-inc'
  }];
};
var headerMenuUserLinksItems = function headerMenuUserLinksItems(user, useOldBreakPoints) {
  var isAdmin = user == null ? void 0 : user.isAdmin;
  var md = _defineProperty({
    _: 'block'
  }, "".concat(useOldBreakPoints ? "old" : '', "md"), 'none');
  var menuItems = [{
    metricLocation: 'posts',
    text: 'Posts',
    href: '/users/contributions/post'
  }, {
    metricLocation: 'messages',
    text: 'Messages',
    href: '/messages',
    alertText: user == null ? void 0 : user.unreadMessageCount
  }, {
    metricLocation: 'network',
    text: 'Network',
    href: '/my-network',
    alertText: user == null ? void 0 : user.pendingConnections
  }, {
    metricLocation: 'groups',
    text: 'Groups',
    href: '/my-network/my-groups'
  }, {
    metricLocation: 'profile',
    text: 'Profile',
    href: '/users/profile',
    display: md
  }, {
    metricLocation: 'settings',
    text: 'Settings',
    href: '/users/alerts'
  }];
  if (isAdmin) {
    menuItems.push({
      metricLocation: 'admin',
      text: 'Admin Access',
      href: '/management'
    });
  }
  menuItems.push({
    metricLocation: 'logout',
    text: 'Log Out',
    href: '/users/logout'
  });
  return menuItems;
};

var HeaderFaqs = function HeaderFaqs(_ref) {
  var emitMetric = _ref.emitMetric,
    useOldBreakPoints = _ref.useOldBreakPoints,
    triggerFaqMenu = _ref.triggerFaqMenu;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _trueViewPort = trueViewPort(useOldBreakPoints),
    isSM = _trueViewPort.isSM;
  var openColor = isSM ? 'transparent' : _wcImport4.secondary[5];
  var closeColor = isSM ? 'transparent' : _wcImport4.neutral[0];
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(_StyledButton$9, {
      onPress: function onPress() {
        setIsOpen(!isOpen);
        triggerFaqMenu();
        emitMetric({
          misc_event_type: 'mobile-hamburger-click-faqs',
          misc_event_count: 1,
          url: window.location.href
        });
      },
      variant: "secondaryText",
      pt: {
        _: '15px'
      },
      pb: {
        _: '16px'
      },
      pl: {
        _: '22px'
      },
      ml: _defineProperty({
        _: '24px'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), '0px'),
      mr: _defineProperty({
        _: '24px'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), '0px'),
      textAlign: "left",
      fontWeight: "400",
      fontSize: _defineProperty({
        _: '18px'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), '16px'),
      rightIcon: isOpen ? /*#__PURE__*/jsx(Icon$1, {
        variant: "chevron_down_16",
        outlineColor: _wcImport4.neutral[100]
      }) : /*#__PURE__*/jsx(Icon$1, {
        variant: "chevron_right_16",
        outlineColor: _wcImport4.neutral[100]
      }),
      $_css: isOpen ? openColor : closeColor,
      $_css2: "".concat(_wcImport4.neutral[90], " !important"),
      $_css3: isOpen ? '700' : '400',
      $_css4: !isSM && isOpen ? '1px solid #B394F2 !important' : "1px solid ".concat(_wcImport4.neutral[40]),
      $_css5: isSM ? 'transparent' : '#F0F2F5',
      $_css6: !isSM ? '1px solid #B394F2 !important' : _wcImport4.neutral[40],
      children: "FAQs"
    }), isOpen && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(HeaderMenuLinks, {
        emitMetric: emitMetric,
        metricLocation: "comguide",
        text: "Community Guidelines",
        href: "/articles/community-guidelines",
        additionalPadding: 19,
        useOldBreakPoints: useOldBreakPoints
      }), /*#__PURE__*/jsx(HeaderMenuLinks, {
        emitMetric: emitMetric,
        metricLocation: "edguide",
        text: "Editorial Guidelines",
        href: "/articles/submissions-editorial-guidelines",
        additionalPadding: 19,
        useOldBreakPoints: useOldBreakPoints
      }), /*#__PURE__*/jsx(HeaderMenuLinks, {
        emitMetric: emitMetric,
        metricLocation: "commpartners",
        text: "Community Partners",
        href: "/partners",
        additionalPadding: 19,
        useOldBreakPoints: useOldBreakPoints
      })]
    })]
  });
};
var _StyledButton$9 = /*#__PURE__*/styled(Button$1).withConfig({
  displayName: "HeaderFaqs___StyledButton",
  componentId: "sc-811civ-0"
})(function (p) {
  return {
    backgroundColor: p.$_css,
    color: p.$_css2,
    borderRadius: '0px',
    fontWeight: p.$_css3,
    borderTop: p.$_css4,
    ':hover': {
      backgroundColor: p.$_css5,
      borderTopColor: p.$_css6,
      fontWeight: '700'
    }
  };
});

var LinkedInIcon20 = function LinkedInIcon20() {
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    children: [/*#__PURE__*/jsx("title", {
      children: "Check out Fairygodboss on Linkedin"
    }), /*#__PURE__*/jsx("path", {
      d: "M6.66732 15.8333H4.16732V6.66659H6.66732V15.8333ZM5.41732 5.60992C4.61232 5.60992 3.95898 4.95159 3.95898 4.13992C3.95898 3.32826 4.61232 2.66992 5.41732 2.66992C6.22232 2.66992 6.87565 3.32826 6.87565 4.13992C6.87565 4.95159 6.22315 5.60992 5.41732 5.60992ZM16.6673 15.8333H14.1673V11.1633C14.1673 8.35659 10.834 8.56909 10.834 11.1633V15.8333H8.33398V6.66659H10.834V8.13742C11.9973 5.98242 16.6673 5.82326 16.6673 10.2008V15.8333Z",
      fill: "white"
    })]
  });
};

var TiktokIcon20 = function TiktokIcon20() {
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    children: [/*#__PURE__*/jsx("title", {
      children: "Check out Fairygodboss on TikTok"
    }), /*#__PURE__*/jsx("path", {
      d: "M16.8743 5.84278C15.892 5.81313 15.0021 5.34262 14.331 4.71371C13.9642 4.36438 13.6735 3.94294 13.4774 3.47595C13.2814 3.00896 13.184 2.50645 13.1914 2H10.4565V12.5314C10.4565 14.2518 9.42524 15.2657 8.15808 15.2657C7.82212 15.2694 7.48946 15.1994 7.18336 15.0606C6.87738 14.9219 6.60542 14.7179 6.38681 14.4627C6.16821 14.2076 6.00817 13.9076 5.91791 13.5841C5.82776 13.2605 5.80951 12.921 5.86467 12.5897C5.91983 12.2582 6.0469 11.9428 6.23702 11.6659C6.42714 11.3889 6.67573 11.1569 6.96518 10.9864C7.25463 10.8157 7.5779 10.7106 7.91237 10.6783C8.24685 10.6461 8.58441 10.6876 8.90107 10.7998V8.01878C8.65707 7.96513 8.40795 7.93878 8.15808 7.94017C7.16309 7.93996 6.19029 8.23479 5.3627 8.78732C4.53521 9.33985 3.89027 10.1253 3.50928 11.0445C3.12829 11.9634 3.02853 12.975 3.2225 13.9507C3.41657 14.9264 3.8956 15.8229 4.59912 16.5263C5.30263 17.2299 6.19915 17.709 7.17504 17.9033C8.15104 18.0974 9.16267 17.9979 10.082 17.6173C11.0014 17.2365 11.7871 16.5919 12.34 15.7647C12.8929 14.9375 13.188 13.9649 13.188 12.9702V7.3022C14.2477 8.03478 15.5137 8.38113 16.8652 8.40503L16.8743 5.84278Z",
      fill: "white"
    })]
  });
};

var HeaderMenu = function HeaderMenu(_ref) {
  var fireSignIn = _ref.fireSignIn,
    fireSignUp = _ref.fireSignUp,
    emitMetric = _ref.emitMetric,
    useOldBreakPoints = _ref.useOldBreakPoints,
    toggleUserMenu = _ref.toggleUserMenu,
    open = _ref.open,
    user = _ref.user;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFaqOpen = _useState2[0],
    setIsFaqOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loaded = _useState4[0],
    setLoaded = _useState4[1];
  var _trueViewPort = trueViewPort(useOldBreakPoints),
    isSM = _trueViewPort.isSM,
    isMD = _trueViewPort.isMD,
    orientation = _trueViewPort.orientation,
    trueHeight = _trueViewPort.height;
  var selector = useRef(null);
  var drawSelector = useRef(null);
  var toggleMenu = function toggleMenu(openStatus) {
    toggleUserMenu(openStatus ? 1 : 0);
  };
  var minusSpace = orientation === 'landscape' ? '100px' : '88px';
  useEffect(function () {
    function handleClickOutside(event) {
      if (selector.current && !selector.current.contains(event.target) && drawSelector.current && !drawSelector.current.contains(event.target) && open) {
        toggleMenu(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [selector, drawSelector, open]);
  useEffect(function () {
    setLoaded(true);
  }, []);
  var heightToUse = "calc(100vh - ".concat(minusSpace, " + env(safe-area-inset-bottom))");
  var curheight = 0;
  var defaultOverflow = 'hidden';
  if (isMD && !user && !isFaqOpen) {
    heightToUse = '700px';
    curheight = 750;
  }
  if (isMD && !user && isFaqOpen) {
    heightToUse = '900px';
    curheight = 950;
  }
  if (isMD && user && !isFaqOpen) {
    heightToUse = '575px';
    curheight = 625;
  }
  if (isMD && user && isFaqOpen) {
    heightToUse = '770px';
    curheight = 830;
  }
  if (isMD && trueHeight < curheight) {
    heightToUse = "".concat(trueHeight - 95, "px");
    defaultOverflow = 'auto';
  }
  return /*#__PURE__*/jsxs(View, {
    ref: selector,
    children: [/*#__PURE__*/jsx(_StyledButton$8, {
      variant: 'secondaryText',
      "aria-label": "menu",
      onPress: function onPress() {
        emitMetric({
          misc_event_type: 'mobile-hamburger-click',
          misc_event_count: 1
        });
        toggleMenu(!open);
      },
      ml: _defineProperty({
        _: '11px'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), '8px'),
      width: _defineProperty({
        _: '20px'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), 'auto'),
      mt: '9px',
      children: /*#__PURE__*/jsxs("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M27.52 22.4C28.2269 22.4 28.8 23.1163 28.8 24C28.8 24.8837 28.2269 25.6 27.52 25.6H4.48001C3.77309 25.6 3.20001 24.8837 3.20001 24C3.20001 23.1163 3.77309 22.4 4.48001 22.4H27.52Z",
          fill: _wcImport4.white
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M27.52 14.4C28.2269 14.4 28.8 15.1163 28.8 16C28.8 16.8837 28.2269 17.6 27.52 17.6H4.48001C3.77309 17.6 3.20001 16.8837 3.20001 16C3.20001 15.1163 3.77309 14.4 4.48001 14.4H27.52Z",
          fill: _wcImport4.white
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M27.52 6.4C28.2269 6.4 28.8 7.11634 28.8 8C28.8 8.88366 28.2269 9.6 27.52 9.6H4.48001C3.77309 9.6 3.20001 8.88366 3.20001 8C3.20001 7.11634 3.77309 6.4 4.48001 6.4H27.52Z",
          fill: _wcImport4.white
        })]
      })
    }), !loaded ? /*#__PURE__*/jsx(Fragment, {}) : /*#__PURE__*/jsx(_StyledDrawer$1, {
      id: 'qa-profile-menu',
      isOpen: open,
      onClose: function onClose() {
        setIsFaqOpen(false);
      },
      useFocusTrap: false,
      selector: selector,
      addExtraHeight: isFaqOpen ? 120 : 110,
      display: _defineProperty({
        _: 'block'
      }, "".concat(useOldBreakPoints ? "old" : '', "lg"), 'none'),
      ml: _defineProperty({
        _: '0px'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), '20px'),
      mt: _defineProperty({
        _: '103px'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), '80px'),
      fullWidth: isSM,
      background: _defineProperty({
        _: 'rgba(246, 242, 255, 1)'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), _wcImport4.neutral[0]),
      $_css: isSM ? '0px' : '6px',
      $_css2: heightToUse,
      children: /*#__PURE__*/jsxs(_StyledView$5, {
        display: "flex",
        position: "fixed",
        width: "100%",
        ref: drawSelector,
        height: _defineProperty({
          _: orientation === 'landscape' ? '55%' : '80%'
        }, "".concat(useOldBreakPoints ? "old" : '', "md"), '100%'),
        fontFamily: "Open Sans",
        flexDirection: 'column',
        $_css3: isSM || orientation === 'landscape' ? 'auto' : defaultOverflow,
        $_css4: "".concat(_wcImport4.neutral[90], " !important"),
        $_css5: "1px solid ".concat(_wcImport4.neutral[40], " !important"),
        children: [/*#__PURE__*/jsx(_StyledButton2$4, {
          onPress: function onPress() {
            return toggleMenu(false);
          },
          variant: "secondaryText",
          $_css6: isSM ? '21px' : '12px',
          $_css7: isSM ? '25px' : '0px',
          $_css8: isSM ? '21px' : '12px',
          children: /*#__PURE__*/jsx(_StyledIcon$1, {
            variant: isSM ? 'close_20' : 'close_16',
            $_css9: isSM ? '32px' : '24px',
            $_css10: isSM ? '32px' : '24px'
          })
        }), headerMenuLinksItems(user == null ? void 0 : user.isClient).map(function (item, index) {
          return /*#__PURE__*/jsx(HeaderMenuLinks, {
            openInNewTab: item.openInNewTab,
            emitMetric: emitMetric,
            metricLocation: item.metricLocation,
            href: item.href,
            text: item.text,
            useOldBreakPoints: useOldBreakPoints
          }, index);
        }), /*#__PURE__*/jsx(HeaderFaqs, {
          triggerFaqMenu: function triggerFaqMenu() {
            return setIsFaqOpen(!isFaqOpen);
          },
          useOldBreakPoints: useOldBreakPoints,
          emitMetric: emitMetric
        }), headerMenuItemsBelowFaqs().map(function (item, index) {
          return /*#__PURE__*/jsx(HeaderMenuLinks, {
            emitMetric: emitMetric,
            metricLocation: item.metricLocation,
            href: item.href,
            text: item.text,
            useOldBreakPoints: useOldBreakPoints
          }, index);
        }), /*#__PURE__*/jsxs(_StyledView2$4, {
          display: "flex",
          flexDirection: "row",
          pt: '18px',
          ml: _defineProperty({
            _: '24px'
          }, "".concat(useOldBreakPoints ? "old" : '', "md"), '0px'),
          mr: _defineProperty({
            _: '24px'
          }, "".concat(useOldBreakPoints ? "old" : '', "md"), '0px'),
          justifyContent: "space-between",
          $_css11: "1px solid ".concat(_wcImport4.neutral[40]),
          children: [/*#__PURE__*/jsx(_StyledButton3$1, {
            variant: 'secondaryText',
            onPress: function onPress() {
              return window.location = 'https://www.facebook.com/fairygodboss';
            },
            children: /*#__PURE__*/jsx(Icon$1, {
              variant: 'thumbsUpOutline_16',
              outlineColor: _wcImport4.secondary[50]
            })
          }), /*#__PURE__*/jsx(_StyledButton4, {
            variant: 'secondaryText',
            onPress: function onPress() {
              return window.location = 'https://www.instagram.com/fairygodboss/';
            },
            children: /*#__PURE__*/jsx(Icon$1, {
              variant: 'instagram_20',
              outlineColor: _wcImport4.secondary[50]
            })
          }), /*#__PURE__*/jsx(_StyledButton5, {
            variant: 'secondaryText',
            onPress: function onPress() {
              return window.location = 'https://twitter.com/Fairygodboss';
            },
            children: /*#__PURE__*/jsx(Icon$1, {
              variant: 'twitter_20',
              outlineColor: _wcImport4.secondary[50]
            })
          }), /*#__PURE__*/jsx(_StyledButton6, {
            variant: 'secondaryText',
            onPress: function onPress() {
              return window.location = 'https://www.linkedin.com/company/fairygodboss';
            },
            $_css12: "".concat(_wcImport4.secondary[50], " !important"),
            children: /*#__PURE__*/jsx(LinkedInIcon20, {})
          }), /*#__PURE__*/jsx(_StyledButton7, {
            variant: 'secondaryText',
            onPress: function onPress() {
              return window.location = 'https://www.tiktok.com/@fairygodboss/';
            },
            $_css13: "".concat(_wcImport4.secondary[50], " !important"),
            children: /*#__PURE__*/jsx(TiktokIcon20, {})
          })]
        }), !user && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(_StyledButton8, {
            variant: "primary",
            mt: _defineProperty({
              _: '38px'
            }, "".concat(useOldBreakPoints ? "old" : '', "md"), '48px'),
            onPress: function onPress() {
              toggleMenu(false);
              fireSignUp('hb');
            },
            ml: 'auto',
            mr: 'auto',
            children: "Sign up free"
          }), /*#__PURE__*/jsx(_StyledButton9, {
            onPress: function onPress() {
              toggleMenu(false);
              fireSignIn('hb');
            },
            variant: "primaryText",
            fontSize: '14px',
            fontWeight: '600',
            lineHeight: '18px',
            ml: 'auto',
            mt: _defineProperty({
              _: '27px'
            }, "".concat(useOldBreakPoints ? "old" : '', "md"), '17px'),
            mr: 'auto',
            mb: _defineProperty({
              _: '40px'
            }, "".concat(useOldBreakPoints ? "old" : '', "md"), '27px'),
            children: "Already a member? Sign in."
          })]
        })]
      })
    })]
  });
};
var _StyledButton$8 = styled(Button$1)({
  backgroundColor: 'transparent',
  ':hover': {
    backgroundColor: 'transparent!important'
  },
  'svg': {
    position: 'absolute',
    left: '-3px'
  }
});
var _StyledDrawer$1 = styled(Drawer)(function (p) {
  return {
    borderRadius: p.$_css,
    zIndex: '211 !important',
    height: p.$_css2,
    boxShadow: '0px 4px 8px rgba(53, 53, 53, 0.2)'
  };
});
var _StyledView$5 = styled(View)(function (p) {
  return {
    overflowY: p.$_css3,
    overflowX: 'hidden',
    a: {
      textDecoration: 'none !important',
      color: p.$_css4,
      lineHeight: '30px',
      opacity: '1 !important',
      marginTop: '0px!important',
      borderTop: p.$_css5
    }
  };
});
var _StyledButton2$4 = styled(Button$1)(function (p) {
  return {
    backgroundColor: 'transparent',
    marginTop: p.$_css6,
    marginLeft: 'auto',
    marginRight: p.$_css7,
    marginBottom: p.$_css8
  };
});
var _StyledIcon$1 = styled(Icon$1)(function (p) {
  return {
    svg: {
      height: p.$_css9,
      width: p.$_css10
    }
  };
});
var _StyledView2$4 = styled(View)(function (p) {
  return {
    borderTop: p.$_css11
  };
});
var _StyledButton3$1 = styled(Button$1)({
  backgroundColor: 'transparent'
});
var _StyledButton4 = styled(Button$1)({
  backgroundColor: 'transparent'
});
var _StyledButton5 = styled(Button$1)({
  backgroundColor: 'transparent'
});
var _StyledButton6 = styled(Button$1)(function (p) {
  return {
    backgroundColor: 'transparent',
    path: {
      fill: p.$_css12
    }
  };
});
var _StyledButton7 = styled(Button$1)(function (p) {
  return {
    backgroundColor: 'transparent',
    path: {
      fill: p.$_css13
    }
  };
});
var _StyledButton8 = styled(Button$1)({
  width: '117px',
  height: '40px',
  fontSize: '14px',
  fontWeight: '600',
  lineHeight: '18px',
  borderRadius: '4px',
  color: 'rgba(255, 255, 255, 1))',
  border: 'none'
});
var _StyledButton9 = /*#__PURE__*/styled(Button$1).withConfig({
  displayName: "HeaderMenu___StyledButton9",
  componentId: "sc-ofav1p-0"
})({
  backgroundColor: 'transparent'
});

var _this$1 = undefined;
var HeaderSearchBar = function HeaderSearchBar(_ref) {
  var useOldBreakPoints = _ref.useOldBreakPoints,
    inputRef = _ref.inputRef,
    openInput = _ref.openInput;
  var _useState = useState({
      value: ''
    }),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    searchOpen = _useState4[0],
    setSearchOpen = _useState4[1];
  var _trueViewPort = trueViewPort(useOldBreakPoints),
    isSM = _trueViewPort.isSM,
    isMD = _trueViewPort.isMD,
    isLG = _trueViewPort.isLG;
  var shrink = !useOldBreakPoints && isSM;
  var wrapperRef = useRef(null);
  function useOutsideAlerter(ref) {
    useEffect(function () {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setSearchOpen(false);
          openInput(false);
        }
      }
      document.addEventListener('mousedown', handleClickOutside);
      return function () {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(wrapperRef);
  useEffect(function () {
    var keyDownHandler = function keyDownHandler(event) {
      if (event.key === 'Enter' && searchOpen && searchValue.value !== '') {
        event.preventDefault();
        window.location = "/search?term=".concat(searchValue.value);
      } else if (event.key === 'Escape' && searchOpen) {
        setSearchOpen(false);
        openInput(false);
      } else if (event.key === 'Enter' && searchOpen && searchValue.value === '') {
        setSearchOpen(false);
        openInput(false);
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return function () {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [searchOpen, searchValue]);
  useEffect(function () {
    function handleResize() {
      if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        setSearchOpen(false);
        openInput(false);
      }
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  var placeholderText = isLG ? 'Search for people, employers, advice' : 'People, employers, advice, jobs';
  return /*#__PURE__*/jsxs(_StyledView$4, {
    $_css: useOldBreakPoints ? '6px' : '12px',
    $_css2: useOldBreakPoints ? '6px' : '12px',
    children: [/*#__PURE__*/jsx(_StyledButton$7, {
      name: "search",
      width: _defineProperty({
        _: 'auto'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), 'auto'),
      variant: 'secondaryText',
      "aria-label": "search",
      onPress: function onPress() {
        setSearchOpen(!searchOpen);
        openInput(!searchOpen);
        inputRef.current.focus();
      },
      mr: _defineProperty({
        _: '0px'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), '0px'),
      leftIcon: /*#__PURE__*/jsx(Icon$1, {
        outlineColor: "#ffffff",
        variant: "magnifyingGlass_24"
      }),
      $_css3: shrink ? '24px' : '32px',
      $_css4: shrink ? '24px' : '32px',
      $_css5: isSM && !useOldBreakPoints ? '0px' : '12px'
    }), /*#__PURE__*/jsx(_StyledView2$3, {
      mt: _defineProperty({
        _: '7px'
      }, "".concat(useOldBreakPoints ? "old" : '', "lg"), '11px'),
      className: searchOpen ? 'open' : 'closed',
      ref: wrapperRef,
      $_css6: isSM ? 'fixed' : 'absolute',
      $_css7: !isMD ? '-150px' : '17px',
      $_css8: !isMD ? 'initial' : '18px',
      $_css9: !isMD ? '-3px' : 'initial',
      $_css10: isSM ? '98vw' : '341px',
      $_css11: !isMD ? '1%' : '17px',
      $_css12: !isMD ? 'initial' : '18px',
      $_css13: !isMD ? '-3px' : 'initial',
      children: /*#__PURE__*/jsx(InputField, {
        height: _defineProperty({
          _: '50px'
        }, "".concat(useOldBreakPoints ? "old" : '', "md"), '48px'),
        ref: inputRef,
        handleInput: function handleInput(el) {
          return _this$1.inputElement = el;
        },
        name: "search",
        type: "text",
        placeholder: placeholderText,
        value: searchValue.value,
        useRightIcon: true,
        rightIconCursor: "pointer",
        rightIconName: "magnifyingGlass_20_light",
        rightIconClick: function rightIconClick() {
          if (searchOpen && searchValue.value !== '') {
            window.location = "/search?term=".concat(searchValue.value);
          } else {
            setSearchOpen(!searchOpen);
            openInput(!searchOpen);
            inputRef.current.focus();
          }
        },
        onChange: function onChange(e) {
          setSearchValue({
            value: e.target.value
          });
        }
      })
    })]
  });
};
var _StyledView$4 = styled(View)(function (p) {
  return {
    position: 'relative',
    top: '10px',
    marginRight: '0px',
    '@media (min-width: 768px)': {
      top: '11px',
      marginLeft: p.$_css,
      marginRight: p.$_css2
    },
    '@media (min-width: 1440px)': {
      marginRight: '12px'
    }
  };
});
var _StyledButton$7 = styled(Button$1)(function (p) {
  return {
    backgroundColor: 'transparent',
    ':hover': {
      backgroundColor: 'transparent!important'
    },
    svg: {
      width: '24px',
      height: '24px',
      '@media (min-width: 768px)': {
        width: p.$_css3,
        height: p.$_css4
      }
    },
    '@media (min-width: 768px)': {
      paddingLeft: '0px',
      paddingRight: p.$_css5
    }
  };
});
var _StyledView2$3 = /*#__PURE__*/styled(View).withConfig({
  displayName: "HeaderSearchBar___StyledView2",
  componentId: "sc-1t79ujg-0"
})(function (p) {
  return {
    position: p.$_css6,
    zIndex: '6 !important',
    transition: 'width 0.5s ease-in-out',
    width: '5vw',
    '&.closed': {
      right: p.$_css7,
      bottom: p.$_css8,
      top: p.$_css9,
      visibility: 'hidden',
      transition: 'visibility 0s ease-out',
      transitionDelay: '.14s',
      div: {
        transition: 'opacity .10s ease-out',
        transitionDelay: '.4s',
        opacity: 0
      }
    },
    '&.open': {
      width: p.$_css10,
      right: p.$_css11,
      bottom: p.$_css12,
      top: p.$_css13,
      opacity: 1,
      visibility: 'visible'
    },
    input: {
      border: '1px solid #868686',
      borderRadius: '4px',
      '::placeholder': {
        color: '#727272'
      }
    }
  };
});

var HeaderAlert = function HeaderAlert(_ref) {
  var alertCount = _ref.alertCount,
    useOldBreakPoints = _ref.useOldBreakPoints,
    emitMetric = _ref.emitMetric;
  var _trueViewPort = trueViewPort(useOldBreakPoints),
    isSM = _trueViewPort.isSM;
  // necessary to adjust old and new app design
  var shrink = !useOldBreakPoints && isSM;
  return /*#__PURE__*/jsx(_StyledButton$6, {
    width: _defineProperty({
      _: '32px'
    }, "".concat(useOldBreakPoints ? "old" : '', "md"), 'auto'),
    variant: 'secondaryText',
    className: "anchor alert-right",
    "aria-label": "user alerts",
    onPress: function onPress() {
      emitMetric({
        misc_event_type: 'top-nav-alerts-click',
        misc_event_count: 1
      });
      window.location = "/users/notifications";
    },
    leftIcon: /*#__PURE__*/jsx(Icon$1, {
      outlineColor: "#ffffff",
      variant: "notification_icon_24"
    }),
    $_css: shrink ? '21px' : '28px',
    $_css2: shrink ? '26px' : '34px',
    children: /*#__PURE__*/jsx(_StyledView$3, {
      width: _defineProperty({
        _: '9px'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), '18px'),
      height: _defineProperty({
        _: '9px'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), 'auto'),
      display: alertCount > 0 ? {
        _: 'block'
      } : {
        _: 'none'
      },
      $_css3: shrink ? '16px' : '32px',
      $_css4: shrink ? '0px' : '3px 0px',
      children: isSM ? '' : alertCount
    })
  });
};
var _StyledButton$6 = styled(Button$1)(function (p) {
  return {
    backgroundColor: 'transparent',
    ':hover': {
      backgroundColor: 'transparent!important'
    },
    svg: {
      width: '21px',
      height: '26px',
      '@media (min-width: 768px)': {
        width: p.$_css,
        height: p.$_css2
      }
    },
    span: {
      marginRight: 0
    },
    '@media (min-width: 1440px)': {
      marginRight: '6px'
    }
  };
});
var _StyledView$3 = /*#__PURE__*/styled(View).withConfig({
  displayName: "HeaderAlert___StyledView",
  componentId: "sc-ahr9wr-0"
})(function (p) {
  return {
    color: '#ffffff',
    fontWeight: '400',
    fontSize: '10px',
    letterSpacing: '-0.4px',
    lineHeight: '12px',
    background: '#BD79C8',
    borderRadius: '50%',
    position: 'absolute',
    padding: '0px',
    left: '16px',
    '@media (min-width: 768px)': {
      left: p.$_css3,
      padding: p.$_css4
    },
    top: '16px'
  };
});

var HeaderUserButton = function HeaderUserButton(_ref) {
  var user = _ref.user,
    _onPress = _ref.onPress,
    useOldBreakPoints = _ref.useOldBreakPoints;
  var _trueViewPort = trueViewPort(useOldBreakPoints),
    isSM = _trueViewPort.isSM;
  var shrink = !useOldBreakPoints && isSM;
  return /*#__PURE__*/jsx(_StyledButton$5, {
    width: _defineProperty({
      _: '37px'
    }, "".concat(useOldBreakPoints ? "old" : '', "md"), '48px'),
    "aria-label": "user menu",
    mt: '0px',
    mr: _defineProperty({
      _: '11px'
    }, "".concat(useOldBreakPoints ? "old" : '', "xl"), '0px'),
    onPress: function onPress() {
      return typeof _onPress === 'function' && _onPress();
    },
    variant: 'secondaryText',
    leftIcon: /*#__PURE__*/jsxs(_StyledView$2, {
      target: "_self",
      $_css: "circle(47px)",
      children: [/*#__PURE__*/jsx(_StyledView2$2, {
        as: "img",
        src: user.logo || 'https://d207ibygpg2z1x.cloudfront.net/image/upload/dpr_1,b_white,c_scale,g_center,r_max,q_auto,w_48,h_48/v1/avatar_black_160_vtg7lw.webp',
        alt: 'Profile Picture',
        $_css2: shrink ? '37px !important' : '48px !important',
        $_css3: shrink ? '37px !important' : '48px !important'
      }), user.isVip === 1 && /*#__PURE__*/jsx(_StyledView3$2, {
        $_css4: shrink ? '28px' : '32px !important',
        $_css5: shrink ? '24px' : '32px !important',
        $_css6: shrink ? '12px' : '16px',
        children: /*#__PURE__*/jsx(Icon$1, {
          variant: 'light_wing_16'
        })
      }), (user == null ? void 0 : user.totalCount) > 0 && /*#__PURE__*/jsx(_StyledView4$2, {
        width: _defineProperty({
          _: '9px'
        }, "".concat(useOldBreakPoints ? "old" : '', "md"), '18px'),
        height: _defineProperty({
          _: '9px'
        }, "".concat(useOldBreakPoints ? "old" : '', "md"), 'auto'),
        display: user.totalCount > 0 ? {
          _: 'block'
        } : {
          _: 'none'
        },
        $_css7: shrink ? '30px' : '36px ',
        $_css8: shrink ? '0px' : '3px 0px',
        children: shrink ? '' : user.totalCount
      })]
    })
  });
};
var _StyledButton$5 = styled(Button$1)({
  backgroundColor: 'transparent',
  minWidth: '37px !important',
  '@media (min-width: 768px)': {
    minWidth: '48px !important'
  },
  ':hover': {
    backgroundColor: 'transparent!important'
  }
});
var _StyledView$2 = styled(View)(function (p) {
  return {
    position: 'relative',
    img: {
      clipPath: p.$_css,
      height: 'max-content'
    }
  };
});
var _StyledView2$2 = styled(View)(function (p) {
  return {
    borderRadius: '47px',
    border: '1px solid white',
    width: '37px !important',
    height: '37px !important',
    '@media (min-width: 768px)': {
      width: p.$_css2,
      height: p.$_css3
    }
  };
});
var _StyledView3$2 = styled(View)(function (p) {
  return {
    svg: {
      width: '12px',
      position: 'absolute',
      left: '28px',
      top: '24px',
      '@media (min-width: 768px)': {
        left: p.$_css4,
        top: p.$_css5,
        width: p.$_css6
      }
    }
  };
});
var _StyledView4$2 = /*#__PURE__*/styled(View).withConfig({
  displayName: "HeaderUserButton___StyledView4",
  componentId: "sc-pddg12-0"
})(function (p) {
  return {
    color: 'transparent',
    fontWeight: '400',
    fontSize: '10px',
    letterSpacing: '-0.4px',
    lineHeight: '12px',
    background: '#BD79C8',
    borderRadius: '50%',
    position: 'absolute',
    padding: '0px',
    left: '30px',
    '@media (min-width: 768px)': {
      color: '#ffffff',
      left: p.$_css7,
      padding: p.$_css8
    },
    top: '3px'
  };
});

var StarSVG = function StarSVG() {
  return /*#__PURE__*/jsx("svg", {
    width: "16",
    height: "15",
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/jsx("path", {
      d: "M8 0L10.1678 5.01635L15.6085 5.52786L11.5075 9.13965L12.7023 14.4721L8 11.688L3.29772 14.4721L4.4925 9.13965L0.391548 5.52786L5.83225 5.01635L8 0Z",
      fill: "#B394F2"
    })
  });
};

var HeaderUserMenu = function HeaderUserMenu(_ref) {
  var emitMetric = _ref.emitMetric,
    useOldBreakPoints = _ref.useOldBreakPoints,
    user = _ref.user,
    toggleUserMenu = _ref.toggleUserMenu,
    open = _ref.open;
  var _trueViewPort = trueViewPort(useOldBreakPoints),
    isSM = _trueViewPort.isSM,
    isMD = _trueViewPort.isMD,
    trueHeight = _trueViewPort.height,
    orientation = _trueViewPort.orientation;
  var selector = React.useRef(null);
  var toggleMenu = function toggleMenu(openStatus) {
    toggleUserMenu(openStatus ? 2 : 0);
  };
  useEffect(function () {
    function handleClickOutside(event) {
      if (selector.current && !selector.current.contains(event.target) && open) {
        toggleMenu(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [selector, open, toggleMenu]);
  var minusSpace = orientation === 'landscape' ? '100px' : '0px';
  var heightToUse = "calc(100vh - ".concat(minusSpace, " + env(safe-area-inset-bottom))");
  if (isMD && trueHeight >= 520) {
    heightToUse = user != null && user.isAdmin ? '520px' : '460px';
  }
  if (isMD && trueHeight < 585) {
    heightToUse = "".concat(trueHeight - 95, "px");
  }
  return /*#__PURE__*/jsxs(_StyledView$1, {
    mt: '3px',
    ref: selector,
    children: [/*#__PURE__*/jsx(HeaderUserButton, {
      user: user,
      onPress: function onPress() {
        emitMetric({
          misc_event_type: 'top-nav-me-click',
          misc_event_count: 1
        });
        toggleMenu(!open);
      },
      useOldBreakPoints: useOldBreakPoints
    }), typeof window == 'undefined' ? /*#__PURE__*/jsx(Fragment, {
      children: " "
    }) : /*#__PURE__*/jsx(_StyledDrawer, {
      id: 'qa-header-menu',
      isOpen: open,
      useFocusTrap: false,
      selector: selector,
      position: "right",
      ml: {
        _: '0px'
      },
      mr: {
        _: '0px'
      },
      mt: _defineProperty({
        _: '103px'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), '80px'),
      fullWidth: isSM,
      background: _defineProperty({
        _: 'rgba(246, 242, 255, 1)'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), _wcImport4.neutral[0]),
      $_css: isSM ? '0px' : '6px',
      $_css2: heightToUse,
      $_css3: isSM ? '100%' : '430px',
      $_css4: isSM ? 'fixed' : 'absolute',
      children: /*#__PURE__*/jsxs(_StyledView2$1, {
        display: "flex",
        position: "fixed",
        width: "100%",
        height: _defineProperty({
          _: orientation === 'landscape' ? '55%' : '80%'
        }, "".concat(useOldBreakPoints ? "old" : '', "md"), '100%'),
        fontFamily: "Open Sans",
        flexDirection: 'column',
        $_css5: isSM || orientation === 'landscape' ? 'auto' : 'hidden',
        $_css6: "".concat(_wcImport4.neutral[90], " !important"),
        $_css7: "1px solid ".concat(_wcImport4.neutral[40], " !important"),
        $_css8: !isSM ? '1px solid #B394F2 !important' : "1px solid ".concat(_wcImport4.neutral[40], " !important"),
        children: [/*#__PURE__*/jsxs(_StyledView3$1, {
          display: _defineProperty({
            _: 'none'
          }, "".concat(useOldBreakPoints ? "old" : '', "md"), 'flex'),
          flexDirection: "row",
          pt: '10px',
          pb: '9px',
          ml: '16px',
          mt: '10px',
          children: [/*#__PURE__*/jsxs(_StyledView4$1, {
            as: "a",
            className: "userInfo",
            href: "/users/profile",
            onClick: function onClick() {
              emitMetric({
                misc_event_type: 'user-nav-profile-click',
                misc_event_count: 1,
                url: window.location.href
              });
            },
            mr: '16px',
            target: "_self",
            $_css9: "circle(48px)",
            children: [/*#__PURE__*/jsx(_StyledView5, {
              as: "img",
              "className-": 'user-image',
              src: user.logo || 'https://d207ibygpg2z1x.cloudfront.net/image/upload/dpr_1,b_white,c_scale,g_center,r_max,q_auto,w_48,h_48/v1/avatar_black_160_vtg7lw.webp',
              width: '48px',
              alt: 'Profile Picture'
            }), user.isVip === 1 && /*#__PURE__*/jsx(_StyledView6, {
              children: /*#__PURE__*/jsx(View, {
                as: "img",
                src: 'https://d207ibygpg2z1x.cloudfront.net/image/upload/c_scale,g_center,r_max,w_16,h_16/v1/SVGs/VIP_LARGE.svg'
              })
            })]
          }), /*#__PURE__*/jsx(View, {
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "column",
            ml: '16px',
            mt: '4px',
            children: /*#__PURE__*/jsxs(View, {
              display: "flex",
              flexDirection: {
                _: 'column'
              },
              alignItems: {
                _: 'start'
              },
              flexWrap: "wrap",
              children: [/*#__PURE__*/jsx(View, {
                display: "flex",
                children: /*#__PURE__*/jsxs(_StyledText, {
                  as: "a",
                  href: "/users/profile",
                  onClick: function onClick() {
                    emitMetric({
                      misc_event_type: 'user-nav-profile-click',
                      misc_event_count: 1,
                      url: window.location.href
                    });
                  },
                  fontWeight: "700",
                  margin: "0",
                  fontSize: "14px",
                  textAlign: "left",
                  variant: "labelMd",
                  letterSpacing: "-0.4px",
                  lineHeight: "18px",
                  color: _wcImport4.neutral[100],
                  $_css10: "".concat(_wcImport4.neutral[100], " !important"),
                  $_css11: "1 !important",
                  $_css12: "".concat(_wcImport4.neutral[80], " !important"),
                  children: [user.username.length > 20 ? user.username.slice(0, 20) + '...' : user.username, user.karmaScore ? /*#__PURE__*/jsxs(Text$1, {
                    pr: _defineProperty({
                      _: '0'
                    }, "".concat(useOldBreakPoints ? "old" : '', "lg"), '12px'),
                    pl: _defineProperty({
                      _: '4px'
                    }, "".concat(useOldBreakPoints ? "old" : '', "md"), '12px'),
                    color: _wcImport4.neutral[100],
                    variant: "labelMd",
                    fontWeight: "400",
                    children: [/*#__PURE__*/jsx(_StyledView7, {
                      as: "span",
                      children: /*#__PURE__*/jsx(StarSVG, {})
                    }), user.karmaScore]
                  }) : null]
                })
              }), /*#__PURE__*/jsx(_StyledLink, {
                href: "/users/profile",
                pt: {
                  _: '2px'
                },
                fontWeight: 400,
                target: "_self",
                fontSize: "14px",
                letterSpacing: "-0.4px",
                color: '#7D268B !important',
                onClick: function onClick() {
                  emitMetric({
                    misc_event_type: 'user-nav-profile-click',
                    misc_event_count: 1,
                    url: window.location.href
                  });
                },
                variant: "labelMd",
                children: "View profile"
              })]
            })
          }), /*#__PURE__*/jsx(View, {
            children: /*#__PURE__*/jsx(_StyledButton$4, {
              onPress: function onPress() {
                return toggleMenu(false);
              },
              variant: "secondaryText",
              $_css13: isSM ? '21px' : '0px',
              $_css14: isSM ? '25px' : '0px',
              $_css15: isSM ? '21px' : '12px',
              children: /*#__PURE__*/jsx(_StyledIcon, {
                variant: isSM ? 'close_20' : 'close_16',
                $_css16: isSM ? '32px' : '24px',
                $_css17: isSM ? '32px' : '24px'
              })
            })
          })]
        }), /*#__PURE__*/jsx(_StyledButton2$3, {
          display: _defineProperty({
            _: 'block'
          }, "".concat(useOldBreakPoints ? "old" : '', "md"), 'none'),
          onPress: function onPress() {
            return toggleMenu(false);
          },
          variant: "secondaryText",
          "aria-label": "Menu",
          $_css18: isSM ? '21px' : '12px',
          $_css19: isSM ? '25px' : '0px',
          $_css20: isSM ? '21px' : '12px',
          children: /*#__PURE__*/jsx(_StyledIcon2, {
            variant: isSM ? 'close_20' : 'close_16',
            $_css21: isSM ? '32px' : '24px',
            $_css22: isSM ? '32px' : '24px'
          })
        }), headerMenuUserLinksItems(user, useOldBreakPoints).map(function (item, index) {
          return /*#__PURE__*/jsx(HeaderMenuLinks, {
            className: "header-menu-links",
            metricLocation: item.metricLocation,
            emitMetric: emitMetric,
            href: item.href,
            alertText: item.alertText,
            useOldBreakPoints: useOldBreakPoints,
            display: item.display ? item.display : 'block',
            text: item.text,
            userMenu: true,
            isLast: item.text === 'Log Out' && isSM
          }, index);
        })]
      })
    })]
  });
};
var _StyledView$1 = styled(View)({
  position: 'relative',
  overflow: 'initial !important',
  minWidth: '37px !important',
  '@media (min-width: 768px)': {
    minWidth: '48px !important'
  }
});
var _StyledDrawer = styled(Drawer)(function (p) {
  return {
    borderRadius: p.$_css,
    boxShadow: '0px 4px 8px rgba(53, 53, 53, 0.2)',
    zIndex: '211 !important',
    height: p.$_css2,
    width: p.$_css3,
    position: p.$_css4
  };
});
var _StyledView2$1 = styled(View)(function (p) {
  return {
    overflowY: p.$_css5,
    overflowX: 'hidden !important',
    '.header-menu-links': {
      textDecoration: 'none !important',
      color: p.$_css6,
      lineHeight: '30px',
      opacity: '1 !important',
      marginTop: '0px!important',
      borderTop: p.$_css7,
      ':hover': {
        borderTop: p.$_css8
      }
    },
    '.userInfo': {
      borderTop: 'none !important',
      ':hover': {
        borderTop: 'none !important',
        backgroundColor: 'transparent !important',
        fontWeight: 400,
        cursor: 'initial !important'
      }
    }
  };
});
var _StyledView3$1 = styled(View)({
  cursor: 'initial'
});
var _StyledView4$1 = styled(View)(function (p) {
  return {
    opacity: '1 !important',
    textDecoration: 'none',
    position: 'relative',
    img: {
      clipPath: p.$_css9,
      height: 'max-content'
    }
  };
});
var _StyledView5 = styled(View)({
  borderRadius: '48px'
});
var _StyledView6 = styled(View)({
  img: {
    width: '16px',
    position: 'absolute',
    left: '32px',
    top: '32px'
  }
});
var _StyledText = styled(Text$1)(function (p) {
  return {
    width: '287px',
    textDecoration: 'none !important',
    color: p.$_css10,
    fontWeight: 700,
    ':hover': {
      opacity: p.$_css11,
      color: p.$_css12
    }
  };
});
var _StyledView7 = styled(View)({
  position: 'relative',
  top: '2px'
});
var _StyledLink = styled(Link$1)({
  textDecoration: 'none !important',
  ':hover': {
    opacity: '.7 !important'
  }
});
var _StyledButton$4 = styled(Button$1)(function (p) {
  return {
    backgroundColor: 'transparent',
    marginTop: p.$_css13,
    marginLeft: 'auto',
    marginRight: p.$_css14,
    marginBottom: p.$_css15
  };
});
var _StyledIcon = styled(Icon$1)(function (p) {
  return {
    svg: {
      height: p.$_css16,
      width: p.$_css17
    }
  };
});
var _StyledButton2$3 = styled(Button$1)(function (p) {
  return {
    backgroundColor: 'transparent',
    marginTop: p.$_css18,
    marginLeft: 'auto',
    marginRight: p.$_css19,
    marginBottom: p.$_css20
  };
});
var _StyledIcon2 = /*#__PURE__*/styled(Icon$1).withConfig({
  displayName: "HeaderUserMenu___StyledIcon2",
  componentId: "sc-176fwup-0"
})(function (p) {
  return {
    svg: {
      height: p.$_css21,
      width: p.$_css22
    }
  };
});

var Header = function Header(_ref) {
  var _ref$user = _ref.user,
    user = _ref$user === void 0 ? null : _ref$user,
    _ref$errorPage = _ref.errorPage,
    errorPage = _ref$errorPage === void 0 ? false : _ref$errorPage,
    _ref$emitMetric = _ref.emitMetric,
    emitMetric = _ref$emitMetric === void 0 ? null : _ref$emitMetric,
    _ref$onSigninClick = _ref.onSigninClick,
    onSigninClick = _ref$onSigninClick === void 0 ? null : _ref$onSigninClick,
    _ref$onSignupClick = _ref.onSignupClick,
    onSignupClick = _ref$onSignupClick === void 0 ? null : _ref$onSignupClick,
    _ref$useOldBreakPoint = _ref.useOldBreakPoints,
    useOldBreakPoints = _ref$useOldBreakPoint === void 0 ? false : _ref$useOldBreakPoint,
    _ref$storyBookTest = _ref.storyBookTest,
    storyBookTest = _ref$storyBookTest === void 0 ? false : _ref$storyBookTest,
    _ref$developmentMode = _ref.developmentMode,
    developmentMode = _ref$developmentMode === void 0 ? false : _ref$developmentMode;
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeHeaderIndex = _React$useState2[0],
    setActiveHeaderIndex = _React$useState2[1];
  var _trueViewPort = trueViewPort(useOldBreakPoints),
    width = _trueViewPort.width,
    isMD = _trueViewPort.isMD,
    isLG = _trueViewPort.isLG;
  var inputRef = useRef(null);
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    inputOpen = _React$useState4[0],
    setOpenInput = _React$useState4[1];
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  var trueEmitMetric = errorPage ? function () {} : emitMetric;
  var fireSignUp = function fireSignUp() {
    var side = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'nav';
    if (onSignupClick) {
      onSignupClick();
    }
    if (trueEmitMetric) {
      emitMetric({
        login_trigger: "".concat(side, "-signup"),
        login_opened: 1,
        url: window.location.href
      });
    }
  };
  var fireSignIn = function fireSignIn() {
    var side = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'nav';
    if (onSigninClick) {
      onSigninClick();
    }
    if (trueEmitMetric) {
      var signIntext = 'signin';
      if (width >= 992) {
        signIntext = 'login';
      }
      emitMetric({
        login_trigger: "".concat(side, "-").concat(signIntext),
        login_opened: 1,
        url: window.location.href
      });
    }
  };
  return /*#__PURE__*/jsxs(View, {
    backgroundColor: _wcImport4.primary[70],
    width: "100%",
    position: "fixed",
    top: storyBookTest && developmentMode ? "300px" : "0px",
    height: _defineProperty({
      _: '56px'
    }, "".concat(useOldBreakPoints ? "old" : '', "md"), '68px'),
    children: [/*#__PURE__*/jsxs(View, {
      display: "flex",
      fontFamily: "Open Sans",
      maxWidth: "1185px",
      height: '100%',
      ml: _defineProperty({
        _: '0px'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), 'auto'),
      mr: _defineProperty(_defineProperty(_defineProperty({
        _: '0px'
      }, "".concat(useOldBreakPoints ? "old" : '', "sm"), '0px'), "".concat(useOldBreakPoints ? "old" : '', "md"), 'auto'), "".concat(useOldBreakPoints ? "old" : '', "lg"), 'auto'),
      children: [/*#__PURE__*/jsx(_StyledView, {
        className: 'logoWider',
        mt: '18px',
        mr: '8px',
        height: "32px",
        as: "a",
        href: "/",
        "aria-label": "home",
        onClick: function onClick() {
          if (trueEmitMetric) {
            trueEmitMetric({
              misc_event_type: 'top-nav-home-click',
              misc_event_count: 1
            });
          }
        },
        children: IconPaths['wide_logo_32'](_wcImport4.neutral[0], _wcImport4.neutral[0], '24px')
      }), /*#__PURE__*/jsx(_StyledView2, {
        className: 'logoWider',
        mt: '21px',
        mr: '8px',
        height: "32px",
        as: "a",
        href: "/",
        "aria-label": "home",
        onClick: function onClick() {
          if (trueEmitMetric) {
            trueEmitMetric({
              misc_event_type: 'top-nav-home-click',
              misc_event_count: 1
            });
          }
        },
        $_css: isMD && isLG ? 'flex' : 'none',
        $_css2: useOldBreakPoints ? '5px' : '11px',
        children: IconPaths['wide_logo_24'](_wcImport4.neutral[0], _wcImport4.neutral[0], '24px')
      }), /*#__PURE__*/jsxs(View, {
        display: _defineProperty({
          _: 'flex'
        }, "".concat(useOldBreakPoints ? "old" : '', "lg"), 'none'),
        flexDirection: "row",
        width: _defineProperty({
          _: '100%'
        }, "".concat(useOldBreakPoints ? "old" : '', "md"), 'initial'),
        children: [!errorPage && /*#__PURE__*/jsx(HeaderMenu, {
          fireSignIn: fireSignIn,
          fireSignUp: fireSignUp,
          emitMetric: trueEmitMetric,
          toggleUserMenu: function toggleUserMenu(index) {
            setActiveHeaderIndex(index);
          },
          open: activeHeaderIndex === 1,
          useOldBreakPoints: useOldBreakPoints,
          user: user
        }), /*#__PURE__*/jsx(_StyledView3, {
          as: "a",
          pl: _defineProperty({
            _: errorPage ? '11px' : '0px'
          }, "".concat(useOldBreakPoints ? "old" : '', "sm"), '24px'),
          mt: '21px',
          height: "32px",
          href: "/",
          "aria-label": "home",
          flex: 1,
          onClick: function onClick() {
            if (trueEmitMetric) {
              trueEmitMetric({
                misc_event_type: 'top-nav-home-click',
                misc_event_count: 1
              });
            }
          },
          children: IconPaths['wide_logo_24'](_wcImport4.neutral[0], _wcImport4.neutral[0], '24px')
        }), !user && !errorPage && /*#__PURE__*/jsx(_StyledButton$3, {
          display: _defineProperty(_defineProperty({}, "".concat(useOldBreakPoints ? "old" : '', "sm"), 'block'), "".concat(useOldBreakPoints ? "old" : '', "md"), 'none'),
          variant: "secondary",
          color: _wcImport4.secondary[70],
          height: '40px',
          ml: 'auto',
          mt: '11px',
          mr: '9px',
          onPress: function onPress() {
            return fireSignUp();
          },
          children: "Get Started"
        })]
      }), errorPage && /*#__PURE__*/jsx(View, {
        width: "50px",
        display: "flex",
        justifyContent: "flex-end"
      }), HeaderItems(useOldBreakPoints, errorPage).map(function (item, index) {
        return /*#__PURE__*/jsx(HeaderLink, {
          emitMetric: trueEmitMetric,
          metricLocation: item.metricLocation,
          text: item.text,
          href: item.href,
          disabled: inputOpen && width < item.inputWidth,
          useOldBreakPoints: useOldBreakPoints,
          className: item.className,
          display: item.display
        }, index);
      }), /*#__PURE__*/jsx(HeaderLink, {
        metricLocation: "employers",
        text: "For Employers",
        href: "/employers",
        emitMetric: trueEmitMetric,
        useOldBreakPoints: useOldBreakPoints,
        disabled: inputOpen && width < 1132 || inputOpen && width > 1440,
        display: user != null && user.isClient && !errorPage ? {
          _: 'none'
        } : _defineProperty({
          _: 'none'
        }, "".concat(useOldBreakPoints ? "old" : '', "lg"), 'block')
      }), /*#__PURE__*/jsx(HeaderLink, {
        metricLocation: "clients",
        text: "For Clients",
        href: "/employers/dashboard",
        emitMetric: trueEmitMetric,
        useOldBreakPoints: useOldBreakPoints,
        disabled: inputOpen && width < 1110 || inputOpen && width > 1440,
        display: !(user != null && user.isClient) || errorPage ? {
          _: 'none'
        } : _defineProperty({
          _: 'none'
        }, "".concat(useOldBreakPoints ? "old" : '', "lg"), 'block')
      }), /*#__PURE__*/jsx(HeaderLink, {
        openInNewTab: true,
        metricLocation: "coach-connect",
        text: "Coach Connect",
        href: "https://www.themuse.com/coaching?source=FGB",
        emitMetric: trueEmitMetric,
        useOldBreakPoints: useOldBreakPoints,
        noMarginRight: true,
        disabled: inputOpen,
        display: _defineProperty({
          _: 'none'
        }, "".concat(useOldBreakPoints ? "old" : '', "lg"), 'block')
      }), user && !errorPage && /*#__PURE__*/jsxs(View, {
        display: "flex",
        marginLeft: "auto",
        children: [/*#__PURE__*/jsx(View, {
          width: {
            _: '0px',
            lg: '60px'
          },
          display: "flex",
          justifyContent: "flex-end"
        }), /*#__PURE__*/jsx(HeaderAlert, {
          alertCount: user.alerts,
          useOldBreakPoints: useOldBreakPoints,
          emitMetric: trueEmitMetric
        }), /*#__PURE__*/jsx(HeaderSearchBar, {
          useOldBreakPoints: useOldBreakPoints,
          inputRef: inputRef,
          openInput: function openInput(value) {
            setOpenInput(value);
          }
        }), /*#__PURE__*/jsx(HeaderUserMenu, {
          user: user,
          emitMetric: trueEmitMetric,
          useOldBreakPoints: useOldBreakPoints,
          toggleUserMenu: function toggleUserMenu(index) {
            setActiveHeaderIndex(index);
          },
          open: activeHeaderIndex === 2
        })]
      }), !user && !errorPage && /*#__PURE__*/jsx(_StyledButton2$2, {
        variant: "secondary",
        size: "small",
        fontSize: _defineProperty({
          _: '14px'
        }, "".concat(useOldBreakPoints ? "old" : '', "lg"), '16px'),
        mt: "10px",
        ml: "auto",
        mr: "9px",
        display: _defineProperty({
          _: 'none'
        }, "".concat(useOldBreakPoints ? "old" : '', "md"), 'block'),
        onPress: function onPress() {
          return fireSignUp();
        },
        $_css3: _wcImport4.secondary[70],
        children: "Get Started"
      }), errorPage && /*#__PURE__*/jsx(View, {
        width: "50px",
        display: "flex",
        justifyContent: "flex-end"
      })]
    }), /*#__PURE__*/jsxs(View, {
      display: _defineProperty({
        _: 'flex'
      }, "".concat(useOldBreakPoints ? "old" : '', "md"), 'none'),
      backgroundColor: _wcImport4.primary[60],
      width: '100%',
      position: "fixed",
      top: "".concat((storyBookTest && developmentMode ? 300 : 0) + 56, "px"),
      justifyContent: "space-around",
      children: [/*#__PURE__*/jsx(HeaderLink, {
        metricLocation: "community",
        text: "Community",
        href: "/community/feed",
        emitMetric: trueEmitMetric,
        useOldBreakPoints: useOldBreakPoints,
        small: true
      }), /*#__PURE__*/jsx(HeaderLink, {
        metricLocation: "jobs",
        text: "Jobs",
        href: "/jobs/filter",
        useOldBreakPoints: useOldBreakPoints,
        emitMetric: trueEmitMetric,
        small: true
      }), /*#__PURE__*/jsx(HeaderLink, {
        metricLocation: "advice",
        text: "Advice",
        href: "/advice",
        useOldBreakPoints: useOldBreakPoints,
        emitMetric: trueEmitMetric,
        small: true
      }), /*#__PURE__*/jsx(HeaderLink, {
        metricLocation: "events",
        text: "Events",
        href: "/events",
        useOldBreakPoints: useOldBreakPoints,
        emitMetric: trueEmitMetric,
        small: true
      })]
    }), developmentMode && /*#__PURE__*/jsxs(_StyledView4, {
      width: '100%',
      position: "fixed",
      top: "".concat((storyBookTest && developmentMode ? 300 : 0) + 110, "px"),
      justifyContent: "space-around",
      children: ["\u2B06\uFE0F Using Old Breakpoints: ", String(useOldBreakPoints).toUpperCase(), " \u2B06\uFE0F"]
    })]
  });
};
var _StyledView = styled(View)({
  display: 'none',
  alignItems: 'center',
  '@media (min-width: 1440px)': {
    display: 'flex'
  }
});
var _StyledView2 = styled(View)(function (p) {
  return {
    display: p.$_css,
    alignItems: 'center',
    marginLeft: p.$_css2,
    '@media (min-width: 1440px)': {
      display: 'none'
    }
  };
});
var _StyledView3 = styled(View)({
  marginTop: '21px',
  ':hover': {
    textDecoration: 'none',
    opacity: '1 !important'
  }
});
var _StyledButton$3 = styled(Button$1)({
  borderColor: '#22385E'
});
var _StyledButton2$2 = styled(Button$1)(function (p) {
  return {
    height: '48px',
    borderRadius: '4px',
    color: p.$_css3,
    padding: '8px 20px',
    border: 'border: 1px solid #22385E;',
    '@media (max-width: 998px)': {
      padding: '8px 10px'
    },
    '@media (max-width: 767px)': {
      display: 'none'
    }
  };
});
var _StyledView4 = /*#__PURE__*/styled(View).withConfig({
  displayName: "Header___StyledView4",
  componentId: "sc-w2y10u-0"
})({
  fontSize: 'x-large',
  display: 'flex',
  justifyContent: 'center'
});

var uncurryThis$7 = functionUncurryThis;
var toObject$3 = toObject$6;

var floor$3 = Math.floor;
var charAt$4 = uncurryThis$7(''.charAt);
var replace$5 = uncurryThis$7(''.replace);
var stringSlice$6 = uncurryThis$7(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$3(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$5(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$4(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$6(str, 0, position);
      case "'": return stringSlice$6(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$6(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor$3(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$4(ch, 1) : captures[f - 1] + charAt$4(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var apply = functionApply;
var call$6 = functionCall;
var uncurryThis$6 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$2 = fixRegexpWellKnownSymbolLogic;
var fails$6 = fails$n;
var anObject$4 = anObject$j;
var isCallable$6 = isCallable$m;
var toIntegerOrInfinity = toIntegerOrInfinity$6;
var toLength$2 = toLength$5;
var toString$6 = toString$e;
var requireObjectCoercible$3 = requireObjectCoercible$b;
var advanceStringIndex$1 = advanceStringIndex$3;
var getMethod$2 = getMethod$7;
var getSubstitution = getSubstitution$1;
var regExpExec$2 = regexpExecAbstract;
var wellKnownSymbol$6 = wellKnownSymbol$l;

var REPLACE = wellKnownSymbol$6('replace');
var max = Math.max;
var min$1 = Math.min;
var concat = uncurryThis$6([].concat);
var push$3 = uncurryThis$6([].push);
var stringIndexOf$1 = uncurryThis$6(''.indexOf);
var stringSlice$5 = uncurryThis$6(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$6(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic$2('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$3(this);
      var replacer = searchValue == undefined ? undefined : getMethod$2(searchValue, REPLACE);
      return replacer
        ? call$6(replacer, searchValue, O, replaceValue)
        : call$6(nativeReplace, toString$6(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$4(this);
      var S = toString$6(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf$1(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf$1(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$6(replaceValue);
      if (!functionalReplace) replaceValue = toString$6(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec$2(rx, S);
        if (result === null) break;

        push$3(results, result);
        if (!global) break;

        var matchStr = toString$6(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex$1(S, toLength$2(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$6(result[0]);
        var position = max(min$1(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$3(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push$3(replacerArgs, namedCaptures);
          var replacement = toString$6(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$5(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice$5(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var fails$5 = fails$n;

var correctPrototypeGetter = !fails$5(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var global$9 = global$Q;
var hasOwn$4 = hasOwnProperty_1;
var isCallable$5 = isCallable$m;
var toObject$2 = toObject$6;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var Object$1 = global$9.Object;
var ObjectPrototype = Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object$1.getPrototypeOf : function (O) {
  var object = toObject$2(O);
  if (hasOwn$4(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$5(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object$1 ? ObjectPrototype : null;
};

var fails$4 = fails$n;
var isCallable$4 = isCallable$m;
var getPrototypeOf$1 = objectGetPrototypeOf;
var redefine$4 = redefine$a.exports;
var wellKnownSymbol$5 = wellKnownSymbol$l;

var ITERATOR$4 = wellKnownSymbol$5('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$4(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$4].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$4(IteratorPrototype$2[ITERATOR$4])) {
  redefine$4(IteratorPrototype$2, ITERATOR$4, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor$2 = createPropertyDescriptor$5;
var setToStringTag$3 = setToStringTag$5;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$2 = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$1(IteratorPrototype$1, { next: createPropertyDescriptor$2(1, next) });
  setToStringTag$3(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var $$6 = _export;
var call$5 = functionCall;
var FunctionName = functionName;
var isCallable$3 = isCallable$m;
var createIteratorConstructor$1 = createIteratorConstructor$2;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$5;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$7;
var redefine$3 = redefine$a.exports;
var wellKnownSymbol$4 = wellKnownSymbol$l;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$3 = wellKnownSymbol$4('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$2 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$3]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$1) {
          setPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$3(CurrentIteratorPrototype[ITERATOR$3])) {
          redefine$3(CurrentIteratorPrototype, ITERATOR$3, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$2(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$2(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$5(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$3(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$6({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$3] !== defaultIterator) {
    redefine$3(IterablePrototype, ITERATOR$3, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables = addToUnscopables$2;
var Iterators = iterators;
var InternalStateModule$3 = internalState;
var defineIterator$1 = defineIterator$2;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$3 = InternalStateModule$3.set;
var getInternalState$1 = InternalStateModule$3.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator$1(Array, 'Array', function (iterated, kind) {
  setInternalState$3(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$8 = global$Q;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$7;
var wellKnownSymbol$3 = wellKnownSymbol$l;

var ITERATOR$2 = wellKnownSymbol$3('iterator');
var TO_STRING_TAG = wellKnownSymbol$3('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$2] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR$2, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$2] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty$1(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$8[COLLECTION_NAME] && global$8[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

var charAt$3 = stringMultibyte.charAt;
var toString$5 = toString$e;
var InternalStateModule$2 = internalState;
var defineIterator = defineIterator$2;

var STRING_ITERATOR = 'String Iterator';
var setInternalState$2 = InternalStateModule$2.set;
var getInternalState = InternalStateModule$2.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState$2(this, {
    type: STRING_ITERATOR,
    string: toString$5(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt$3(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

var fails$3 = fails$n;
var wellKnownSymbol$2 = wellKnownSymbol$l;
var IS_PURE = isPure;

var ITERATOR$1 = wellKnownSymbol$2('iterator');

var nativeUrl = !fails$3(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR$1]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

var anObject$3 = anObject$j;
var iteratorClose = iteratorClose$2;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$3(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

var toPropertyKey = toPropertyKey$3;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$5;

var createProperty$1 = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor$1(0, value));
  else object[propertyKey] = value;
};

var global$7 = global$Q;
var bind$2 = functionBindContext;
var call$4 = functionCall;
var toObject$1 = toObject$6;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var isArrayIteratorMethod = isArrayIteratorMethod$2;
var isConstructor = isConstructor$2;
var lengthOfArrayLike$1 = lengthOfArrayLike$4;
var createProperty = createProperty$1;
var getIterator$1 = getIterator$3;
var getIteratorMethod$1 = getIteratorMethod$4;

var Array$1 = global$7.Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom$1 = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject$1(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind$2(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod$1(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this == Array$1 && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator$1(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call$4(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike$1(O);
    result = IS_CONSTRUCTOR ? new this(length) : Array$1(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var global$6 = global$Q;
var uncurryThis$5 = functionUncurryThis;

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var RangeError = global$6.RangeError;
var exec$2 = uncurryThis$5(regexSeparators.exec);
var floor$2 = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis$5(''.charCodeAt);
var join$2 = uncurryThis$5([].join);
var push$2 = uncurryThis$5([].push);
var replace$4 = uncurryThis$5(''.replace);
var split$2 = uncurryThis$5(''.split);
var toLowerCase$1 = uncurryThis$5(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        push$2(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push$2(output, value);
        counter--;
      }
    } else {
      push$2(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$2(delta / damp) : delta >> 1;
  delta += floor$2(delta / numPoints);
  for (; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor$2(delta / baseMinusTMin);
  }
  return floor$2(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
// eslint-disable-next-line max-statements -- TODO
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push$2(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push$2(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor$2((maxInt - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        for (var k = base; /* no condition */; k += base) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push$2(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$2(qMinusT / baseMinusT);
        }

        push$2(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;
  }
  return join$2(output, '');
};

var stringPunycodeToAscii = function (input) {
  var encoded = [];
  var labels = split$2(replace$4(toLowerCase$1(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push$2(encoded, exec$2(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join$2(encoded, '.');
};

var arraySlice$1 = arraySlice$4;

var floor$1 = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor$1(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice$1(array, 0, middle), comparefn),
    mergeSort(arraySlice$1(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

var arraySort$1 = mergeSort;

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$5 = _export;
var global$5 = global$Q;
var getBuiltIn = getBuiltIn$8;
var call$3 = functionCall;
var uncurryThis$4 = functionUncurryThis;
var USE_NATIVE_URL$1 = nativeUrl;
var redefine$2 = redefine$a.exports;
var redefineAll = redefineAll$2;
var setToStringTag$1 = setToStringTag$5;
var createIteratorConstructor = createIteratorConstructor$2;
var InternalStateModule$1 = internalState;
var anInstance$1 = anInstance$3;
var isCallable$2 = isCallable$m;
var hasOwn$3 = hasOwnProperty_1;
var bind$1 = functionBindContext;
var classof = classof$7;
var anObject$2 = anObject$j;
var isObject$1 = isObject$a;
var $toString$1 = toString$e;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$5;
var getIterator = getIterator$3;
var getIteratorMethod = getIteratorMethod$4;
var wellKnownSymbol$1 = wellKnownSymbol$l;
var arraySort = arraySort$1;

var ITERATOR = wellKnownSymbol$1('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalParamsState = InternalStateModule$1.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule$1.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var n$Fetch = getBuiltIn('fetch');
var N$Request = getBuiltIn('Request');
var Headers = getBuiltIn('Headers');
var RequestPrototype = N$Request && N$Request.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp$1 = global$5.RegExp;
var TypeError$3 = global$5.TypeError;
var decodeURIComponent = global$5.decodeURIComponent;
var encodeURIComponent$1 = global$5.encodeURIComponent;
var charAt$2 = uncurryThis$4(''.charAt);
var join$1 = uncurryThis$4([].join);
var push$1 = uncurryThis$4([].push);
var replace$3 = uncurryThis$4(''.replace);
var shift$1 = uncurryThis$4([].shift);
var splice = uncurryThis$4([].splice);
var split$1 = uncurryThis$4(''.split);
var stringSlice$4 = uncurryThis$4(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace$3(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace$3(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace$3(encodeURIComponent$1(it), find, replacer);
};

var parseSearchParams = function (result, query) {
  if (query) {
    var attributes = split$1(query, '&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = split$1(attribute, '=');
        push$1(result, {
          key: deserialize(shift$1(entry)),
          value: deserialize(join$1(entry, '='))
        });
      }
    }
  }
};

var updateSearchParams = function (query) {
  this.entries.length = 0;
  parseSearchParams(this.entries, query);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError$3('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState$1(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance$1(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState$1(that, {
    type: URL_SEARCH_PARAMS,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams
  });

  if (init !== undefined) {
    if (isObject$1(init)) {
      iteratorMethod = getIteratorMethod(init);
      if (iteratorMethod) {
        iterator = getIterator(init, iteratorMethod);
        next = iterator.next;
        while (!(step = call$3(next, iterator)).done) {
          entryIterator = getIterator(anObject$2(step.value));
          entryNext = entryIterator.next;
          if (
            (first = call$3(entryNext, entryIterator)).done ||
            (second = call$3(entryNext, entryIterator)).done ||
            !call$3(entryNext, entryIterator).done
          ) throw TypeError$3('Expected sequence with length 2');
          push$1(entries, { key: $toString$1(first.value), value: $toString$1(second.value) });
        }
      } else for (key in init) if (hasOwn$3(init, key)) push$1(entries, { key: key, value: $toString$1(init[key]) });
    } else {
      parseSearchParams(
        entries,
        typeof init == 'string' ? charAt$2(init, 0) === '?' ? stringSlice$4(init, 1) : init : $toString$1(init)
      );
    }
  }
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    push$1(state.entries, { key: $toString$1(name), value: $toString$1(value) });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = $toString$1(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) splice(entries, index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString$1(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString$1(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$1(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString$1(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = $toString$1(name);
    var val = $toString$1(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push$1(entries, { key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind$1(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine$2(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine$2(URLSearchParamsPrototype, 'toString', function toString() {
  var entries = getInternalParamsState(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    push$1(result, serialize(entry.key) + '=' + serialize(entry.value));
  } return join$1(result, '&');
}, { enumerable: true });

setToStringTag$1(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$$5({ global: true, forced: !USE_NATIVE_URL$1 }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL$1 && isCallable$2(Headers)) {
  var headersHas = uncurryThis$4(HeadersPrototype.has);
  var headersSet = uncurryThis$4(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject$1(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString$1(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable$2(n$Fetch)) {
    $$5({ global: true, enumerable: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return n$Fetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable$2(N$Request)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance$1(this, RequestPrototype);
      return new N$Request(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $$5({ global: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

var web_urlSearchParams = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$4 = _export;
var DESCRIPTORS$2 = descriptors;
var USE_NATIVE_URL = nativeUrl;
var global$4 = global$Q;
var bind = functionBindContext;
var call$2 = functionCall;
var uncurryThis$3 = functionUncurryThis;
var defineProperties = objectDefineProperties;
var redefine$1 = redefine$a.exports;
var anInstance = anInstance$3;
var hasOwn$2 = hasOwnProperty_1;
var assign = objectAssign;
var arrayFrom = arrayFrom$1;
var arraySlice = arraySlice$4;
var codeAt = stringMultibyte.codeAt;
var toASCII = stringPunycodeToAscii;
var $toString = toString$e;
var setToStringTag = setToStringTag$5;
var URLSearchParamsModule = web_urlSearchParams;
var InternalStateModule = internalState;

var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var URLSearchParams$1 = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = global$4.URL;
var TypeError$2 = global$4.TypeError;
var parseInt$1 = global$4.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt$1 = uncurryThis$3(''.charAt);
var exec$1 = uncurryThis$3(/./.exec);
var join = uncurryThis$3([].join);
var numberToString = uncurryThis$3(1.0.toString);
var pop = uncurryThis$3([].pop);
var push = uncurryThis$3([].push);
var replace$2 = uncurryThis$3(''.replace);
var shift = uncurryThis$3([].shift);
var split = uncurryThis$3(''.split);
var stringSlice$3 = uncurryThis$3(''.slice);
var toLowerCase = uncurryThis$3(''.toLowerCase);
var unshift = uncurryThis$3([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

var parseHost = function (url, input) {
  var result, codePoints, index;
  if (charAt$1(input, 0) == '[') {
    if (charAt$1(input, input.length - 1) != ']') return INVALID_HOST;
    result = parseIPv6(stringSlice$3(input, 1, -1));
    if (!result) return INVALID_HOST;
    url.host = result;
  // opaque host
  } else if (!isSpecial(url)) {
    if (exec$1(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
    result = '';
    codePoints = arrayFrom(input);
    for (index = 0; index < codePoints.length; index++) {
      result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
    }
    url.host = result;
  } else {
    input = toASCII(input);
    if (exec$1(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
    result = parseIPv4(input);
    if (result === null) return INVALID_HOST;
    url.host = result;
  }
};

var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && charAt$1(part, 0) == '0') {
      radix = exec$1(HEX_START, part) ? 16 : 8;
      part = stringSlice$3(part, radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec$1(radix == 10 ? DEC : radix == 8 ? OCT : HEX, part)) return input;
      number = parseInt$1(part, radix);
    }
    push(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt$1(input, pointer);
  };

  if (chr() == ':') {
    if (charAt$1(input, 1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex == 8) return;
    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec$1(HEX, chr())) {
      value = value * 16 + parseInt$1(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec$1(DIGIT, chr())) return;
        while (exec$1(DIGIT, chr())) {
          number = parseInt$1(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor(host / 256);
    } return join(result, '.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwn$2(set, chr) ? chr : encodeURIComponent(chr);
};

var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

var isSpecial = function (url) {
  return hasOwn$2(specialSchemes, url.scheme);
};

var includesCredentials = function (url) {
  return url.username != '' || url.password != '';
};

var cannotHaveUsernamePasswordPort = function (url) {
  return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
};

var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && exec$1(ALPHA, charAt$1(string, 0))
    && ((second = charAt$1(string, 1)) == ':' || (!normalized && second == '|'));
};

var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice$3(string, 0, 2)) && (
    string.length == 2 ||
    ((third = charAt$1(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

var shortenURLsPath = function (url) {
  var path = url.path;
  var pathSize = path.length;
  if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
    path.length--;
  }
};

var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

// eslint-disable-next-line max-statements -- TODO
var parseURL = function (url, input, stateOverride, base) {
  var state = stateOverride || SCHEME_START;
  var pointer = 0;
  var buffer = '';
  var seenAt = false;
  var seenBracket = false;
  var seenPasswordToken = false;
  var codePoints, chr, bufferCodePoints, failure;

  if (!stateOverride) {
    url.scheme = '';
    url.username = '';
    url.password = '';
    url.host = null;
    url.port = null;
    url.path = [];
    url.query = null;
    url.fragment = null;
    url.cannotBeABaseURL = false;
    input = replace$2(input, LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
  }

  input = replace$2(input, TAB_AND_NEW_LINE, '');

  codePoints = arrayFrom(input);

  while (pointer <= codePoints.length) {
    chr = codePoints[pointer];
    switch (state) {
      case SCHEME_START:
        if (chr && exec$1(ALPHA, chr)) {
          buffer += toLowerCase(chr);
          state = SCHEME;
        } else if (!stateOverride) {
          state = NO_SCHEME;
          continue;
        } else return INVALID_SCHEME;
        break;

      case SCHEME:
        if (chr && (exec$1(ALPHANUMERIC, chr) || chr == '+' || chr == '-' || chr == '.')) {
          buffer += toLowerCase(chr);
        } else if (chr == ':') {
          if (stateOverride && (
            (isSpecial(url) != hasOwn$2(specialSchemes, buffer)) ||
            (buffer == 'file' && (includesCredentials(url) || url.port !== null)) ||
            (url.scheme == 'file' && !url.host)
          )) return;
          url.scheme = buffer;
          if (stateOverride) {
            if (isSpecial(url) && specialSchemes[url.scheme] == url.port) url.port = null;
            return;
          }
          buffer = '';
          if (url.scheme == 'file') {
            state = FILE;
          } else if (isSpecial(url) && base && base.scheme == url.scheme) {
            state = SPECIAL_RELATIVE_OR_AUTHORITY;
          } else if (isSpecial(url)) {
            state = SPECIAL_AUTHORITY_SLASHES;
          } else if (codePoints[pointer + 1] == '/') {
            state = PATH_OR_AUTHORITY;
            pointer++;
          } else {
            url.cannotBeABaseURL = true;
            push(url.path, '');
            state = CANNOT_BE_A_BASE_URL_PATH;
          }
        } else if (!stateOverride) {
          buffer = '';
          state = NO_SCHEME;
          pointer = 0;
          continue;
        } else return INVALID_SCHEME;
        break;

      case NO_SCHEME:
        if (!base || (base.cannotBeABaseURL && chr != '#')) return INVALID_SCHEME;
        if (base.cannotBeABaseURL && chr == '#') {
          url.scheme = base.scheme;
          url.path = arraySlice(base.path);
          url.query = base.query;
          url.fragment = '';
          url.cannotBeABaseURL = true;
          state = FRAGMENT;
          break;
        }
        state = base.scheme == 'file' ? FILE : RELATIVE;
        continue;

      case SPECIAL_RELATIVE_OR_AUTHORITY:
        if (chr == '/' && codePoints[pointer + 1] == '/') {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          pointer++;
        } else {
          state = RELATIVE;
          continue;
        } break;

      case PATH_OR_AUTHORITY:
        if (chr == '/') {
          state = AUTHORITY;
          break;
        } else {
          state = PATH;
          continue;
        }

      case RELATIVE:
        url.scheme = base.scheme;
        if (chr == EOF) {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = arraySlice(base.path);
          url.query = base.query;
        } else if (chr == '/' || (chr == '\\' && isSpecial(url))) {
          state = RELATIVE_SLASH;
        } else if (chr == '?') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = arraySlice(base.path);
          url.query = '';
          state = QUERY;
        } else if (chr == '#') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = arraySlice(base.path);
          url.query = base.query;
          url.fragment = '';
          state = FRAGMENT;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = arraySlice(base.path);
          url.path.length--;
          state = PATH;
          continue;
        } break;

      case RELATIVE_SLASH:
        if (isSpecial(url) && (chr == '/' || chr == '\\')) {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        } else if (chr == '/') {
          state = AUTHORITY;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          state = PATH;
          continue;
        } break;

      case SPECIAL_AUTHORITY_SLASHES:
        state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        if (chr != '/' || charAt$1(buffer, pointer + 1) != '/') continue;
        pointer++;
        break;

      case SPECIAL_AUTHORITY_IGNORE_SLASHES:
        if (chr != '/' && chr != '\\') {
          state = AUTHORITY;
          continue;
        } break;

      case AUTHORITY:
        if (chr == '@') {
          if (seenAt) buffer = '%40' + buffer;
          seenAt = true;
          bufferCodePoints = arrayFrom(buffer);
          for (var i = 0; i < bufferCodePoints.length; i++) {
            var codePoint = bufferCodePoints[i];
            if (codePoint == ':' && !seenPasswordToken) {
              seenPasswordToken = true;
              continue;
            }
            var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
            if (seenPasswordToken) url.password += encodedCodePoints;
            else url.username += encodedCodePoints;
          }
          buffer = '';
        } else if (
          chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
          (chr == '\\' && isSpecial(url))
        ) {
          if (seenAt && buffer == '') return INVALID_AUTHORITY;
          pointer -= arrayFrom(buffer).length + 1;
          buffer = '';
          state = HOST;
        } else buffer += chr;
        break;

      case HOST:
      case HOSTNAME:
        if (stateOverride && url.scheme == 'file') {
          state = FILE_HOST;
          continue;
        } else if (chr == ':' && !seenBracket) {
          if (buffer == '') return INVALID_HOST;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PORT;
          if (stateOverride == HOSTNAME) return;
        } else if (
          chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
          (chr == '\\' && isSpecial(url))
        ) {
          if (isSpecial(url) && buffer == '') return INVALID_HOST;
          if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null)) return;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PATH_START;
          if (stateOverride) return;
          continue;
        } else {
          if (chr == '[') seenBracket = true;
          else if (chr == ']') seenBracket = false;
          buffer += chr;
        } break;

      case PORT:
        if (exec$1(DIGIT, chr)) {
          buffer += chr;
        } else if (
          chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
          (chr == '\\' && isSpecial(url)) ||
          stateOverride
        ) {
          if (buffer != '') {
            var port = parseInt$1(buffer, 10);
            if (port > 0xFFFF) return INVALID_PORT;
            url.port = (isSpecial(url) && port === specialSchemes[url.scheme]) ? null : port;
            buffer = '';
          }
          if (stateOverride) return;
          state = PATH_START;
          continue;
        } else return INVALID_PORT;
        break;

      case FILE:
        url.scheme = 'file';
        if (chr == '/' || chr == '\\') state = FILE_SLASH;
        else if (base && base.scheme == 'file') {
          if (chr == EOF) {
            url.host = base.host;
            url.path = arraySlice(base.path);
            url.query = base.query;
          } else if (chr == '?') {
            url.host = base.host;
            url.path = arraySlice(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.host = base.host;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
              url.host = base.host;
              url.path = arraySlice(base.path);
              shortenURLsPath(url);
            }
            state = PATH;
            continue;
          }
        } else {
          state = PATH;
          continue;
        } break;

      case FILE_SLASH:
        if (chr == '/' || chr == '\\') {
          state = FILE_HOST;
          break;
        }
        if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
          if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
          else url.host = base.host;
        }
        state = PATH;
        continue;

      case FILE_HOST:
        if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
          if (!stateOverride && isWindowsDriveLetter(buffer)) {
            state = PATH;
          } else if (buffer == '') {
            url.host = '';
            if (stateOverride) return;
            state = PATH_START;
          } else {
            failure = parseHost(url, buffer);
            if (failure) return failure;
            if (url.host == 'localhost') url.host = '';
            if (stateOverride) return;
            buffer = '';
            state = PATH_START;
          } continue;
        } else buffer += chr;
        break;

      case PATH_START:
        if (isSpecial(url)) {
          state = PATH;
          if (chr != '/' && chr != '\\') continue;
        } else if (!stateOverride && chr == '?') {
          url.query = '';
          state = QUERY;
        } else if (!stateOverride && chr == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (chr != EOF) {
          state = PATH;
          if (chr != '/') continue;
        } break;

      case PATH:
        if (
          chr == EOF || chr == '/' ||
          (chr == '\\' && isSpecial(url)) ||
          (!stateOverride && (chr == '?' || chr == '#'))
        ) {
          if (isDoubleDot(buffer)) {
            shortenURLsPath(url);
            if (chr != '/' && !(chr == '\\' && isSpecial(url))) {
              push(url.path, '');
            }
          } else if (isSingleDot(buffer)) {
            if (chr != '/' && !(chr == '\\' && isSpecial(url))) {
              push(url.path, '');
            }
          } else {
            if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
              if (url.host) url.host = '';
              buffer = charAt$1(buffer, 0) + ':'; // normalize windows drive letter
            }
            push(url.path, buffer);
          }
          buffer = '';
          if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
            while (url.path.length > 1 && url.path[0] === '') {
              shift(url.path);
            }
          }
          if (chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          }
        } else {
          buffer += percentEncode(chr, pathPercentEncodeSet);
        } break;

      case CANNOT_BE_A_BASE_URL_PATH:
        if (chr == '?') {
          url.query = '';
          state = QUERY;
        } else if (chr == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (chr != EOF) {
          url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
        } break;

      case QUERY:
        if (!stateOverride && chr == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (chr != EOF) {
          if (chr == "'" && isSpecial(url)) url.query += '%27';
          else if (chr == '#') url.query += '%23';
          else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
        } break;

      case FRAGMENT:
        if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
        break;
    }

    pointer++;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var urlString = $toString(url);
  var state = setInternalState(that, { type: 'URL' });
  var baseState, failure;
  if (base !== undefined) {
    try {
      baseState = getInternalURLState(base);
    } catch (error) {
      failure = parseURL(baseState = {}, $toString(base));
      if (failure) throw TypeError$2(failure);
    }
  }
  failure = parseURL(state, urlString, null, baseState);
  if (failure) throw TypeError$2(failure);
  var searchParams = state.searchParams = new URLSearchParams$1();
  var searchParamsState = getInternalSearchParamsState(searchParams);
  searchParamsState.updateSearchParams(state.query);
  searchParamsState.updateURL = function () {
    state.query = $toString(searchParams) || null;
  };
  if (!DESCRIPTORS$2) {
    that.href = call$2(serializeURL, that);
    that.origin = call$2(getOrigin, that);
    that.protocol = call$2(getProtocol, that);
    that.username = call$2(getUsername, that);
    that.password = call$2(getPassword, that);
    that.host = call$2(getHost, that);
    that.hostname = call$2(getHostname, that);
    that.port = call$2(getPort, that);
    that.pathname = call$2(getPathname, that);
    that.search = call$2(getSearch, that);
    that.searchParams = call$2(getSearchParams, that);
    that.hash = call$2(getHash, that);
  }
};

var URLPrototype = URLConstructor.prototype;

var serializeURL = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var username = url.username;
  var password = url.password;
  var host = url.host;
  var port = url.port;
  var path = url.path;
  var query = url.query;
  var fragment = url.fragment;
  var output = scheme + ':';
  if (host !== null) {
    output += '//';
    if (includesCredentials(url)) {
      output += username + (password ? ':' + password : '') + '@';
    }
    output += serializeHost(host);
    if (port !== null) output += ':' + port;
  } else if (scheme == 'file') output += '//';
  output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  if (query !== null) output += '?' + query;
  if (fragment !== null) output += '#' + fragment;
  return output;
};

var getOrigin = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var port = url.port;
  if (scheme == 'blob') try {
    return new URLConstructor(scheme.path[0]).origin;
  } catch (error) {
    return 'null';
  }
  if (scheme == 'file' || !isSpecial(url)) return 'null';
  return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '');
};

var getProtocol = function () {
  return getInternalURLState(this).scheme + ':';
};

var getUsername = function () {
  return getInternalURLState(this).username;
};

var getPassword = function () {
  return getInternalURLState(this).password;
};

var getHost = function () {
  var url = getInternalURLState(this);
  var host = url.host;
  var port = url.port;
  return host === null ? ''
    : port === null ? serializeHost(host)
    : serializeHost(host) + ':' + port;
};

var getHostname = function () {
  var host = getInternalURLState(this).host;
  return host === null ? '' : serializeHost(host);
};

var getPort = function () {
  var port = getInternalURLState(this).port;
  return port === null ? '' : $toString(port);
};

var getPathname = function () {
  var url = getInternalURLState(this);
  var path = url.path;
  return url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
};

var getSearch = function () {
  var query = getInternalURLState(this).query;
  return query ? '?' + query : '';
};

var getSearchParams = function () {
  return getInternalURLState(this).searchParams;
};

var getHash = function () {
  var fragment = getInternalURLState(this).fragment;
  return fragment ? '#' + fragment : '';
};

var accessorDescriptor = function (getter, setter) {
  return { get: getter, set: setter, configurable: true, enumerable: true };
};

if (DESCRIPTORS$2) {
  defineProperties(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor(serializeURL, function (href) {
      var url = getInternalURLState(this);
      var urlString = $toString(href);
      var failure = parseURL(url, urlString);
      if (failure) throw TypeError$2(failure);
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor(getOrigin),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor(getProtocol, function (protocol) {
      var url = getInternalURLState(this);
      parseURL(url, $toString(protocol) + ':', SCHEME_START);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor(getUsername, function (username) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom($toString(username));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.username = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor(getPassword, function (password) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom($toString(password));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.password = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor(getHost, function (host) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, $toString(host), HOST);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor(getHostname, function (hostname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, $toString(hostname), HOSTNAME);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor(getPort, function (port) {
      var url = getInternalURLState(this);
      if (cannotHaveUsernamePasswordPort(url)) return;
      port = $toString(port);
      if (port == '') url.port = null;
      else parseURL(url, port, PORT);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor(getPathname, function (pathname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      url.path = [];
      parseURL(url, $toString(pathname), PATH_START);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor(getSearch, function (search) {
      var url = getInternalURLState(this);
      search = $toString(search);
      if (search == '') {
        url.query = null;
      } else {
        if ('?' == charAt$1(search, 0)) search = stringSlice$3(search, 1);
        url.query = '';
        parseURL(url, search, QUERY);
      }
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor(getSearchParams),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor(getHash, function (hash) {
      var url = getInternalURLState(this);
      hash = $toString(hash);
      if (hash == '') {
        url.fragment = null;
        return;
      }
      if ('#' == charAt$1(hash, 0)) hash = stringSlice$3(hash, 1);
      url.fragment = '';
      parseURL(url, hash, FRAGMENT);
    })
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine$1(URLPrototype, 'toJSON', function toJSON() {
  return call$2(serializeURL, this);
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine$1(URLPrototype, 'toString', function toString() {
  return call$2(serializeURL, this);
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) redefine$1(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) redefine$1(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

$$4({ global: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS$2 }, {
  URL: URLConstructor
});

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

var call$1 = functionCall;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var anObject$1 = anObject$j;
var requireObjectCoercible$2 = requireObjectCoercible$b;
var sameValue = sameValue$1;
var toString$4 = toString$e;
var getMethod$1 = getMethod$7;
var regExpExec$1 = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic$1('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$2(this);
      var searcher = regexp == undefined ? undefined : getMethod$1(regexp, SEARCH);
      return searcher ? call$1(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$4(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject$1(this);
      var S = toString$4(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec$1(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

var $$3 = _export;
var DESCRIPTORS$1 = descriptors;
var global$3 = global$Q;
var uncurryThis$2 = functionUncurryThis;
var hasOwn$1 = hasOwnProperty_1;
var isCallable$1 = isCallable$m;
var isPrototypeOf$1 = objectIsPrototypeOf;
var toString$3 = toString$e;
var defineProperty$1 = objectDefineProperty.f;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$3.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS$1 && isCallable$1(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$3(arguments[0]);
    var result = isPrototypeOf$1(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var symbolToString = uncurryThis$2(SymbolPrototype.toString);
  var symbolValueOf = uncurryThis$2(SymbolPrototype.valueOf);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$1 = uncurryThis$2(''.replace);
  var stringSlice$2 = uncurryThis$2(''.slice);

  defineProperty$1(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = symbolValueOf(this);
      var string = symbolToString(symbol);
      if (hasOwn$1(EmptyStringDescriptionStore, symbol)) return '';
      var desc = NATIVE_SYMBOL ? stringSlice$2(string, 7, -1) : replace$1(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$3({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

var PROPER_FUNCTION_NAME = functionName.PROPER;
var fails$2 = fails$n;
var whitespaces = whitespaces$3;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$2(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$2 = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$2({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

var global$2 = global$Q;
var aCallable = aCallable$6;
var toObject = toObject$6;
var IndexedObject = indexedObject;
var lengthOfArrayLike = lengthOfArrayLike$4;

var TypeError$1 = global$2.TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError$1('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};

var fails$1 = fails$n;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$1(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $$1 = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

var STRICT_METHOD = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$1({ target: 'Array', proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

var isCallable = isCallable$m;
var isObject = isObject$a;
var setPrototypeOf = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var DESCRIPTORS = descriptors;
var global$1 = global$Q;
var uncurryThis$1 = functionUncurryThis;
var isForced = isForced_1;
var inheritIfRequired = inheritIfRequired$1;
var createNonEnumerableProperty = createNonEnumerableProperty$7;
var defineProperty = objectDefineProperty.f;
var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var isPrototypeOf = objectIsPrototypeOf;
var isRegExp = isRegexp;
var toString$2 = toString$e;
var regExpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var redefine = redefine$a.exports;
var fails = fails$n;
var hasOwn = hasOwnProperty_1;
var enforceInternalState = internalState.enforce;
var setSpecies = setSpecies$2;
var wellKnownSymbol = wellKnownSymbol$l;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global$1.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = global$1.SyntaxError;
var getFlags = uncurryThis$1(regExpFlags);
var exec = uncurryThis$1(RegExpPrototype.exec);
var charAt = uncurryThis$1(''.charAt);
var replace = uncurryThis$1(''.replace);
var stringIndexOf = uncurryThis$1(''.indexOf);
var stringSlice$1 = uncurryThis$1(''.slice);
// TODO: Use only propper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      chr = chr + charAt(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec(IS_NCG, stringSlice$1(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = 'flags' in rawPattern ? rawPattern.flags : getFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString$2(pattern);
    flags = flags === undefined ? '' : toString$2(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
      if (dotAll) flags = replace(flags, /s/g, '');
    }

    rawFlags = flags;

    if (UNSUPPORTED_Y && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
      if (sticky) flags = replace(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxy(keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global$1, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

var _FGBLocalStorage;
var FGBLocalStorage = /*#__PURE__*/_createClass(function FGBLocalStorage() {
  _classCallCheck(this, FGBLocalStorage);
});
_FGBLocalStorage = FGBLocalStorage;
FGBLocalStorage.removeItem = function (key) {
  if (!window || !window.localStorage) {
    return null;
  }
  var myStorage = window.localStorage;
  myStorage.removeItem(key);
};
FGBLocalStorage.getItem = function (key) {
  if (!window || !window.localStorage) {
    return null;
  }
  var myStorage = window.localStorage;
  var item = myStorage.getItem(key);
  item = item ? JSON.parse(item) : null;
  return item;
};
FGBLocalStorage.setItem = function (key, item) {
  var myStorage = window.localStorage;
  if (!window || !window.localStorage) {
    return null;
  }
  if (key === 'companyAds') {
    var savedItems = _FGBLocalStorage.getItem(key);
    var uniqueItems = new Set(savedItems);
    uniqueItems.add(item);
    var arrayItems = Array.from(uniqueItems);
    while (arrayItems.length > 2) {
      /** delete until two left */
      arrayItems.shift();
    }
    return myStorage.setItem(key, JSON.stringify(arrayItems));
  } else {
    return myStorage.setItem(key, JSON.stringify(item));
  }
};

var VisibilityPixel = function VisibilityPixel(_ref) {
  var _ref$metrics = _ref.metrics,
    metrics = _ref$metrics === void 0 ? null : _ref$metrics,
    _ref$visibilityCallba = _ref.visibilityCallback,
    visibilityCallback = _ref$visibilityCallba === void 0 ? null : _ref$visibilityCallba,
    _ref$singleFire = _ref.singleFire,
    singleFire = _ref$singleFire === void 0 ? true : _ref$singleFire;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasFired = _useState2[0],
    setHasFired = _useState2[1];
  var itemRef = useRef(null);
  var onVisChange = function onVisChange(isVis) {
    if (isVis && (!hasFired || !singleFire)) {
      setHasFired(true);
      if (visibilityCallback) visibilityCallback();
      if (!metrics) return;
      metrics.type = 'pixel';
      EmitMetric(metrics, 'pixel');
      if (singleFire) window.sessionStorage.setItem(singleFire, 'true');
    }
  };
  useEffect(function () {
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        onVisChange(true);
        observer.disconnect();
      }
    });
    observer.observe(itemRef.current);
    return function () {
      if (itemRef.current) {
        observer.unobserve(itemRef.current);
      }
    };
  }, []);
  return /*#__PURE__*/jsx("div", {
    style: {
      width: '1px',
      height: '1px'
    },
    ref: itemRef,
    children: /*#__PURE__*/jsx("div", {
      style: {
        width: '1px',
        height: '1px'
      }
    })
  });
};
VisibilityPixel.setLastActionParams = function (lac, lat) {
  var trackingPropsHsh = getTrackingPropsCookie() || {};
  trackingPropsHsh.last_action_category = lac;
  trackingPropsHsh.last_action_type = lat;
};
VisibilityPixel.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  metrics: PropTypes.object
};
VisibilityPixel.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  visibilityCallback: null,
  metrics: null
};
var isDebug = function isDebug() {
  if (window && window.globalPageData && window.globalPageData.analytics) {
    return window.globalPageData.analytics.debug === true;
  }
  return false;
};
var buildMetrics = function buildMetrics(metrics, type) {
  metrics.url = window.location.pathname;
  var url = new URL(window.location);
  if (url.searchParams.get('utm_source')) {
    metrics.utmSource = url.searchParams.get('utm_source');
  }
  if (url.searchParams.get('utm_campaign')) {
    metrics.utmCampaign = url.searchParams.get('utm_campaign');
  }
  if (url.searchParams.get('utm_medium')) {
    metrics.utmMedium = url.searchParams.get('utm_medium');
  }
  if (url.searchParams.get('LAT')) {
    metrics.last_action_type = url.searchParams.get('LAT');
  }
  if (url.searchParams.get('LAC')) {
    metrics.last_action_category = url.searchParams.get('LAC');
  }
  // Include incoming referrer if exists
  var referrer = getValueFromTrackingProps('referrer');
  if (referrer) {
    metrics.referrer = referrer;
  }
  if (isDebug()) {
    // eslint-disable-next-line no-console
    console.log("Debug ".concat(type, " metrics:"), metrics);
  }
  var metricsString = JSON.stringify(metrics);
  return encodeURIComponent(metricsString);
};
var getPageMetrics = function getPageMetrics() {
  var metricsData = {
    source: 'frontend'
  };
  if (window && window.globalPageData && window.globalPageData.analytics && window.globalPageData.analytics.metrics) {
    metricsData = window.globalPageData.analytics.metrics;
  }
  return metricsData;
};
var getMetricData = function getMetricData(metrics) {
  var fullMetrics = Object.assign({}, getPageMetrics(), metrics);
  return fullMetrics;
};
var EmitMetric = function EmitMetric() {
  var metrics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  axios.get("/_m/emit?metrics=".concat(buildMetrics(getMetricData(metrics), 'emit')));
};
var getTrackingPropsCookie = function getTrackingPropsCookie() {
  var trackingProps = Cookies.get('TRACKING_PROPS');
  return trackingProps ? JSON.parse(trackingProps.split('j:')[1]) : null;
};
var getValueFromTrackingProps = function getValueFromTrackingProps(key) {
  var trackingPropsHsh = getTrackingPropsCookie();
  return trackingPropsHsh ? trackingPropsHsh[key] : null;
};

var $ = _export;
var uncurryThis = functionUncurryThis;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var toLength$1 = toLength$5;
var toString$1 = toString$e;
var notARegExp = notARegexp;
var requireObjectCoercible$1 = requireObjectCoercible$b;
var correctIsRegExpLogic = correctIsRegexpLogic;

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var un$StartsWith = uncurryThis(''.startsWith);
var stringSlice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString$1(requireObjectCoercible$1(this));
    notARegExp(searchString);
    var index = toLength$1(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString$1(searchString);
    return un$StartsWith
      ? un$StartsWith(that, search, index)
      : stringSlice(that, index, index + search.length) === search;
  }
});

var IMAGE_CDN_URL = 'https://d207ibygpg2z1x.cloudfront.net/image/upload';

"".concat(IMAGE_CDN_URL.split('/image/upload')[0], "/video/upload/");
var LOGO_IMAGE_SIZE = {
  XXS_SMALL: 'xxSmall',
  XS_SMALL: 'xSmall',
  SMALL: 'small',
  SMALL_MEDIUM: 'small-medium',
  MEDIUM: 'medium',
  LARGE: 'large'
};
var CLOUDINARY_SIZE_TRANSFORM = {
  LOGO: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, LOGO_IMAGE_SIZE.XXS_SMALL, 'c_scale,f_auto,q_auto,w_32'), LOGO_IMAGE_SIZE.XS_SMALL, 'c_scale,f_auto,q_auto,w_60'), LOGO_IMAGE_SIZE.SMALL, 'c_scale,f_auto,q_auto,w_70'), LOGO_IMAGE_SIZE.SMALL_MEDIUM, 'c_scale,f_auto,q_auto,w_80'), LOGO_IMAGE_SIZE.MEDIUM, 'c_scale,f_auto,q_auto,w_120'), LOGO_IMAGE_SIZE.LARGE, 'c_scale,f_auto,q_auto,w_180')
};
var DIGIT_REGEX = /\/?v[0-9]*\//;
var getCloudinaryImagePathById = function getCloudinaryImagePathById(cloudinaryId) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LOGO_IMAGE_SIZE.SMALL;
  var injectedTransforms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : CLOUDINARY_SIZE_TRANSFORM.LOGO;
  var formattedUrl = '/v1' + cloudinaryId.replace(DIGIT_REGEX, '/');
  return IMAGE_CDN_URL + '/' + injectedTransforms[size] + formattedUrl;
};
var buildImagePath = function buildImagePath(cloudinaryId, size, injectedTransforms) {
  var src = "".concat(IMAGE_CDN_URL, "/");
  var regex = /\/?v[0-9]+\//;
  var defaultTransforms = {
    button: 'c_scale,f_auto,q_auto,h_22',
    xxSmall: 'c_scale,f_auto,q_auto,h_24',
    xSmall: 'c_scale,f_auto,q_auto,w_60',
    small: 'c_scale,f_auto,q_auto,w_70',
    "default": 'c_scale,f_auto,q_auto,h_300',
    fullScreen: 'c_scale,f_auto,q_auto,w_1500',
    'small-lPad': 'c_lpad,f_auto,q_auto,w_60,h_60'
  };
  var formattedUrl = cloudinaryId.startsWith('/') ? "/v1".concat(cloudinaryId.replace(regex, '/').replace('.anim', '')) : "/v1/".concat(cloudinaryId.replace(regex, '/').replace('.anim', ''));
  var transforms = injectedTransforms || defaultTransforms;
  return src + transforms[size] + formattedUrl;
};

var POPUP_MODE = 'popup';
var CREATE_LAYOUT = 'create';
var LOGIN_LAYOUT = 'login';
var RESET_PASSWORD_CONFIRMATION_LAYOUT = 'password-confirmation';
var RESET_PASSWORD_LAYOUT = 'password';
var FACEBOOK_REAUTHORIZATION_LAYOUT = 'facebook-reauthorization';
var FACEBOOK_REAUTHORIZATION_CONFIRMATION_LAYOUT = 'facebook-reauthorization-confirmation';

var truncateWithEllipsis = function truncateWithEllipsis(text, length) {
  var ellipses = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!text || text.length < length) {
    return text;
  }
  var truncated = text.substr(0, length);
  var splitWord = truncated.split(' ');
  if (splitWord.length > 1) {
    delete splitWord[splitWord.length - 1];
  }
  return ellipses ? "".concat(splitWord.join(' ').trim(), "...") : "".concat(splitWord.join(' '));
};

var FacebookButton = function FacebookButton(_ref) {
  var onClick = _ref.onClick;
  var iconSrc = buildImagePath('/v1541017251/Login/facebook.png', 'button');
  return /*#__PURE__*/jsxs("div", {
    className: "component-Login-LoginLayoutComponent-SocialMediaButtons-FacebookButton",
    children: [/*#__PURE__*/jsx("style", {
      jsx: true,
      children: "\n                    .component-Login-LoginLayoutComponent-SocialMediaButtons-FacebookButton {\n                        margin-bottom: 10px;\n                        height: 40px;\n                        width: 100%;\n                    }\n                    .component-Login-LoginLayoutComponent-SocialMediaButtons-FacebookButton\n                        .component-Input-ButtonWithChildren {\n                        cursor: pointer;\n                        height: 100%;\n                    }\n                    .component-Login-LoginLayoutComponent-SocialMediaButtons-FacebookButton\n                        .component-Input-ButtonWithChildren\n                        button {\n                        height: 40px;\n                        width: 98%;\n                        background-color: #3b5998 !important;\n                        border-color: #3b5998;\n                    }\n                    .component-Login-LoginLayoutComponent-SocialMediaButtons-FacebookButton\n                        .component-Input-ButtonWithChildren\n                        button\n                        .call-to-action-button-text {\n                        color: #fff;\n                        -webkit-text-fill-color: #fff;\n                    }\n                "
    }), /*#__PURE__*/jsx("div", {
      className: "component-Input-ButtonWithChildren",
      children: /*#__PURE__*/jsx(Button$1, {
        onPress: function onPress() {
          return onClick({}, 'facebook');
        },
        height: "40px",
        children: /*#__PURE__*/jsxs("div", {
          className: "button-content-container",
          children: [/*#__PURE__*/jsx("img", {
            src: iconSrc,
            alt: 'facebook login'
          }), /*#__PURE__*/jsx("div", {
            className: "call-to-action-button-text",
            children: "Continue with Facebook"
          })]
        })
      })
    })]
  });
};

var GoogleButton = function GoogleButton(_ref) {
  var onClick = _ref.onClick;
  var iconSrc = buildImagePath('/v1541017251/Login/google.png', 'button');
  return /*#__PURE__*/jsxs("div", {
    className: "component-Login-LoginLayoutComponent-SocialMediaButtons-GoogleButton",
    children: [/*#__PURE__*/jsx("style", {
      jsx: true,
      children: "\n                    .component-Login-LoginLayoutComponent-SocialMediaButtons-GoogleButton {\n                        margin-bottom: 10px;\n                    }\n                    .component-Login-LoginLayoutComponent-SocialMediaButtons-GoogleButton\n                        .component-Input-ButtonWithChildren {\n                        font-family: 'Open Sans', sans-serif;\n                        font-weight: 500;\n                        cursor: pointer;\n                    }\n                    .component-Login-LoginLayoutComponent-SocialMediaButtons-GoogleButton\n                        .component-Input-ButtonWithChildren\n                        button {\n                        border: 1px solid #95989c;\n                        color: #353535 !important;\n                        background-color: white !important;\n                        height: 40px;\n                        width: 98%;\n                    }\n                "
    }), /*#__PURE__*/jsx("div", {
      className: "component-Input-ButtonWithChildren",
      children: /*#__PURE__*/jsx(Button$1, {
        onPress: function onPress() {
          onClick({}, 'google');
        },
        children: /*#__PURE__*/jsxs("div", {
          className: "button-content-container",
          children: [/*#__PURE__*/jsx("img", {
            src: iconSrc,
            alt: "google login"
          }), /*#__PURE__*/jsx("div", {
            className: "call-to-action-button-text",
            children: "Continue with Google"
          })]
        })
      })
    })]
  });
};

var styles$b = "\n    .component-Login-LoginLayoutComponent-Layouts-EmailLoginForm .errorMessage {\n        text-align: left;\n        font-family: \"Open Sans\", sans-serif;\n        font-style: italic;\n        font-size: 12px;\n        font-weight: 700;\n        color: #ff4578;\n    }\n    .component-Login-LoginLayoutComponent-Layouts-EmailLoginForm .errorMessage-createLayout {\n        font-family: \"Open Sans\", sans-serif;\n        font-style: italic;\n        font-size: 12px;\n        font-weight: 700;\n        color: #ff4578;\n    }\n    .component-Login-LoginLayoutComponent-Layouts-EmailLoginForm .errorMessage-createLayout ul {\n        list-style-type: none;\n        margin: 0;\n        padding: 0;\n    }\n   .component-Login-LoginLayoutComponent-Layouts-EmailLoginForm .actionButton button {\n        margin-top: 32px;\n        width: 98%;\n        height: 38px;\n        font-family: \"Open Sans\", sans-serif;\n        font-size: 16px;\n        font-weight: 400;\n    }\n    .component-Login-LoginLayoutComponent-Layouts-EmailLoginForm .actionButton button:disable {\n        background-color: #95989c!important;\n    }\n    .component-Login-LoginLayoutComponent-Layouts-EmailLoginForm .actionButtonError {\n        margin-top: 16px;\n\n    }\n   .component-Login-LoginLayoutComponent-Layouts-EmailLoginForm .actionButtonError button {\n\n        width: 100%;\n        height: 38px;\n        font-family: \"Open Sans\", sans-serif;\n        font-size: 16px;\n        font-weight: 400;\n    }\n    .component-Login-LoginLayoutComponent-Layouts-EmailLoginForm input {\n        height: 40px;\n        background-color: #f3f5f8;\n        width: 98%;\n        color: #95989c;\n        border-radius: 0px;\n    }\n    .component-Login-LoginLayoutComponent-Layouts-EmailLoginForm .password-info {\n        font-family: \"Open Sans\", sans-serif;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 12px;\n        line-height: 16px;\n        color: #5f5d5d;\n        margin-bottom: 4px;\n    }\n";

var loginSchema = function loginSchema() {
  return object().shape({
    password: string().min(8, 'invalid_password_length').matches(/(.*[A-Z].*)/, 'password_missing_uppercase').matches(/(.*[a-z].*)/, 'password_missing_lowercase').matches(/(.*\d.*)/, 'password_missing_number').matches(/.*[[\-:;\\|<>/ {}=+_!@#$%^&*.,? "'`~)(\]].*/, 'password_missing_special_character').required('Password is required')
  });
};

var PASSWORD_INVALID_LENGTH = 'password_invalid_length';
var INVALID_PASSWORD_LENGTH = 'invalid_password_length';
var PASSWORD_MISSING_UPPERCASE = 'password_missing_uppercase';
var PASSWORD_MISSING_LOWERCASE = 'password_missing_lowercase';
var PASSWORD_MISSING_NUMBER = 'password_missing_number';
var PASSWORD_MATCH = 'password_match';
var PASSWORD_MISSING_SPECIAL_CHARACTER = 'password_missing_special_character';
var getRegwallValues = function getRegwallValues(key, pathname) {
  return {
    advice: {
      allowClosing: 0,
      buttonText: 'Get started',
      delaySeconds: 2,
      description: 'Unlock to connect and get advice on the most powerful career platform for free.',
      forceLogin: 1,
      image: '/signup-wall/ucffjgsw07q5dih8spkl',
      overlayColor: 'black',
      placementName: 'Advice Hub Testing',
      redirectUrl: pathname,
      targetUrl: null,
      title: "There's a lot more to this story"
    },
    join: {
      allowClosing: 0,
      buttonText: 'Join the community',
      delaySeconds: 2,
      description: 'Our free online career community for women is here to help you solve your toughest work challenges.',
      forceLogin: 1,
      image: '/signup-wall/ucffjgsw07q5dih8spkl',
      overlayColor: 'black',
      placementName: 'Discussion  Testing',
      redirectUrl: pathname,
      targetUrl: null,
      title: 'Get your questions answered.'
    }
  }[key];
};

var errorMessagesMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, PASSWORD_INVALID_LENGTH, 'Password must be at least 8 characters'), INVALID_PASSWORD_LENGTH, 'Password must be at least 8 characters'), PASSWORD_MATCH, 'Passwords do not match'), PASSWORD_MISSING_UPPERCASE, 'Password must have at least 1 uppercase letter'), PASSWORD_MISSING_LOWERCASE, 'Password must have at least 1 lowercase letter'), PASSWORD_MISSING_NUMBER, 'Password must have at least one number'), PASSWORD_MISSING_SPECIAL_CHARACTER, 'Password must have at least one special character');

var EmailLoginForm = function EmailLoginForm(_ref) {
  var location = _ref.location,
    onClick = _ref.onClick,
    handleEmailInput = _ref.handleEmailInput,
    handlePasswordInput = _ref.handlePasswordInput,
    handleEmailInputBlur = _ref.handleEmailInputBlur,
    handleNameInput = _ref.handleNameInput;
  var _useContext = useContext(CurrentLogin),
    loaded = _useContext.loaded,
    emailError = _useContext.emailError,
    passwordError = _useContext.passwordError,
    generalError = _useContext.generalError,
    nameError = _useContext.nameError;
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    buttonDisabled = _React$useState2[0],
    setButtonDisabled = _React$useState2[1];
  var _React$useState3 = React.useState('Processing'),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    buttonText = _React$useState4[0],
    setButtonText = _React$useState4[1];
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    email = _React$useState6[0],
    setEmail = _React$useState6[1];
  var _React$useState7 = React.useState(''),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    password = _React$useState8[0],
    setPassword = _React$useState8[1];
  var _React$useState9 = React.useState(''),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    name = _React$useState10[0],
    setName = _React$useState10[1];
  var _React$useState11 = React.useState(''),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    newEmailError = _React$useState12[0],
    setEmailError = _React$useState12[1];
  var _React$useState13 = React.useState(''),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    newPasswordError = _React$useState14[0],
    setPasswordError = _React$useState14[1];
  var _React$useState15 = React.useState(''),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    newNameError = _React$useState16[0],
    setNameError = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    formValid = _React$useState18[0],
    setFormValid = _React$useState18[1];
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    canValidateEmail = _React$useState20[0],
    setCanValidateEmail = _React$useState20[1];
  var _React$useState21 = React.useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    canValidatePassword = _React$useState22[0],
    setCanValidatePassword = _React$useState22[1];
  var onKeyPress = function onKeyPress(e) {
    if (e.key === 'Enter' && !buttonDisabled) {
      onClick({
        name: name,
        email: email,
        password: password
      });
    }
  };
  useEffect(function () {
    setNameError('');
    setPasswordError('');
    setEmailError('');
  }, [emailError, passwordError, generalError, nameError]);
  useEffect(function () {
    var validateForm = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var emailTest, emailValid, yupSchema, passwordErrors;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              emailTest = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              setEmailError('');
              setPasswordError('');
              setNameError('');
              emailValid = true;
              if (!emailTest.test(String(email).toLowerCase()) && canValidateEmail) {
                setEmailError('invalid email address');
                setFormValid(false);
                emailValid = false;
              }
              _context.next = 8;
              return loginSchema();
            case 8:
              yupSchema = _context.sent;
              _context.prev = 9;
              _context.next = 12;
              return yupSchema.validate({
                password: password
              }, {
                abortEarly: false
              });
            case 12:
              if (emailValid) setFormValid(true);
              _context.next = 21;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](9);
              passwordErrors = [];
              _context.t0.errors.forEach(function (element) {
                passwordErrors.push(errorMessagesMap[element]);
              });
              if (canValidatePassword) setPasswordError(passwordErrors);
              setFormValid(false);
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[9, 15]]);
      }));
      return function validateForm() {
        return _ref2.apply(this, arguments);
      };
    }();
    if (location !== 'login') {
      validateForm();
    } else setFormValid(true);
  }, [password, email, canValidateEmail, canValidatePassword, location]);
  React.useEffect(function () {
    var emailFieldIsValid = email && email.length;
    var passwordFieldIsValid = password && password.length;
    if (location === 'create') {
      var nameFieldIsValid = name && name.length;
      setButtonDisabled(!(emailFieldIsValid && passwordFieldIsValid && nameFieldIsValid && formValid));
    } else setButtonDisabled(!(emailFieldIsValid && passwordFieldIsValid));
  }, [email, password, name, formValid]);
  React.useEffect(function () {
    if (!loaded) {
      setButtonText('Processing');
    } else {
      setButtonText('Submit');
    }
  }, [loaded]);
  var showNameField = location === CREATE_LAYOUT;
  var buttonClass = showNameField && passwordError ? 'actionButtonError' : 'actionButton';
  return /*#__PURE__*/jsxs("div", {
    className: "component-Login-LoginLayoutComponent-Layouts-EmailLoginForm",
    children: [/*#__PURE__*/jsx("style", {
      jsx: true,
      children: styles$b
    }), /*#__PURE__*/jsxs("div", {
      className: "input-section email-login-input-section email-field",
      children: [/*#__PURE__*/jsxs("div", {
        className: "form-label",
        children: ["Email", ' ', /*#__PURE__*/jsxs("span", {
          className: "errorMessage ml-1",
          children: [newEmailError, emailError]
        })]
      }), /*#__PURE__*/jsx(InputField, {
        name: "email-input-reset-password",
        qaDataAttr: "email",
        onChange: function onChange(e) {
          handleEmailInput(e.target.value);
          setEmail(e.target.value);
        },
        onBlur: handleEmailInputBlur,
        value: email
      })]
    }), showNameField && /*#__PURE__*/jsxs("div", {
      className: "input-section username-login-input-section username-field",
      children: [/*#__PURE__*/jsxs("div", {
        className: "form-label",
        children: ["Your name", ' ', /*#__PURE__*/jsxs("span", {
          className: "errorMessage ml-1",
          children: [newNameError, " ", nameError]
        })]
      }), /*#__PURE__*/jsx(InputField, {
        type: "text",
        name: "username-input-reset-password",
        qaDataAttr: "name",
        onChange: function onChange(e) {
          handleNameInput(e.target.value);
          setName(e.target.value);
        },
        onBlur: function onBlur() {
          return setCanValidateEmail(true);
        },
        value: name
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: "input-section passowrd-login-input-section password-field",
      children: [/*#__PURE__*/jsx("div", {
        className: "form-label",
        children: "Password "
      }), location === CREATE_LAYOUT && /*#__PURE__*/jsx("div", {
        className: "password-info",
        children: "Password must contain at least 8 characters, 1 uppercase and lowercase letter, 1 number, and 1 special character"
      }), /*#__PURE__*/jsx(InputField, {
        type: "password",
        name: "email-input-reset-password",
        qaDataAttr: "password",
        onKeyPress: onKeyPress,
        onChange: function onChange(e) {
          handlePasswordInput(e.target.value);
          setPassword(e.target.value);
        },
        onBlur: function onBlur() {
          return setCanValidatePassword(true);
        },
        value: password
      }), location !== CREATE_LAYOUT && /*#__PURE__*/jsxs("span", {
        className: "errorMessage ",
        children: [newPasswordError, passwordError]
      }), location === CREATE_LAYOUT && newPasswordError && /*#__PURE__*/jsx("div", {
        className: "errorMessage-createLayout",
        children: /*#__PURE__*/jsx("ul", {
          children: newPasswordError.map(function (error, i) {
            return /*#__PURE__*/jsx("li", {
              children: error
            }, i);
          })
        })
      })]
    }), /*#__PURE__*/jsx("div", {
      className: "errorMessage",
      children: generalError
    }), /*#__PURE__*/jsx("div", {
      className: buttonClass,
      children: /*#__PURE__*/jsx(Button$1, {
        type: "solid",
        qaAttr: buttonText,
        disabled: buttonDisabled,
        onPress: function onPress() {
          if (formValid) onClick({
            name: name,
            email: email,
            password: password
          });
        },
        children: buttonText
      })
    })]
  });
};

var styles$a = "\n    .component-Login-LoginLayoutComponent-Layouts-CreateAccountLayout {\n        width: 100%;\n    }\n    @media (max-width: 905px) {\n      .component-Login-LoginLayoutComponent-Layouts-CreateAccountLayout{\n        margin-left: 2%;\n      }\n    }\n    .component-Login-LoginLayoutComponent-Layouts-CreateAccountLayout .email-button {\n        height: 40px;\n        height: 40px;\n        width: 98%;\n    }\n    .component-Login-LoginLayoutComponent-Layouts-CreateAccountLayout .email-button button {\n        height: 100%;\n        background-color: #a234b2 !important;\n\n    }\n    .component-Login-LoginLayoutComponent-Layouts-CreateAccountLayout .email-button button .call-to-action-button-text {\n        color: #fff;\n        -webkit-text-fill-color: #fff;\n    }\n";

var CreateAccountLayout = function CreateAccountLayout(_ref) {
  var onLogin = _ref.onLogin,
    usernameError = _ref.usernameError,
    onClick = _ref.onClick,
    handleEmailInput = _ref.handleEmailInput,
    handlePasswordInput = _ref.handlePasswordInput,
    handleEmailInputBlur = _ref.handleEmailInputBlur,
    handleNameInput = _ref.handleNameInput,
    handleNameInputBlur = _ref.handleNameInputBlur,
    handlePasswordInputBlur = _ref.handlePasswordInputBlur,
    nameError = _ref.nameError,
    emailError = _ref.emailError,
    passwordError = _ref.passwordError,
    generalError = _ref.generalError,
    showUsernameField = _ref.showUsernameField,
    handleUsernameInput = _ref.handleUsernameInput,
    callToActionSubTitle = _ref.callToActionSubTitle,
    loaded = _ref.loaded,
    leadInLogin = _ref.leadInLogin;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showEmailForm = _useState2[0],
    setShowEmailForm = _useState2[1];
  var openEmailForm = function openEmailForm() {
    setShowEmailForm(true);
  };
  var renderEmailButton = function renderEmailButton() {
    var iconSrc = buildImagePath('/v1541017253/Login/Mail.png', 'button');
    return !showEmailForm ? /*#__PURE__*/jsx("div", {
      className: "component-Input-ButtonWithChildren",
      children: /*#__PURE__*/jsx(Button$1, {
        className: "email-button",
        onPress: openEmailForm,
        children: /*#__PURE__*/jsxs("div", {
          className: "button-content-container",
          children: [/*#__PURE__*/jsx("img", {
            alt: "",
            src: iconSrc
          }), /*#__PURE__*/jsx("div", {
            className: "call-to-action-button-text",
            "data-qa": "continue",
            children: "Continue with email"
          })]
        })
      })
    }) : null;
  };
  return /*#__PURE__*/jsxs("div", {
    className: "component-Login-LoginLayoutComponent-Layouts-CreateAccountLayout",
    children: [/*#__PURE__*/jsx("style", {
      jsx: true,
      children: styles$a
    }), !showEmailForm && !leadInLogin && /*#__PURE__*/jsx("div", {
      className: "login-subText-call-to-action-component",
      children: truncateWithEllipsis(callToActionSubTitle, 80)
    }), leadInLogin && !showEmailForm && /*#__PURE__*/jsxs("div", {
      className: "login-subText-call-to-action-component",
      children: [/*#__PURE__*/jsx("b", {
        children: "Sign up to continue reading."
      }), " ", /*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsx("b", {
        children: "Fairygodboss"
      }), " is the largest career community for women. We help you achieve your career goals by providing community advice, connections, jobs, events and exclusive company intel from other women."]
    }), /*#__PURE__*/jsx(FacebookButton, {
      onClick: onLogin
    }), /*#__PURE__*/jsx(GoogleButton, {
      onClick: onLogin
    }), renderEmailButton(), showEmailForm && /*#__PURE__*/jsx(EmailLoginForm, {
      location: CREATE_LAYOUT,
      showUsernameField: showUsernameField,
      onClick: onClick,
      handleEmailInput: handleEmailInput,
      handleEmailInputBlur: handleEmailInputBlur,
      handlePasswordInput: handlePasswordInput,
      handlePasswordInputBlur: handlePasswordInputBlur,
      handleUsernameInput: handleUsernameInput,
      handleNameInput: handleNameInput,
      handleNameInputBlur: handleNameInputBlur,
      nameError: nameError,
      newEmailError: emailError,
      newPasswordError: passwordError,
      newUsernameError: usernameError,
      newGeneralError: generalError,
      loaded: loaded
    })]
  });
};

var styles$9 = "\n    .component-Login-LoginLayoutComponent-Layouts-FBReauthorizationConfirmationLayout {\n        width: 100%;\n        margin-bottom: 10px;\n        position: relative;\n        height: 100%;\n        .component-Input-Button {\n            position: absolute;\n            bottom: 0;\n        }\n        .login-subText-FGReauthorization {\n            font-family: \"Open Sans\", sans-serif;\n            font-weight: 400;\n            font-size: 16px;\n            font-style: italic;\n            text-align: center;\n            max-width: 300px;\n            margin: 120px auto 15px;\n        }\n    }\n";

var FBReauthorizationConfirmationLayout = function FBReauthorizationConfirmationLayout(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/jsxs("div", {
    className: "component-Login-LoginLayoutComponent-Layouts-FBReauthorizationConfirmationLayout",
    children: [/*#__PURE__*/jsx("style", {
      jsx: true,
      children: styles$9
    }), /*#__PURE__*/jsx("div", {
      className: "login-subText-FGReauthorization",
      children: "Your email has been saved. Please log in now."
    }), /*#__PURE__*/jsx("div", {
      children: /*#__PURE__*/jsx(Button$1, {
        type: "solid",
        value: "Back to login",
        onClick: onClick
      })
    })]
  });
};

var styles$8 = "\n    .component-Login-LoginLayoutComponent-Layouts-FBReauthorizationLayout {\n        width: 100%;\n        margin-bottom: 10px;\n        position: relative;\n        height: 100%;\n        .component-Input-Button {\n            position: absolute;\n            bottom: 0;\n        }\n        .FGReauthorizationLayout-subText-call-to-action-component {\n            font-family: \"Open Sans\", sans-serif;\n            font-weight: 400;\n            font-size: 16px;\n            font-style: italic;\n            text-align: center;\n            max-width: 300px;\n            margin: 120px auto 15px;\n        }\n    }\n";

var FBReauthorizationLayout = function FBReauthorizationLayout(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/jsxs("div", {
    className: "component-Login-LoginLayoutComponent-Layouts-FBReauthorizationLayout",
    children: [/*#__PURE__*/jsx("style", {
      jsx: true,
      children: styles$8
    }), /*#__PURE__*/jsxs("div", {
      className: "FGReauthorizationLayout-subText-call-to-action-component",
      children: ["An email is required for registration. Please add the email permission from Facebook and ensure you have a primary contact email address saved in\xA0", /*#__PURE__*/jsx("a", {
        target: "_blank",
        href: "https://www.facebook.com/help/166986580029611",
        rel: "noreferrer",
        children: "General Account Settings"
      })]
    }), /*#__PURE__*/jsx("div", {
      children: /*#__PURE__*/jsx(Button$1, {
        type: "solid",
        value: "Resend Permission",
        onPress: onClick
      })
    })]
  });
};

var styles$7 = "\n    .component-Login-LoginLayoutComponent-Layouts-LogInLayout {\n        width: 100%;\n      }\n      @media (max-width: 905px){\n        .component-Login-LoginLayoutComponent-Layouts-LogInLayout {\n          margin-left:2%;\n        }\n      }\n        .forgot-password-link {\n            margin-top: 10px;\n            font-family: \"Open Sans\", sans-serif;\n            font-weight: 700;\n            font-size: 12px;\n            font-style: italic;\n            width: 100%;\n            display: flex;\n            justify-content: flex-end;\n        }\n        @media (max-width: 905px){\n          .forgot-password-link {\n            width: 98%;\n          }\n        }\n        .forgot-password-link a, .forgot-password-link a:link {\n            color: #a234b2;\n            -webkit-text-fill-color: #a234b2;\n        }\n    }\n";

var LogInLayout = function LogInLayout(_ref) {
  var onLogin = _ref.onLogin,
    handleEmailInput = _ref.handleEmailInput,
    handlePasswordInput = _ref.handlePasswordInput,
    email = _ref.email,
    callToActionSubTitle = _ref.callToActionSubTitle,
    password = _ref.password,
    emailError = _ref.emailError,
    passwordError = _ref.passwordError,
    generalError = _ref.generalError,
    loaded = _ref.loaded,
    resetPasswordCallBack = _ref.resetPasswordCallBack;
  return /*#__PURE__*/jsxs("div", {
    className: "component-Login-LoginLayoutComponent-Layouts-LogInLayout",
    children: [/*#__PURE__*/jsx("style", {
      jsx: true,
      children: styles$7
    }), /*#__PURE__*/jsx("div", {
      className: "login-subText-call-to-action-component",
      children: truncateWithEllipsis(callToActionSubTitle, 80)
    }), /*#__PURE__*/jsx(FacebookButton, {
      onClick: onLogin
    }), /*#__PURE__*/jsx(GoogleButton, {
      onClick: onLogin
    }), /*#__PURE__*/jsx(EmailLoginForm, {
      location: LOGIN_LAYOUT,
      onClick: onLogin,
      handleEmailInput: handleEmailInput,
      handlePasswordInput: handlePasswordInput,
      email: email,
      password: password,
      newEmailError: emailError,
      newPasswordError: passwordError,
      newGeneralError: generalError,
      loaded: loaded
    }), /*#__PURE__*/jsx("div", {
      className: "forgot-password-link",
      children: /*#__PURE__*/jsxs(_StyledButton$2, {
        type: "button",
        role: "button",
        variant: "primaryLink",
        onKeyPress: resetPasswordCallBack,
        onPress: resetPasswordCallBack,
        children: ["Forgot Password", '>']
      })
    })]
  });
};
var _StyledButton$2 = /*#__PURE__*/styled(Button$1).withConfig({
  displayName: "LogInLayout___StyledButton",
  componentId: "sc-er33mt-0"
})({
  textAlign: 'right'
});

var styles$6 = "\n    .component-Login-LoginLayoutComponent-Layouts-ResetPasswordConfirmationLayout {\n        width: 100%;\n        margin-bottom: 10px;\n        position: relative;\n        height: 100%;\n        min-height: 400px;\n    }\n    .component-Login-LoginLayoutComponent-Layouts-ResetPasswordConfirmationLayout .component-Input-Button {\n        position: absolute;\n        bottom: 0;\n    }\n    .component-Login-LoginLayoutComponent-Layouts-ResetPasswordConfirmationLayout .reset-password-confirmation-layout-subText-call-to-action-component {\n        font-family: \"Open Sans\", sans-serif;\n        font-weight: 400;\n        font-size: 16px;\n        font-style: italic;\n        text-align: center;\n        max-width: 300px;\n        margin: 120px auto;\n    }\n\n    .component-Login-LoginLayoutComponent-Layouts-ResetPasswordConfirmationLayout .reset-password-confirmation-layout-button-wrapper {\n      display: flex;\n      justify-content: center;\n      aling-content: center;\n      direction: row;\n      font-family: 'Open Sans';\n      font-size: 16px;\n      position: relative;\n      bottom: -55px;\n    }\n\n    .component-Login-LoginLayoutComponent-Layouts-ResetPasswordConfirmationLayout .reset-password-confirmation-layout-button-wrapper button {\n      width: 95%;\n      max-width: 400px;\n      margin-bottom: 20px;\n    }\n";

var ResetPasswordConfirmationLayout = function ResetPasswordConfirmationLayout(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/jsxs("div", {
    className: "component-Login-LoginLayoutComponent-Layouts-ResetPasswordConfirmationLayout",
    children: [/*#__PURE__*/jsx("style", {
      jsx: true,
      children: styles$6
    }), /*#__PURE__*/jsx("div", {
      className: "reset-password-confirmation-layout-subText-call-to-action-component",
      children: "Great. If your account exists in our database, you will receive an email with instructions on how to reset your password."
    }), /*#__PURE__*/jsx("div", {
      className: "reset-password-confirmation-layout-button-wrapper",
      children: /*#__PURE__*/jsx(Button$1, {
        type: "solid",
        onPress: onClick,
        children: "Back to login"
      })
    })]
  });
};

var styles$5 = "\n    .component-Login-LoginLayoutComponent-Layouts-ResetPasswordLayout    {\n        width: 100%;\n        margin-bottom: 10px;\n        position: relative;\n        height: 100%;\n        min-height: 320px;\n     }\n     .component-Login-LoginLayoutComponent-Layouts-ResetPasswordLayout   .input-section {\n            margin-top: 0 !important;\n        }\n     .component-Login-LoginLayoutComponent-Layouts-ResetPasswordLayout   .component-Input-Button {\n            position: absolute;\n            bottom: -30px;\n        }\n     .component-Login-LoginLayoutComponent-Layouts-ResetPasswordLayout input {\n        height: 40px;\n        background-color: #f3f5f8;\n        width: 98%;\n        color: #95989c;\n        border-radius: 0px;\n    }\n     .component-Login-LoginLayoutComponent-Layouts-ResetPasswordLayout   .errorMessage {\n            text-align: left;\n            font-family: \"Open Sans\", sans-serif;\n            font-style: italic;\n            font-size: 12px;\n            font-weight: 700;\n            color: #ff4578;\n        }\n     .component-Login-LoginLayoutComponent-Layouts-ResetPasswordLayout   .component-Input-InputField input {\n            height: 40px;\n       }\n     .component-Login-LoginLayoutComponent-Layouts-ResetPasswordLayout     .actionButton button {\n         bottom: -30px;\n        position: absolute;\n        width: 100%;\n        height: 38px;\n        font-family: \"Open Sans\", sans-serif;\n\n        font-size: 16px;\n        font-weight: 400;\n     }\n     .component-Login-LoginLayoutComponent-Layouts-ResetPasswordLayout     .actionButton button:disable {\n       background-color: #95989c!important;\n      }\n    }\n";

var ResetPasswordLayout = function ResetPasswordLayout(_ref) {
  var handleEmailInput = _ref.handleEmailInput,
    onClick = _ref.onClick,
    _ref$callToActionSubT = _ref.callToActionSubTitle,
    callToActionSubTitle = _ref$callToActionSubT === void 0 ? '' : _ref$callToActionSubT;
  var _useContext = useContext(CurrentLogin),
    loaded = _useContext.loaded,
    emailError = _useContext.emailError;
  var onKeyPress = function onKeyPress(e) {
    if (e.key === 'Enter') {
      onClick({
        email: email
      });
    }
  };
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    email = _React$useState2[0],
    setEmail = _React$useState2[1];
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    buttonDisabled = _React$useState4[0],
    setButtonDisabled = _React$useState4[1];
  useEffect(function () {
    if (email.length > 0) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [email]);
  var buttonText = !loaded ? 'Processing' : 'Submit';
  return /*#__PURE__*/jsxs("div", {
    className: "component-Login-LoginLayoutComponent-Layouts-ResetPasswordLayout",
    children: [/*#__PURE__*/jsx("style", {
      jsx: true,
      children: styles$5
    }), /*#__PURE__*/jsx("div", {
      className: "login-subText-call-to-action-component",
      children: truncateWithEllipsis(callToActionSubTitle, 100)
    }), /*#__PURE__*/jsxs("div", {
      className: "input-section reset-password-input-field email-field",
      children: [/*#__PURE__*/jsx("div", {
        className: "form-label reset-password-input-field-label",
        children: "Email"
      }), /*#__PURE__*/jsx(InputField, {
        name: "email-input-reset-password",
        qaDataAttr: "email",
        onChange: function onChange(e) {
          handleEmailInput(e.target.value);
          setEmail(e.target.value);
        },
        onKeyPress: onKeyPress,
        value: email
      }), /*#__PURE__*/jsx("div", {
        className: "errorMessage",
        children: emailError
      })]
    }), /*#__PURE__*/jsx("div", {
      className: "actionButton",
      children: /*#__PURE__*/jsx(Button$1, {
        type: "solid",
        qaAttr: buttonText,
        disabled: buttonDisabled,
        onPress: function onPress() {
          return onClick({
            email: email
          });
        },
        children: buttonText
      })
    })]
  });
};

var bottomspacing = "\n .bottom-spacing {\n        margin-bottom: 28px;\n        margin-top: 50px;\n    }\n    .small-screen-fix {\n        align-self: flex-start;\n        margin-top: -18px;\n    }\n    @media only screen and (min-width: 360px) {\n        .small-screen-fix {\n            margin-top: 10px;\n            align-self: center;\n        }\n    }\n    @media only screen and (max-width: 905px) {\n        .popup-layout-header-components {\n            margin-top: 10px;\n            margin-left: 10px;\n        }\n     }\n    ";
var leadLogin = "\n.leadInLogin .switch-layout-component {\n        font-style: normal;\n        color: #566d96;\n        font-family: \"Open Sans\", sans-serif;\n        font-weight: 700;\n        font-size: 13px;\n        line-height: 20px;\n        margin-top: 10px;\n        a-color: #566d96;\n    }\n    .disclosure-text-component {\n        position: absolute;\n        bottom: 0;\n        right: 0;\n        left: 0;\n        font-family: \"Open Sans\", sans-serif;\n        font-weight: 400;\n        font-size: 12px;\n        font-style: italic;\n        text-align: center;\n        width: 100%;\n        margin-top: 10px;\n    }\n    .disclosure-text-component .text {\n        max-width: 280px;\n        margin: 0 auto 20px;\n    }\n    .disclosure-text-component a, .disclosure-text-component a:link,\n    .disclosure-text-component a:not([href], [tabindex]):focus,\n    .disclosure-text-component a:not([href], [tabindex]):hover {\n        color: #a234b2;\n    }\n    .leadInLogin .disclosure-text-component {\n        position: inherit;\n        margin-top: 18px;\n        color: #353535;\n    }\n    @media only screen and (max-width: \"540px\") {\n        .leadInLogin .disclosure-text-component {\n            margin-top: 52px;\n        }\n    }\n";
var inputSection = "\n.input-section {\n        margin-top: 16px;\n    }\n    .input-section .form-label {\n        font-family: \"Open Sans\", sans-serif;\n        font-style: italic;\n        font-weight: 700;\n        font-size: 12px;\n    }\n    .input-section .component-Input-InputField {\n        width: 100%;\n    }\n    .input-section .component-Input-InputField .input {\n        width: 100%;\n        font-family: \"Open Sans\", sans-serif;\n        font-style: italic;\n        color: #95989c;\n        background-color: #f3f5f8;\n    }\n    ";
var switches = "\n .switch-layout-component {\n        font-family: \"Open Sans\", sans-serif;\n        font-weight: 700;\n        font-size: 12px;\n        font-style: italic;\n        margin-top: 20px;\n        margin-bottom: 50px;\n    }\n    .switch-layout-component a, .switch-layout-component a:link,\n     .switch-layout-component a:not([href],\n      [tabindex]):focus,\n       .switch-layout-component a:not([href],\n       [tabindex]):hover {\n        cursor: pointer;\n        color: #a234b2;\n    }\n";
var inputButton = "\n .component-Input-ButtonWithChildren button:focus-visible {\n        border: 1px solid #dfe5f2;\n    }\n    .component-Input-ButtonWithChildren .button-content-container {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .component-Input-ButtonWithChildren .button-content-container .call-to-action-button-text {\n        width: 145px;\n        margin-left: 10px;\n        text-align: left;\n    }\n";
var loginLayout = "\n .login-layout-main-header {\n        font-family: \"Open Sans\", sans-serif;\n        font-weight: 200;\n        font-size: 28px;\n        padding-bottom: 10px;\n        border-bottom: 1px solid #e0e0e0;\n        width: 100%;\n        text-align: center;\n        margin-bottom: 10px;\n    }\n    .leadInLogin .login-layout-main-header {\n        display: none;\n    }\n    .login-subText-call-to-action-component {\n        font-family: \"Open Sans\", sans-serif;\n        font-weight: 400;\n        font-size: 16px;\n        font-style: italic;\n        text-align: center;\n        max-width: 300px;\n        margin: 0 auto 15px;\n    }\n";
var popup = "\n.popup-layout-header-components .close {\n        height: 22px;\n        cursor: pointer;\n    }\n    .leadInLogin .popup-layout-header-components {\n        justify-content: center;\n        width: 126px;\n    }\n    @media only screen and (max-width: \"540px\") {\n        .leadInLogin .popup-layout-header-components {\n            margin-bottom: 12px;\n        }\n    }\n    .input-section .component-Input-InputField .input:hover,\n    .input-section .component-Input-InputField .input:focus,\n    .input-section .component-Input-InputField .textarea:hover,\n    .input-section .component-Input-InputField .textarea:focus {\n        border: 1px solid #dfe5f2 !important;\n    }\n";
var styles$4 = "\n.component-Login-LoginLayoutComponent {\n    width: 100%;\n    margin: 0;\n    height: fit-content;\n    min-height: 570px;\n    background-color: white;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    position: relative;\n   }\n   .component-Login-LoginLayoutComponent.wide{\n    width: 95%;\n    padding: 20px 10px;\n    margin-right: 5px;\n   }\n    .popup-layout-header-components {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 15px;\n    }\n\n    ".concat(popup, "\n    ").concat(loginLayout, "\n    ").concat(inputButton, "\n    ").concat(switches, "\n    ").concat(inputSection, "\n    ").concat(leadLogin, "\n    ").concat(bottomspacing, "\n}\n");

var styles$3 = "\n  @keyframes fade-in {\n    0% {\n      opacity: 0;\n    }\n  }\n  @keyframes slide-up {\n    0% {\n      transform: translateY(10%);\n    }\n  }\n  .modal {\n    -webkit-font-smoothing: antialiased;\n    animation: fade-in 400ms 200ms both, slide-up 400ms 200ms both;\n    background-color: white;\n    border-radius: 0px;\n    border: 0 none;\n    box-sizing: border-box;\n    overflow:scroll;\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    padding: 0;\n    position: fixed;\n    text-rendering: optimizeLegibility;\n    width: 100%;\n    z-index: 999;\n    overflow: hidden;\n  }\n\n  @media (min-width: 768px) {\n    .modal {\n      height: fit-content;\n      margin: auto;\n      max-height: 100%;\n      max-width: fit-content;\n      overflow-y:auto;\n      width: fit-content;\n    }\n  }\n  .modal::backdrop {\n    background-color: rgba(0, 0, 0, 0.65);\n    transition: 0.5s;\n  }\n  .closeButton {\n    background-color: transparent;\n    border: none;\n    color: inherit;\n    cursor: pointer;\n    font: inherit;\n    line-height: 0;\n    margin: 4px;\n    padding: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n  }\n  .closeButton:hover {\n    background-color: transparent ;\n    border-radius: 4px;\n  }\n  .closeButton:active {\n    background-color: transparent;\n    outline: none;\n  }\n  .closeButton:focus:not(:active) {\n    border-radius: 4px;\n    box-shadow: 0 0 4px 2px blue;\n    box-sizing: border-box;\n    outline: none;\n  }\n  .closeButton svg {\n    padding: 8px;\n    box-sizing: content-box;\n    opacity: .5;\n    text-shadow: 0 1px 0 #fff;\n  }\n  .closeButton svg:hover {\n    color: #000;\n    opacity: .75;\n    text-decoration: none;\n   }\n  .screenreaderText {\n    border: 0;\n    clip-path: inset(50%);\n    clip: rect(1px, 1px, 1px, 1px);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n    word-wrap: normal;\n  }\n  .content {\n    box-sizing: border-box;\n    overflow: hidden;\n    padding: 10px;\n    position: relative;\n  }\n  @media (min-width: 520px) {\n    .closeButton {\n      right:10px;\n    }\n  }\n\n  @media (max-width: 768px) {\n    .content.wide .closeButton svg path {\n      fill: #FFF;\n      }\n  }\n\n  @media (min-width: 768px) {\n    .content {\n      width: 512px;\n    }\n\n    .content.wide {\n      width: 680px;\n      padding:0px\n    }\n\n  }\n  @media (max-width: 905px)  and (orientation: portrait) {\n    .content {\n      width:340px;\n      background-color: white;\n      margin-left: auto;\n      margin-right: auto;\n    }\n    .modal {\n      background-color: transparent;\n      margin-top: 5%;\n      height: 580px;\n      width: 340px;\n      overflow: scroll;\n    }\n    .closeButton{\n        margin-top: 10px;\n        margin-right: 5px;\n     }\n   }\n    @media (max-width: 905px)  and (orientation: landscape) {\n      .content {\n        width:340px;\n        background-color: white;\n        margin-left: auto;\n        margin-right: auto;\n      }\n      .modal {\n        background-color: transparent;\n        margin-top: 2%;\n        height: 570px;\n        width: 340px;\n        overflow: scroll;\n      }\n      .closeButton{\n          margin-top: 20px;\n          margin-right: 10px;\n       }\n   }\n";

/**
 * Generate the X button in the top right of the modal.
 * @param {boolean} props.isPayWall - Is this a paywall and should not be closeable.
 * @param {function} props.closeModal - An additional function to call when the modal is closed in any way.
 * @param {string} props.closeButtonClassNames - Additional styling for the close button.
 * @returns A close button that appears in the top right of the modal.
 */
var DefaultCloseButton = function DefaultCloseButton(props) {
  var isPayWall = props.isPayWall,
    closeModal = props.closeModal,
    closeButtonClassNames = props.closeButtonClassNames,
    allowClosing = props.allowClosing;
  // if we are a paywall we do not get a close button.
  if (isPayWall && !allowClosing) return null;
  return jsx("button", Object.assign({
    className: "closeButton ".concat(closeButtonClassNames || null),
    onClick: function onClick(e) {
      return closeModal(e);
    },
    type: "button",
    "aria-label": "close dialog"
  }, {
    children: jsx(Icon$1, {
      variant: "close_20"
    }, void 0)
  }), void 0);
};
/**
 * Generate a modal attached as a portal.
 * @param {string} props.closeButtonClassName - An optional CSS module to override the close button styles.
 * @param {string} props.containerClassName - An optional CSS module to override the container styles.
 * @param {string} props.contentClassName - An optional CSS module to override the content styles.
 * @param {number} props.timer - An optional time in seconds to wait for the modal to auto open.
 * @param {function} props.onClose - An optional external function to call when the modal closes.
 * @param {function} props.onOpen - An optional external function to call when the modal opens.
 * @param {boolean} props.isPayWall - Is this a paywall and therefore can not be closed?
 * @param {boolean} props.isOpen - Is the modal currently open. Can be controlled from outside.
 * @param {string} props.label - Announces the modal by name to users with assistive devices
 * @example <Modal {...args}><CONTENT /></Modal>
 * @returns An ADA compliant modal as a [React Portal](https://reactjs.org/docs/portals.html).
 */
var ModalStyles = function ModalStyles(props) {
  var children = props.children,
    _props$closeButtonCla = props.closeButtonClassName,
    closeButtonClassName = _props$closeButtonCla === void 0 ? '' : _props$closeButtonCla,
    _props$containerClass = props.containerClassName,
    containerClassName = _props$containerClass === void 0 ? '' : _props$containerClass,
    _props$contentClassNa = props.contentClassName,
    contentClassName = _props$contentClassNa === void 0 ? '' : _props$contentClassNa,
    _props$timer = props.timer,
    timer = _props$timer === void 0 ? 0 : _props$timer,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? function () {} : _props$onClose,
    _props$onOpen = props.onOpen,
    onOpen = _props$onOpen === void 0 ? function () {} : _props$onOpen,
    _props$isPayWall = props.isPayWall,
    isPayWall = _props$isPayWall === void 0 ? false : _props$isPayWall,
    _props$allowClosing = props.allowClosing,
    allowClosing = _props$allowClosing === void 0 ? true : _props$allowClosing,
    _props$isOpen = props.isOpen,
    isOpen = _props$isOpen === void 0 ? true : _props$isOpen,
    _props$label = props.label,
    label = _props$label === void 0 ? 'A basic modal.' : _props$label,
    _props$key = props.key,
    key = _props$key === void 0 ? 'basic-modal' : _props$key,
    restProps = __rest(props, ["children", "closeButtonClassName", "containerClassName", "contentClassName", "timer", "onClose", "onOpen", "isPayWall", "allowClosing", "isOpen", "label", "key"]);
  var _React$useState = React.useState(timer * 1000),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    timerMilliseconds = _React$useState2[0],
    setTimerMilliseconds = _React$useState2[1];
  var _React$useState3 = React.useState(isOpen),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    open = _React$useState4[0],
    setOpen = _React$useState4[1];
  var _React$useState5 = React.useState(isOpen),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    modalIsOpen = _React$useState6[0],
    setModalIsOpen = _React$useState6[1];
  var bodyRef = React.useRef();
  var dialogRef = React.useRef(null);
  bodyRef.current = document.body;
  var toggleBodyScroll = function toggleBodyScroll(scroll) {
    var ref = bodyRef.current;
    ref.style.overflow = scroll ? 'auto' : 'hidden';
  };
  var openModal = React.useCallback(function () {
    var _a, _b;
    if ((dialogRef === null || dialogRef === void 0 ? void 0 : dialogRef.current) && !((_a = dialogRef === null || dialogRef === void 0 ? void 0 : dialogRef.current) === null || _a === void 0 ? void 0 : _a.open)) {
      toggleBodyScroll(false);
      (_b = dialogRef === null || dialogRef === void 0 ? void 0 : dialogRef.current) === null || _b === void 0 ? void 0 : _b.showModal();
      setModalIsOpen(true);
      onOpen();
    }
  }, [onOpen]);
  var closeModal = React.useCallback(function () {
    var _a, _b;
    if ((_a = dialogRef === null || dialogRef === void 0 ? void 0 : dialogRef.current) === null || _a === void 0 ? void 0 : _a.open) {
      toggleBodyScroll(true);
      (_b = dialogRef === null || dialogRef === void 0 ? void 0 : dialogRef.current) === null || _b === void 0 ? void 0 : _b.close();
      setModalIsOpen(false);
      onClose();
    }
  }, [onClose]);
  var handleBackdropClick = function handleBackdropClick(e) {
    var _a;
    // We do not allow paywalls to close.
    if (isPayWall && !allowClosing) return;
    // If we are the base dialog or by extension its backdrop, Close. Inner elements behave as normal.
    if (((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.nodeName) === 'DIALOG') {
      closeModal();
    }
  };
  var closeButtonClassNames = cn('closeButton', closeButtonClassName);
  var containerClassNames = cn('modal', containerClassName);
  var contentClassNames = cn('content', contentClassName);
  // We have to remove the default open attribute so we can programmatically change it later.
  React.useEffect(function () {
    var _a;
    (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.removeAttribute('open');
  }, []);
  // Internally set the timeout.
  React.useEffect(function () {
    if (timerMilliseconds) {
      setTimeout(function () {
        setTimerMilliseconds(0);
        setOpen(true);
      }, timerMilliseconds);
    }
  }, [timerMilliseconds]);
  React.useEffect(function () {
    if (isOpen && !timerMilliseconds) {
      // all setup processes are async so we pop the stack.
      setTimeout(function () {
        return openModal();
      }, 0);
    }
  }, [isOpen, openModal, timerMilliseconds]);
  React.useEffect(function () {
    if (!isOpen && modalIsOpen) {
      closeModal();
    }
  }, [isOpen, modalIsOpen, closeModal]);
  return /*#__PURE__*/ReactDOM.createPortal(jsxs(Fragment, {
    children: [jsx("style", {
      children: styles$3
    }, void 0), /*#__PURE__*/createElement$2("dialog", Object.assign({
      "aria-live": "polite",
      "aria-atomic": "true",
      "aria-label": label,
      "aria-modal": open,
      "aria-hidden": !open
    }, restProps, {
      className: containerClassNames,
      ref: dialogRef,
      onClick: handleBackdropClick,
      key: key
    }), jsxs("div", Object.assign({
      className: contentClassNames
    }, {
      children: [children, jsx(DefaultCloseButton, Object.assign({}, {
        isPayWall: isPayWall,
        closeButtonClassNames: closeButtonClassNames,
        closeModal: closeModal,
        allowClosing: allowClosing
      }), void 0)]
    }), void 0))]
  }, void 0), document.body);
};
ModalStyles.displayName = 'Modal';
var Modal = ModalStyles;

var LeadLoginImage = function LeadLoginImage(_ref) {
  var image = _ref.image,
    title = _ref.title,
    description = _ref.description,
    buttonText = _ref.buttonText,
    setShowLeadImage = _ref.setShowLeadImage,
    loginMetrics = _ref.loginMetrics;
  var bgImageUrl = getCloudinaryImagePathById(image, 'customStyle', {
    customStyle: 'ar_4:3,c_crop/c_fit,w_400'
  });
  return /*#__PURE__*/jsxs("div", {
    className: "component-Login-LoginWall-LoginImageContainer",
    children: [/*#__PURE__*/jsx("style", {
      jsx: true,
      children: "\n                .component-Login-LoginWall-LoginImageContainer {\n                    width: 100%;\n                    height: 100%;\n                    position: relative;\n                }\n                .component-Login-LoginWall-LoginImageContainer\n                    > .wall-background {\n                    width: 100%;\n                    height: 100%;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    flex-direction: column;\n                }\n                .component-Login-LoginWall-LoginImageContainer\n                    > .wall-background\n                    .bg-image {\n                    background-size: cover;\n                    width: 100%;\n                    height: 254px;\n                    background-repeat: no-repeat;\n                }\n                @media (max-width: 905px) {\n                    .component-Login-LoginWall-LoginImageContainer {\n                        height: 560px;\n                    }\n                    .component-Login-LoginWall-LoginImageContainer\n                        > .wall-background {\n                        height: 560px;\n                    }\n                }\n                .component-Login-LoginWall-LoginImageContainer\n                    > .wall-background\n                    .bg-color {\n                    width: 100%;\n                    background-color: #213559;\n                    height: -webkit-calc(100% - 254px);\n                    height: -moz-calc(100% - 254px);\n                    height: calc(100% - 254px);\n                }\n                .component-Login-LoginWall-LoginImageContainer > .wall-content {\n                    width: 100%;\n                    height: 100%;\n                    position: absolute;\n                    top: 0;\n                    display: flex;\n                    flex-direction: column;\n                    align-items: center;\n                }\n                .component-Login-LoginWall-LoginImageContainer\n                    > .wall-content\n                    > .close {\n                    position: absolute;\n                    top: 35px;\n                    right: 35px;\n                }\n                .component-Login-LoginWall-LoginImageContainer\n                    > .wall-content\n                    .msg-box {\n                    width: 215px;\n                    max-height: 280px;\n                    border-radius: 12px;\n                    background-color: #fff;\n                    margin-top: 206px;\n                    display: flex;\n                    flex-direction: column;\n                    justify-content: center;\n                    padding: 30px 35px;\n                }\n                .component-Login-LoginWall-LoginImageContainer\n                    > .wall-content\n                    .msg-box\n                    .title,\n                .component-Login-LoginWall-LoginImageContainer\n                    > .wall-content\n                    .msg-box\n                    .description {\n                    width: 100%;\n                    height: auto;\n                    font-stretch: normal;\n                    text-align: center;\n                    color: #353535;\n                    overflow-wrap: break-word;\n                    overflow: hidden;\n                }\n                .component-Login-LoginWall-LoginImageContainer\n                    > .wall-content\n                    .msg-box\n                    .title {\n                    font-family: 'Open Sans', sans-serif;\n                    font-size: 24px;\n                    font-weight: 100;\n                    font-style: normal;\n                    line-height: 1.29;\n                    letter-spacing: -0.4px;\n                }\n                .component-Login-LoginWall-LoginImageContainer\n                    > .wall-content\n                    .msg-box\n                    .description {\n                    font-family: 'Open Sans', sans-serif;\n                    font-size: 16px;\n                    font-weight: 400;\n                    font-style: italic;\n                    line-height: 1.44;\n                    letter-spacing: normal;\n                    padding-top: 15px;\n                }\n                .component-Login-LoginWall-LoginImageContainer\n                    > .wall-content\n                    > .wall-button {\n                    font-family: 'Open Sans', sans-serif;\n                    width: 180px;\n                    height: 40px;\n                    position: relative;\n                    top: 20px;\n                }\n                .component-Login-LoginWall-LoginImageContainer\n                    > .wall-content\n                    > .wall-button\n                    .inputStyle {\n                    width: 180px;\n                    height: 40px;\n                    margin-top: 20px;\n                }\n            "
    }), /*#__PURE__*/jsxs("div", {
      className: "wall-background",
      children: [/*#__PURE__*/jsx("div", {
        className: "bg-image",
        style: {
          backgroundImage: "url(".concat(bgImageUrl, ")")
        }
      }), /*#__PURE__*/jsx("div", {
        className: "bg-color"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: "wall-content",
      children: [/*#__PURE__*/jsxs("div", {
        className: "msg-box",
        children: [/*#__PURE__*/jsx("div", {
          className: "title",
          children: title
        }), /*#__PURE__*/jsx("div", {
          className: "description",
          children: description
        })]
      }), /*#__PURE__*/jsx(Button$1, {
        className: "wall-button",
        display: {
          _: 'block',
          md: 'none'
        },
        onPress: function onPress() {
          setShowLeadImage(false);
          EmitMetric(Object.assign({}, loginMetrics, {
            misc_event_type: 'signup-wall-button',
            misc_event_count: 1
          }));
        },
        children: buttonText
      })]
    })]
  });
};

var _excluded$1 = ["fireMultiple"];
var CurrentLogin = /*#__PURE__*/createContext({
  loaded: true
});
var AuthModal = function AuthModal(_ref) {
  var displayMode = _ref.displayMode,
    layoutType = _ref.layoutType,
    setLayoutType = _ref.setLayoutType,
    auth0 = _ref.auth0,
    loginRedirectPath = _ref.loginRedirectPath,
    loginMetrics = _ref.loginMetrics,
    regWallInfo = _ref.regWallInfo,
    incompleteRegistrationId = _ref.incompleteRegistrationId,
    invitationToken = _ref.invitationToken,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    allowClosing = _ref.allowClosing,
    inviteHash = _ref.inviteHash,
    groupInviteHash = _ref.groupInviteHash,
    connectionInviteHash = _ref.connectionInviteHash,
    callToActionSubTitle = _ref.callToActionSubTitle,
    leadInLogin = _ref.leadInLogin,
    setLeadLoginInPopup = _ref.setLeadLoginInPopup,
    leadInPopup = _ref.leadInPopup,
    employerInviteHash = _ref.employerInviteHash,
    isOpen = _ref.isOpen,
    isPayWall = _ref.isPayWall;
  var _React$useState = React.useState(layoutType),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    layout = _React$useState2[0];
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    showLeadImage = _React$useState4[0],
    setShowLeadImage = _React$useState4[1];
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    password = _React$useState6[0],
    setPassword = _React$useState6[1];
  var _React$useState7 = React.useState(true),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    loaded = _React$useState8[0],
    setLoaded = _React$useState8[1];
  var _React$useState9 = React.useState(null),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    email = _React$useState10[0],
    setEmail = _React$useState10[1];
  var _React$useState11 = React.useState(null),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    emailError = _React$useState12[0],
    setEmailError = _React$useState12[1];
  var _React$useState13 = React.useState(null),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    passwordError = _React$useState14[0],
    setPasswordError = _React$useState14[1];
  var _React$useState15 = React.useState(null),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    nameError = _React$useState16[0],
    setNameError = _React$useState16[1];
  var _React$useState17 = React.useState(null),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    usernameError = _React$useState18[0],
    setUsernameError = _React$useState18[1];
  var _React$useState19 = React.useState(null),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    generalError = _React$useState20[0],
    setGeneralError = _React$useState20[1];
  var renderComponents = function renderComponents(newLayout) {
    var titleText = null;
    var optionChangeComponent = null;
    var Component = null;
    var onCreateLayoutPress = function onCreateLayoutPress() {
      if (leadInLogin && setLeadLoginInPopup) {
        setLeadLoginInPopup(true, true);
      }
      changeLayoutState(LOGIN_LAYOUT);
    };
    switch (newLayout) {
      case CREATE_LAYOUT:
        titleText = 'Create an account';
        optionChangeComponent = /*#__PURE__*/jsxs("div", {
          className: "switch-layout-component",
          children: ["Already a member?", ' ', /*#__PURE__*/jsxs("a", {
            type: "button",
            role: "button",
            onKeyPress: onCreateLayoutPress,
            onClick: onCreateLayoutPress,
            children: ["Log in ", !leadInLogin ? '>' : '']
          })]
        });
        Component = /*#__PURE__*/jsx(CreateAccountLayout, {
          changeLayoutState: changeLayoutState,
          leadInLogin: leadInLogin,
          auth0: auth0,
          setAuth0ErrorMsg: resetErrorState,
          emailError: emailError,
          usernameError: usernameError,
          nameError: nameError,
          handleNameInput: handleNameInput,
          onClick: onClick,
          passwordError: passwordError,
          generalError: generalError,
          handleEmailInput: handleCreateLayoutEmailInput,
          handleUsernameInput: handleUsernameInput,
          handlePasswordInput: handleCreateLayoutPasswordInput,
          onLogin: onInternalSignup,
          loaded: loaded,
          callToActionSubTitle: callToActionSubTitle,
          invitationToken: invitationToken,
          loginMetrics: loginMetrics,
          incompleteRegistrationId: incompleteRegistrationId
        });
        break;
      case LOGIN_LAYOUT:
        titleText = loginMetrics && loginMetrics.login_trigger === 'employer-login' ? 'Employer Login' : 'Log In';
        optionChangeComponent = /*#__PURE__*/jsxs("div", {
          className: "switch-layout-component small-screen-fix",
          children: ["Not a member yet?", ' ', /*#__PURE__*/jsxs("a", {
            type: "button",
            role: "button",
            onKeyPress: function onKeyPress() {
              return changeLayoutState(CREATE_LAYOUT);
            },
            onClick: function onClick() {
              return changeLayoutState(CREATE_LAYOUT);
            },
            children: ["Join us ", '>']
          })]
        });
        Component = /*#__PURE__*/jsx(LogInLayout, {
          resetPasswordCallBack: function resetPasswordCallBack() {
            return changeLayoutState(RESET_PASSWORD_LAYOUT);
          },
          onLogin: onLoginInternal,
          emailError: emailError,
          passwordError: passwordError,
          generalError: generalError,
          handleEmailInput: handleEmailInput,
          handlePasswordInput: handlePasswordInput,
          email: email,
          password: password,
          loaded: loaded,
          callToActionSubTitle: callToActionSubTitle
        });
        break;
      case RESET_PASSWORD_LAYOUT:
        titleText = 'Reset your password';
        optionChangeComponent = /*#__PURE__*/jsxs("div", {
          className: "switch-layout-component bottom-spacing",
          children: ["Back to", ' ', /*#__PURE__*/jsxs("a", {
            type: "button",
            role: "button",
            onKeyPress: function onKeyPress() {
              return changeLayoutState(LOGIN_LAYOUT);
            },
            onClick: function onClick() {
              return changeLayoutState(LOGIN_LAYOUT);
            },
            children: ["Login ", '>']
          })]
        });
        Component = /*#__PURE__*/jsx(ResetPasswordLayout, {
          onClick: internalPasswordReset,
          handleEmailInput: handleEmailInput,
          email: email,
          newEmailError: emailError,
          loaded: loaded,
          callToActionSubTitle: callToActionSubTitle
        });
        break;
      case RESET_PASSWORD_CONFIRMATION_LAYOUT:
        titleText = 'Reset your password';
        optionChangeComponent = null;
        Component = /*#__PURE__*/jsx(ResetPasswordConfirmationLayout, {
          onClick: function onClick() {
            return changeLayoutState(LOGIN_LAYOUT);
          }
        });
        break;
      case FACEBOOK_REAUTHORIZATION_LAYOUT:
        titleText = 'Just one thing...';
        optionChangeComponent = null;
        Component = /*#__PURE__*/jsx(FBReauthorizationLayout, {
          onClick: function onClick() {
            return onResendFBPermissionInternal(loginRedirectPath);
          }
        });
        break;
      case FACEBOOK_REAUTHORIZATION_CONFIRMATION_LAYOUT:
        titleText = 'Got it';
        optionChangeComponent = null;
        Component = /*#__PURE__*/jsx(FBReauthorizationConfirmationLayout, {
          onClick: function onClick() {
            return changeLayoutState(LOGIN_LAYOUT);
          }
        });
        break;
      default:
        titleText = 'Create an account';
        optionChangeComponent = /*#__PURE__*/jsxs("div", {
          className: "switch-layout-component",
          children: ["Already a member?", ' ', /*#__PURE__*/jsxs("a", {
            type: "button",
            role: "button",
            onKeyPress: onCreateLayoutPress,
            onClick: onCreateLayoutPress,
            children: ["Log in ", !leadInLogin ? '>' : '']
          })]
        });
        Component = /*#__PURE__*/jsx(CreateAccountLayout, {
          changeLayoutState: changeLayoutState,
          leadInLogin: leadInLogin,
          auth0: auth0,
          setAuth0ErrorMsg: resetErrorState,
          emailError: emailError,
          usernameError: usernameError,
          nameError: nameError,
          handleNameInput: handleNameInput,
          onClick: onClick,
          passwordError: passwordError,
          generalError: generalError,
          handleEmailInput: handleCreateLayoutEmailInput,
          handleUsernameInput: handleUsernameInput,
          handlePasswordInput: handleCreateLayoutPasswordInput,
          onLogin: onInternalSignup,
          loaded: loaded,
          callToActionSubTitle: callToActionSubTitle,
          invitationToken: invitationToken,
          loginMetrics: loginMetrics,
          incompleteRegistrationId: incompleteRegistrationId
        });
    }
    var title = /*#__PURE__*/jsx("div", {
      className: "login-layout-main-header",
      children: titleText
    });
    return {
      title: title,
      layoutName: newLayout,
      Component: Component,
      optionChangeComponent: optionChangeComponent
    };
  };
  var _React$useState21 = React.useState(renderComponents(layoutType ? layoutType.valueOf() : CREATE_LAYOUT)),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    components = _React$useState22[0],
    setComponents = _React$useState22[1];
  useEffect(function () {
    FGBLocalStorage.setItem('last_login_metrics', loginMetrics);
  }, [loginMetrics]);
  var clearMessages = function clearMessages() {
    setLoaded(true);
    setPassword(null);
    setNameError(null);
    setUsernameError(null);
    setEmailError(null);
    setPasswordError(null);
    setGeneralError(null);
  };
  var changeLayoutState = function changeLayoutState(updatedLayout) {
    clearMessages();
    setComponents(renderComponents(updatedLayout));
  };
  var handleEmailInput = function handleEmailInput(inputEmail) {
    var trimmedEmail = inputEmail.replace(/ /g, '');
    setEmail(trimmedEmail);
    clearMessages();
  };
  var handleCreateLayoutEmailInput = function handleCreateLayoutEmailInput(inputEmail) {
    var trimmedEmail = inputEmail.replace(/ /g, '');
    setEmail(trimmedEmail);
    setEmailError(null);
  };
  var handlePasswordInput = function handlePasswordInput(inputPassword) {
    setPassword(inputPassword);
    clearMessages();
  };
  var handleCreateLayoutPasswordInput = function handleCreateLayoutPasswordInput(inputPassword) {
    setPassword(inputPassword);
    setPasswordError(null);
  };
  var handleUsernameInput = function handleUsernameInput() {
    clearMessages();
  };
  var handleNameInput = function handleNameInput() {
    setNameError(null);
  };
  var resetErrorState = function resetErrorState() {
    clearMessages();
  };
  var setAuth0ErrorMsg = function setAuth0ErrorMsg(auth0ErrorMSg) {
    switch (auth0ErrorMSg.type) {
      case 'general':
        setGeneralError(auth0ErrorMSg.message);
        break;
      case 'user':
        setEmailError(auth0ErrorMSg.message);
        break;
      case 'password':
        setPasswordError(auth0ErrorMSg.message);
        break;
      case 'username':
        setUsernameError(auth0ErrorMSg.message);
        break;
      case 'name':
        setNameError(auth0ErrorMSg.message);
        break;
      default:
        setGeneralError(auth0ErrorMSg.message);
    }
  };
  var handleAuth0Error = function handleAuth0Error(err, operation) {
    var error = {};
    switch (err.code) {
      case "error in email - email format validation failed: ".concat(email):
        error = {
          message: 'Invalid email address.',
          type: 'user'
        };
        break;
      case 'invalid_password_length':
        error = {
          message: 'Password must be at least 8 characters.',
          type: 'password'
        };
        break;
      case 'password_missing_uppercase':
        error = {
          message: 'Password must contain at least 1 uppercase letter.',
          type: 'password'
        };
        break;
      case 'password_missing_lowercase':
        error = {
          message: 'Password must contain at least 1 lowercase letter.',
          type: 'password'
        };
        break;
      case 'password_missing_number':
        error = {
          message: 'Password must contain at least one number.',
          type: 'password'
        };
        break;
      case 'password_missing_special_character':
        error = {
          message: 'Password must contain at least one special character.',
          type: 'password'
        };
        break;
      case 'invalid email address':
        error = {
          message: 'Invalid email address.',
          type: 'user'
        };
        break;
      case 'user_exists':
        error = {
          message: 'The user already exists.',
          type: 'user'
        };
        break;
      case 'access_denied':
        error = {
          message: 'Invalid user credentials.',
          type: 'general'
        };
        break;
      case 'blocked_user':
        error = {
          message: 'User is blocked.',
          type: 'general'
        };
        break;
      case 'password_leaked':
        error = {
          message: "This login attempt has been blocked because the password you're using was previously disclosed through a data breach (not in this application).",
          type: 'general'
        };
        break;
      case 'rate_limited':
        error = {
          message: 'You have made to many login requests please wait a few minutes to try again.',
          type: 'general'
        };
        break;
      case 'too_many_attempts':
        error = {
          message: 'Your account has been blocked after multiple consecutive login attempts. We’ve sent you an email with instructions on how to unblock it.',
          type: 'general'
        };
        break;
      case 'username_exists':
        error = {
          message: 'Username already exists.',
          type: 'username'
        };
        break;
      case 'invalid_username':
        error = {
          message: 'Username must be at most 32 characters.',
          type: 'username'
        };
        break;
      case 'invalid_name':
        error = {
          message: 'Your name is limited to 100 characters.',
          type: 'name'
        };
        break;
      default:
        error = "".concat(operation, "  failed");
    }
    setAuth0ErrorMsg(error);
  };
  var serializeMetaData = function serializeMetaData() {
    return JSON.stringify({
      inviteHash: inviteHash,
      connectionInviteHash: connectionInviteHash,
      groupInviteHash: groupInviteHash,
      employerInviteHash: employerInviteHash
    });
  };
  var setLoginMeta = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(redirectPath, serializedMetaData) {
      var url;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            url = "/auth-v2/init-reg?rp=".concat(encodeURIComponent(redirectPath), "&md=").concat(encodeURIComponent(serializedMetaData));
            _context.prev = 1;
            _context.next = 4;
            return axios.post(url);
          case 4:
            _context.next = 9;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 6]]);
    }));
    return function setLoginMeta(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var redirectToPath = function redirectToPath(redirectPath) {
    var _window;
    // eslint-disable-next-line no-unsafe-optional-chaining
    var _window$location = (_window = window) == null ? void 0 : _window.location,
      origin = _window$location.origin;
    var newState = {
      origin: origin,
      pathName: redirectPath
    };
    window.history.pushState(newState, '', "".concat(origin).concat(redirectPath));
    setTimeout(function () {
      window.location.reload();
    }, 10);
  };
  var onLoginInternal = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(payload) {
      var option,
        customRedirect,
        redirectPath,
        url,
        serializedMetaData,
        result,
        data,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            option = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'local';
            customRedirect = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : null;
            setLoaded(false);
            redirectPath = customRedirect || loginRedirectPath;
            if (leadInLogin || leadInPopup) {
              url = new URL(redirectPath, window.location.origin);
              url.searchParams.append('scroll', window.scrollY);
              redirectPath = url.pathname + url.search;
            }
            serializedMetaData = serializeMetaData();
            _context2.t0 = option;
            _context2.next = _context2.t0 === 'google' ? 9 : _context2.t0 === 'facebook' ? 9 : 13;
            break;
          case 9:
            _context2.next = 11;
            return setLoginMeta(redirectPath, serializedMetaData);
          case 11:
            window.location = "/auth-v2/init-social/".concat(option, "?rp=").concat(encodeURIComponent(redirectPath), "&md=").concat(encodeURIComponent(serializedMetaData));
            return _context2.abrupt("break", 26);
          case 13:
            _context2.prev = 13;
            _context2.next = 16;
            return axios.post('/auth-v2/user-pass/login', {
              email: payload.email,
              password: payload.password
            });
          case 16:
            result = _context2.sent;
            data = result.data;
            setLoadedStateForLoaderComponent(true);
            if (data.success === true) {
              redirectToPath(redirectPath);
            } else {
              handleAuth0Error({
                code: data.err
              }, 'Login');
            }
            _context2.next = 26;
            break;
          case 22:
            _context2.prev = 22;
            _context2.t1 = _context2["catch"](13);
            setLoadedStateForLoaderComponent(true);
            console.error(_context2.t1);
          case 26:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[13, 22]]);
    }));
    return function onLoginInternal(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var onInternalSignup = function onInternalSignup(payload) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'local';
    var customRedirect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (option !== 'local') {
      onLoginInternal(payload, option, customRedirect);
      return;
    }
    redirectToPath(customRedirect);
  };
  var handleInternalAuthError = function handleInternalAuthError(error, type, operation) {
    switch (error) {
      case 'email is not valid':
        setAuth0ErrorMsg({
          type: type,
          message: 'The email in invalid. Please enter a valid email.'
        });
        break;
      case 'email does not exist':
        setAuth0ErrorMsg({
          type: type,
          message: 'The user does not exist.'
        });
        break;
      case 'user has been deactivated':
        setAuth0ErrorMsg({
          type: type,
          message: 'User has been deactivated.'
        });
        break;
      case 'server failed processing request':
        setAuth0ErrorMsg({
          type: type,
          message: 'Something went wrong. Please try again.'
        });
        break;
      default:
        setAuth0ErrorMsg({
          type: type,
          message: "".concat(operation, " failed.")
        });
        break;
    }
  };
  var internalPasswordReset = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(payload) {
      var _ref5, data, _ref6, emailErrors, generalErrors, emailNewError;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setLoaded(false);
            _context3.prev = 1;
            _context3.next = 4;
            return axios.post('/api/auth-v2/forgot-password', payload);
          case 4:
            setLoaded(true);
            changeLayoutState(RESET_PASSWORD_CONFIRMATION_LAYOUT);
            resetErrorState();
            _context3.next = 16;
            break;
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](1);
            setLoaded(true);
            _ref5 = _context3.t0.response || {}, data = _ref5.data;
            _ref6 = data.errors || {}, emailErrors = _ref6.email, generalErrors = _ref6._general;
            emailNewError = emailErrors && emailErrors[0] || generalErrors;
            handleInternalAuthError(emailNewError, 'user', 'Password Reset');
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 9]]);
    }));
    return function internalPasswordReset(_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
  var onResendFBPermissionInternal = function onResendFBPermissionInternal(successUri) {
    window.location = "/auth-v2/init-social/facebook-reauth?rp=".concat(encodeURIComponent(successUri), "&md=").concat(encodeURIComponent(serializeMetaData()));
  };
  var setLoadedStateForLoaderComponent = function setLoadedStateForLoaderComponent(value) {
    setLoaded(value);
  };
  var onSignUpSuccess = function onSignUpSuccess(loginRedirect) {
    setTimeout(function () {
      return onInternalSignup({}, 'local', loginRedirect);
    }, 10);
  };
  var onClick = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(payload) {
      var redirectPath, metaData, result, data, loginRedirect;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            setLoadedStateForLoaderComponent(false);
            redirectPath = loginRedirectPath;
            metaData = {
              inviteHash: inviteHash,
              groupInviteHash: groupInviteHash,
              connectionInviteHash: connectionInviteHash,
              employerInviteHash: employerInviteHash,
              redirectPath: redirectPath
            };
            setLoaded(false);
            _context4.prev = 4;
            payload.metaData = metaData;
            _context4.next = 8;
            return axios.post('/auth-v2/user-pass/register', payload);
          case 8:
            result = _context4.sent;
            data = result.data;
            if (data.success === true) {
              loginRedirect = redirectPath || '/';
              onSignUpSuccess(loginRedirect);
            } else {
              setLoadedStateForLoaderComponent(true);
              handleAuth0Error({
                code: data.err
              }, 'Sign Up');
            }
            setLoaded(true);
            _context4.next = 18;
            break;
          case 14:
            _context4.prev = 14;
            _context4.t0 = _context4["catch"](4);
            setLoaded(true);
            setLoadedStateForLoaderComponent(true);
          case 18:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[4, 14]]);
    }));
    return function onClick(_x5) {
      return _ref7.apply(this, arguments);
    };
  }();
  var showPopupHeaders = function showPopupHeaders() {
    var allowNewClosing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var imageSources = [{
      src: '/v1528477802/icons/logo_new.png',
      size: leadInLogin && !leadInPopup ? 'leadInHeaderLogo' : 'headerLogo'
    }];
    var imageTransforms = {
      leadInHeaderLogo: 'c_scale,f_auto,q_auto,h_28',
      headerLogo: 'c_scale,f_auto,q_auto,h_35',
      close: 'c_scale,f_auto,q_auto,w_22,h_22'
    };
    return /*#__PURE__*/jsx("div", {
      className: "popup-layout-header-components",
      children: imageSources.map(function (image, idx) {
        var src = buildImagePath(image.src, image.size, imageTransforms);
        if (image.size === 'close') {
          return allowNewClosing ?
          /*#__PURE__*/
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
          jsx("img", {
            alt: ""
            // eslint-disable-next-line react/no-array-index-key
            ,

            className: image.size,
            src: src,
            onKeyPress: image.onClick,
            onClick: image.onClick
          }, idx) : null;
        }
        return (
          /*#__PURE__*/
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
          jsx("img", {
            alt: ""
            // eslint-disable-next-line react/no-array-index-key
            ,

            className: image.size,
            src: src,
            onKeyPress: image.onClick,
            onClick: image.onClick
          }, idx)
        );
      })
    });
  };
  var closeModal = function closeModal() {
    onClose();
    setLayoutType(String('none'));
    resetErrorState();
  };
  useEffect(function () {
    if (layout) setLayoutType(String(layout));
  }, [layout, loaded]);
  useEffect(function () {
    if (layoutType) setComponents(renderComponents(layoutType.valueOf()));
  }, [layoutType]);
  var pixelMetrics = null;
  var fireMultipleTimes = false;
  if (loginMetrics) {
    var fireMultiple = loginMetrics.fireMultiple,
      metrics = _objectWithoutProperties(loginMetrics, _excluded$1);
    pixelMetrics = Object.assign({}, metrics, {
      login_trigger: auth0,
      login_opened: 1
    });
    fireMultipleTimes = fireMultiple;
  }
  var regWallValues = leadInPopup || leadInLogin ? getRegwallValues(leadInPopup, loginRedirectPath) : {};
  if (regWallInfo) regWallValues = regWallInfo;
  var contentClassName = leadInPopup ? 'authModal wide' : 'authModal';
  return /*#__PURE__*/jsx(Modal, {
    isOpen: isOpen,
    isPayWall: isPayWall,
    allowClosing: regWallInfo == null ? void 0 : regWallInfo.allowClosing,
    label: '',
    timer: 2,
    onClose: closeModal,
    onOpen: onOpen,
    contentClassName: contentClassName,
    children: /*#__PURE__*/jsx(View, {
      children: /*#__PURE__*/jsxs(_StyledGrid$4, {
        pl: {
          _: '0px !important'
        },
        pr: {
          _: '0px !important'
        },
        $_css: "".concat(isPayWall ? '#213559' : '#fff'),
        children: [(leadInLogin || leadInPopup) && /*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 12,
            md: 6
          },
          pl: {
            _: '0px !important'
          },
          pr: {
            _: '0px !important'
          },
          display: {
            _: !showLeadImage ? 'none' : 'initial',
            md: 'initial'
          },
          children: /*#__PURE__*/jsx(LeadLoginImage, {
            image: regWallValues.image,
            title: regWallValues.title,
            description: regWallValues.description,
            allowClosing: regWallValues.allowClosing,
            buttonText: regWallValues.buttonText,
            setShowLeadImage: setShowLeadImage,
            loginMetrics: loginMetrics
          })
        }), /*#__PURE__*/jsx(GridColumn$1, {
          pl: {
            _: '0px !important'
          },
          pr: {
            _: '0px !important'
          },
          size: {
            _: 12,
            md: leadInLogin || leadInPopup ? 6 : 12
          },
          display: {
            _: (leadInPopup || leadInLogin) && showLeadImage ? 'none' : 'initial',
            md: 'initial'
          },
          children: /*#__PURE__*/jsxs("div", {
            className: "component-Login-LoginLayoutComponent ".concat(leadInLogin || leadInPopup ? 'wide' : ''),
            children: [/*#__PURE__*/jsx("style", {
              children: styles$4
            }), displayMode === POPUP_MODE ? showPopupHeaders(allowClosing) : null, components.title, /*#__PURE__*/jsx(CurrentLogin.Provider, {
              value: {
                loaded: loaded,
                emailError: emailError,
                passwordError: passwordError,
                generalError: generalError,
                nameError: nameError
              },
              children: components.Component
            }), components.optionChangeComponent, components.layoutName === CREATE_LAYOUT ? /*#__PURE__*/jsx("div", {
              className: "disclosure-text-component",
              children: /*#__PURE__*/jsxs("div", {
                className: "text",
                children: ["By registering, I am agreeing to the", /*#__PURE__*/jsx("a", {
                  className: "ml-1 mr-1",
                  href: "/terms-and-conditions",
                  children: "Terms and Conditions"
                }), "and", ' ', /*#__PURE__*/jsx("a", {
                  className: "ml-1 mr-1",
                  href: "/privacy-policy",
                  children: "Privacy Policy"
                }), ' ', "of this site."]
              })
            }) : null, loginMetrics && /*#__PURE__*/jsx(VisibilityPixel, Object.assign({
              metrics: pixelMetrics
            }, fireMultipleTimes ? {
              singleFire: false
            } : {}))]
          })
        })]
      })
    })
  });
};
var _StyledGrid$4 = /*#__PURE__*/styled(Grid).withConfig({
  displayName: "AuthModal___StyledGrid",
  componentId: "sc-9ofpgi-0"
})(function (p) {
  return {
    backgroundColor: p.$_css
  };
});

var request;
var db;
var Stores;
(function (Stores) {
  Stores["Application"] = "Application";
})(Stores || (Stores = {}));
var initDB = function initDB() {
  return new Promise(function (resolve) {
    request = indexedDB.open('DirectApply');
    request.onupgradeneeded = function () {
      db = request.result;
      if (!db.objectStoreNames.contains(Stores.Application)) {
        db.createObjectStore(Stores.Application, {
          keyPath: 'id'
        });
      }
    };
    request.onsuccess = function () {
      db = request.result;
      resolve(true);
    };
    request.onerror = function () {
      resolve(false);
    };
  });
};
var addApplication = function addApplication(application) {
  return new Promise(function (resolve) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var transaction, store, applicationRequest;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return initDB();
          case 2:
            transaction = db.transaction([Stores.Application], 'readwrite');
            store = transaction.objectStore(Stores.Application);
            applicationRequest = store.put(application);
            applicationRequest.onsuccess = function () {
              resolve(true);
            };
            applicationRequest.onerror = function () {
              resolve(false);
            };
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  });
};
var getApplication = function getApplication(id) {
  return new Promise(function (resolve) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var transaction, store, applicationRequest;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return initDB();
          case 2:
            transaction = db.transaction([Stores.Application], 'readonly');
            store = transaction.objectStore(Stores.Application);
            applicationRequest = store.get(id);
            applicationRequest.onsuccess = function () {
              resolve(applicationRequest.result);
            };
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  });
};

var getFileType = function getFileType(file) {
  var _a, _b, _c, _d;
  if (!file) return null;
  return (_d = (_c = (_b = (_a = file === null || file === void 0 ? void 0 : file.split(',')) === null || _a === void 0 ? void 0 : _a.shift()) === null || _b === void 0 ? void 0 : _b.replace('data:', '')) === null || _c === void 0 ? void 0 : _c.replace(';base64', '')) !== null && _d !== void 0 ? _d : null;
};
var formatPayload = function formatPayload(form, job, snowPlowId) {
  var payload = {
    ats_job_apply_link: job.url,
    phone_number: form.phone,
    first_name: form.firstName,
    last_name: form.lastName,
    email: form.email,
    resume_name: form.resumeName,
    resume_content_type: getFileType(form.resume),
    resume: form.resume,
    cover_letter: form.coverLetter,
    cover_letter_content_file_type: getFileType(form.coverLetter),
    cover_letter_name: form.coverLetterName,
    snowplow_id: snowPlowId,
    company_id: job.companyId,
    job_id: job.hash,
    applicationId: form.applicationId,
    service: 'mega'
  };
  return payload;
};
var submitApplication = function submitApplication(form, endpoint, job, snowPlowId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetch(endpoint, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formatPayload(form, job, snowPlowId))
          });
        case 2:
          response = _context.sent;
          return _context.abrupt("return", response.json());
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
};

var baseStyles = {
  fontFamily: 'Open Sans',
  color: '#353535',
  '.inputField, .PhoneInputInput': {
    width: '100%',
    height: '48px',
    borderRadius: '4px',
    border: 'solid 1px #868686',
    gap: '4px',
    fontSize: '14px',
    fontWeight: '400',
    color: '#000000'
  },
  '.inputField::placeholder, .PhoneInputInput::placeholder': {
    color: '#727272',
    fontSize: '14px',
    fontWeight: '400'
  },
  '.PhoneInputInput': {
    borderLeft: 0,
    borderRight: 0,
    borderTop: 0,
    borderBottom: 0,
    borderRadius: '0px 4px 4px 0px',
    height: '41px'
  },
  '.PhoneInputCountry': {
    paddingLeft: 9
  },
  '.errorLabel': {
    fontFamily: 'Open Sans',
    fontSize: '10px',
    fontStyle: 'italic',
    fontWeight: '400',
    lineHeight: '12px',
    letterSpacing: '-0.4px',
    textAlign: 'left',
    height: '12px',
    color: '#db0607',
    marginTop: '8px',
    marginBottom: '8px'
  },
  '.errorLabel2': {
    fontFamily: 'Open Sans',
    fontSize: '10px',
    fontStyle: 'italic',
    fontWeight: '400',
    lineHeight: '12px',
    letterSpacing: '-0.4px',
    textAlign: 'left',
    color: '#db0607',
    marginTop: '8px',
    marginBottom: '8px'
  },
  '.progressbarWrapper': {
    marginTop: '15px',
    marginBottom: '15px'
  },
  '.continueButton': {
    width: '124px',
    height: '48px',
    padding: '8px, 28px, 8px, 28px',
    borderRadius: '4px',
    gap: '8px',
    marginBottom: '15px',
    "float": 'right'
  },
  '.prevButton': {
    width: '92px',
    height: '48px',
    padding: '8px, 28px, 8px, 28px',
    borderRadius: '4px',
    gap: '8px',
    marginBottom: '15px'
  },
  '.uploadButton': {
    height: '48px',
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '-0.4px'
  },
  '.uploadLabel': {
    minHeight: '24px',
    marginLeft: '9px',
    marginTop: '10px'
  },
  '.uploadLabelCover': {
    marginLeft: '9px',
    marginTop: '10px',
    minHeight: '14px'
  },
  '.uploadHeader': {
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '26px',
    color: '#353535'
  },
  '.uploadSubHeader': {
    fontSize: '10px',
    fontWeight: '400',
    lineHeight: '26px',
    color: '#353535',
    marginBottom: '5px'
  },
  '.uploadAddendium': {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '26px',
    color: '#353535'
  },
  '.editButton': {
    width: '35px',
    height: '35px'
  },
  '.editButton span img': {
    marginTop: '4px'
  },
  '@media (min-width: 906px)': {
    '.inputField, .PhoneInputInput': {
      fontSize: '16px'
    },
    '.inputField::placeholder, .PhoneInputInput::placeholder': {
      fontSize: '16px'
    },
    '.uploadHeader, .uploadAddendium': {
      fontSize: '16px'
    },
    '.errorLabel2': {
      fontSize: '16px'
    },
    '.errorLabel': {
      fontSize: '16px',
      marginBottom: '8px'
    },
    '.uploadLabel': {
      marginLeft: '14px'
    }
  }
};

var phoneStyles = "\n  :root {\n    --PhoneInput-color--focus: #03b2cb;\n    --PhoneInputInternationalIconPhone-opacity: 0.8;\n    --PhoneInputInternationalIconGlobe-opacity: 0.65;\n    --PhoneInputCountrySelect-marginRight: 0.35em;\n    --PhoneInputCountrySelectArrow-width: 0.3em;\n    --PhoneInputCountrySelectArrow-marginLeft: var(--PhoneInputCountrySelect-marginRight);\n    --PhoneInputCountrySelectArrow-borderWidth: 1px;\n    --PhoneInputCountrySelectArrow-opacity: 0.45;\n    --PhoneInputCountrySelectArrow-color: currentColor;\n    --PhoneInputCountrySelectArrow-color--focus: var(--PhoneInput-color--focus);\n    --PhoneInputCountrySelectArrow-transform: rotate(45deg);\n    --PhoneInputCountryFlag-aspectRatio: 1.5;\n    --PhoneInputCountryFlag-height: 1em;\n    --PhoneInputCountryFlag-borderWidth: 1px;\n    --PhoneInputCountryFlag-borderColor: rgba(0,0,0,0.5);\n    --PhoneInputCountryFlag-borderColor--focus: var(--PhoneInput-color--focus);\n    --PhoneInputCountryFlag-backgroundColor--loading: rgba(0,0,0,0.1);\n  }\n\n  .PhoneInput {\n\n    display: flex;\n    align-items: center;\n  }\n\n  .PhoneInputInput {\n    min-width: 0;\n  }\n\n  .PhoneInputCountryIcon {\n    width: calc(var(--PhoneInputCountryFlag-height) * var(--PhoneInputCountryFlag-aspectRatio));\n    height: var(--PhoneInputCountryFlag-height);\n  }\n\n  .PhoneInputCountryIcon--square {\n    width: var(--PhoneInputCountryFlag-height);\n  }\n\n  .PhoneInputCountryIcon--border {\n\n    box-shadow: 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor),\n    inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor);\n  }\n\n  .PhoneInputCountryIconImg {\n    width: 100%;\n    height: 100%;\n  }\n\n  .PhoneInputInternationalIconPhone {\n    opacity: var(--PhoneInputInternationalIconPhone-opacity);\n  }\n\n  .PhoneInputInternationalIconGlobe {\n    opacity: var(--PhoneInputInternationalIconGlobe-opacity);\n  }\n\n\n  .PhoneInputCountry {\n    position: relative;\n    align-self: stretch;\n    display: flex;\n    align-items: center;\n    margin-right: var(--PhoneInputCountrySelect-marginRight);\n  }\n\n  .PhoneInputCountrySelect {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n    border: 0;\n    opacity: 0;\n    cursor: pointer;\n  }\n\n  .PhoneInputCountrySelect[disabled],\n  .PhoneInputCountrySelect[readonly] {\n    cursor: default;\n  }\n\n  .PhoneInputCountrySelectArrow {\n    display: block;\n    content: '';\n    width: var(--PhoneInputCountrySelectArrow-width);\n    height: var(--PhoneInputCountrySelectArrow-width);\n    margin-left: var(--PhoneInputCountrySelectArrow-marginLeft);\n    border-style: solid;\n    border-color: var(--PhoneInputCountrySelectArrow-color);\n    border-top-width: 0;\n    border-bottom-width: var(--PhoneInputCountrySelectArrow-borderWidth);\n    border-left-width: 0;\n    border-right-width: var(--PhoneInputCountrySelectArrow-borderWidth);\n    transform: var(--PhoneInputCountrySelectArrow-transform);\n    opacity: var(--PhoneInputCountrySelectArrow-opacity);\n  }\n\n  .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon + .PhoneInputCountrySelectArrow {\n    opacity: 1;\n    color: var(--PhoneInputCountrySelectArrow-color--focus);\n  }\n\n  .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {\n    box-shadow: 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus),\n    inset 0 0 0 var(--PhoneInputCountryFlag-borderWidth) var(--PhoneInputCountryFlag-borderColor--focus);\n  }\n\n  .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon .PhoneInputInternationalIconGlobe {\n    opacity: 1;\n    color: var(--PhoneInputCountrySelectArrow-color--focus);\n  }\n  .PhoneInputCountrySelect option{\n     minWidth: 400px;\n   }\n";

// Container for the progress bar
var ProgressBarContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "ProgressBar__ProgressBarContainer",
  componentId: "sc-r4ys3m-0"
})(["width:100%;height:20px;background-color:#46154e;border-radius:100px;overflow:hidden;"]);
// Filler for the progress
var ProgressBarFiller = /*#__PURE__*/styled.div.withConfig({
  displayName: "ProgressBar__ProgressBarFiller",
  componentId: "sc-r4ys3m-1"
})(["background-color:#982ea9;height:100%;border-radius:inherit;transition:width 0.3s ease-in-out;"]);
var ProgressBar = function ProgressBar(_ref) {
  var progress = _ref.progress;
  return jsx(ProgressBarContainer, {
    children: jsx(ProgressBarFiller, {
      style: {
        width: "".concat(progress, "%")
      }
    }, void 0)
  }, void 0);
};
ProgressBar.displayName = 'ProgressBar';

// Container for the progress bar with steps count
var ProgressBarWithStepCountContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "ProgressBarWithStepCount__ProgressBarWithStepCountContainer",
  componentId: "sc-12ne672-0"
})(["width:100%;display:flex;flex-direction:row;margin-top:15px;margin-bottom:15px;"]);
var StepCount = /*#__PURE__*/styled.div.withConfig({
  displayName: "ProgressBarWithStepCount__StepCount",
  componentId: "sc-12ne672-1"
})(["white-space:nowrap;margin-top:auto;margin-bottom:auto;margin-left:0.85rem;font-family:Open Sans;font-size:14px;font-weight:400;line-height:12px;text-align:left;color:#737478;"]);
var ProgressBarWithStepCount = function ProgressBarWithStepCount(_ref) {
  var step = _ref.step,
    totalSteps = _ref.totalSteps;
  return jsxs(ProgressBarWithStepCountContainer, {
    children: [jsx(ProgressBar, {
      progress: step / totalSteps * 100
    }, void 0), jsxs(StepCount, {
      children: [step, " /", totalSteps]
    }, void 0)]
  }, void 0);
};
ProgressBarWithStepCount.displayName = 'ProgressBarWithStepCount';
var ProgressBarWithStepCount$1 = ProgressBarWithStepCount;

var Step1 = function Step1(_ref) {
  var form = _ref.form;
    _ref.user;
    var setForm = _ref.setForm,
    nextStep = _ref.nextStep;
    _ref.formUpdated;
    var totalSteps = _ref.totalSteps;
  var _useForm = useForm({
      defaultValues: {
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        'phone-input': form.phone
      }
    }),
    handleSubmit = _useForm.handleSubmit,
    errors = _useForm.formState.errors,
    setValue = _useForm.setValue,
    control = _useForm.control;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    formHasDefaultValues = _useState2[0],
    setformHasDefaultValues = _useState2[1];
  useEffect(function () {
    if (form.firstName && form.lastName && form.email && form.phone) {
      setValue('firstName', form.firstName);
      setValue('lastName', form.lastName);
      setValue('email', form.email);
      setValue('phone-input', form.phone);
    }
    if (form.resumeSubmitted) setformHasDefaultValues(true);
  }, [form.firstName, form.lastName, form.email, form.phone, form.resumeSubmitted]);
  var onSubmit = function onSubmit(data) {
    var newForm = Object.assign({}, form);
    newForm.firstName = data.firstName.trim();
    newForm.lastName = data.lastName.trim();
    newForm.email = data.email.trim();
    newForm.phone = data['phone-input'];
    setForm(newForm);
    nextStep();
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("style", {
      jsx: true,
      children: phoneStyles
    }), /*#__PURE__*/jsxs("form", {
      onSubmit: handleSubmit(onSubmit),
      children: [/*#__PURE__*/jsxs(Grid, {
        children: [formHasDefaultValues && /*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 12
          },
          fontWeight: "400",
          fontSize: {
            _: '14px',
            md: '16px'
          },
          lineHeight: "24px",
          marginBottom: {
            _: '5px',
            md: '8px'
          },
          children: "Your details have been auto-populated from your most recent application. Please validate that they are still correct."
        }), /*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 12,
            md: 6
          },
          children: /*#__PURE__*/jsx(Controller, {
            render: function render(_ref2) {
              var _errors$firstName;
              var field = _ref2.field;
              return /*#__PURE__*/jsxs(Fragment, {
                children: [/*#__PURE__*/jsx(InputField, Object.assign({
                  placeholder: "First name*",
                  dataQa: "firstname",
                  border: "solid 1px",
                  className: "inputField"
                }, field)), /*#__PURE__*/jsx("div", {
                  className: "errorLabel",
                  children: errors == null ? void 0 : (_errors$firstName = errors.firstName) == null ? void 0 : _errors$firstName.message
                })]
              });
            },
            name: "firstName",
            control: control,
            rules: {
              required: 'First name is a required field'
            }
          })
        }), /*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 12,
            md: 6
          },
          children: /*#__PURE__*/jsx(Controller, {
            render: function render(_ref3) {
              var _errors$lastName;
              var field = _ref3.field;
              return /*#__PURE__*/jsxs(Fragment, {
                children: [/*#__PURE__*/jsx(InputField, Object.assign({
                  dataQa: "lastName",
                  placeholder: "Last name*",
                  border: "solid 1px",
                  className: "inputField"
                }, field)), /*#__PURE__*/jsx("div", {
                  className: "errorLabel",
                  children: errors == null ? void 0 : (_errors$lastName = errors.lastName) == null ? void 0 : _errors$lastName.message
                })]
              });
            },
            name: "lastName",
            control: control,
            rules: {
              required: 'Last name is a required field'
            }
          })
        })]
      }), /*#__PURE__*/jsx(Controller, {
        render: function render(_ref4) {
          var _errors$email;
          var field = _ref4.field;
          return /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(InputField, Object.assign({
              dataQa: "email",
              placeholder: "Email address*",
              border: "solid 1px",
              className: "inputField"
            }, field)), /*#__PURE__*/jsx("div", {
              className: "errorLabel",
              children: errors == null ? void 0 : (_errors$email = errors.email) == null ? void 0 : _errors$email.message
            })]
          });
        },
        name: "email",
        control: control,
        rules: {
          required: 'Email is a required field',
          validate: {
            emailCorrectFormat: function emailCorrectFormat(value) {
              var emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
              return emailRegex.test(value.trim()) || 'Invalid email address. Correct format is name@emailprovider.com';
            }
          }
        }
      }), /*#__PURE__*/jsx(Controller, {
        name: "phone-input",
        control: control,
        rules: {
          validate: function validate(value) {
            return isValidPhoneNumber(value) || 'Invalid phone number format, correct format is +1 555 555-5555';
          },
          required: 'Phone number is a required field'
        },
        render: function render(_ref5) {
          var _errors$phoneInput;
          var _ref5$field = _ref5.field,
            onChange = _ref5$field.onChange,
            value = _ref5$field.value;
          return /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx(PhoneInput, {
              value: value,
              onChange: onChange,
              className: "inputField",
              defaultCountry: "US",
              placeholder: "Phone*",
              id: "phone-input",
              withCountryCallingCode: true,
              international: true,
              countryCallingCodeEditable: false
            }), /*#__PURE__*/jsx("div", {
              className: "errorLabel",
              children: (_errors$phoneInput = errors['phone-input']) == null ? void 0 : _errors$phoneInput.message
            })]
          });
        }
      }), /*#__PURE__*/jsx(ProgressBarWithStepCount$1, {
        step: 1,
        totalSteps: totalSteps
      }), /*#__PURE__*/jsxs(Grid, {
        children: [/*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 6
          }
        }), /*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 6
          },
          children: /*#__PURE__*/jsx(Button$1, {
            type: "submit",
            className: "continueButton",
            disabled: Object.keys(errors).length > 0,
            children: "Continue"
          })
        })]
      })]
    })]
  });
};

var img$5 = "data:image/svg+xml,%3csvg width='36' height='36' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='18' cy='18' r='16' fill='%23FDBE61' fill-opacity='0.31'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.6198 11.52C19.6198 10.629 18.8908 9.90005 17.9998 9.90005C17.1088 9.90005 16.3798 10.629 16.3798 11.52V18C16.3798 18.8911 17.1088 19.62 17.9998 19.62C18.8908 19.62 19.6198 18.8911 19.6198 18V11.52ZM1.7998 18C1.7998 9.05765 9.0412 1.80005 17.9836 1.80005C26.9422 1.80005 34.1998 9.05765 34.1998 18C34.1998 26.9424 26.9422 34.2001 17.9836 34.2001C9.0412 34.2001 1.7998 26.9424 1.7998 18ZM5.0398 18C5.0398 25.1604 10.8394 30.96 17.9998 30.96C25.1602 30.96 30.9598 25.1604 30.9598 18C30.9598 10.8396 25.1602 5.04005 17.9998 5.04005C10.8394 5.04005 5.0398 10.8396 5.0398 18ZM18.0064 25.8141C18.8977 25.8141 19.6203 25.0916 19.6203 24.2002C19.6203 23.3089 18.8977 22.5863 18.0064 22.5863C17.1151 22.5863 16.3925 23.3089 16.3925 24.2002C16.3925 25.0916 17.1151 25.8141 18.0064 25.8141Z' fill='%23FDBE61'/%3e%3c/svg%3e";
  var alert = img$5;

var img$4 = "data:image/svg+xml,%3csvg width='33' height='34' viewBox='0 0 33 34' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='17' cy='17' r='15' fill='%23E5F6F6' stroke='%231FA5A4' stroke-width='2'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.7071 16.2929C10.3166 15.9024 9.68342 15.9024 9.29289 16.2929C8.90237 16.6834 8.90237 17.3166 9.29289 17.7071L14.2929 22.7071C14.698 23.1122 15.36 23.0948 15.7433 22.669L24.7433 12.669C25.1128 12.2585 25.0795 11.6262 24.669 11.2567C24.2585 10.8873 23.6262 10.9205 23.2567 11.331L14.9618 20.5476L10.7071 16.2929Z' fill='%231FA5A4'/%3e%3c/svg%3e";
  var checkmark = img$4;

var img$3 = "data:image/svg+xml,%3csvg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M17.7071 4.00014C18.0976 3.60961 18.0976 2.97643 17.7071 2.58588C17.3166 2.19534 16.6834 2.19533 16.2929 2.58586L10 8.87874L3.70709 2.58586C3.31656 2.19533 2.6834 2.19534 2.29288 2.58588C1.90236 2.97643 1.90237 3.60961 2.29291 4.00014L8.58576 10.293L2.29291 16.5858C1.90237 16.9763 1.90236 17.6095 2.29288 18.0001C2.6834 18.3906 3.31656 18.3906 3.70709 18.0001L10 11.7072L16.2929 18.0001C16.6834 18.3906 17.3166 18.3906 17.7071 18.0001C18.0976 17.6095 18.0976 16.9763 17.7071 16.5858L11.4142 10.293L17.7071 4.00014Z' fill='%23868686'/%3e%3c/svg%3e";
  var Close20 = img$3;

var img$2 = "data:image/svg+xml,%3csvg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M17 16.0449C17.5523 16.0449 18 16.4926 18 17.0449C18 17.5972 17.5523 18.0449 17 18.0449H3C2.44772 18.0449 2 17.5972 2 17.0449C2 16.4926 2.44772 16.0449 3 16.0449H17ZM6.29289 9.33782L13.2929 2.33782C13.6534 1.97733 14.2206 1.9496 14.6129 2.25463L14.7071 2.33782L17.7071 5.33782C18.0676 5.6983 18.0953 6.26553 17.7903 6.65782L17.7071 6.75203L10.7071 13.752C10.5508 13.9083 10.3481 14.0075 10.1314 14.0362L10 14.0449H7C6.48716 14.0449 6.06449 13.6589 6.00673 13.1615L6 13.0449V10.0449C6 9.82391 6.07316 9.61044 6.20608 9.43689L6.29289 9.33782L13.2929 2.33782L6.29289 9.33782ZM14 4.45914L8 10.4591V12.0449H9.58579L15.5858 6.04492L14 4.45914Z' fill='%23868686'/%3e%3c/svg%3e";
  var Edit20 = img$2;

var img$1 = "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='16' cy='16' r='15' fill='%23F7C4C6' stroke='%23DB0607' stroke-width='2'/%3e%3cpath d='M22.9362 10.3365C23.2877 9.98503 23.2877 9.41516 22.9362 9.06367C22.5847 8.71218 22.0149 8.71217 21.6634 9.06365L15.9998 14.7272L10.3362 9.06365C9.98471 8.71217 9.41486 8.71218 9.0634 9.06367C8.71193 9.41516 8.71194 9.98503 9.06342 10.3365L14.727 16L9.06342 21.6636C8.71194 22.0151 8.71193 22.5849 9.0634 22.9364C9.41486 23.2879 9.98471 23.2879 10.3362 22.9364L15.9998 17.2729L21.6634 22.9364C22.0149 23.2879 22.5847 23.2879 22.9362 22.9364C23.2877 22.5849 23.2877 22.0151 22.9362 21.6636L17.2726 16L22.9362 10.3365Z' fill='%23DB0607'/%3e%3c/svg%3e";
  var Error$1 = img$1;

var dateFormatter = new Intl.DateTimeFormat('en-us', {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric'
});

/**
 * Converts a Blob file to a Base64 string wile removing the data type.
 *
 * @returns {Promise} - A Promise that resolves with the Base64 string or rejects with an error.
 */
var convertToBase64 = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            var fileReader = new FileReader();
            fileReader.onload = function () {
              var dataURL = fileReader.result;
              resolve(dataURL);
            };
            fileReader.onerror = function (error) {
              reject(error);
            };
            fileReader.readAsDataURL(file[0]);
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function convertToBase64(_x) {
    return _ref.apply(this, arguments);
  };
}();
var Step2 = function Step2(_ref2) {
  var form = _ref2.form,
    setForm = _ref2.setForm,
    job = _ref2.job,
    nextStep = _ref2.nextStep,
    prevStep = _ref2.prevStep,
    totalSteps = _ref2.totalSteps;
  //form to upload resume and cover letter with a max file sizeof 100 mb and file typesof only .doc, .docx, .pdf or .rtf
  var _useForm = useForm({
      reValidateMode: 'onChange',
      criteriaMode: 'all'
    }),
    handleSubmit = _useForm.handleSubmit,
    errors = _useForm.formState.errors,
    control = _useForm.control,
    resetField = _useForm.resetField,
    trigger = _useForm.trigger;
  var _useState = useState(form),
    _useState2 = _slicedToArray(_useState, 2),
    _useState2$ = _useState2[0],
    curForm = _useState2$ === void 0 ? {} : _useState2$,
    setCurForm = _useState2[1];
  var onSubmit = function onSubmit() {
    var newForm = Object.assign({}, curForm);
    setForm(newForm);
    nextStep();
  };
  var today = React.useRef('');
  useEffect(function () {
    today.current = dateFormatter.format(new Date()).toString();
  }, []);
  var onFileChange = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e, type) {
      var newForm;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            newForm = Object.assign({}, curForm);
            newForm[type + 'Name'] = e.target.files[0].name;
            newForm[type + 'Size'] = e.target.files[0].size;
            newForm[type + 'Stats'] = "Uploaded on ".concat(today.current);
            newForm[type + 'UploadDate'] = today.current;
            newForm[type + 'Submitted'] = false;
            newForm[type + 'JobHash'] = job.hash;
            _context2.next = 9;
            return convertToBase64(e.target.files);
          case 9:
            newForm[type] = _context2.sent;
            setCurForm(newForm);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onFileChange(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var maxSizeText = 'Upload as .doc, .docx, .pdf, or .rft (100MB Max)';
  var vaildateFileType = function vaildateFileType(filename) {
    var fileType = filename != null && filename.name ? filename.name.split('.').pop() : filename.split('.').pop();
    if (fileType !== 'doc' && fileType !== 'docx' && fileType !== 'pdf' && fileType !== 'rtf') {
      return 'Invalid file format. Please upload a .doc, .docx, .pdf, or .rtf';
    }
    return true;
  };
  var DocumentUploaderGrid = function DocumentUploaderGrid(_ref4) {
    var selector = _ref4.selector;
    return /*#__PURE__*/jsxs(_StyledGrid$3, {
      width: "100%",
      border: {
        _: 'none',
        md: 'solid 1px #BD79C8'
      },
      borderRadius: "4px",
      height: {
        _: '55px',
        md: '73px'
      },
      paddingTop: "5px",
      marginLeft: "-1px",
      children: [/*#__PURE__*/jsx(_StyledGridColumn$5, {
        display: {
          _: 'none',
          md: 'block'
        },
        size: {
          _: 8
        },
        fontSize: "16px",
        fontWeight: "400",
        marginTop: "20px",
        children: maxSizeText
      }), /*#__PURE__*/jsx(GridColumn$1, {
        size: {
          _: 12,
          md: 4
        },
        marginTop: {
          _: '0px',
          md: '7px'
        },
        paddingLeft: {
          _: '0px',
          md: 'auto'
        },
        paddingRight: {
          _: '0px',
          md: '10px',
          lg: 'auto'
        },
        children: /*#__PURE__*/jsx(_StyledButton$1, {
          type: "button",
          className: "uploadButton",
          width: {
            _: '100%',
            md: '110px'
          },
          onPress: function onPress() {
            document.querySelector(selector).click();
          },
          children: "Upload"
        })
      })]
    });
  };
  var DocumentUploadedGrid = function DocumentUploadedGrid(_ref5) {
    var type = _ref5.type,
      selector = _ref5.selector,
      showAlert = _ref5.showAlert,
      showError = _ref5.showError;
    return /*#__PURE__*/jsxs(_StyledGrid2, {
      width: "100%",
      border: "solid 1px #BD79C8",
      borderRadius: "4px",
      height: {
        _: '55px',
        md: '73px'
      },
      paddingTop: "5px",
      ml: "-1px",
      children: [/*#__PURE__*/jsx(GridColumn$1, {
        size: {
          _: 2,
          md: 1
        },
        marginTop: {
          _: '6px',
          md: '14px'
        },
        marginLeft: "2px",
        onClick: function onClick() {
          document.querySelector(selector).click();
        },
        children: showAlert ? /*#__PURE__*/jsx("img", {
          src: alert,
          alt: "alert"
        }) : showError ? /*#__PURE__*/jsx("img", {
          src: Error$1,
          alt: "error"
        }) : /*#__PURE__*/jsx("img", {
          src: checkmark,
          alt: "success"
        })
      }), /*#__PURE__*/jsx(_StyledGridColumn2$5, {
        size: {
          _: 6,
          md: 7
        },
        onClick: function onClick() {
          document.querySelector(selector).click();
        },
        $_css: showError ? '#DB0607' : '#611D6C',
        children: curForm ? curForm[type + 'Name'] : ''
      }), /*#__PURE__*/jsxs(GridColumn$1, {
        size: {
          _: 3.5,
          md: 3
        },
        padding: "0px",
        paddingLeft: "12px",
        paddingTop: {
          _: '5px',
          md: '12px'
        },
        marginLeft: {
          _: '0px',
          md: 'auto'
        },
        children: [/*#__PURE__*/jsx(_StyledButton2$1, {
          type: "button",
          className: "editButton",
          variant: "primaryText",
          onPress: function onPress() {
            document.querySelector(selector).click();
          },
          children: /*#__PURE__*/jsx("img", {
            src: Edit20,
            alt: "edit",
            className: "sideImage"
          })
        }), /*#__PURE__*/jsx(_StyledButton3, {
          type: "button",
          className: "editButton",
          variant: "primaryText",
          onPress: function onPress() {
            var newForm = Object.assign({}, curForm);
            newForm[type] = null;
            newForm[type + 'Name'] = null;
            newForm[type + 'Stats'] = null;
            newForm[type + 'Size'] = null;
            resetField(type);
            setCurForm(newForm);
          },
          children: /*#__PURE__*/jsx("img", {
            src: Close20,
            alt: "clear",
            className: "sideImage"
          })
        })]
      })]
    });
  };
  return /*#__PURE__*/jsxs("form", {
    onSubmit: handleSubmit(onSubmit),
    children: [/*#__PURE__*/jsx(Controller, {
      render: function render(_ref6) {
        var _field$value, _errors$resume, _errors$resume2;
        var field = _ref6.field;
        return /*#__PURE__*/jsxs(Grid, {
          children: [/*#__PURE__*/jsxs(_StyledGridColumn3$5, {
            size: {
              _: 12
            },
            children: [/*#__PURE__*/jsx("div", {
              className: "uploadHeader",
              children: "Resume *"
            }), ' ']
          }), /*#__PURE__*/jsx(GridColumn$1, {
            size: {
              _: 12
            },
            display: {
              _: 'block',
              md: 'none'
            },
            children: /*#__PURE__*/jsx("div", {
              className: "uploadSubHeader",
              children: maxSizeText
            })
          }), /*#__PURE__*/jsx(_StyledInputField$1, Object.assign({
            dataQa: "resume",
            border: "solid 1px",
            className: "uploadResumeForm",
            accept: ".doc,.docx,.pdf,.rtf",
            ariaLabel: "Resume Upload"
          }, field, {
            value: (_field$value = field.value) == null ? void 0 : _field$value.fileName,
            type: "file",
            onChange: function onChange(e) {
              resetField('resume');
              onFileChange(e, 'resume');
              field.onChange(e.target.files[0]);
              trigger('resume');
            }
          })), /*#__PURE__*/jsx(_StyledGridColumn4$5, {
            size: {
              _: 12
            },
            children: curForm != null && curForm.resumeName ? /*#__PURE__*/jsx(DocumentUploadedGrid, {
              selector: ".uploadResumeForm",
              type: "resume",
              showError: !!(errors != null && (_errors$resume = errors.resume) != null && _errors$resume.message)
            }) : /*#__PURE__*/jsx(DocumentUploaderGrid, {
              selector: ".uploadResumeForm"
            })
          }), (curForm == null ? void 0 : curForm.resumeUploadDate) && (curForm == null ? void 0 : curForm.resumeName) && (curForm == null ? void 0 : curForm.resumeSubmitted) && /*#__PURE__*/jsxs(_StyledGridColumn5$3, {
            size: {
              _: 12
            },
            fontSize: {
              _: '10px',
              md: '12px'
            },
            lineHeight: "26px",
            fontWeight: "400",
            letterSpacing: "-.4px",
            position: "relative",
            top: "-10px",
            paddingLeft: "9px",
            paddingRight: "0px",
            children: ["File saved from your most recent previous application on ", curForm.resumeUploadDate]
          }), (errors == null ? void 0 : errors.resume) && Object.entries(errors == null ? void 0 : (_errors$resume2 = errors.resume) == null ? void 0 : _errors$resume2.types).filter(function (_ref7) {
            var _ref8 = _slicedToArray(_ref7, 2),
              value = _ref8[1];
            return value;
          }).map(function (_ref9) {
            var _ref10 = _slicedToArray(_ref9, 2),
              key = _ref10[0],
              value = _ref10[1];
            return /*#__PURE__*/jsx("div", {
              className: "errorLabel uploadLabel",
              children: value
            }, key);
          })]
        });
      },
      name: "resume",
      control: control,
      rules: {
        validate: {
          fileTypeCheck: function fileTypeCheck(value) {
            if (value) {
              return vaildateFileType(value);
            } else if (curForm.resumeName) {
              return vaildateFileType(curForm.resumeName);
            }
            return true;
          },
          lessThan100MB: function lessThan100MB(value) {
            if ((value == null ? void 0 : value.size) > 100000000) {
              return 'File size exceeds 100MB limit';
            }
            return true;
          },
          resumeIsRequired: function resumeIsRequired(value) {
            if (value) return true;
            if (!curForm.resumeName) {
              return 'Resume is a required field';
            }
            return true;
          }
        }
      }
    }), /*#__PURE__*/jsx(Controller, {
      render: function render(_ref11) {
        var _field$value2, _errors$coverLetter, _errors$coverLetter2;
        var field = _ref11.field;
        return /*#__PURE__*/jsxs(Grid, {
          children: [/*#__PURE__*/jsxs(_StyledGridColumn6$1, {
            children: [/*#__PURE__*/jsx("span", {
              className: "uploadHeader",
              children: " Cover Letter "
            }), /*#__PURE__*/jsxs("span", {
              className: "uploadAddendium",
              children: ["(Optional)", ' ']
            }), ' ']
          }), /*#__PURE__*/jsx(GridColumn$1, {}), /*#__PURE__*/jsx(GridColumn$1, {
            size: {
              _: 12
            },
            marginTop: "6px",
            marginLeft: "2px",
            display: {
              _: 'block',
              md: 'none'
            },
            children: /*#__PURE__*/jsx("div", {
              className: "uploadSubHeader",
              children: maxSizeText
            })
          }), /*#__PURE__*/jsx(_StyledInputField2, Object.assign({
            dataQa: "coverLetter",
            border: "solid 1px",
            className: "uploadCoverLetterForm",
            ariaLabel: "Cover Letter Upload",
            accept: ".doc,.docx,.pdf,.rtf",
            marginTop: "10px"
          }, field, {
            value: (_field$value2 = field.value) == null ? void 0 : _field$value2.fileName,
            type: "file",
            onChange: function onChange(e) {
              resetField('coverLetter');
              onFileChange(e, 'coverLetter');
              field.onChange(e.target.files[0]);
              trigger('coverLetter');
            }
          })), /*#__PURE__*/jsx(_StyledGridColumn7$1, {
            size: {
              _: 12
            },
            children: curForm != null && curForm.coverLetterName ? /*#__PURE__*/jsx(DocumentUploadedGrid, {
              selector: ".uploadCoverLetterForm",
              type: "coverLetter",
              showAlert: false,
              showError: !!(errors != null && (_errors$coverLetter = errors.coverLetter) != null && _errors$coverLetter.message)
            }) : /*#__PURE__*/jsx(DocumentUploaderGrid, {
              selector: ".uploadCoverLetterForm"
            })
          }), (curForm == null ? void 0 : curForm.coverLetterUploadDate) && (curForm == null ? void 0 : curForm.coverLetterName) && (curForm == null ? void 0 : curForm.coverLetterSubmitted) && /*#__PURE__*/jsxs(_StyledGridColumn8, {
            size: {
              _: 12
            },
            fontSize: {
              _: '10px',
              md: '12px'
            },
            lineHeight: "26px",
            fontWeight: "400",
            letterSpacing: "-.4px",
            position: "relative",
            top: "-10px",
            paddingLeft: "9px",
            paddingRight: "0px",
            children: ["File saved from your most recent previous application on ", curForm.coverLetterUploadDate]
          }), (errors == null ? void 0 : errors.coverLetter) && Object.entries(errors == null ? void 0 : (_errors$coverLetter2 = errors.coverLetter) == null ? void 0 : _errors$coverLetter2.types).filter(function (_ref12) {
            var _ref13 = _slicedToArray(_ref12, 2),
              value = _ref13[1];
            return value;
          }).map(function (_ref14) {
            var _ref15 = _slicedToArray(_ref14, 2),
              key = _ref15[0],
              value = _ref15[1];
            return /*#__PURE__*/jsx("div", {
              className: "errorLabel uploadLabelCover",
              children: value
            }, key);
          })]
        });
      },
      name: "coverLetter",
      control: control,
      rules: {
        validate: {
          fileTypeCheck: function fileTypeCheck(value) {
            if (value) {
              return vaildateFileType(value);
            } else if (curForm.coverLetterName) {
              return vaildateFileType(curForm.coverLetterName);
            }
            return true;
          },
          lessThan100MB: function lessThan100MB(value) {
            if ((value == null ? void 0 : value.size) > 100000000) {
              return 'File size exceeds 100MB limit';
            }
            return true;
          }
        }
      }
    }), /*#__PURE__*/jsx(ProgressBarWithStepCount$1, {
      step: 2,
      totalSteps: totalSteps
    }), /*#__PURE__*/jsxs(Grid, {
      children: [/*#__PURE__*/jsx(GridColumn$1, {
        size: {
          _: 6
        },
        children: /*#__PURE__*/jsx(Button$1, {
          className: "prevButton",
          variant: "secondary",
          onPress: function onPress() {
            setForm(curForm);
            prevStep();
          },
          type: "button",
          children: "Back"
        })
      }), /*#__PURE__*/jsx(GridColumn$1, {
        size: {
          _: 6
        },
        children: /*#__PURE__*/jsx(Button$1, {
          type: "submit",
          className: "continueButton",
          onClick: handleSubmit(onSubmit),
          disabled: Object.keys(errors).length > 0,
          children: "Continue"
        })
      })]
    })]
  });
};
var _StyledGrid$3 = styled(Grid)({
  '@media (min-width:  905px)': {
    marginLeft: '0px',
    marginRight: '0px'
  }
});
var _StyledGridColumn$5 = styled(GridColumn$1)({
  color: '#727272'
});
var _StyledButton$1 = styled(Button$1)({
  '@media (min-width:  905px)': {
    "float": 'right'
  }
});
var _StyledGrid2 = styled(Grid)({
  '@media (min-width:  905px)': {
    marginLeft: '0px',
    marginRight: '0px'
  }
});
var _StyledGridColumn2$5 = styled(GridColumn$1)(function (p) {
  return {
    color: p.$_css,
    fontWeight: 700,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': '1',
    marginTop: '10px',
    '@media (min-width:  905px)': {
      marginTop: '20px'
    }
  };
});
var _StyledButton2$1 = styled(Button$1)({
  padding: '0px',
  '@media (min-width:  905px)': {
    marginLeft: '20px',
    '.sideImage': {
      height: '35px'
    }
  }
});
var _StyledButton3 = styled(Button$1)({
  padding: '0px',
  height: '18px',
  position: 'relative',
  top: '-2px',
  '@media (min-width:  905px)': {
    marginLeft: '20px',
    '.sideImage': {
      height: '30px',
      position: 'relative',
      top: '-3px'
    }
  }
});
var _StyledGridColumn3$5 = styled(GridColumn$1)({
  '@media (min-width:  905px)': {
    marginBottom: '5px'
  }
});
var _StyledInputField$1 = styled(InputField)({
  display: 'none!important'
});
var _StyledGridColumn4$5 = styled(GridColumn$1)({
  marginBottom: '15px'
});
var _StyledGridColumn5$3 = styled(GridColumn$1)({
  color: '#353535',
  marginTop: '5px',
  '@media (min-width:  905px)': {
    paddingLeft: '12px',
    paddingRight: '0px',
    marginTop: '8px'
  }
});
var _StyledGridColumn6$1 = styled(GridColumn$1)({
  '@media (min-width:  905px)': {
    marginBottom: '5px'
  }
});
var _StyledInputField2 = styled(InputField)({
  display: 'none!important'
});
var _StyledGridColumn7$1 = styled(GridColumn$1)({
  marginBottom: '15px'
});
var _StyledGridColumn8 = /*#__PURE__*/styled(GridColumn$1).withConfig({
  displayName: "Step2___StyledGridColumn8",
  componentId: "sc-1p46xfx-0"
})({
  color: '#353535',
  marginTop: '5px',
  '@media (min-width:  905px)': {
    paddingLeft: '12px',
    paddingRight: '0px',
    marginTop: '8px'
  }
});

var Step3 = function Step3(_ref) {
  var form = _ref.form,
    job = _ref.job,
    prevStep = _ref.prevStep,
    nextStep = _ref.nextStep,
    totalSteps = _ref.totalSteps;
  return /*#__PURE__*/jsxs(Grid, {
    children: [/*#__PURE__*/jsx(GridColumn$1, {
      size: {
        _: 12
      },
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "24px",
      children: "Review your application"
    }), /*#__PURE__*/jsxs(GridColumn$1, {
      size: {
        _: 12
      },
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "26px",
      marginBottom: "10px",
      children: ["Please review your details below carefully prior to submitting your application to ", job.company, ". Once submitted you will not be able to make changes."]
    }), /*#__PURE__*/jsx(GridColumn$1, {
      size: {
        _: 12
      },
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "24px",
      marginBottom: "5px",
      children: "Contact Info"
    }), /*#__PURE__*/jsx(GridColumn$1, {
      size: {
        _: 6
      },
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "26px",
      marginBottom: "5px",
      children: "First name:"
    }), /*#__PURE__*/jsx(_StyledGridColumn$4, {
      size: {
        _: 6
      },
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "26px",
      marginBottom: "5px",
      children: form.firstName
    }), /*#__PURE__*/jsx(GridColumn$1, {
      size: {
        _: 6
      },
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "26px",
      marginBottom: "5px",
      children: "Last name:"
    }), /*#__PURE__*/jsx(_StyledGridColumn2$4, {
      size: {
        _: 6
      },
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "26px",
      marginBottom: "5px",
      children: form.lastName
    }), /*#__PURE__*/jsx(GridColumn$1, {
      size: {
        _: 6
      },
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "26px",
      marginBottom: "5px",
      children: "Email:"
    }), /*#__PURE__*/jsx(_StyledGridColumn3$4, {
      size: {
        _: 6
      },
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "26px",
      marginBottom: "5px",
      children: form.email
    }), /*#__PURE__*/jsx(GridColumn$1, {
      size: {
        _: 6
      },
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "26px",
      marginBottom: "5px",
      children: "Phone:"
    }), /*#__PURE__*/jsx(GridColumn$1, {
      size: {
        _: 6
      },
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "26px",
      marginBottom: "5px",
      children: form.phone
    }), /*#__PURE__*/jsx(ProgressBarWithStepCount$1, {
      step: 3,
      totalSteps: totalSteps
    }), /*#__PURE__*/jsxs(_StyledGrid$2, {
      width: "100%",
      marginTop: "5px",
      children: [/*#__PURE__*/jsx(_StyledGridColumn4$4, {
        size: {
          _: 6
        },
        children: /*#__PURE__*/jsx(Button$1, {
          className: "prevButton",
          variant: "secondary",
          onPress: prevStep,
          type: "button",
          children: "Back"
        })
      }), /*#__PURE__*/jsx(_StyledGridColumn5$2, {
        size: {
          _: 6
        },
        children: /*#__PURE__*/jsx(Button$1, {
          type: "submit",
          className: "continueButton",
          onPress: nextStep,
          children: "Continue"
        })
      })]
    })]
  });
};
var _StyledGridColumn$4 = styled(GridColumn$1)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '1'
});
var _StyledGridColumn2$4 = styled(GridColumn$1)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '1'
});
var _StyledGridColumn3$4 = styled(GridColumn$1)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '1'
});
var _StyledGrid$2 = styled(Grid)({
  marginLeft: '0px',
  marginRight: '0px'
});
var _StyledGridColumn4$4 = styled(GridColumn$1)({
  paddingLeft: '0px'
});
var _StyledGridColumn5$2 = /*#__PURE__*/styled(GridColumn$1).withConfig({
  displayName: "Step3___StyledGridColumn5",
  componentId: "sc-17v1jqi-0"
})({
  paddingLeft: '0px',
  paddingRight: '0px'
});

var Step3Desktop = function Step3Desktop(_ref) {
  var form = _ref.form,
    job = _ref.job,
    prevStep = _ref.prevStep,
    onSubmit = _ref.onSubmit,
    totalSteps = _ref.totalSteps;
  return /*#__PURE__*/jsxs(Grid, {
    children: [/*#__PURE__*/jsx(GridColumn$1, {
      size: {
        _: 12
      },
      fontWeight: "700",
      fontSize: "16px",
      lineHeight: "24px",
      children: "Review your application"
    }), /*#__PURE__*/jsxs(GridColumn$1, {
      size: {
        _: 12
      },
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "26px",
      marginBottom: "10px",
      children: ["Please review your details below carefully prior to submitting your application to ", job.company, ". Once submitted you will not be able to make changes."]
    }), /*#__PURE__*/jsx(GridColumn$1, {
      size: {
        _: 6
      },
      children: /*#__PURE__*/jsxs(Grid, {
        children: [/*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 12
          },
          fontWeight: "700",
          fontSize: "16px",
          lineHeight: "26px",
          marginBottom: "5px",
          children: "Contact Info"
        }), /*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 12
          },
          fontSize: "16px",
          fontWeight: "400",
          lineHeight: "26px",
          children: "First name"
        }), /*#__PURE__*/jsx(_StyledGridColumn$3, {
          size: {
            _: 12
          },
          fontWeight: "700",
          fontSize: "16px",
          lineHeight: "26px",
          marginBottom: "10px",
          children: form.firstName
        }), /*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 12
          },
          fontWeight: "400",
          fontSize: "16px",
          lineHeight: "26px",
          children: "Last name"
        }), /*#__PURE__*/jsx(_StyledGridColumn2$3, {
          size: {
            _: 12
          },
          fontWeight: "700",
          fontSize: "16px",
          lineHeight: "26px",
          marginBottom: "10px",
          children: form.lastName
        }), /*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 12
          },
          fontWeight: "400",
          fontSize: "16px",
          lineHeight: "26px",
          children: "Email address"
        }), /*#__PURE__*/jsx(_StyledGridColumn3$3, {
          size: {
            _: 12
          },
          fontWeight: "700",
          fontSize: "16px",
          lineHeight: "26px",
          marginBottom: "10px",
          children: form.email
        }), /*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 12
          },
          fontWeight: "400",
          fontSize: "16px",
          lineHeight: "26px",
          children: "Phone"
        }), /*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 12
          },
          fontWeight: "700",
          fontSize: "16px",
          lineHeight: "26px",
          marginBottom: "15px",
          children: form.phone
        })]
      })
    }), /*#__PURE__*/jsx(GridColumn$1, {
      size: {
        _: 6
      },
      children: /*#__PURE__*/jsxs(Grid, {
        children: [/*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 12
          },
          fontWeight: "700",
          fontSize: "16px",
          lineHeight: "26px",
          marginBottom: "5px",
          children: "Resume"
        }), /*#__PURE__*/jsxs(_StyledGridColumn4$3, {
          size: {
            _: 12
          },
          fontSize: "16px",
          fontWeight: "700",
          lineHeight: "26px",
          marginBottom: "10px",
          children: [form.resumeName, ' ']
        }), /*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 12
          },
          fontSize: "16px",
          fontWeight: "400",
          lineHeight: "26px",
          marginBottom: "20px",
          children: form.resumeStats
        }), form.coverLetter && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(GridColumn$1, {
            size: {
              _: 12
            },
            fontWeight: "700",
            fontSize: "16px",
            lineHeight: "26px",
            marginBottom: "5px",
            children: "Cover Letter"
          }), /*#__PURE__*/jsxs(_StyledGridColumn5$1, {
            size: {
              _: 12
            },
            fontWeight: "700",
            fontSize: "16px",
            lineHeight: "26px",
            marginBottom: "10px",
            children: [form.coverLetterName, ' ']
          }), /*#__PURE__*/jsx(GridColumn$1, {
            size: {
              _: 12
            },
            fontWeight: "400",
            fontSize: "16px",
            lineHeight: "26px",
            marginBottom: "5px",
            children: form.coverLetterStats
          })]
        })]
      })
    }), /*#__PURE__*/jsx(ProgressBarWithStepCount$1, {
      step: 3,
      totalSteps: totalSteps
    }), /*#__PURE__*/jsxs(_StyledGrid$1, {
      width: "100%",
      marginTop: "5px",
      children: [/*#__PURE__*/jsx(_StyledGridColumn6, {
        size: {
          _: 6
        },
        children: /*#__PURE__*/jsx(Button$1, {
          className: "prevButton",
          variant: "secondary",
          onPress: prevStep,
          type: "button",
          children: "Back"
        })
      }), /*#__PURE__*/jsx(_StyledGridColumn7, {
        size: {
          _: 6
        },
        pl: "0px",
        children: /*#__PURE__*/jsx(Button$1, {
          type: "submit",
          className: "continueButton",
          onPress: onSubmit,
          children: "Submit"
        })
      })]
    })]
  });
};
var _StyledGridColumn$3 = styled(GridColumn$1)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '1'
});
var _StyledGridColumn2$3 = styled(GridColumn$1)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '1'
});
var _StyledGridColumn3$3 = styled(GridColumn$1)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '1'
});
var _StyledGridColumn4$3 = styled(GridColumn$1)({
  color: ' #982EA9',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '1'
});
var _StyledGridColumn5$1 = styled(GridColumn$1)({
  color: ' #982EA9',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '1'
});
var _StyledGrid$1 = styled(Grid)({
  marginLeft: '0px',
  marginRight: '0px'
});
var _StyledGridColumn6 = styled(GridColumn$1)({
  paddingLeft: '0px'
});
var _StyledGridColumn7 = /*#__PURE__*/styled(GridColumn$1).withConfig({
  displayName: "Step3Desktop___StyledGridColumn7",
  componentId: "sc-1ch36sj-0"
})({
  paddingLeft: '0px',
  paddingRight: '0px'
});

var Step4 = function Step4(_ref) {
  var form = _ref.form,
    job = _ref.job,
    prevStep = _ref.prevStep,
    onSubmit = _ref.onSubmit,
    totalSteps = _ref.totalSteps;
  return /*#__PURE__*/jsxs(Grid, {
    children: [/*#__PURE__*/jsx(GridColumn$1, {
      size: {
        _: 12
      },
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "24px",
      children: "Review your application"
    }), /*#__PURE__*/jsxs(GridColumn$1, {
      size: {
        _: 12
      },
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "26px",
      marginBottom: "10px",
      children: ["Please review your details below carefully prior to submitting your application to ", job.company, ". Once submitted you will not be able to make changes."]
    }), /*#__PURE__*/jsx(GridColumn$1, {
      size: {
        _: 12
      },
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "24px",
      marginBottom: "5px",
      children: "Uploaded Files"
    }), /*#__PURE__*/jsx(GridColumn$1, {
      size: {
        _: 6
      },
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "26px",
      marginBottom: "5px",
      children: "Resume:"
    }), /*#__PURE__*/jsx(GridColumn$1, {
      size: {
        _: 6
      },
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "26px",
      children: /*#__PURE__*/jsxs(Grid, {
        children: [/*#__PURE__*/jsxs(_StyledGridColumn$2, {
          size: {
            _: 12
          },
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "700",
          children: [form.resumeName, ' ']
        }), /*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 12
          },
          fontSize: "10px",
          lineHeight: "26px",
          fontWeight: "400",
          children: form.resumeStats
        })]
      })
    }), form.coverLetter && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(GridColumn$1, {
        size: {
          _: 6
        },
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "26px",
        marginBottom: "5px",
        children: "Cover Letter:"
      }), /*#__PURE__*/jsx(GridColumn$1, {
        size: {
          _: 6
        },
        fontWeight: "700",
        fontSize: "14px",
        lineHeight: "26px",
        marginBottom: "5px",
        children: /*#__PURE__*/jsxs(Grid, {
          children: [/*#__PURE__*/jsx(_StyledGridColumn2$2, {
            size: {
              _: 12
            },
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: "700",
            children: form.coverLetterName
          }), /*#__PURE__*/jsx(GridColumn$1, {
            size: {
              _: 12
            },
            fontSize: "10px",
            lineHeight: "26px",
            fontWeight: "400",
            children: form.coverLetterStats
          })]
        })
      })]
    }), /*#__PURE__*/jsx(ProgressBarWithStepCount$1, {
      step: 4,
      totalSteps: totalSteps
    }), /*#__PURE__*/jsxs(_StyledGrid, {
      width: "100%",
      marginTop: "5px",
      children: [/*#__PURE__*/jsx(_StyledGridColumn3$2, {
        size: {
          _: 6
        },
        children: /*#__PURE__*/jsx(Button$1, {
          className: "prevButton",
          variant: "secondary",
          onPress: prevStep,
          type: "button",
          children: "Back"
        })
      }), /*#__PURE__*/jsx(_StyledGridColumn4$2, {
        size: {
          _: 6
        },
        children: /*#__PURE__*/jsx(Button$1, {
          type: "submit",
          className: "continueButton",
          onPress: onSubmit,
          children: "Submit"
        })
      })]
    })]
  });
};
var _StyledGridColumn$2 = styled(GridColumn$1)({
  color: ' #982EA9',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '1'
});
var _StyledGridColumn2$2 = styled(GridColumn$1)({
  color: ' #982EA9',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '1'
});
var _StyledGrid = styled(Grid)({
  marginLeft: '0px',
  marginRight: '0px'
});
var _StyledGridColumn3$2 = styled(GridColumn$1)({
  paddingLeft: '0px'
});
var _StyledGridColumn4$2 = /*#__PURE__*/styled(GridColumn$1).withConfig({
  displayName: "Step4___StyledGridColumn4",
  componentId: "sc-14kslt8-0"
})({
  paddingLeft: '0px',
  paddingRight: '0px'
});

var call = functionCall;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$j;
var toLength = toLength$5;
var toString = toString$e;
var requireObjectCoercible = requireObjectCoercible$b;
var getMethod = getMethod$7;
var advanceStringIndex = advanceStringIndex$3;
var regExpExec = regexpExecAbstract;

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

var img = "data:image/svg+xml,%3csvg width='42' height='49' viewBox='0 0 42 49' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='21' cy='20' r='20' fill='%23F2ECFE'/%3e%3cg filter='url(%23filter0_d_3315_6419)'%3e%3crect x='9.3335' y='5' width='23.3333' height='30' rx='3.5' fill='white'/%3e%3c/g%3e%3crect x='12.25' y='9.1665' width='5.41667' height='1.66667' rx='0.833333' fill='%23C4CBD8'/%3e%3crect x='12.25' y='14.1665' width='17.5' height='1.66667' rx='0.833333' fill='%23C4CBD8'/%3e%3crect x='12.25' y='19.1665' width='17.5' height='1.66667' rx='0.833333' fill='%23C4CBD8'/%3e%3crect x='12.25' y='24.1665' width='17.5' height='1.66667' rx='0.833333' fill='%23C4CBD8'/%3e%3crect x='12.25' y='29.1665' width='17.5' height='1.66667' rx='0.833333' fill='%23C4CBD8'/%3e%3ccircle cx='29.3333' cy='19.9998' r='8.33333' fill='%231FA5A4'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M27.8656 21.9119L26.9732 21.0195L26.0808 20.1271C25.7644 19.8107 25.2514 19.8107 24.9351 20.1271C24.6187 20.4435 24.6187 20.9565 24.9351 21.2729L26.1503 22.4881L27.3656 23.7034C27.7091 24.0469 28.2755 24.013 28.5755 23.6311L34.2468 17.1496C34.5233 16.7978 34.4621 16.2885 34.1103 16.012C33.7585 15.7356 33.2491 15.7967 32.9727 16.1485L27.8656 21.9119Z' fill='white'/%3e%3cdefs%3e%3cfilter id='filter0_d_3315_6419' x='0.000162125' y='0.333333' width='42.0002' height='48.6667' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset dy='4.66667'/%3e%3cfeGaussianBlur stdDeviation='4.66667'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0.207843 0 0 0 0 0.207843 0 0 0 0 0.207843 0 0 0 0.2 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_3315_6419'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_3315_6419' result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e";
  var whatnext = img;

var Step5 = function Step5(_ref) {
  var _errors$password2, _errors$password3;
  var user = _ref.user,
    job = _ref.job,
    loginPressed = _ref.loginPressed,
    signUpError = _ref.signUpError,
    onSignUpPressed = _ref.onSignUpPressed;
  var _useForm = useForm({
      criteriaMode: 'all',
      reValidateMode: 'onChange'
    }),
    handleSubmit = _useForm.handleSubmit,
    errors = _useForm.formState.errors,
    control = _useForm.control;
  var onSubmit = function onSubmit(data) {
    onSignUpPressed(data);
  };
  var onInvalid = function onInvalid(errors) {
    return console.error(errors);
  };
  return /*#__PURE__*/jsxs(Grid, {
    children: [/*#__PURE__*/jsxs(_StyledGridColumn$1, {
      size: {
        _: 12
      },
      fontWeight: "400",
      fontSize: {
        _: '14px',
        md: '16px'
      },
      mb: {
        _: '5px',
        md: '8px'
      },
      maxHeight: "23px",
      children: [job.title, " - ", job.company]
    }), /*#__PURE__*/jsx(_StyledGridColumn2$1, {
      size: {
        _: 2
      },
      children: /*#__PURE__*/jsx("img", {
        src: whatnext,
        "class": "whatsNextImage"
      })
    }), /*#__PURE__*/jsx(GridColumn$1, {
      size: {
        _: 10
      },
      children: /*#__PURE__*/jsxs(Grid, {
        children: [/*#__PURE__*/jsx(_StyledGridColumn3$1, {
          fontWeight: "600",
          fontSize: {
            _: '20px',
            md: '26px'
          },
          lineHeight: "30px",
          marginTop: "8px",
          children: "What Happens Next?"
        }), /*#__PURE__*/jsx(GridColumn$1, {
          size: {
            _: 1
          }
        }), /*#__PURE__*/jsxs(_StyledGridColumn4$1, {
          fontWeight: "400",
          fontSize: {
            _: '14px',
            md: '16px'
          },
          lineHeight: {
            _: '24px',
            md: '26px'
          },
          size: {
            _: 11
          },
          marginBottom: "10px",
          display: {
            _: 'none',
            md: 'block'
          },
          children: ["The hiring manager at ", job.company, " will review your application and will contact you with next steps."]
        })]
      })
    }), /*#__PURE__*/jsxs(GridColumn$1, {
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "24px",
      size: {
        _: 12
      },
      marginBottom: "10px",
      display: {
        _: 'block',
        md: 'none'
      },
      children: ["The hiring manager at ", job.company, " will review your application and will contact you with next steps."]
    }), !(user != null && user.isLoggedIn) && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(GridColumn$1, {
        fontWeight: "600",
        fontSize: {
          _: '16px',
          md: '20px'
        },
        lineHeight: "24px",
        size: {
          _: 12
        },
        marginBottom: "10px",
        children: "Sign up to to save your application for next time."
      }), /*#__PURE__*/jsxs(GridColumn$1, {
        fontWeight: "400",
        fontSize: {
          _: '14px',
          md: '16px'
        },
        lineHeight: "24px",
        size: {
          _: 12
        },
        marginBottom: "10px",
        children: ["Create a password to join Fairygodboss, the largest online career community for women. Already a member?", ' ', /*#__PURE__*/jsxs(Button$1, {
          variant: "primaryText",
          onPress: loginPressed,
          children: ["Login", ' ']
        })]
      }), /*#__PURE__*/jsx(GridColumn$1, {
        children: /*#__PURE__*/jsxs("form", {
          onSubmit: handleSubmit(onSubmit, onInvalid),
          children: [/*#__PURE__*/jsx(Controller, {
            render: function render(_ref2) {
              var _errors$password;
              var field = _ref2.field;
              return /*#__PURE__*/jsxs(Fragment, {
                children: [/*#__PURE__*/jsx(InputField, Object.assign({
                  placeholder: "Password*",
                  type: "password",
                  dataQa: "password",
                  border: "solid 1px",
                  className: "inputField"
                }, field)), (errors == null ? void 0 : errors.password) && Object.entries(errors == null ? void 0 : (_errors$password = errors.password) == null ? void 0 : _errors$password.types).filter(function (_ref3) {
                  var _ref4 = _slicedToArray(_ref3, 2),
                    value = _ref4[1];
                  return value;
                }).map(function (_ref5) {
                  var _ref6 = _slicedToArray(_ref5, 2),
                    key = _ref6[0],
                    value = _ref6[1];
                  return /*#__PURE__*/jsx("div", {
                    className: "errorLabel2",
                    children: value
                  }, key);
                }), /*#__PURE__*/jsx("div", {
                  className: "errorLabel2",
                  children: signUpError && /*#__PURE__*/jsxs(Fragment, {
                    children: ["An account for this user exists, please", /*#__PURE__*/jsxs(_StyledButton, {
                      variant: "primaryText",
                      onPress: loginPressed,
                      children: ["login", ' ']
                    })]
                  })
                })]
              });
            },
            name: "password",
            control: control,
            rules: {
              required: 'Password is required',
              validate: {
                minLength: function minLength(value) {
                  return (value == null ? void 0 : value.length) >= 8 || 'Password must be at least 8 characters';
                },
                atLeast1Number: function atLeast1Number(value) {
                  if (!(value != null && value.match(/\d/))) return 'Password must have at least 1 number';
                },
                atLeastOneUppercase: function atLeastOneUppercase(value) {
                  if (!(value != null && value.match(/[A-Z]/))) return 'Password must have at least 1 uppercase letter';
                },
                atLeastOneLowercase: function atLeastOneLowercase(value) {
                  if (!(value != null && value.match(/[a-z]/))) return 'Password must have at least 1 lowercase letter';
                },
                atLeast1SpecialCharacter: function atLeast1SpecialCharacter(value) {
                  if (!(value != null && value.match(/[^a-zA-Z0-9]/))) return 'Password must have at least 1 special character';
                }
              }
            }
          }), /*#__PURE__*/jsx(Grid, {
            children: /*#__PURE__*/jsx(_StyledGridColumn5, {
              fontWeight: "400",
              fontSize: {
                _: '10px',
                md: '12px'
              },
              lineHeight: "14px",
              marginBottom: "20px",
              children: "Password must have at least 8 characters, 1 uppercase and lowercase letter, 1 number, and 1 special character"
            })
          }), /*#__PURE__*/jsxs(_StyledButton2, {
            variant: "primary",
            type: "submit",
            width: {
              _: '100%',
              md: '110px'
            },
            disabled: (errors == null ? void 0 : (_errors$password2 = errors.password) == null ? void 0 : _errors$password2.message) && (errors == null ? void 0 : (_errors$password3 = errors.password) == null ? void 0 : _errors$password3.message) !== '' || signUpError,
            height: "48px",
            marginBottom: "10px",
            children: [' ', "Sign up", ' ']
          })]
        })
      })]
    })]
  });
};
var _StyledGridColumn$1 = styled(GridColumn$1)({
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '1',
  overflow: 'hidden'
});
var _StyledGridColumn2$1 = styled(GridColumn$1)({
  '@media (min-width: 905px)': {
    '.whatsNextImage': {
      height: '98px',
      marginTop: '25px'
    }
  }
});
var _StyledGridColumn3$1 = styled(GridColumn$1)({
  '@media (min-width: 905px)': {
    marginBottom: '5px',
    paddingLeft: '3px'
  }
});
var _StyledGridColumn4$1 = styled(GridColumn$1)({
  marginTop: '10px',
  paddingLeft: '19px'
});
var _StyledButton = styled(Button$1)({
  backgroundColor: 'transparent',
  left: '1px',
  fontStyle: 'italic',
  fontSize: '10px',
  paddingLeft: '0px',
  paddingRight: '0px',
  width: '30px',
  '@media (min-width: 905px)': {
    left: '2px',
    fontSize: '16px',
    width: '50px'
  }
});
var _StyledGridColumn5 = styled(GridColumn$1)({
  color: '#727272'
});
var _StyledButton2 = /*#__PURE__*/styled(Button$1).withConfig({
  displayName: "Step5___StyledButton2",
  componentId: "sc-1tyvi6s-0"
})({
  '@media (min-width: 905px)': {
    "float": 'right'
  }
});

var _$1 = function _(t) {
    return t;
  },
  _t$1;
var screenNames = ['contact_details', 'attachment_upload', 'review_application_contact_details', 'review_application_attachments', 'apply_confirmation'];
var DirectApply = function DirectApply(_ref) {
  var isOpen = _ref.isOpen,
    job = _ref.job,
    onClose = _ref.onClose,
    onSignUp = _ref.onSignUp,
    onSubmitClicked = _ref.onSubmitClicked,
    pageKey = _ref.pageKey,
    user = _ref.user,
    reset = _ref.reset,
    newError = _ref.newError,
    emitMetric = _ref.emitMetric,
    emitImpression = _ref.emitImpression,
    baseMetrics = _ref.baseMetrics,
    onLoginPressed = _ref.onLoginPressed,
    directApplyUrl = _ref.directApplyUrl,
    snowPlowId = _ref.snowPlowId;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    step = _useState2[0],
    setStep = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    form = _useState4[0],
    setForm = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    canFireImpression = _useState6[0],
    setCanFireImpression = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loaded = _useState8[0],
    setLoaded = _useState8[1];
  var _useState9 = useState(newError),
    _useState10 = _slicedToArray(_useState9, 2),
    signUpError = _useState10[0],
    setSignUpError = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    pagesSeen = _useState12[0],
    setPagesSeen = _useState12[1];
  var _trueViewPort = trueViewPort(false),
    isSM = _trueViewPort.isSM;
  var nextStep = function nextStep() {
    var newMetric = Object.assign({}, baseMetrics);
    newMetric.modalActionType = step + 1 === 4 ? "submit" : "continue";
    newMetric.click = true;
    emitMetric(addScreenInfoToMetric(newMetric));
    setStep(step + 1);
    localStorage.setItem("directApplyStep".concat(job.hash).concat(pageKey), String(step + 1));
  };
  var prevStep = function prevStep() {
    var newMetric = Object.assign({}, baseMetrics);
    newMetric.modalActionType = "back";
    newMetric.click = true;
    emitMetric(addScreenInfoToMetric(newMetric));
    setStep(step - 1);
    localStorage.setItem("directApplyStep".concat(job.hash).concat(pageKey), String(step - 1));
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var newMetric, newForm;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            newMetric = Object.assign({}, baseMetrics);
            newMetric.modalActionType = "submit";
            newMetric.click = true;
            newForm = Object.assign({}, form);
            newForm.resumeSubmitted = true;
            if (form.coverLetter) newForm.coverLetterSubmitted = true;
            newForm.id = 1;
            setForm(form);
            _context.next = 10;
            return addApplication(newForm);
          case 10:
            localStorage.setItem("directApplyStep".concat(job.hash).concat(pageKey), '4');
            localStorage.setItem("directSubmitted".concat(job.hash), '1');
            onSubmitClicked();
            _context.prev = 13;
            _context.next = 16;
            return submitApplication(form, directApplyUrl, job, snowPlowId);
          case 16:
            emitMetric(addScreenInfoToMetric(newMetric));
            _context.next = 23;
            break;
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](13);
            newMetric.errorType = "Job Apply was unsuccessful";
            emitMetric(addScreenInfoToMetric(newMetric));
          case 23:
            setStep(4);
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[13, 19]]);
    }));
    return function onSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  var onSignUpPressed = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data) {
      var results, response, newMetric;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(form.email === 'test@themuse.com')) {
              _context2.next = 3;
              break;
            }
            setSignUpError('inUse');
            return _context2.abrupt("return");
          case 3:
            _context2.prev = 3;
            _context2.next = 6;
            return fetch('/auth-v2/user-pass/register', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                email: form.email,
                password: data.password,
                name: form.firstName + ' ' + form.lastName
              })
            });
          case 6:
            results = _context2.sent;
            _context2.next = 9;
            return results.json();
          case 9:
            response = _context2.sent;
            if (response.success === true) {
              onSignUp({
                email: form.email,
                password: data.password
              });
              newMetric = Object.assign({}, baseMetrics);
              newMetric.modalActionType = "sign_up";
              newMetric.click = true;
              emitMetric(addScreenInfoToMetric(newMetric));
            } else {
              setSignUpError('inUse');
            }
            _context2.next = 15;
            break;
          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](3);
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 13]]);
    }));
    return function onSignUpPressed(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var loginPressed = function loginPressed() {
    onLoginPressed();
  };
  useEffect(function () {
    if (pagesSeen.indexOf(step) === -1 && canFireImpression) {
      var newMetric = {
        component: "modal",
        posistion: "pop_up",
        impression: true
      };
      emitImpression(addScreenInfoToMetric(newMetric));
      setPagesSeen([].concat(_toConsumableArray(pagesSeen), [step]));
      sessionStorage.setItem("directApplyPagesSeen".concat(job.hash).concat(pageKey), JSON.stringify([].concat(_toConsumableArray(pagesSeen), [step])));
    }
  }, [step, canFireImpression]);
  var addScreenInfoToMetric = function addScreenInfoToMetric(metric) {
    metric.modalScreenOrder = step + 1;
    metric.modalScreenName = screenNames[step];
    if ((step == 2 || step == 3) && !isSM) {
      metric.modalScreenName = "review_application";
    }
    if (step == 4 && !isSM) {
      metric.modalScreenOrder = 4;
    }
    return metric;
  };
  var tryClosing = function tryClosing() {
    var newMetric = Object.assign({}, baseMetrics);
    newMetric.modalActionType = "close";
    newMetric.click = true;
    emitMetric(addScreenInfoToMetric(newMetric));
    onClose();
  };
  var formUpdatingApplicaiton = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(form) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setForm(form);
            if (!(form && Object.keys(form).length > 0)) {
              _context3.next = 5;
              break;
            }
            form.id = 1;
            _context3.next = 5;
            return addApplication(form);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function formUpdatingApplicaiton(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var checkApplication = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var formData, tempForm, curStep, stepOn, storedPages;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getApplication(1);
          case 2:
            formData = _context4.sent;
            tempForm = formData || {};
            if (tempForm) {
              setForm(tempForm);
            }
            curStep = localStorage.getItem("directApplyStep".concat(job.hash).concat(pageKey));
            setLoaded(true);
            stepOn = curStep ? parseInt(curStep) : 0;
            setStep(stepOn);
            // get pages seen form session storage
            storedPages = JSON.parse(sessionStorage.getItem("directApplyPagesSeen".concat(job.hash).concat(pageKey)));
            setPagesSeen(storedPages || []);
            setSignUpError(null);
            setCanFireImpression(true);
          case 13:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function checkApplication() {
      return _ref5.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (isOpen) {
      checkApplication();
    }
  }, [reset, isOpen, job]);
  var styles = "\n          .direct-apply-modal {\n            border-radius: 8px !important;\n            box-shadow: 0px 4px 8px 0px #35353533;\n            font-family: 'Open Sans';\n          }\n          .content {\n            border-radius: 10px !important;\n          }\n\n            @media (min-width: 672px){\n              .closeButton {\n                margin-top: 12px !important;\n                margin-right: 6px !important;\n                right:0px !important;\n                }\n            }\n            @media (min-width: 906px){\n              .content {\n                  width: 632px !important;\n              }\n              .closeButton {\n                  right:10px !important;\n               }\n            }\n            @media (max-width: 905px) and (orientation: landscape){\n\n                    .closeButton {\n                          margin-top: 14px !important;\n                          margin-right: 0px !important;\n                          right: 4px !important;\n                    }\n              }\n        ";
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("style", {
      children: styles
    }), /*#__PURE__*/jsx(Modal, {
      isOpen: isOpen,
      onClose: tryClosing,
      timer: 2,
      label: '',
      containerClassName: "direct-apply-modal ".concat(isOpen ? "open" : ""),
      children: /*#__PURE__*/jsx(View, {
        children: /*#__PURE__*/jsxs(Grid, {
          children: [/*#__PURE__*/jsx(_StyledGridColumn, {
            size: {
              _: 11.5
            },
            fontSize: {
              _: '26px',
              md: '32px'
            },
            fontWeight: {
              _: '700'
            },
            lineHeight: {
              _: '38px'
            },
            overflow: {
              _: 'hidden'
            },
            maxHeight: {
              _: '78px'
            },
            children: step == 4 ? 'Your application was submitted!' : job.title
          }), step < 2 && /*#__PURE__*/jsxs(_StyledGridColumn2, {
            size: {
              _: 12
            },
            fontSize: {
              _: '14px',
              md: '16px'
            },
            fontWeight: {
              _: '400'
            },
            lineHeight: {
              _: '24px'
            },
            maxHeight: {
              _: '48px'
            },
            overflow: {
              _: 'hidden'
            },
            children: [job.company, " - ", job.location]
          }), /*#__PURE__*/jsxs(_StyledGridColumn3, {
            size: {
              _: 12
            },
            children: [step == 0 && loaded && /*#__PURE__*/jsx(Step1, {
              form: form,
              user: user,
              setForm: formUpdatingApplicaiton,
              nextStep: nextStep,
              totalSteps: isSM ? 5 : 4
            }), step == 1 && loaded && /*#__PURE__*/jsx(Step2, {
              form: form,
              setForm: formUpdatingApplicaiton,
              job: job,
              nextStep: nextStep,
              prevStep: prevStep,
              totalSteps: isSM ? 5 : 4
            }), step == 2 && isSM && loaded && /*#__PURE__*/jsx(Step3, {
              form: form,
              job: job,
              nextStep: nextStep,
              prevStep: prevStep,
              totalSteps: isSM ? 5 : 4
            }), step == 3 && isSM && loaded && /*#__PURE__*/jsx(Step4, {
              form: form,
              job: job,
              onSubmit: onSubmit,
              prevStep: prevStep,
              totalSteps: isSM ? 5 : 4
            }), (step == 2 || step == 3) && !isSM && loaded && /*#__PURE__*/jsx(Step3Desktop, {
              form: form,
              job: job,
              onSubmit: onSubmit,
              prevStep: prevStep,
              totalSteps: isSM ? 5 : 4
            }), step == 4 && loaded && /*#__PURE__*/jsx(Step5, {
              user: user,
              signUpError: signUpError,
              onSignUpPressed: onSignUpPressed,
              job: job,
              loginPressed: loginPressed
            })]
          }), (!(user != null && user.isLoggedIn) && step === 4 || step !== 4) && /*#__PURE__*/jsxs(_StyledGridColumn4, {
            size: {
              _: 12
            },
            fontSize: {
              _: '12px'
            },
            fontWeight: {
              _: '400'
            },
            lineHeight: {
              _: '20px'
            },
            textAlign: {
              _: 'center'
            },
            letterSpacing: {
              _: '-0.4px'
            },
            children: ["By continuing, you are agreeing to our", ' ', /*#__PURE__*/jsxs(Link$1, {
              target: "_blank",
              href: "/terms-and-conditions",
              variant: "inline",
              children: [' ', "Terms and Conditions", ' ']
            }), ' ', "and", ' ', /*#__PURE__*/jsxs(Link$1, {
              target: "_blank",
              href: "/privacy-policy",
              variant: "inline",
              children: [' ', "Privacy Policy", ' ']
            }), "."]
          })]
        })
      })
    })]
  });
};
var _StyledGridColumn = styled(GridColumn$1)({
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '2',
  minHeight: '42px',
  marginBottom: '5px',
  marginTop: '8px',
  '@media (min-width: 906px)': {
    marginBottom: '10px',
    marginTop: '15px'
  }
});
var _StyledGridColumn2 = styled(GridColumn$1)({
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '2',
  marginBottom: '5px',
  '@media (min-width: 906px)': {
    marginBottom: '10px'
  }
});
var _StyledGridColumn3 = styled(GridColumn$1)(_t$1 || (_t$1 = _$1`${0}`), baseStyles);
var _StyledGridColumn4 = /*#__PURE__*/styled(GridColumn$1).withConfig({
  displayName: "DirectApply___StyledGridColumn4",
  componentId: "sc-1f2gesn-0"
})({
  marginBottom: '15px'
});

var styles$2 = "\n    .quick-registration-layout {\n      width: 100%;\n    }\n    .step-title {\n      padding-top: 20px;\n    }\n    .step-subtitle {\n      padding-bottom: 20px;\n     }\n     .field-wrapper{\n        padding-left: 0px;\n        padding-right: 0px;\n      }\n    .step-title,\n    .step-subtitle {\n        width: 100%;\n        font-family: $lato;\n        letter-spacing: 0;\n        color: $black-regular;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        text-align: center;\n        margin: 0;\n    }\n\n    .step-title {\n        font-size: 18px;\n        font-weight: bold;\n    }\n\n    .step-subtitle {\n        font-size: 16px;\n    }\n\n    .quick-registration-layout .non-student-layout {\n      margin-bottom: 18px\n    }\n\n    .quick-registration-layout .field-wrapper {\n      display: flex;\n      flex-direction: column;\n      margin-bottom: 10px;\n    }\n\n    .quick-registration-layout .form-label {\n      -webkit-box-align: center;\n      -webkit-box-pack: start;\n      align-items: left;\n      color: rgb(53, 53, 53);\n      display: flex;\n      flex-direction: column;\n      font-family: 'Open Sans', sans-serif;\n      font-size: 16px;\n      font-weight: 700;\n      justify-content: flex-start;\n      letter-spacing: 0px;\n      line-height: 1;\n      width: 100%;\n      margin: 0px 0px 6px;\n      padding: 0px;\n    }\n\n    .quick-registration-layout .form-error {\n        -webkit-box-align: start;\n        -webkit-box-pack: start;\n        align-items: flex-start;\n        color: red;\n        display: flex;\n        font-size: 12px;\n        font-style: italic;\n        font-weight: 700;\n        justify-content: flex-start;\n        min-height: 18px;\n        width: 100%;\n        margin: 0px;\n        padding: 3px 0px 0px 2px;\n    }\n  .non-student-layout, .student-layout {\n    width: 100%;\n  }\n    .quick-registration-layout .quick-profile-is-student-switch {\n      margin-bottom: 32px;\n      display: flex;\n    }\n\n    .quick-registration-layout .quick-profile-footer {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n    }\n    .job-title-count{\n        text-align: right;\n        float: right;\n        color: rgb(224, 224, 224);\n        font-weight: normal;\n    }\n    .quick-profile-is-student-switch{\n        font-size: 16px;\n        text-align: center;\n        font-family: \"Open Sans\", sans-serif;\n        color: rgb(152, 46, 169);\n        margin-bottom: 32px;\n        font-weight: 600;\n        padding: 0px;\n        background: none;\n        outline: none;\n        border-width: initial;\n        border-style: none;\n        border-color: initial;\n        border-image: initial;\n      }\n      .error input {\n        border-width: 1px;\n        border-style: solid;\n        border-color: rgb(179, 148, 242);\n      }\n\n";
var inputStyle = {
  backgroundColor: 'rgb(243, 245, 248)',
  color: 'rgb(53, 53, 53)',
  fontFamily: '"Open Sans", sans-serif',
  fontSize: '14px',
  fontStyle: 'italic',
  fontWeight: '400',
  height: '50px',
  width: '100%',
  borderWidth: 'initial',
  borderStyle: 'none',
  borderColor: 'initial',
  borderImage: 'initial',
  borderRadius: '0px',
  outline: 'none'
  // padding: '10px',
};

var getCompanyId = function getCompanyId(_ref) {
  var companyId = _ref.companyId,
    id = _ref.id;
  return companyId ? companyId : id ? id : null;
};
var getCompanyName = function getCompanyName(_ref2) {
  var companyName = _ref2.companyName,
    name = _ref2.name;
  return companyName ? companyName : name ? name : '';
};

var _this = undefined;
var SVGIconWrapper = function SVGIconWrapper() {
  var _this$props = _this.props,
    children = _this$props.children,
    handleClickSVGWrapper = _this$props.handleClickSVGWrapper,
    handleMouseEnter = _this$props.handleMouseEnter,
    handleMouseLeave = _this$props.handleMouseLeave,
    SVGWrapperCssClass = _this$props.SVGWrapperCssClass,
    SVGCssClass = _this$props.SVGCssClass,
    gCssClass = _this$props.gCssClass,
    gAdditionalCssClass = _this$props.gAdditionalCssClass;
  var element = children ? React.Children.only(children) : /*#__PURE__*/jsx("svg", {});
  return /*#__PURE__*/jsx("span", {
    role: "img",
    className: "component-Icons-SVGIconWrapper ".concat(SVGWrapperCssClass),
    onClick: handleClickSVGWrapper,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    children: /*#__PURE__*/React.cloneElement(element, {
      svgcssclass: SVGCssClass,
      gcssclass: gCssClass,
      gadditionalcssclass: gAdditionalCssClass
    })
  });
};
SVGIconWrapper.defaultProps = {
  children: /*#__PURE__*/React.createElement('div', null),
  handleClickSVGWrapper: function handleClickSVGWrapper() {
    return null;
  },
  handleMouseEnter: function handleMouseEnter() {
    return null;
  },
  handleMouseLeave: function handleMouseLeave() {
    return null;
  },
  SVGWrapperCssClass: ''
};
SVGIconWrapper.propTypes = {
  /**
   * children components wrapped inside SVGIconWrapper should be an svg image component,
   */
  children: PropTypes.node,
  /**
   * Function that SVGIconWrapper would triggered on click event
   */
  handleClickSVGWrapper: PropTypes.func,
  /**
   * Function that SVGIconWrapper would triggered on mouse enter event
   */
  handleMouseEnter: PropTypes.func,
  /**
   * Function that SVGIconWrapper would triggered on mouse leave event
   */
  handleMouseLeave: PropTypes.func,
  /**
   * css class that would take effect in SVGIconWrapper
   */
  SVGWrapperCssClass: PropTypes.string,
  /**
   * css class that would take effect in svg tag, there's example in SVGIconWrapper.md
   */
  SVGCssClass: PropTypes.string,
  /**
   * css class that would take effect in g tag, there's example in SVGIconWrapper.md
   */
  gCssClass: PropTypes.string,
  /**
   * addition css class that would take effect in g tag if there are different styling for more than one g tag, there's example in SVGIconWrapper.md
   */
  gAdditionalCssClass: PropTypes.string
};
var SVGIconWrapper$1 = SVGIconWrapper;

var styles$1 = "\n.component-Elements-Tag {\n background-color: #dfe5f2;\n color: #353535;\n border: 1px solid #b5bdd5;\n border-radius: 6px;\n padding: 5px 15px;\n text-align: center;\n margin-bottom: 10px;\n margin-right: 15px;\n font-size: 12px;\n display: inline-flex;\n align-items: center;\n word-break: break-word;\n word-wrap: break-word;\n}\n .component-Elements-Tag.pinkTag {\n background-color: #fbf2f5;\n}\n .component-Elements-Tag span.component-Icons-SVGIconWrapper {\n display: inline-block;\n margin-left: 3px;\n height: 13px;\n width: 13px;\n word-break: break-word;\n word-wrap: break-word;\n}\n .component-Elements-Tag span.component-Icons-SVGIconWrapper svg {\n height: 13px;\n width: 13px;\n}\n .component-Elements-Tag .cancel-image-box {\n fill: #dfe5f2;\n}\n ";

var Tag = /*#__PURE__*/function (_React$PureComponent) {
  function Tag() {
    _classCallCheck(this, Tag);
    return _callSuper(this, Tag, arguments);
  }
  _inherits(Tag, _React$PureComponent);
  return _createClass(Tag, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/jsxs("span", {
        className: "component-Elements-Tag ".concat(this.props.tagCssClass),
        children: [/*#__PURE__*/jsx("style", {
          children: styles$1
        }), this.props.children, this.props.shouldAllowDelete && /*#__PURE__*/jsx(SVGIconWrapper$1, {
          handleClickSVGWrapper: this.props.onRemove,
          SVGWrapperCssClass: this.props.svgCssClass,
          children: /*#__PURE__*/jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            children: /*#__PURE__*/jsxs("g", {
              fill: "none",
              fillRule: "evenodd",
              transform: "translate(-78 -8)",
              children: [/*#__PURE__*/jsx("rect", {
                className: 'cancel-image-box',
                width: "101",
                height: "30",
                x: ".5",
                y: ".5",
                fill: "#DFE5F2",
                stroke: "#B5BDD5",
                rx: "6"
              }), /*#__PURE__*/jsx("path", {
                fill: "#8E9DB9",
                d: "M86 15.057l1.652-1.652c.26-.26.68-.258.94.002a.664.664 0 0 1 .003.941L86.943 16l1.652 1.652c.259.26.26.679-.002.94a.665.665 0 0 1-.941.003L86 16.943l-1.652 1.652a.665.665 0 0 1-.94-.002.664.664 0 0 1-.003-.941L85.057 16l-1.652-1.652a.664.664 0 0 1 .002-.94.665.665 0 0 1 .941-.003L86 15.057zm0 7.61a6.667 6.667 0 1 1 0-13.334 6.667 6.667 0 0 1 0 13.334zm0-1.334a5.333 5.333 0 1 0 0-10.666 5.333 5.333 0 0 0 0 10.666z"
              })]
            })
          })
        })]
      });
    }
  }]);
}(React.PureComponent);
Tag.propTypes = {
  tagCssClass: PropTypes.string,
  svgCssClass: PropTypes.string,
  onRemove: PropTypes.func,
  shouldAllowDelete: PropTypes.bool
};
Tag.defaultProps = {
  tagCssClass: '',
  svgCssClass: '',
  shouldAllowDelete: true
};

var styles = "\n  component-Input-Typeahead {\n        width: 100%;\n        position: relative;\n  }\n   component-Input-Typeahead input {\n        background-color: #f3f5f8;\n        width: 100%;\n        height: 30px;\n        border-radius: 0;\n        border: none;\n        outline: none;\n        font-family: 'Open Sans', sans-serif;\n        font-weight: 400;\n        font-size: 14px;\n        font-style: italic;\n        color: #353535;\n        padding: 10px;\n  }\n   component-Input-Typeahead input::placeholder {\n        color: #353535;\n        font-weight: 300;\n  }\n   component-Input-Typeahead .suggestion-box {\n        max-height: 255px;\n        overflow-y: auto;\n        padding: 5px 0 0;\n        position: absolute;\n        width: 100%;\n        z-index: 3;\n  }\n   component-Input-Typeahead .suggestion-box .suggestion-option {\n        background-color: #f2f2f2;\n        font-family: 'Open Sans', sans-serif;\n        font-weight: 400;\n        font-size: 13px;\n        display: flex;\n        align-items: center;\n        min-height: 25px;\n        padding: 0 5px;\n  }\n   component-Input-Typeahead .suggestion-box .suggestion-option.suggestion-active {\n        background-color: #2a4473;\n        color: #fff;\n        -webkit-text-fill-color: #fff;\n  }\n   component-Input-Typeahead div.tags-container {\n        display: inline-flex;\n        flex-wrap: wrap;\n        margin: 10px 0 0;\n        width: 100%;\n  }\n";

var ENTER_KEY = 13;
var UP_KEY = 38;
var DOWN_KEY = 40;
var ITEM_ALREADY_ADDED_ERROR = "You've already selected  Please select another one.";
var Typeahead = /*#__PURE__*/function (_React$PureComponent) {
  function Typeahead(props) {
    var _this;
    _classCallCheck(this, Typeahead);
    _this = _callSuper(this, Typeahead, [props]);
    // for clicking outside of dropdown
    _this.setWrapperRef = function (node) {
      _this.wrapperRef = node;
    };
    _this.handleClickOutside = function () {
      if (_this.state.shouldShowSuggestions && _this.wrapperRef && !_this.wrapperRef.contains(event.target)) {
        _this.setState({
          shouldShowSuggestions: false
        });
      }
    };
    // set filteredSuggestions according to how parent wrapper wants suggestion obj to be
    _this.mapKeysInSuggestion = function (suggestions) {
      return suggestions && suggestions.map(_this.props.setUserInput);
    };
    _this.handleChange = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        var userInput, cancelToken, results, mappedSuggestions;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              userInput = event.target.value; // clears typeahead error on new input change
              _this.props.onError();
              _this.props.onChange(userInput);
              if (userInput.length > _this.props.inputMaxLength) {
                _this.setState({
                  filteredSuggestions: []
                });
                _this.props.onError("Input exceeded max length of ".concat(_this.props.inputMaxLength));
              }
              if (!_this.props.fetchSuggestionsApi) {
                _context.next = 25;
                break;
              }
              _context.prev = 5;
              _this.setState({
                userInput: userInput
              });

              // cancel the previous request
              if (_typeof(_this._source) !== ("undefined" )) {
                _this._source.cancel('Operation canceled due to new request.');
              }

              // save the new request for cancellation
              _this._source = axios.CancelToken.source();
              cancelToken = {
                cancelToken: _this._source.token
              };
              if (!userInput.length) {
                _context.next = 16;
                break;
              }
              _context.next = 13;
              return axios.get("".concat(_this.props.fetchSuggestionsApi, "/").concat(userInput), cancelToken);
            case 13:
              _context.t0 = _context.sent;
              _context.next = 17;
              break;
            case 16:
              _context.t0 = {};
            case 17:
              results = _context.t0;
              mappedSuggestions = _this.mapKeysInSuggestion(results.data);
              _this.setState({
                selectedSuggestionIndex: 0,
                filteredSuggestions: mappedSuggestions || [],
                shouldShowSuggestions: !!userInput
              });
              _context.next = 25;
              break;
            case 22:
              _context.prev = 22;
              _context.t1 = _context["catch"](5);
              console.log(_context.t1);
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[5, 22]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    _this.handleSelectSuggestion = function (selectedSuggestion) {
      var newObject = Object.assign({}, selectedSuggestion, {
        option: selectedSuggestion.parent ? selectedSuggestion.parent.name : selectedSuggestion.name
      });
      _this.setState({
        selectedSuggestionIndex: 0,
        filteredSuggestions: [],
        userInput: _this.props.isMulti ? '' : newObject,
        shouldShowSuggestions: false
      }, function () {
        return _this.handleSelectMultiple(newObject);
      });
    };
    _this.handleSelectMultiple = function (newObject) {
      _this.props.onChange(''); //clears state of input field's character counter managed in parent component

      if (_this.props.isMulti) {
        var isItemAddedAlready = _this.props.selectedSuggestions.some(function (_ref2) {
          var id = _ref2.id;
          return id === newObject.id;
        });
        if (!isItemAddedAlready) {
          var updatedSelectedSuggestions = [].concat(_toConsumableArray(_this.props.selectedSuggestions), [newObject]);
          _this.props.onSelect(updatedSelectedSuggestions);
        } else {
          _this.props.onError(ITEM_ALREADY_ADDED_ERROR);
        }
        return;
      }
      _this.props.onSelect(newObject);
    };
    _this.handleKeyDown = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        var keyCode, selectedSuggestionIndex, filteredSuggestions, enterKeys, selectedItem;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              keyCode = event.keyCode;
              selectedSuggestionIndex = _this.state.selectedSuggestionIndex;
              filteredSuggestions = _this.state.filteredSuggestions;
              enterKeys = [ENTER_KEY];
              if (!enterKeys.includes(keyCode)) {
                _context2.next = 14;
                break;
              }
              if (!(selectedSuggestionIndex >= filteredSuggestions.length)) {
                _context2.next = 9;
                break;
              }
              _context2.next = 8;
              return _this.handleAddNewItem();
            case 8:
              return _context2.abrupt("return");
            case 9:
              selectedItem = filteredSuggestions[selectedSuggestionIndex];
              _this.handleSelectSuggestion(selectedItem);
              event.preventDefault();
              _context2.next = 24;
              break;
            case 14:
              if (!(keyCode === UP_KEY)) {
                _context2.next = 20;
                break;
              }
              if (!(selectedSuggestionIndex === 0)) {
                _context2.next = 17;
                break;
              }
              return _context2.abrupt("return");
            case 17:
              _this.setState(function (previousState) {
                return {
                  selectedSuggestionIndex: previousState.selectedSuggestionIndex - 1
                };
              }, _this.handleScroll);
              _context2.next = 24;
              break;
            case 20:
              if (!(keyCode === DOWN_KEY)) {
                _context2.next = 24;
                break;
              }
              if (!(selectedSuggestionIndex === filteredSuggestions.length)) {
                _context2.next = 23;
                break;
              }
              return _context2.abrupt("return");
            case 23:
              _this.setState(function (previousState) {
                return {
                  selectedSuggestionIndex: previousState.selectedSuggestionIndex + 1
                };
              }, _this.handleScroll);
            case 24:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    _this.handleScroll = function () {
      var selection = document.querySelector('.suggestion-active');
      if (selection) {
        selection.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }
    };
    _this.handleMouseOver = function (index) {
      return function () {
        _this.setState({
          selectedSuggestionIndex: index
        });
      };
    };
    _this.handleAddNewItem = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var payload, createNewItemApi, result, newItem;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(_this.state.userInput.length > _this.props.inputMaxLength)) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            payload = _this.props.createPayloadForCreation(_this.state.userInput);
            createNewItemApi = _this.props.createNewItemApi;
            if (createNewItemApi) {
              _context3.next = 7;
              break;
            }
            _this.handleSelectSuggestion(_this.props.setUserInput(payload));
            return _context3.abrupt("return");
          case 7:
            _context3.prev = 7;
            _context3.next = 10;
            return axios.post(createNewItemApi, payload);
          case 10:
            _context3.t0 = _context3.sent;
            if (_context3.t0) {
              _context3.next = 13;
              break;
            }
            _context3.t0 = {};
          case 13:
            result = _context3.t0;
            newItem = result.data.data || {};
            _this.handleSelectSuggestion(_this.props.setUserInput(newItem));
            _context3.next = 21;
            break;
          case 18:
            _context3.prev = 18;
            _context3.t1 = _context3["catch"](7);
            _this.props.onError('Something went wrong. Please try again.');
          case 21:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[7, 18]]);
    }));
    _this.handleRemoveItem = function (item) {
      var updatedItems = _this.props.selectedSuggestions.filter(function (_ref5) {
        var id = _ref5.id;
        return id !== item.id;
      });
      _this.props.onSelect(_toConsumableArray(updatedItems));
    };
    // whether to show add new option if input is not in suggestions already
    _this.isInputInFilteredSuggestions = function (input) {
      return _this.state.filteredSuggestions.every(function (_ref6) {
        var option = _ref6.option;
        return option !== input;
      });
    };
    _this.renderSuggestions = function () {
      var input = _this.state.userInput.option || _this.state.userInput;
      var showAddNewOption = _this.props.allowAddNewItem && _this.isInputInFilteredSuggestions(input);
      var addNewOptionActiveCss = _this.state.filteredSuggestions.length === _this.state.selectedSuggestionIndex ? 'suggestion-active' : '';
      return /*#__PURE__*/jsxs("section", {
        className: "suggestion-box",
        children: [_this.state.filteredSuggestions.map(_this.renderSuggestionOption), showAddNewOption && /*#__PURE__*/jsxs("div", {
          className: "suggestion-option add-selection ".concat(addNewOptionActiveCss),
          onClick: _this.handleAddNewItem,
          onMouseOver: _this.handleMouseOver(_this.state.filteredSuggestions.length),
          children: ["Add", ' ', _this.state.userInput.option || _this.state.userInput]
        })]
      });
    };
    _this.renderSuggestionOption = function (suggestion, index) {
      var activeCssClass = index === _this.state.selectedSuggestionIndex ? 'suggestion-active' : '';
      return /*#__PURE__*/jsx("div", {
        className: "suggestion-option ".concat(activeCssClass),
        onClick: function onClick() {
          return _this.handleSelectSuggestion(suggestion);
        },
        onMouseOver: _this.handleMouseOver(index),
        children: suggestion.option
      }, "suggestion-".concat(index));
    };
    _this.renderTags = function () {
      var withTags = _this.props.selectedSuggestions;
      var selectedSuggestions = _this.props.selectedSuggestions;
      return withTags && !!selectedSuggestions.length && /*#__PURE__*/jsx("div", {
        className: "tags-container",
        children: _this.props.selectedSuggestions.map(function (item, index) {
          return /*#__PURE__*/jsx(Tag, {
            onRemove: function onRemove() {
              return _this.handleRemoveItem(item);
            },
            tagCssClass: "item-tags",
            svgCssClass: "item-remove-icon",
            children: item.option
          }, "item-".concat(index));
        })
      });
    };
    _this.preventSubmit = function (e) {
      var enterKeys = [ENTER_KEY];
      if (enterKeys.includes(e.keyCode)) {
        e.preventDefault();
      }
    };
    _this.state = {
      filteredSuggestions: [],
      selectedSuggestionIndex: 0,
      shouldShowSuggestions: false,
      userInput: function (props) {
        if (props.isMulti || !(props.selectedSuggestions && props.selectedSuggestions[0])) {
          return '';
        }
        if (props.selectedSuggestions[0].parent) {
          return props.selectedSuggestions[0].parent.name;
        }
        return props.selectedSuggestions[0].name;
      }(props)
    };
    return _this;
  }
  _inherits(Typeahead, _React$PureComponent);
  return _createClass(Typeahead, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      var inputId = this.props.inputId;
      return /*#__PURE__*/jsxs("div", {
        className: "component-Input-Typeahead",
        ref: this.setWrapperRef,
        children: [/*#__PURE__*/jsx("style", {
          children: styles
        }), /*#__PURE__*/jsx("input", {
          name: "typeahead",
          onChange: this.handleChange,
          placeholder: this.props.placeholderText,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.preventSubmit,
          value: this.state.userInput.option || this.state.userInput,
          autoComplete: this.props.autoComplete,
          "data-qa": this.props.qaDataAttr,
          className: this.props.cssClass,
          id: inputId
        }), this.state.shouldShowSuggestions && this.renderSuggestions(), this.renderTags()]
      });
    }
  }]);
}(React.PureComponent);

var CREATE_API$1 = 'http://localhost:3000/api/company/create';
var TYPEAHEAD_API$1 = 'http://localhost:3000/api/company/typeahead';
var CompanySelectorInput = function CompanySelectorInput(_ref) {
  var items = _ref.items,
    isMulti = _ref.isMulti,
    withTags = _ref.withTags,
    inputId = _ref.inputId,
    addOption = _ref.addOption,
    error = _ref.error,
    allowAPICreation = _ref.allowAPICreation,
    setTypeaheadInput = _ref.setTypeaheadInput,
    handleError = _ref.handleError,
    handleSelect = _ref.handleSelect,
    placeholder = _ref.placeholder,
    className = _ref.className;
  var formatCompanyResult = function formatCompanyResult(company) {
    /*
    This object formatting is required for backwards compatibility with the company typeahead created for the job review survey
    It requires mapping the same values to multiple keys e.g.
    the company id maps to both companyId and id keys.
    For all other typeaheads, the typeahead response objects should be consistently serialized
    with an id and name key -MsH 02152020
    */
    var companyId = getCompanyId(company);
    var companyName = getCompanyName(company);
    return {
      companyId: companyId,
      companyName: companyName,
      id: companyId,
      name: companyName,
      option: companyName,
      logo: company.logo
    };
  };
  var selectedSuggestions = items.map(function (c) {
    return formatCompanyResult(c);
  });
  return /*#__PURE__*/jsx("div", {
    children: /*#__PURE__*/jsx(Typeahead, {
      allowAddNewItem: addOption && !error,
      createNewItemApi: allowAPICreation && CREATE_API$1,
      fetchSuggestionsApi: TYPEAHEAD_API$1,
      isMulti: isMulti,
      onChange: setTypeaheadInput,
      onError: handleError,
      onSelect: handleSelect,
      placeholderText: placeholder,
      selectedSuggestions: selectedSuggestions,
      setUserInput: formatCompanyResult,
      cssClass: className,
      withTags: withTags,
      qaDataAttr: 'company',
      inputId: inputId
    })
  });
};
CompanySelectorInput.defaultProps = {
  addOption: true,
  allowAPICreation: true,
  items: [],
  error: '',
  isMulti: false,
  placeholder: 'Select one or add a new employer',
  resetInput: false,
  withTags: false,
  className: '',
  inputId: ''
};
CompanySelectorInput.propTypes = {
  addOption: PropTypes.bool,
  allowAPICreation: PropTypes.bool,
  items: PropTypes.array,
  error: PropTypes.string,
  isMulti: PropTypes.bool,
  placeholder: PropTypes.string,
  resetInput: PropTypes.bool,
  withTags: PropTypes.bool,
  className: PropTypes.string,
  inputId: PropTypes.string
};

var degreeDropdownOpts = ['High School', 'Associate Degree', "Bachelor's Degree", "Master's Degree", 'Doctorate / PhD'].map(function (v) {
  return {
    value: v,
    label: v
  };
});
var SchoolDegreeSelector = function SchoolDegreeSelector(_ref) {
  var onChange = _ref.onChange,
    value = _ref.value;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    opened = _useState2[0],
    setOpened = _useState2[1];
  var toggleDropdown = function toggleDropdown() {
    setOpened(!opened);
  };
  var handleChange = function handleChange(e) {
    onChange(e.target.value);
  };
  return /*#__PURE__*/jsx("div", {
    style: {
      width: '100%'
    },
    children: /*#__PURE__*/jsx("select", {
      onClick: toggleDropdown,
      onChange: handleChange,
      value: value,
      placeholder: "Select...",
      style: {
        color: '#353535',
        height: '50px',
        backgroundColor: 'rgb(243,245,248)',
        fontFamily: 'Lato, sans-serif',
        fontSize: '16px',
        fontStyle: 'italic',
        fontWeight: '300',
        letterSpacing: '0px',
        width: '100%',
        borderWidth: 'initial',
        borderStyle: 'none',
        borderColor: 'initial',
        borderImage: 'initial',
        borderRadius: '0px',
        outline: 'none',
        padding: '10px 15px'
      },
      children: [{
        label: 'Select...',
        value: null
      }].concat(_toConsumableArray(degreeDropdownOpts)).map(function (opt) {
        return /*#__PURE__*/jsx("option", {
          value: opt.value,
          children: opt.label
        }, "opt-id-".concat(opt.value));
      })
    })
  });
};

var CREATE_API = '/api/school/create';
var TYPEAHEAD_API = '/api/school/typeahead';
var SchoolSelector = function SchoolSelector(_ref) {
  var allowAddNewItem = _ref.allowAddNewItem,
    error = _ref.error,
    inputMaxLength = _ref.inputMaxLength,
    setTypeaheadInput = _ref.setTypeaheadInput,
    handleError = _ref.handleError,
    handleSelect = _ref.handleSelect,
    items = _ref.items;
  return /*#__PURE__*/jsx(Typeahead, {
    allowAddNewItem: allowAddNewItem && !error,
    createNewItemApi: CREATE_API,
    fetchSuggestionsApi: TYPEAHEAD_API,
    inputMaxLength: inputMaxLength,
    isMulti: false,
    onChange: setTypeaheadInput,
    onError: handleError,
    onSelect: handleSelect,
    placeholderText: 'Start typing to select a school or add a new one',
    selectedSuggestions: items,
    withTags: false,
    qaDataAttr: 'school'
  });
};
SchoolSelector.propTypes = {
  /**
   * can new item be added
   */
  allowAddNewItem: PropTypes.bool,
  /**
   * error message to show
   */
  error: PropTypes.string,
  /**
   * array of skills
   */
  items: PropTypes.array.isRequired,
  /**
   * error handling callback
   */
  onErrorUpdate: PropTypes.func,
  /**
   * function to call when item gets added or removed
   */
  onUpdate: PropTypes.func,
  className: PropTypes.string,
  isRequired: PropTypes.bool,
  /**
   * qa data attribute
   */
  qaDataAttr: PropTypes.string
};
SchoolSelector.defaultProps = {
  allowAddNewItem: true,
  error: '',
  onUpdate: function onUpdate() {
    return null;
  },
  onErrorUpdate: function onErrorUpdate() {
    return null;
  },
  isRequired: false,
  className: ''
};

var submitQuickProfile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var payload,
      endpoint,
      response,
      data,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          endpoint = '/api/user/profile';
          _context.prev = 2;
          _context.next = 5;
          return axios.patch(endpoint, payload);
        case 5:
          response = _context.sent;
          data = response.data;
          if (!data.meta.success) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", {
            ok: true,
            errors: null
          });
        case 9:
          _context.next = 14;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", {
            ok: false,
            errors: _context.t0
          });
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 11]]);
  }));
  return function submitQuickProfile() {
    return _ref.apply(this, arguments);
  };
}();

var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
var QuickProfileModal = function QuickProfileModal(_ref) {
  var onClose = _ref.onClose,
    isOpen = _ref.isOpen,
    onOpen = _ref.onOpen,
    userName = _ref.userName;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isStudent = _useState2[0],
    setIsStudent = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    jobTitle = _useState4[0],
    setJobTitle = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    company = _useState6[0],
    setCompany = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    jobLocation = _useState8[0],
    setJobLocation = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    school = _useState10[0],
    setSchool = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    schoolLocation = _useState12[0],
    setSchoolLocation = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    degree = _useState14[0],
    setDegree = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isRemote = _useState16[0],
    setIsRemote = _useState16[1];
  var _useState17 = useState({}),
    _useState18 = _slicedToArray(_useState17, 2),
    formErrors = _useState18[0],
    setFormErrors = _useState18[1];
  //When the student state changes
  useEffect(function () {
    if (isOpen) {
      EmitMetric({
        misc_event_count: 1,
        misc_event_type: 'quick-profile-modal-impression'
      });
    }
  }, [isOpen]);
  var handleSave = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var apiRequestPayload, formValid, errors, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            //check if the form is valid
            //if valid then save the data

            EmitMetric({
              misc_event_count: 1,
              misc_event_type: 'quick-profile-modal-submit-click'
            });
            apiRequestPayload = {
              name: userName
            };
            formValid = true;
            errors = {};
            if (!isStudent) {
              apiRequestPayload.experiences = [{
                title: jobTitle,
                company: company,
                location: Object.assign({
                  name: jobLocation.value
                }, jobLocation),
                isRemote: isRemote
              }];
              if (jobTitle === '') {
                errors.jobTitle = 'Job title is required';
                formValid = false;
              }
              if (company === '') {
                errors.company = 'Please add or select a company from the dropdown';
                formValid = false;
              }
              if (jobLocation === '') {
                errors.jobLocation = 'Job location is required';
                formValid = false;
              }
              setFormErrors(errors);
            } else if (isStudent) {
              apiRequestPayload.educations = [{
                school: school,
                location: Object.assign({
                  name: schoolLocation.value
                }, schoolLocation),
                degree: degree
              }];
              if (school === '') {
                errors.school = 'Please add or select a school from the dropdown';
                formValid = false;
              }
              if (schoolLocation === '') {
                errors.schoolLocation = 'School location is required';
                formValid = false;
              }
              if (degree === '') {
                errors.degree = 'Please select a degree from the dropdown';
                formValid = false;
              }
              setFormErrors(errors);
            }
            if (formValid) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return");
          case 7:
            _context.next = 9;
            return submitQuickProfile(apiRequestPayload);
          case 9:
            response = _context.sent;
            if (!response.ok) {
              _context.next = 13;
              break;
            }
            onClose();
            return _context.abrupt("return");
          case 13:
            setFormErrors(response.errors);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSave() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleStudentToggle = function handleStudentToggle() {
    setIsStudent(!isStudent);
  };
  var handleJobChange = function handleJobChange(e) {
    setJobTitle(e.target.value);
  };
  var handleCompanyChange = function handleCompanyChange(e) {
    setCompany(e.target.value);
  };
  var handleJobLocationChange = function handleJobLocationChange(location) {
    setJobLocation(location);
  };
  var handleSchoolDegreeChange = function handleSchoolDegreeChange(value) {
    setDegree(value);
  };
  var handleSchoolChange = function handleSchoolChange(value) {
    setSchool(value);
  };
  var handleSchoolLocationChange = function handleSchoolLocationChange(value) {
    setSchoolLocation(value);
  };
  var renderStudentLayout = function renderStudentLayout() {
    return /*#__PURE__*/jsxs("div", {
      className: "student-layout",
      children: [/*#__PURE__*/jsxs(GridColumn$1, {
        className: "school-selector-container ".concat(formErrors.school ? 'error' : ''),
        pl: 0,
        pr: 0,
        children: [/*#__PURE__*/jsx("div", {
          className: "form-label",
          children: /*#__PURE__*/jsx("span", {
            children: "School*"
          })
        }), /*#__PURE__*/jsx(SchoolSelector, {
          setTypeaheadInput: function setTypeaheadInput() {},
          handleSelect: handleSchoolChange,
          className: "quick-profile-school-typeahead",
          items: [],
          allowAddNewItem: true,
          isRequired: true
        }), /*#__PURE__*/jsx("div", {
          className: "form-error",
          children: /*#__PURE__*/jsx("span", {
            children: formErrors.school
          })
        })]
      }), /*#__PURE__*/jsxs(GridColumn$1, {
        className: "school-dropdown-container ".concat(formErrors.degree ? 'error' : ''),
        pl: 0,
        pr: 0,
        children: [/*#__PURE__*/jsx("div", {
          className: "form-label",
          children: /*#__PURE__*/jsx("span", {
            children: "Degree*"
          })
        }), /*#__PURE__*/jsx(SchoolDegreeSelector, {
          value: degree,
          onChange: handleSchoolDegreeChange
        }), /*#__PURE__*/jsx("div", {
          className: "form-error",
          children: /*#__PURE__*/jsx("span", {
            children: formErrors.degree
          })
        })]
      }), /*#__PURE__*/jsxs(GridColumn$1, {
        className: "school-location-container ".concat(formErrors.schoolLocation ? 'error' : ''),
        pl: 0,
        pr: 0,
        children: [/*#__PURE__*/jsx("div", {
          className: "form-label",
          children: /*#__PURE__*/jsx("span", {
            children: "School Location*"
          })
        }), /*#__PURE__*/jsx(_StyledLocationInput, {
          changeHandler: handleSchoolLocationChange,
          placeholder: 'City, state',
          value: schoolLocation.value || ''
        }), /*#__PURE__*/jsx("div", {
          className: "form-error",
          children: /*#__PURE__*/jsx("span", {
            children: formErrors.schoolLocation
          })
        })]
      }), /*#__PURE__*/jsx(GridColumn$1, {
        height: 85
      })]
    });
  };
  var renderNonStudentLayout = function renderNonStudentLayout() {
    return /*#__PURE__*/jsxs("div", {
      className: "non-student-layout",
      children: [/*#__PURE__*/jsxs(GridColumn$1, {
        className: "field-wrapper ".concat(formErrors.jobTitle ? 'error' : ''),
        pl: 0,
        pr: 0,
        children: [/*#__PURE__*/jsx("div", {
          className: "form-label",
          children: /*#__PURE__*/jsxs("span", {
            children: [" Most recent job title* ", /*#__PURE__*/jsxs("span", {
              className: "job-title-count",
              children: [" ", jobTitle.length, "/200 "]
            }), " "]
          })
        }), /*#__PURE__*/jsx(_StyledInputField, {
          value: jobTitle,
          changeHandler: handleJobChange,
          maxLength: 200,
          placeholder: ''
        }), /*#__PURE__*/jsx("div", {
          className: "form-error",
          children: /*#__PURE__*/jsx("span", {
            children: formErrors.jobTitle
          })
        })]
      }), /*#__PURE__*/jsxs(GridColumn$1, {
        className: "field-wrapper ".concat(formErrors.company ? 'error' : ''),
        pl: 0,
        pr: 0,
        children: [/*#__PURE__*/jsx("div", {
          className: "form-label",
          children: /*#__PURE__*/jsx("span", {
            children: "Company*"
          })
        }), /*#__PURE__*/jsx(CompanySelectorInput, {
          inputName: "",
          value: company,
          label: "Company*",
          setTypeaheadInput: function setTypeaheadInput() {},
          handleSelect: handleCompanyChange
        }), /*#__PURE__*/jsx("div", {
          className: "form-error",
          children: /*#__PURE__*/jsx("span", {
            children: formErrors.company
          })
        })]
      }), /*#__PURE__*/jsxs(GridColumn$1, {
        className: "field-wrapper ".concat(formErrors.jobLocation ? 'error' : ''),
        pl: 0,
        pr: 0,
        children: [/*#__PURE__*/jsx("div", {
          className: "form-label",
          children: /*#__PURE__*/jsx("span", {
            children: "Most recent job location*"
          })
        }), /*#__PURE__*/jsx(_StyledLocationInput2, {
          changeHandler: handleJobLocationChange,
          placeholder: 'City, state',
          value: jobLocation.value || ''
        }), /*#__PURE__*/jsx("div", {
          className: "form-error",
          children: /*#__PURE__*/jsx("span", {
            children: formErrors.jobLocation
          })
        })]
      }), /*#__PURE__*/jsx("label", {
        className: "remote-check-wrapper",
        children: /*#__PURE__*/jsx(Checkbox, {
          checked: isRemote,
          onClick: function onClick() {
            setIsRemote(!isRemote);
          },
          label: 'Remote',
          style: {
            borderRadius: '12px'
          }
        })
      })]
    });
  };
  return /*#__PURE__*/jsx(Modal, {
    isOpen: isOpen,
    isPayWall: true,
    allowClosing: false,
    label: '',
    timer: 2,
    onClose: onClose,
    onOpen: onOpen,
    contentClassName: "wide",
    children: /*#__PURE__*/jsxs(View, {
      className: "quick-registration-layout",
      children: [/*#__PURE__*/jsx("style", {
        children: styles$2
      }), /*#__PURE__*/jsxs(View, {
        alignItems: "center",
        justifyContent: "center",
        pl: 15,
        pr: 15,
        pt: 20,
        pb: 20,
        children: [/*#__PURE__*/jsxs(Grid, {
          className: "quick-profile-header",
          children: [/*#__PURE__*/jsx(GridColumn$1, {
            className: "step-title",
            children: "We need a few details to continue."
          }), /*#__PURE__*/jsx(GridColumn$1, {
            className: "step-subtitle",
            children: "(You'll only have to do this once.)"
          })]
        }), /*#__PURE__*/jsx(Grid, {
          className: "quick-profile-body",
          children: !isStudent ? renderNonStudentLayout() : renderStudentLayout()
        }), /*#__PURE__*/jsxs(Grid, {
          className: "quick-profile-footer",
          children: [/*#__PURE__*/jsx("div", {
            className: "quick-profile-is-student-switch",
            onClick: handleStudentToggle,
            children: !isStudent ? "I'm a student" : "'I'm not a  Student"
          }), /*#__PURE__*/jsx("div", {
            children: /*#__PURE__*/jsx(Button$1, {
              width: 175,
              onPress: handleSave,
              children: "Finish"
            })
          })]
        })]
      })]
    })
  });
};
var _StyledLocationInput = styled(LocationInput)(_t || (_t = _`${0}`), inputStyle);
var _StyledInputField = styled(InputField)(_t2 || (_t2 = _`${0}`), inputStyle);
var _StyledLocationInput2 = /*#__PURE__*/styled(LocationInput).withConfig({
  displayName: "QuickProfileModal___StyledLocationInput2",
  componentId: "sc-peu5tb-0"
})(["", ""], inputStyle);

var labelSizes = {
  small: typography.labelSm,
  medium: typography.labelMd,
  large: typography.labelLg
};
var captionSizes = {
  small: typography.labelXs,
  medium: typography.labelSm,
  large: typography.labelSm
};
var radioContainerSizeVariants = variant({
  prop: 'size',
  scale: 'radio.radioContainerSizeVariant',
  variants: {
    "default": {}
  }
});
var colorVariants$1 = variant({
  prop: 'color',
  scale: 'radio.colorVariants',
  variants: {
    "default": {}
  }
});
var sizeVariants$1 = variant({
  prop: 'size',
  scale: 'radio.sizeVariants',
  variants: {
    "default": {}
  }
});
var textStyleVariants = variant({
  prop: 'textStyleVariant',
  scale: 'radio.textStyleVariant',
  variants: {
    "default": {}
  }
});
var radioContainerSizeProps = compose(radioContainerSizeVariants);
var RadioContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "helpers__RadioContainer",
  componentId: "sc-1xjglt-0"
})(["display:flex;align-items:center;position:relative;", ""], radioContainerSizeProps);
var hiddenInputProps = compose(colorVariants$1);
var HiddenInput = /*#__PURE__*/styled.input.attrs({
  type: 'radio'
}).withConfig({
  displayName: "helpers__HiddenInput",
  componentId: "sc-1xjglt-1"
})(["opacity:0;z-index:1;cursor:pointer;margin:0;padding:0;width:20px;height:20px;", " ", ";"], function (props) {
  return styledCss({
    '&:checked ~ div': {
      '&::after': {
        content: '""',
        display: 'block',
        width: props.size === 'medium' ? '10px' : '12px',
        //Update sizes
        height: props.size === 'medium' ? '10px' : '12px',
        borderRadius: '50%',
        margin: props.size === 'medium' ? '3px' : '2px'
      }
    }
  });
}, hiddenInputProps);
var styledInputProps = compose(sizeVariants$1);
var StyledInput = /*#__PURE__*/styled.div.withConfig({
  displayName: "helpers__StyledInput",
  componentId: "sc-1xjglt-2"
})(["position:absolute;border-radius:50%;", ";"], styledInputProps);
var textStyleProps = compose(textStyleVariants);
var TextWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "helpers__TextWrapper",
  componentId: "sc-1xjglt-3"
})(["display:flex;flex-direction:column;align-items:flex-start;margin:0 0 0 12px;", ""], textStyleProps);
var LabelText = /*#__PURE__*/styled.label.withConfig({
  displayName: "helpers__LabelText",
  componentId: "sc-1xjglt-4"
})(["", ";"], function (props) {
  return styledCss({
    cursor: 'pointer',
    margin: "".concat(props.size === 'medium' ? '1px 0 0' : '2px 0 0'),
    fontFamily: "".concat(openSans()),
    fontSize: "".concat(labelSizes[props.size].size, "px"),
    lineHeight: "".concat(labelSizes[props.size].lineHeight, "px")
  });
});
var CaptionText = /*#__PURE__*/styled.p.withConfig({
  displayName: "helpers__CaptionText",
  componentId: "sc-1xjglt-5"
})(["margin:0;", ";"], function (props) {
  return styledCss({
    fontFamily: "".concat(openSans()),
    fontSize: "".concat(captionSizes[props.size].size, "px"),
    lineHeight: "".concat(captionSizes[props.size].lineHeight, "px"),
    margin: props.hasLabel ? '8px 0 0' : '0'
  });
});

var _excluded = ["label", "caption", "checked", "onChange", "disabled", "value", "size", "color", "hasError", "name"];
var RadioWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Radio__RadioWrapper",
  componentId: "sc-10l3fsy-0"
})(["display:flex;"]);
var Radio = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var label = _ref.label,
    caption = _ref.caption,
    checked = _ref.checked,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    value = _ref.value,
    size = _ref.size,
    color = _ref.color,
    hasError = _ref.hasError,
    name = _ref.name,
    others = _objectWithoutProperties(_ref, _excluded);
  var textStyleVariant;
  switch (true) {
    case disabled:
      textStyleVariant = 'disabled';
      break;
    case hasError:
      textStyleVariant = 'error';
      break;
    default:
      textStyleVariant = 'default';
  }
  return /*#__PURE__*/jsxs(RadioWrapper, Object.assign({
    ref: ref
  }, others, {
    children: [/*#__PURE__*/jsxs(RadioContainer, {
      size: size,
      children: [/*#__PURE__*/jsx(HiddenInput, {
        id: value,
        disabled: disabled,
        value: value,
        checked: checked,
        onChange: onChange,
        size: size,
        color: hasError ? 'error' : color,
        name: name
      }), /*#__PURE__*/jsx(StyledInput, {
        htmlFor: value,
        size: size
      })]
    }), label || caption ? /*#__PURE__*/jsxs(TextWrapper, {
      textStyleVariant: textStyleVariant,
      children: [/*#__PURE__*/jsx(LabelText, {
        htmlFor: value,
        size: size,
        children: label
      }), /*#__PURE__*/jsx(CaptionText, {
        hasLabel: !!(label != null && label.length) > 0,
        size: size,
        children: caption
      })]
    }) : null]
  }));
});
Radio.displayName = 'Radio';

// define available radio variants
var sizeVariants = ['medium', 'large'];
var colorVariants = ['purple'];
Radio.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  caption: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  size: PropTypes.oneOf(sizeVariants),
  color: PropTypes.oneOf(colorVariants),
  hasError: PropTypes.bool
};
Radio.defaultProps = {
  id: null,
  label: null,
  caption: null,
  disabled: false,
  checked: false,
  size: 'medium',
  color: 'purple',
  hasError: false,
  value: null
};
var Radio$1 = Radio;

var theme = {};
theme["view"] = _wcImport20;
theme["typography"] = _wcImport19;
theme["toggle"] = _wcImport18;
theme["timing"] = _wcImport17;
theme["switch"] = _wcImport16;
theme["space"] = _wcImport15;
theme["shadows"] = _wcImport14;
theme["radio"] = _wcImport13;
theme["radii"] = _wcImport12;
theme["progressCircle"] = _wcImport11;
theme["padding"] = _wcImport10;
theme["loaders"] = _wcImport9;
theme["list"] = _wcImport8;
theme["link"] = _wcImport7;
theme["icon"] = _wcImport6;
theme["gutters"] = _wcImport5;
theme["colors"] = _wcImport4;
theme["checkbox"] = _wcImport3;
theme["button"] = _wcImport2;
theme["breakpoints"] = _wcImport;
var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsx(ThemeProvider$1, {
    theme: theme,
    children: children
  });
};

export { AuthModal, BasicChip$1 as BasicChip, Button$1 as Button, Checkbox, CheckboxFilter$1 as CheckboxFilter, DirectApply, Drawer, Grid, GridColumn$1 as GridColumn, Header, Heading$1 as Heading, Icon$1 as Icon, InputField, JobSearchAutocompleteInput, Link$1 as Link, List, ListItem, LocationInput, Menu$1 as Menu, Modal, PageWrapper$1 as Page, Pagination$1 as Pagination, PopOver$1 as Popover, PopupFilter$1 as PopupFilter, ProgressCircle, QuickProfileModal, Radio$1 as Radio, Ratings, Switch, Text$1 as Text, ThemeProvider, View, _wcImport4 as colors, theme, trueViewPort, useViewport };
